/* eslint-disable */
// @ts-nocheck 
import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  /** The javascript `Date` as string. Type represents date and time as the ISO Date string. */
  DateTime: any;
  /** The `JSON` scalar type represents JSON values as specified by [ECMA-404](http://www.ecma-international.org/publications/files/ECMA-ST/ECMA-404.pdf). */
  JSON: any;
  /** The `JSONObject` scalar type represents JSON objects as specified by [ECMA-404](http://www.ecma-international.org/publications/files/ECMA-ST/ECMA-404.pdf). */
  JSONObject: any;
};

export type AccessLabel = {
  __typename?: 'AccessLabel';
  _count?: Maybe<AccessLabelCount>;
  adBoardIDs: Array<Scalars['String']>;
  adBoards: Array<AdBoard>;
  bookingIDs: Array<Scalars['String']>;
  bookings: Array<Booking>;
  id: Scalars['String'];
  label: Scalars['String'];
  playlistIDs: Array<Scalars['String']>;
  playlists: Array<Playlist>;
  user: Array<User>;
  userID: Array<Scalars['String']>;
  workspace?: Maybe<Workspace>;
  workspaceId?: Maybe<Scalars['String']>;
};


export type AccessLabelAdBoardsArgs = {
  cursor?: InputMaybe<AdBoardWhereUniqueInput>;
  distinct?: InputMaybe<Array<AdBoardScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<AdBoardOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<AdBoardWhereInput>;
};


export type AccessLabelBookingsArgs = {
  cursor?: InputMaybe<BookingWhereUniqueInput>;
  distinct?: InputMaybe<Array<BookingScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<BookingOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<BookingWhereInput>;
};


export type AccessLabelPlaylistsArgs = {
  cursor?: InputMaybe<PlaylistWhereUniqueInput>;
  distinct?: InputMaybe<Array<PlaylistScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<PlaylistOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<PlaylistWhereInput>;
};


export type AccessLabelUserArgs = {
  cursor?: InputMaybe<UserWhereUniqueInput>;
  distinct?: InputMaybe<Array<UserScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<UserOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<UserWhereInput>;
};


export type AccessLabelWorkspaceArgs = {
  where?: InputMaybe<WorkspaceWhereInput>;
};

export type AccessLabelCount = {
  __typename?: 'AccessLabelCount';
  adBoards: Scalars['Int'];
  bookings: Scalars['Int'];
  playlists: Scalars['Int'];
  user: Scalars['Int'];
};


export type AccessLabelCountAdBoardsArgs = {
  where?: InputMaybe<AdBoardWhereInput>;
};


export type AccessLabelCountBookingsArgs = {
  where?: InputMaybe<BookingWhereInput>;
};


export type AccessLabelCountPlaylistsArgs = {
  where?: InputMaybe<PlaylistWhereInput>;
};


export type AccessLabelCountUserArgs = {
  where?: InputMaybe<UserWhereInput>;
};

export type AccessLabelCountAggregate = {
  __typename?: 'AccessLabelCountAggregate';
  _all: Scalars['Int'];
  adBoardIDs: Scalars['Int'];
  bookingIDs: Scalars['Int'];
  id: Scalars['Int'];
  label: Scalars['Int'];
  playlistIDs: Scalars['Int'];
  userID: Scalars['Int'];
  workspaceId: Scalars['Int'];
};

export type AccessLabelCountOrderByAggregateInput = {
  adBoardIDs?: InputMaybe<SortOrder>;
  bookingIDs?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  label?: InputMaybe<SortOrder>;
  playlistIDs?: InputMaybe<SortOrder>;
  userID?: InputMaybe<SortOrder>;
  workspaceId?: InputMaybe<SortOrder>;
};

export type AccessLabelCreateInput = {
  adBoards?: InputMaybe<AdBoardCreateNestedManyWithoutAccessLabelsInput>;
  bookings?: InputMaybe<BookingCreateNestedManyWithoutAccessLabelsInput>;
  id?: InputMaybe<Scalars['String']>;
  label: Scalars['String'];
  playlists?: InputMaybe<PlaylistCreateNestedManyWithoutAccessLabelsInput>;
  user?: InputMaybe<UserCreateNestedManyWithoutAccessLabelsInput>;
  workspace?: InputMaybe<WorkspaceCreateNestedOneWithoutAccessLabelsInput>;
};

export type AccessLabelCreateManyInput = {
  adBoardIDs?: InputMaybe<Array<Scalars['String']>>;
  bookingIDs?: InputMaybe<Array<Scalars['String']>>;
  id?: InputMaybe<Scalars['String']>;
  label: Scalars['String'];
  playlistIDs?: InputMaybe<Array<Scalars['String']>>;
  userID?: InputMaybe<Array<Scalars['String']>>;
  workspaceId?: InputMaybe<Scalars['String']>;
};

export type AccessLabelCreateManyWorkspaceInput = {
  adBoardIDs?: InputMaybe<Array<Scalars['String']>>;
  bookingIDs?: InputMaybe<Array<Scalars['String']>>;
  id?: InputMaybe<Scalars['String']>;
  label: Scalars['String'];
  playlistIDs?: InputMaybe<Array<Scalars['String']>>;
  userID?: InputMaybe<Array<Scalars['String']>>;
};

export type AccessLabelCreateManyWorkspaceInputEnvelope = {
  data: Array<AccessLabelCreateManyWorkspaceInput>;
};

export type AccessLabelCreateNestedManyWithoutAdBoardsInput = {
  connect?: InputMaybe<Array<AccessLabelWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<AccessLabelCreateOrConnectWithoutAdBoardsInput>>;
  create?: InputMaybe<Array<AccessLabelCreateWithoutAdBoardsInput>>;
};

export type AccessLabelCreateNestedManyWithoutBookingsInput = {
  connect?: InputMaybe<Array<AccessLabelWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<AccessLabelCreateOrConnectWithoutBookingsInput>>;
  create?: InputMaybe<Array<AccessLabelCreateWithoutBookingsInput>>;
};

export type AccessLabelCreateNestedManyWithoutPlaylistsInput = {
  connect?: InputMaybe<Array<AccessLabelWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<AccessLabelCreateOrConnectWithoutPlaylistsInput>>;
  create?: InputMaybe<Array<AccessLabelCreateWithoutPlaylistsInput>>;
};

export type AccessLabelCreateNestedManyWithoutUserInput = {
  connect?: InputMaybe<Array<AccessLabelWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<AccessLabelCreateOrConnectWithoutUserInput>>;
  create?: InputMaybe<Array<AccessLabelCreateWithoutUserInput>>;
};

export type AccessLabelCreateNestedManyWithoutWorkspaceInput = {
  connect?: InputMaybe<Array<AccessLabelWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<AccessLabelCreateOrConnectWithoutWorkspaceInput>>;
  create?: InputMaybe<Array<AccessLabelCreateWithoutWorkspaceInput>>;
  createMany?: InputMaybe<AccessLabelCreateManyWorkspaceInputEnvelope>;
};

export type AccessLabelCreateOrConnectWithoutAdBoardsInput = {
  create: AccessLabelCreateWithoutAdBoardsInput;
  where: AccessLabelWhereUniqueInput;
};

export type AccessLabelCreateOrConnectWithoutBookingsInput = {
  create: AccessLabelCreateWithoutBookingsInput;
  where: AccessLabelWhereUniqueInput;
};

export type AccessLabelCreateOrConnectWithoutPlaylistsInput = {
  create: AccessLabelCreateWithoutPlaylistsInput;
  where: AccessLabelWhereUniqueInput;
};

export type AccessLabelCreateOrConnectWithoutUserInput = {
  create: AccessLabelCreateWithoutUserInput;
  where: AccessLabelWhereUniqueInput;
};

export type AccessLabelCreateOrConnectWithoutWorkspaceInput = {
  create: AccessLabelCreateWithoutWorkspaceInput;
  where: AccessLabelWhereUniqueInput;
};

export type AccessLabelCreateWithoutAdBoardsInput = {
  bookings?: InputMaybe<BookingCreateNestedManyWithoutAccessLabelsInput>;
  id?: InputMaybe<Scalars['String']>;
  label: Scalars['String'];
  playlists?: InputMaybe<PlaylistCreateNestedManyWithoutAccessLabelsInput>;
  user?: InputMaybe<UserCreateNestedManyWithoutAccessLabelsInput>;
  workspace?: InputMaybe<WorkspaceCreateNestedOneWithoutAccessLabelsInput>;
};

export type AccessLabelCreateWithoutBookingsInput = {
  adBoards?: InputMaybe<AdBoardCreateNestedManyWithoutAccessLabelsInput>;
  id?: InputMaybe<Scalars['String']>;
  label: Scalars['String'];
  playlists?: InputMaybe<PlaylistCreateNestedManyWithoutAccessLabelsInput>;
  user?: InputMaybe<UserCreateNestedManyWithoutAccessLabelsInput>;
  workspace?: InputMaybe<WorkspaceCreateNestedOneWithoutAccessLabelsInput>;
};

export type AccessLabelCreateWithoutPlaylistsInput = {
  adBoards?: InputMaybe<AdBoardCreateNestedManyWithoutAccessLabelsInput>;
  bookings?: InputMaybe<BookingCreateNestedManyWithoutAccessLabelsInput>;
  id?: InputMaybe<Scalars['String']>;
  label: Scalars['String'];
  user?: InputMaybe<UserCreateNestedManyWithoutAccessLabelsInput>;
  workspace?: InputMaybe<WorkspaceCreateNestedOneWithoutAccessLabelsInput>;
};

export type AccessLabelCreateWithoutUserInput = {
  adBoards?: InputMaybe<AdBoardCreateNestedManyWithoutAccessLabelsInput>;
  bookings?: InputMaybe<BookingCreateNestedManyWithoutAccessLabelsInput>;
  id?: InputMaybe<Scalars['String']>;
  label: Scalars['String'];
  playlists?: InputMaybe<PlaylistCreateNestedManyWithoutAccessLabelsInput>;
  workspace?: InputMaybe<WorkspaceCreateNestedOneWithoutAccessLabelsInput>;
};

export type AccessLabelCreateWithoutWorkspaceInput = {
  adBoards?: InputMaybe<AdBoardCreateNestedManyWithoutAccessLabelsInput>;
  bookings?: InputMaybe<BookingCreateNestedManyWithoutAccessLabelsInput>;
  id?: InputMaybe<Scalars['String']>;
  label: Scalars['String'];
  playlists?: InputMaybe<PlaylistCreateNestedManyWithoutAccessLabelsInput>;
  user?: InputMaybe<UserCreateNestedManyWithoutAccessLabelsInput>;
};

export type AccessLabelGroupBy = {
  __typename?: 'AccessLabelGroupBy';
  _count?: Maybe<AccessLabelCountAggregate>;
  _max?: Maybe<AccessLabelMaxAggregate>;
  _min?: Maybe<AccessLabelMinAggregate>;
  adBoardIDs?: Maybe<Array<Scalars['String']>>;
  bookingIDs?: Maybe<Array<Scalars['String']>>;
  id: Scalars['String'];
  label: Scalars['String'];
  playlistIDs?: Maybe<Array<Scalars['String']>>;
  userID?: Maybe<Array<Scalars['String']>>;
  workspaceId?: Maybe<Scalars['String']>;
};

export type AccessLabelLabelWorkspaceIdCompoundUniqueInput = {
  label: Scalars['String'];
  workspaceId: Scalars['String'];
};

export type AccessLabelListRelationFilter = {
  every?: InputMaybe<AccessLabelWhereInput>;
  none?: InputMaybe<AccessLabelWhereInput>;
  some?: InputMaybe<AccessLabelWhereInput>;
};

export type AccessLabelMaxAggregate = {
  __typename?: 'AccessLabelMaxAggregate';
  id?: Maybe<Scalars['String']>;
  label?: Maybe<Scalars['String']>;
  workspaceId?: Maybe<Scalars['String']>;
};

export type AccessLabelMaxOrderByAggregateInput = {
  id?: InputMaybe<SortOrder>;
  label?: InputMaybe<SortOrder>;
  workspaceId?: InputMaybe<SortOrder>;
};

export type AccessLabelMinAggregate = {
  __typename?: 'AccessLabelMinAggregate';
  id?: Maybe<Scalars['String']>;
  label?: Maybe<Scalars['String']>;
  workspaceId?: Maybe<Scalars['String']>;
};

export type AccessLabelMinOrderByAggregateInput = {
  id?: InputMaybe<SortOrder>;
  label?: InputMaybe<SortOrder>;
  workspaceId?: InputMaybe<SortOrder>;
};

export type AccessLabelOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type AccessLabelOrderByWithAggregationInput = {
  _count?: InputMaybe<AccessLabelCountOrderByAggregateInput>;
  _max?: InputMaybe<AccessLabelMaxOrderByAggregateInput>;
  _min?: InputMaybe<AccessLabelMinOrderByAggregateInput>;
  adBoardIDs?: InputMaybe<SortOrder>;
  bookingIDs?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  label?: InputMaybe<SortOrder>;
  playlistIDs?: InputMaybe<SortOrder>;
  userID?: InputMaybe<SortOrder>;
  workspaceId?: InputMaybe<SortOrder>;
};

export type AccessLabelOrderByWithRelationInput = {
  adBoardIDs?: InputMaybe<SortOrder>;
  adBoards?: InputMaybe<AdBoardOrderByRelationAggregateInput>;
  bookingIDs?: InputMaybe<SortOrder>;
  bookings?: InputMaybe<BookingOrderByRelationAggregateInput>;
  id?: InputMaybe<SortOrder>;
  label?: InputMaybe<SortOrder>;
  playlistIDs?: InputMaybe<SortOrder>;
  playlists?: InputMaybe<PlaylistOrderByRelationAggregateInput>;
  user?: InputMaybe<UserOrderByRelationAggregateInput>;
  userID?: InputMaybe<SortOrder>;
  workspace?: InputMaybe<WorkspaceOrderByWithRelationInput>;
  workspaceId?: InputMaybe<SortOrder>;
};

export enum AccessLabelScalarFieldEnum {
  AdBoardIDs = 'adBoardIDs',
  BookingIDs = 'bookingIDs',
  Id = 'id',
  Label = 'label',
  PlaylistIDs = 'playlistIDs',
  UserId = 'userID',
  WorkspaceId = 'workspaceId'
}

export type AccessLabelScalarWhereInput = {
  AND?: InputMaybe<Array<AccessLabelScalarWhereInput>>;
  NOT?: InputMaybe<Array<AccessLabelScalarWhereInput>>;
  OR?: InputMaybe<Array<AccessLabelScalarWhereInput>>;
  adBoardIDs?: InputMaybe<StringNullableListFilter>;
  bookingIDs?: InputMaybe<StringNullableListFilter>;
  id?: InputMaybe<StringFilter>;
  label?: InputMaybe<StringFilter>;
  playlistIDs?: InputMaybe<StringNullableListFilter>;
  userID?: InputMaybe<StringNullableListFilter>;
  workspaceId?: InputMaybe<StringNullableFilter>;
};

export type AccessLabelScalarWhereWithAggregatesInput = {
  AND?: InputMaybe<Array<AccessLabelScalarWhereWithAggregatesInput>>;
  NOT?: InputMaybe<Array<AccessLabelScalarWhereWithAggregatesInput>>;
  OR?: InputMaybe<Array<AccessLabelScalarWhereWithAggregatesInput>>;
  adBoardIDs?: InputMaybe<StringNullableListFilter>;
  bookingIDs?: InputMaybe<StringNullableListFilter>;
  id?: InputMaybe<StringWithAggregatesFilter>;
  label?: InputMaybe<StringWithAggregatesFilter>;
  playlistIDs?: InputMaybe<StringNullableListFilter>;
  userID?: InputMaybe<StringNullableListFilter>;
  workspaceId?: InputMaybe<StringNullableWithAggregatesFilter>;
};

export type AccessLabelUpdateInput = {
  adBoards?: InputMaybe<AdBoardUpdateManyWithoutAccessLabelsNestedInput>;
  bookings?: InputMaybe<BookingUpdateManyWithoutAccessLabelsNestedInput>;
  label?: InputMaybe<Scalars['String']>;
  playlists?: InputMaybe<PlaylistUpdateManyWithoutAccessLabelsNestedInput>;
  user?: InputMaybe<UserUpdateManyWithoutAccessLabelsNestedInput>;
  workspace?: InputMaybe<WorkspaceUpdateOneWithoutAccessLabelsNestedInput>;
};

export type AccessLabelUpdateManyMutationInput = {
  label?: InputMaybe<Scalars['String']>;
};

export type AccessLabelUpdateManyWithWhereWithoutAdBoardsInput = {
  data: AccessLabelUpdateManyMutationInput;
  where: AccessLabelScalarWhereInput;
};

export type AccessLabelUpdateManyWithWhereWithoutBookingsInput = {
  data: AccessLabelUpdateManyMutationInput;
  where: AccessLabelScalarWhereInput;
};

export type AccessLabelUpdateManyWithWhereWithoutPlaylistsInput = {
  data: AccessLabelUpdateManyMutationInput;
  where: AccessLabelScalarWhereInput;
};

export type AccessLabelUpdateManyWithWhereWithoutUserInput = {
  data: AccessLabelUpdateManyMutationInput;
  where: AccessLabelScalarWhereInput;
};

export type AccessLabelUpdateManyWithWhereWithoutWorkspaceInput = {
  data: AccessLabelUpdateManyMutationInput;
  where: AccessLabelScalarWhereInput;
};

export type AccessLabelUpdateManyWithoutAdBoardsNestedInput = {
  connect?: InputMaybe<Array<AccessLabelWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<AccessLabelCreateOrConnectWithoutAdBoardsInput>>;
  create?: InputMaybe<Array<AccessLabelCreateWithoutAdBoardsInput>>;
  delete?: InputMaybe<Array<AccessLabelWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<AccessLabelScalarWhereInput>>;
  disconnect?: InputMaybe<Array<AccessLabelWhereUniqueInput>>;
  set?: InputMaybe<Array<AccessLabelWhereUniqueInput>>;
  update?: InputMaybe<Array<AccessLabelUpdateWithWhereUniqueWithoutAdBoardsInput>>;
  updateMany?: InputMaybe<Array<AccessLabelUpdateManyWithWhereWithoutAdBoardsInput>>;
  upsert?: InputMaybe<Array<AccessLabelUpsertWithWhereUniqueWithoutAdBoardsInput>>;
};

export type AccessLabelUpdateManyWithoutBookingsNestedInput = {
  connect?: InputMaybe<Array<AccessLabelWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<AccessLabelCreateOrConnectWithoutBookingsInput>>;
  create?: InputMaybe<Array<AccessLabelCreateWithoutBookingsInput>>;
  delete?: InputMaybe<Array<AccessLabelWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<AccessLabelScalarWhereInput>>;
  disconnect?: InputMaybe<Array<AccessLabelWhereUniqueInput>>;
  set?: InputMaybe<Array<AccessLabelWhereUniqueInput>>;
  update?: InputMaybe<Array<AccessLabelUpdateWithWhereUniqueWithoutBookingsInput>>;
  updateMany?: InputMaybe<Array<AccessLabelUpdateManyWithWhereWithoutBookingsInput>>;
  upsert?: InputMaybe<Array<AccessLabelUpsertWithWhereUniqueWithoutBookingsInput>>;
};

export type AccessLabelUpdateManyWithoutPlaylistsNestedInput = {
  connect?: InputMaybe<Array<AccessLabelWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<AccessLabelCreateOrConnectWithoutPlaylistsInput>>;
  create?: InputMaybe<Array<AccessLabelCreateWithoutPlaylistsInput>>;
  delete?: InputMaybe<Array<AccessLabelWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<AccessLabelScalarWhereInput>>;
  disconnect?: InputMaybe<Array<AccessLabelWhereUniqueInput>>;
  set?: InputMaybe<Array<AccessLabelWhereUniqueInput>>;
  update?: InputMaybe<Array<AccessLabelUpdateWithWhereUniqueWithoutPlaylistsInput>>;
  updateMany?: InputMaybe<Array<AccessLabelUpdateManyWithWhereWithoutPlaylistsInput>>;
  upsert?: InputMaybe<Array<AccessLabelUpsertWithWhereUniqueWithoutPlaylistsInput>>;
};

export type AccessLabelUpdateManyWithoutUserNestedInput = {
  connect?: InputMaybe<Array<AccessLabelWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<AccessLabelCreateOrConnectWithoutUserInput>>;
  create?: InputMaybe<Array<AccessLabelCreateWithoutUserInput>>;
  delete?: InputMaybe<Array<AccessLabelWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<AccessLabelScalarWhereInput>>;
  disconnect?: InputMaybe<Array<AccessLabelWhereUniqueInput>>;
  set?: InputMaybe<Array<AccessLabelWhereUniqueInput>>;
  update?: InputMaybe<Array<AccessLabelUpdateWithWhereUniqueWithoutUserInput>>;
  updateMany?: InputMaybe<Array<AccessLabelUpdateManyWithWhereWithoutUserInput>>;
  upsert?: InputMaybe<Array<AccessLabelUpsertWithWhereUniqueWithoutUserInput>>;
};

export type AccessLabelUpdateManyWithoutWorkspaceNestedInput = {
  connect?: InputMaybe<Array<AccessLabelWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<AccessLabelCreateOrConnectWithoutWorkspaceInput>>;
  create?: InputMaybe<Array<AccessLabelCreateWithoutWorkspaceInput>>;
  createMany?: InputMaybe<AccessLabelCreateManyWorkspaceInputEnvelope>;
  delete?: InputMaybe<Array<AccessLabelWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<AccessLabelScalarWhereInput>>;
  disconnect?: InputMaybe<Array<AccessLabelWhereUniqueInput>>;
  set?: InputMaybe<Array<AccessLabelWhereUniqueInput>>;
  update?: InputMaybe<Array<AccessLabelUpdateWithWhereUniqueWithoutWorkspaceInput>>;
  updateMany?: InputMaybe<Array<AccessLabelUpdateManyWithWhereWithoutWorkspaceInput>>;
  upsert?: InputMaybe<Array<AccessLabelUpsertWithWhereUniqueWithoutWorkspaceInput>>;
};

export type AccessLabelUpdateWithWhereUniqueWithoutAdBoardsInput = {
  data: AccessLabelUpdateWithoutAdBoardsInput;
  where: AccessLabelWhereUniqueInput;
};

export type AccessLabelUpdateWithWhereUniqueWithoutBookingsInput = {
  data: AccessLabelUpdateWithoutBookingsInput;
  where: AccessLabelWhereUniqueInput;
};

export type AccessLabelUpdateWithWhereUniqueWithoutPlaylistsInput = {
  data: AccessLabelUpdateWithoutPlaylistsInput;
  where: AccessLabelWhereUniqueInput;
};

export type AccessLabelUpdateWithWhereUniqueWithoutUserInput = {
  data: AccessLabelUpdateWithoutUserInput;
  where: AccessLabelWhereUniqueInput;
};

export type AccessLabelUpdateWithWhereUniqueWithoutWorkspaceInput = {
  data: AccessLabelUpdateWithoutWorkspaceInput;
  where: AccessLabelWhereUniqueInput;
};

export type AccessLabelUpdateWithoutAdBoardsInput = {
  bookings?: InputMaybe<BookingUpdateManyWithoutAccessLabelsNestedInput>;
  label?: InputMaybe<Scalars['String']>;
  playlists?: InputMaybe<PlaylistUpdateManyWithoutAccessLabelsNestedInput>;
  user?: InputMaybe<UserUpdateManyWithoutAccessLabelsNestedInput>;
  workspace?: InputMaybe<WorkspaceUpdateOneWithoutAccessLabelsNestedInput>;
};

export type AccessLabelUpdateWithoutBookingsInput = {
  adBoards?: InputMaybe<AdBoardUpdateManyWithoutAccessLabelsNestedInput>;
  label?: InputMaybe<Scalars['String']>;
  playlists?: InputMaybe<PlaylistUpdateManyWithoutAccessLabelsNestedInput>;
  user?: InputMaybe<UserUpdateManyWithoutAccessLabelsNestedInput>;
  workspace?: InputMaybe<WorkspaceUpdateOneWithoutAccessLabelsNestedInput>;
};

export type AccessLabelUpdateWithoutPlaylistsInput = {
  adBoards?: InputMaybe<AdBoardUpdateManyWithoutAccessLabelsNestedInput>;
  bookings?: InputMaybe<BookingUpdateManyWithoutAccessLabelsNestedInput>;
  label?: InputMaybe<Scalars['String']>;
  user?: InputMaybe<UserUpdateManyWithoutAccessLabelsNestedInput>;
  workspace?: InputMaybe<WorkspaceUpdateOneWithoutAccessLabelsNestedInput>;
};

export type AccessLabelUpdateWithoutUserInput = {
  adBoards?: InputMaybe<AdBoardUpdateManyWithoutAccessLabelsNestedInput>;
  bookings?: InputMaybe<BookingUpdateManyWithoutAccessLabelsNestedInput>;
  label?: InputMaybe<Scalars['String']>;
  playlists?: InputMaybe<PlaylistUpdateManyWithoutAccessLabelsNestedInput>;
  workspace?: InputMaybe<WorkspaceUpdateOneWithoutAccessLabelsNestedInput>;
};

export type AccessLabelUpdateWithoutWorkspaceInput = {
  adBoards?: InputMaybe<AdBoardUpdateManyWithoutAccessLabelsNestedInput>;
  bookings?: InputMaybe<BookingUpdateManyWithoutAccessLabelsNestedInput>;
  label?: InputMaybe<Scalars['String']>;
  playlists?: InputMaybe<PlaylistUpdateManyWithoutAccessLabelsNestedInput>;
  user?: InputMaybe<UserUpdateManyWithoutAccessLabelsNestedInput>;
};

export type AccessLabelUpsertWithWhereUniqueWithoutAdBoardsInput = {
  create: AccessLabelCreateWithoutAdBoardsInput;
  update: AccessLabelUpdateWithoutAdBoardsInput;
  where: AccessLabelWhereUniqueInput;
};

export type AccessLabelUpsertWithWhereUniqueWithoutBookingsInput = {
  create: AccessLabelCreateWithoutBookingsInput;
  update: AccessLabelUpdateWithoutBookingsInput;
  where: AccessLabelWhereUniqueInput;
};

export type AccessLabelUpsertWithWhereUniqueWithoutPlaylistsInput = {
  create: AccessLabelCreateWithoutPlaylistsInput;
  update: AccessLabelUpdateWithoutPlaylistsInput;
  where: AccessLabelWhereUniqueInput;
};

export type AccessLabelUpsertWithWhereUniqueWithoutUserInput = {
  create: AccessLabelCreateWithoutUserInput;
  update: AccessLabelUpdateWithoutUserInput;
  where: AccessLabelWhereUniqueInput;
};

export type AccessLabelUpsertWithWhereUniqueWithoutWorkspaceInput = {
  create: AccessLabelCreateWithoutWorkspaceInput;
  update: AccessLabelUpdateWithoutWorkspaceInput;
  where: AccessLabelWhereUniqueInput;
};

export type AccessLabelWhereInput = {
  AND?: InputMaybe<Array<AccessLabelWhereInput>>;
  NOT?: InputMaybe<Array<AccessLabelWhereInput>>;
  OR?: InputMaybe<Array<AccessLabelWhereInput>>;
  adBoardIDs?: InputMaybe<StringNullableListFilter>;
  adBoards?: InputMaybe<AdBoardListRelationFilter>;
  bookingIDs?: InputMaybe<StringNullableListFilter>;
  bookings?: InputMaybe<BookingListRelationFilter>;
  id?: InputMaybe<StringFilter>;
  label?: InputMaybe<StringFilter>;
  playlistIDs?: InputMaybe<StringNullableListFilter>;
  playlists?: InputMaybe<PlaylistListRelationFilter>;
  user?: InputMaybe<UserListRelationFilter>;
  userID?: InputMaybe<StringNullableListFilter>;
  workspace?: InputMaybe<WorkspaceNullableRelationFilter>;
  workspaceId?: InputMaybe<StringNullableFilter>;
};

export type AccessLabelWhereUniqueInput = {
  AND?: InputMaybe<Array<AccessLabelWhereInput>>;
  NOT?: InputMaybe<Array<AccessLabelWhereInput>>;
  OR?: InputMaybe<Array<AccessLabelWhereInput>>;
  adBoardIDs?: InputMaybe<StringNullableListFilter>;
  adBoards?: InputMaybe<AdBoardListRelationFilter>;
  bookingIDs?: InputMaybe<StringNullableListFilter>;
  bookings?: InputMaybe<BookingListRelationFilter>;
  id?: InputMaybe<Scalars['String']>;
  label?: InputMaybe<StringFilter>;
  label_workspaceId?: InputMaybe<AccessLabelLabelWorkspaceIdCompoundUniqueInput>;
  playlistIDs?: InputMaybe<StringNullableListFilter>;
  playlists?: InputMaybe<PlaylistListRelationFilter>;
  user?: InputMaybe<UserListRelationFilter>;
  userID?: InputMaybe<StringNullableListFilter>;
  workspace?: InputMaybe<WorkspaceNullableRelationFilter>;
  workspaceId?: InputMaybe<StringNullableFilter>;
};

export type AccountDetails = {
  displayName: Scalars['String'];
  password: Scalars['String'];
  phoneNumber: Scalars['String'];
};

export type AdBoard = {
  __typename?: 'AdBoard';
  _count?: Maybe<AdBoardCount>;
  aboutSpecifications: Array<Specification>;
  accessLabels: Array<AccessLabel>;
  accessLabelsIDs: Array<Scalars['String']>;
  adBoardGroup: AdBoardGroup;
  adBoardGroupId: Scalars['String'];
  address: Scalars['String'];
  alias?: Maybe<Scalars['String']>;
  bookedSlots: Array<Slot>;
  bookings: Array<Booking>;
  category?: Maybe<BusinessCategory>;
  categoryId?: Maybe<Scalars['String']>;
  city?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  createdBy?: Maybe<User>;
  createdByUserId?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  featuredImage?: Maybe<Scalars['String']>;
  galleryImgs: Array<Scalars['String']>;
  href?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  map: Map;
  notes: Array<Scalars['String']>;
  orders: Array<Order>;
  playbackTimes: Array<PlaybackTime>;
  pricePerDay: Scalars['Int'];
  resolution?: Maybe<Resolution>;
  restrictedBusines: Array<BusinessCategory>;
  restrictedBusinessIds: Array<Scalars['String']>;
  screenSize?: Maybe<ScreenSize>;
  slots?: Maybe<Scalars['String']>;
  /** @dperecated Use `targetAudiences` instead. */
  specifications: Array<Specification>;
  state?: Maybe<Scalars['String']>;
  status: AdBoardStatus;
  tags: Array<Scalars['String']>;
  targetAudiences: Array<Scalars['String']>;
  title: Scalars['String'];
  type?: Maybe<ScreenType>;
  visible: Scalars['Boolean'];
  workspace: Workspace;
  workspaceId: Scalars['String'];
};


export type AdBoardAccessLabelsArgs = {
  cursor?: InputMaybe<AccessLabelWhereUniqueInput>;
  distinct?: InputMaybe<Array<AccessLabelScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<AccessLabelOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<AccessLabelWhereInput>;
};


export type AdBoardBookedSlotsArgs = {
  cursor?: InputMaybe<SlotWhereUniqueInput>;
  distinct?: InputMaybe<Array<SlotScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<SlotOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<SlotWhereInput>;
};


export type AdBoardBookingsArgs = {
  cursor?: InputMaybe<BookingWhereUniqueInput>;
  distinct?: InputMaybe<Array<BookingScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<BookingOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<BookingWhereInput>;
};


export type AdBoardCategoryArgs = {
  where?: InputMaybe<BusinessCategoryWhereInput>;
};


export type AdBoardCreatedByArgs = {
  where?: InputMaybe<UserWhereInput>;
};


export type AdBoardOrdersArgs = {
  cursor?: InputMaybe<OrderWhereUniqueInput>;
  distinct?: InputMaybe<Array<OrderScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<OrderOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<OrderWhereInput>;
};


export type AdBoardRestrictedBusinesArgs = {
  cursor?: InputMaybe<BusinessCategoryWhereUniqueInput>;
  distinct?: InputMaybe<Array<BusinessCategoryScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<BusinessCategoryOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<BusinessCategoryWhereInput>;
};

export type AdBoardAvgAggregate = {
  __typename?: 'AdBoardAvgAggregate';
  pricePerDay?: Maybe<Scalars['Float']>;
};

export type AdBoardAvgOrderByAggregateInput = {
  pricePerDay?: InputMaybe<SortOrder>;
};

export type AdBoardCount = {
  __typename?: 'AdBoardCount';
  accessLabels: Scalars['Int'];
  bookedSlots: Scalars['Int'];
  bookings: Scalars['Int'];
  orders: Scalars['Int'];
  restrictedBusines: Scalars['Int'];
};


export type AdBoardCountAccessLabelsArgs = {
  where?: InputMaybe<AccessLabelWhereInput>;
};


export type AdBoardCountBookedSlotsArgs = {
  where?: InputMaybe<SlotWhereInput>;
};


export type AdBoardCountBookingsArgs = {
  where?: InputMaybe<BookingWhereInput>;
};


export type AdBoardCountOrdersArgs = {
  where?: InputMaybe<OrderWhereInput>;
};


export type AdBoardCountRestrictedBusinesArgs = {
  where?: InputMaybe<BusinessCategoryWhereInput>;
};

export type AdBoardCountAggregate = {
  __typename?: 'AdBoardCountAggregate';
  _all: Scalars['Int'];
  accessLabelsIDs: Scalars['Int'];
  adBoardGroupId: Scalars['Int'];
  address: Scalars['Int'];
  alias: Scalars['Int'];
  categoryId: Scalars['Int'];
  city: Scalars['Int'];
  country: Scalars['Int'];
  createdAt: Scalars['Int'];
  createdByUserId: Scalars['Int'];
  description: Scalars['Int'];
  featuredImage: Scalars['Int'];
  galleryImgs: Scalars['Int'];
  href: Scalars['Int'];
  id: Scalars['Int'];
  notes: Scalars['Int'];
  pricePerDay: Scalars['Int'];
  restrictedBusinessIds: Scalars['Int'];
  slots: Scalars['Int'];
  state: Scalars['Int'];
  status: Scalars['Int'];
  tags: Scalars['Int'];
  targetAudiences: Scalars['Int'];
  title: Scalars['Int'];
  visible: Scalars['Int'];
  workspaceId: Scalars['Int'];
};

export type AdBoardCountOrderByAggregateInput = {
  accessLabelsIDs?: InputMaybe<SortOrder>;
  adBoardGroupId?: InputMaybe<SortOrder>;
  address?: InputMaybe<SortOrder>;
  alias?: InputMaybe<SortOrder>;
  categoryId?: InputMaybe<SortOrder>;
  city?: InputMaybe<SortOrder>;
  country?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  createdByUserId?: InputMaybe<SortOrder>;
  description?: InputMaybe<SortOrder>;
  featuredImage?: InputMaybe<SortOrder>;
  galleryImgs?: InputMaybe<SortOrder>;
  href?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  notes?: InputMaybe<SortOrder>;
  pricePerDay?: InputMaybe<SortOrder>;
  restrictedBusinessIds?: InputMaybe<SortOrder>;
  slots?: InputMaybe<SortOrder>;
  state?: InputMaybe<SortOrder>;
  status?: InputMaybe<SortOrder>;
  tags?: InputMaybe<SortOrder>;
  targetAudiences?: InputMaybe<SortOrder>;
  title?: InputMaybe<SortOrder>;
  visible?: InputMaybe<SortOrder>;
  workspaceId?: InputMaybe<SortOrder>;
};

export type AdBoardCreateInput = {
  aboutSpecifications?: InputMaybe<Array<SpecificationCreateInput>>;
  accessLabels?: InputMaybe<AccessLabelCreateNestedManyWithoutAdBoardsInput>;
  adBoardGroup: AdBoardGroupCreateNestedOneWithoutAdBoardInput;
  address: Scalars['String'];
  alias?: InputMaybe<Scalars['String']>;
  bookedSlots?: InputMaybe<SlotCreateNestedManyWithoutAdBoardInput>;
  bookings?: InputMaybe<BookingCreateNestedManyWithoutAdBoardInput>;
  category?: InputMaybe<BusinessCategoryCreateNestedOneWithoutAdBoardsInput>;
  city?: InputMaybe<Scalars['String']>;
  country?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  createdBy?: InputMaybe<UserCreateNestedOneWithoutAdBoardsInput>;
  description?: InputMaybe<Scalars['String']>;
  featuredImage?: InputMaybe<Scalars['String']>;
  galleryImgs?: InputMaybe<Array<Scalars['String']>>;
  href?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  map: MapCreateInput;
  notes?: InputMaybe<Array<Scalars['String']>>;
  orders?: InputMaybe<OrderCreateNestedManyWithoutAdBoardInput>;
  playbackTimes?: InputMaybe<Array<PlaybackTimeCreateInput>>;
  pricePerDay: Scalars['Int'];
  resolution?: InputMaybe<ResolutionCreateInput>;
  restrictedBusines?: InputMaybe<BusinessCategoryCreateNestedManyWithoutRestrictedByAdBoardsInput>;
  screenSize?: InputMaybe<ScreenSizeCreateInput>;
  slots?: InputMaybe<Scalars['String']>;
  specifications?: InputMaybe<Array<SpecificationCreateInput>>;
  state?: InputMaybe<Scalars['String']>;
  status: AdBoardStatus;
  tags?: InputMaybe<Array<Scalars['String']>>;
  targetAudiences?: InputMaybe<Array<Scalars['String']>>;
  title: Scalars['String'];
  type?: InputMaybe<ScreenTypeCreateInput>;
  visible?: InputMaybe<Scalars['Boolean']>;
  workspace: WorkspaceCreateNestedOneWithoutAdBoardsInput;
};

export type AdBoardCreateManyCategoryInput = {
  aboutSpecifications?: InputMaybe<Array<SpecificationCreateInput>>;
  accessLabelsIDs?: InputMaybe<Array<Scalars['String']>>;
  adBoardGroupId: Scalars['String'];
  address: Scalars['String'];
  alias?: InputMaybe<Scalars['String']>;
  city?: InputMaybe<Scalars['String']>;
  country?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  createdByUserId?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  featuredImage?: InputMaybe<Scalars['String']>;
  galleryImgs?: InputMaybe<Array<Scalars['String']>>;
  href?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  map: MapCreateInput;
  notes?: InputMaybe<Array<Scalars['String']>>;
  playbackTimes?: InputMaybe<Array<PlaybackTimeCreateInput>>;
  pricePerDay: Scalars['Int'];
  resolution?: InputMaybe<ResolutionCreateInput>;
  restrictedBusinessIds?: InputMaybe<Array<Scalars['String']>>;
  screenSize?: InputMaybe<ScreenSizeCreateInput>;
  slots?: InputMaybe<Scalars['String']>;
  specifications?: InputMaybe<Array<SpecificationCreateInput>>;
  state?: InputMaybe<Scalars['String']>;
  status: AdBoardStatus;
  tags?: InputMaybe<Array<Scalars['String']>>;
  targetAudiences?: InputMaybe<Array<Scalars['String']>>;
  title: Scalars['String'];
  type?: InputMaybe<ScreenTypeCreateInput>;
  visible?: InputMaybe<Scalars['Boolean']>;
  workspaceId: Scalars['String'];
};

export type AdBoardCreateManyCategoryInputEnvelope = {
  data: Array<AdBoardCreateManyCategoryInput>;
};

export type AdBoardCreateManyCreatedByInput = {
  aboutSpecifications?: InputMaybe<Array<SpecificationCreateInput>>;
  accessLabelsIDs?: InputMaybe<Array<Scalars['String']>>;
  adBoardGroupId: Scalars['String'];
  address: Scalars['String'];
  alias?: InputMaybe<Scalars['String']>;
  categoryId?: InputMaybe<Scalars['String']>;
  city?: InputMaybe<Scalars['String']>;
  country?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  description?: InputMaybe<Scalars['String']>;
  featuredImage?: InputMaybe<Scalars['String']>;
  galleryImgs?: InputMaybe<Array<Scalars['String']>>;
  href?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  map: MapCreateInput;
  notes?: InputMaybe<Array<Scalars['String']>>;
  playbackTimes?: InputMaybe<Array<PlaybackTimeCreateInput>>;
  pricePerDay: Scalars['Int'];
  resolution?: InputMaybe<ResolutionCreateInput>;
  restrictedBusinessIds?: InputMaybe<Array<Scalars['String']>>;
  screenSize?: InputMaybe<ScreenSizeCreateInput>;
  slots?: InputMaybe<Scalars['String']>;
  specifications?: InputMaybe<Array<SpecificationCreateInput>>;
  state?: InputMaybe<Scalars['String']>;
  status: AdBoardStatus;
  tags?: InputMaybe<Array<Scalars['String']>>;
  targetAudiences?: InputMaybe<Array<Scalars['String']>>;
  title: Scalars['String'];
  type?: InputMaybe<ScreenTypeCreateInput>;
  visible?: InputMaybe<Scalars['Boolean']>;
  workspaceId: Scalars['String'];
};

export type AdBoardCreateManyCreatedByInputEnvelope = {
  data: Array<AdBoardCreateManyCreatedByInput>;
};

export type AdBoardCreateManyInput = {
  aboutSpecifications?: InputMaybe<Array<SpecificationCreateInput>>;
  accessLabelsIDs?: InputMaybe<Array<Scalars['String']>>;
  adBoardGroupId: Scalars['String'];
  address: Scalars['String'];
  alias?: InputMaybe<Scalars['String']>;
  categoryId?: InputMaybe<Scalars['String']>;
  city?: InputMaybe<Scalars['String']>;
  country?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  createdByUserId?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  featuredImage?: InputMaybe<Scalars['String']>;
  galleryImgs?: InputMaybe<Array<Scalars['String']>>;
  href?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  map: MapCreateInput;
  notes?: InputMaybe<Array<Scalars['String']>>;
  playbackTimes?: InputMaybe<Array<PlaybackTimeCreateInput>>;
  pricePerDay: Scalars['Int'];
  resolution?: InputMaybe<ResolutionCreateInput>;
  restrictedBusinessIds?: InputMaybe<Array<Scalars['String']>>;
  screenSize?: InputMaybe<ScreenSizeCreateInput>;
  slots?: InputMaybe<Scalars['String']>;
  specifications?: InputMaybe<Array<SpecificationCreateInput>>;
  state?: InputMaybe<Scalars['String']>;
  status: AdBoardStatus;
  tags?: InputMaybe<Array<Scalars['String']>>;
  targetAudiences?: InputMaybe<Array<Scalars['String']>>;
  title: Scalars['String'];
  type?: InputMaybe<ScreenTypeCreateInput>;
  visible?: InputMaybe<Scalars['Boolean']>;
  workspaceId: Scalars['String'];
};

export type AdBoardCreateManyWorkspaceInput = {
  aboutSpecifications?: InputMaybe<Array<SpecificationCreateInput>>;
  accessLabelsIDs?: InputMaybe<Array<Scalars['String']>>;
  adBoardGroupId: Scalars['String'];
  address: Scalars['String'];
  alias?: InputMaybe<Scalars['String']>;
  categoryId?: InputMaybe<Scalars['String']>;
  city?: InputMaybe<Scalars['String']>;
  country?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  createdByUserId?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  featuredImage?: InputMaybe<Scalars['String']>;
  galleryImgs?: InputMaybe<Array<Scalars['String']>>;
  href?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  map: MapCreateInput;
  notes?: InputMaybe<Array<Scalars['String']>>;
  playbackTimes?: InputMaybe<Array<PlaybackTimeCreateInput>>;
  pricePerDay: Scalars['Int'];
  resolution?: InputMaybe<ResolutionCreateInput>;
  restrictedBusinessIds?: InputMaybe<Array<Scalars['String']>>;
  screenSize?: InputMaybe<ScreenSizeCreateInput>;
  slots?: InputMaybe<Scalars['String']>;
  specifications?: InputMaybe<Array<SpecificationCreateInput>>;
  state?: InputMaybe<Scalars['String']>;
  status: AdBoardStatus;
  tags?: InputMaybe<Array<Scalars['String']>>;
  targetAudiences?: InputMaybe<Array<Scalars['String']>>;
  title: Scalars['String'];
  type?: InputMaybe<ScreenTypeCreateInput>;
  visible?: InputMaybe<Scalars['Boolean']>;
};

export type AdBoardCreateManyWorkspaceInputEnvelope = {
  data: Array<AdBoardCreateManyWorkspaceInput>;
};

export type AdBoardCreateNestedManyWithoutAccessLabelsInput = {
  connect?: InputMaybe<Array<AdBoardWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<AdBoardCreateOrConnectWithoutAccessLabelsInput>>;
  create?: InputMaybe<Array<AdBoardCreateWithoutAccessLabelsInput>>;
};

export type AdBoardCreateNestedManyWithoutCategoryInput = {
  connect?: InputMaybe<Array<AdBoardWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<AdBoardCreateOrConnectWithoutCategoryInput>>;
  create?: InputMaybe<Array<AdBoardCreateWithoutCategoryInput>>;
  createMany?: InputMaybe<AdBoardCreateManyCategoryInputEnvelope>;
};

export type AdBoardCreateNestedManyWithoutCreatedByInput = {
  connect?: InputMaybe<Array<AdBoardWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<AdBoardCreateOrConnectWithoutCreatedByInput>>;
  create?: InputMaybe<Array<AdBoardCreateWithoutCreatedByInput>>;
  createMany?: InputMaybe<AdBoardCreateManyCreatedByInputEnvelope>;
};

export type AdBoardCreateNestedManyWithoutRestrictedBusinesInput = {
  connect?: InputMaybe<Array<AdBoardWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<AdBoardCreateOrConnectWithoutRestrictedBusinesInput>>;
  create?: InputMaybe<Array<AdBoardCreateWithoutRestrictedBusinesInput>>;
};

export type AdBoardCreateNestedManyWithoutWorkspaceInput = {
  connect?: InputMaybe<Array<AdBoardWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<AdBoardCreateOrConnectWithoutWorkspaceInput>>;
  create?: InputMaybe<Array<AdBoardCreateWithoutWorkspaceInput>>;
  createMany?: InputMaybe<AdBoardCreateManyWorkspaceInputEnvelope>;
};

export type AdBoardCreateNestedOneWithoutAdBoardGroupInput = {
  connect?: InputMaybe<AdBoardWhereUniqueInput>;
  connectOrCreate?: InputMaybe<AdBoardCreateOrConnectWithoutAdBoardGroupInput>;
  create?: InputMaybe<AdBoardCreateWithoutAdBoardGroupInput>;
};

export type AdBoardCreateNestedOneWithoutBookedSlotsInput = {
  connect?: InputMaybe<AdBoardWhereUniqueInput>;
  connectOrCreate?: InputMaybe<AdBoardCreateOrConnectWithoutBookedSlotsInput>;
  create?: InputMaybe<AdBoardCreateWithoutBookedSlotsInput>;
};

export type AdBoardCreateNestedOneWithoutBookingsInput = {
  connect?: InputMaybe<AdBoardWhereUniqueInput>;
  connectOrCreate?: InputMaybe<AdBoardCreateOrConnectWithoutBookingsInput>;
  create?: InputMaybe<AdBoardCreateWithoutBookingsInput>;
};

export type AdBoardCreateNestedOneWithoutOrdersInput = {
  connect?: InputMaybe<AdBoardWhereUniqueInput>;
  connectOrCreate?: InputMaybe<AdBoardCreateOrConnectWithoutOrdersInput>;
  create?: InputMaybe<AdBoardCreateWithoutOrdersInput>;
};

export type AdBoardCreateOrConnectWithoutAccessLabelsInput = {
  create: AdBoardCreateWithoutAccessLabelsInput;
  where: AdBoardWhereUniqueInput;
};

export type AdBoardCreateOrConnectWithoutAdBoardGroupInput = {
  create: AdBoardCreateWithoutAdBoardGroupInput;
  where: AdBoardWhereUniqueInput;
};

export type AdBoardCreateOrConnectWithoutBookedSlotsInput = {
  create: AdBoardCreateWithoutBookedSlotsInput;
  where: AdBoardWhereUniqueInput;
};

export type AdBoardCreateOrConnectWithoutBookingsInput = {
  create: AdBoardCreateWithoutBookingsInput;
  where: AdBoardWhereUniqueInput;
};

export type AdBoardCreateOrConnectWithoutCategoryInput = {
  create: AdBoardCreateWithoutCategoryInput;
  where: AdBoardWhereUniqueInput;
};

export type AdBoardCreateOrConnectWithoutCreatedByInput = {
  create: AdBoardCreateWithoutCreatedByInput;
  where: AdBoardWhereUniqueInput;
};

export type AdBoardCreateOrConnectWithoutOrdersInput = {
  create: AdBoardCreateWithoutOrdersInput;
  where: AdBoardWhereUniqueInput;
};

export type AdBoardCreateOrConnectWithoutRestrictedBusinesInput = {
  create: AdBoardCreateWithoutRestrictedBusinesInput;
  where: AdBoardWhereUniqueInput;
};

export type AdBoardCreateOrConnectWithoutWorkspaceInput = {
  create: AdBoardCreateWithoutWorkspaceInput;
  where: AdBoardWhereUniqueInput;
};

export type AdBoardCreateWithoutAccessLabelsInput = {
  aboutSpecifications?: InputMaybe<Array<SpecificationCreateInput>>;
  adBoardGroup: AdBoardGroupCreateNestedOneWithoutAdBoardInput;
  address: Scalars['String'];
  alias?: InputMaybe<Scalars['String']>;
  bookedSlots?: InputMaybe<SlotCreateNestedManyWithoutAdBoardInput>;
  bookings?: InputMaybe<BookingCreateNestedManyWithoutAdBoardInput>;
  category?: InputMaybe<BusinessCategoryCreateNestedOneWithoutAdBoardsInput>;
  city?: InputMaybe<Scalars['String']>;
  country?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  createdBy?: InputMaybe<UserCreateNestedOneWithoutAdBoardsInput>;
  description?: InputMaybe<Scalars['String']>;
  featuredImage?: InputMaybe<Scalars['String']>;
  galleryImgs?: InputMaybe<Array<Scalars['String']>>;
  href?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  map: MapCreateInput;
  notes?: InputMaybe<Array<Scalars['String']>>;
  orders?: InputMaybe<OrderCreateNestedManyWithoutAdBoardInput>;
  playbackTimes?: InputMaybe<Array<PlaybackTimeCreateInput>>;
  pricePerDay: Scalars['Int'];
  resolution?: InputMaybe<ResolutionCreateInput>;
  restrictedBusines?: InputMaybe<BusinessCategoryCreateNestedManyWithoutRestrictedByAdBoardsInput>;
  screenSize?: InputMaybe<ScreenSizeCreateInput>;
  slots?: InputMaybe<Scalars['String']>;
  specifications?: InputMaybe<Array<SpecificationCreateInput>>;
  state?: InputMaybe<Scalars['String']>;
  status: AdBoardStatus;
  tags?: InputMaybe<Array<Scalars['String']>>;
  targetAudiences?: InputMaybe<Array<Scalars['String']>>;
  title: Scalars['String'];
  type?: InputMaybe<ScreenTypeCreateInput>;
  visible?: InputMaybe<Scalars['Boolean']>;
  workspace: WorkspaceCreateNestedOneWithoutAdBoardsInput;
};

export type AdBoardCreateWithoutAdBoardGroupInput = {
  aboutSpecifications?: InputMaybe<Array<SpecificationCreateInput>>;
  accessLabels?: InputMaybe<AccessLabelCreateNestedManyWithoutAdBoardsInput>;
  address: Scalars['String'];
  alias?: InputMaybe<Scalars['String']>;
  bookedSlots?: InputMaybe<SlotCreateNestedManyWithoutAdBoardInput>;
  bookings?: InputMaybe<BookingCreateNestedManyWithoutAdBoardInput>;
  category?: InputMaybe<BusinessCategoryCreateNestedOneWithoutAdBoardsInput>;
  city?: InputMaybe<Scalars['String']>;
  country?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  createdBy?: InputMaybe<UserCreateNestedOneWithoutAdBoardsInput>;
  description?: InputMaybe<Scalars['String']>;
  featuredImage?: InputMaybe<Scalars['String']>;
  galleryImgs?: InputMaybe<Array<Scalars['String']>>;
  href?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  map: MapCreateInput;
  notes?: InputMaybe<Array<Scalars['String']>>;
  orders?: InputMaybe<OrderCreateNestedManyWithoutAdBoardInput>;
  playbackTimes?: InputMaybe<Array<PlaybackTimeCreateInput>>;
  pricePerDay: Scalars['Int'];
  resolution?: InputMaybe<ResolutionCreateInput>;
  restrictedBusines?: InputMaybe<BusinessCategoryCreateNestedManyWithoutRestrictedByAdBoardsInput>;
  screenSize?: InputMaybe<ScreenSizeCreateInput>;
  slots?: InputMaybe<Scalars['String']>;
  specifications?: InputMaybe<Array<SpecificationCreateInput>>;
  state?: InputMaybe<Scalars['String']>;
  status: AdBoardStatus;
  tags?: InputMaybe<Array<Scalars['String']>>;
  targetAudiences?: InputMaybe<Array<Scalars['String']>>;
  title: Scalars['String'];
  type?: InputMaybe<ScreenTypeCreateInput>;
  visible?: InputMaybe<Scalars['Boolean']>;
  workspace: WorkspaceCreateNestedOneWithoutAdBoardsInput;
};

export type AdBoardCreateWithoutBookedSlotsInput = {
  aboutSpecifications?: InputMaybe<Array<SpecificationCreateInput>>;
  accessLabels?: InputMaybe<AccessLabelCreateNestedManyWithoutAdBoardsInput>;
  adBoardGroup: AdBoardGroupCreateNestedOneWithoutAdBoardInput;
  address: Scalars['String'];
  alias?: InputMaybe<Scalars['String']>;
  bookings?: InputMaybe<BookingCreateNestedManyWithoutAdBoardInput>;
  category?: InputMaybe<BusinessCategoryCreateNestedOneWithoutAdBoardsInput>;
  city?: InputMaybe<Scalars['String']>;
  country?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  createdBy?: InputMaybe<UserCreateNestedOneWithoutAdBoardsInput>;
  description?: InputMaybe<Scalars['String']>;
  featuredImage?: InputMaybe<Scalars['String']>;
  galleryImgs?: InputMaybe<Array<Scalars['String']>>;
  href?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  map: MapCreateInput;
  notes?: InputMaybe<Array<Scalars['String']>>;
  orders?: InputMaybe<OrderCreateNestedManyWithoutAdBoardInput>;
  playbackTimes?: InputMaybe<Array<PlaybackTimeCreateInput>>;
  pricePerDay: Scalars['Int'];
  resolution?: InputMaybe<ResolutionCreateInput>;
  restrictedBusines?: InputMaybe<BusinessCategoryCreateNestedManyWithoutRestrictedByAdBoardsInput>;
  screenSize?: InputMaybe<ScreenSizeCreateInput>;
  slots?: InputMaybe<Scalars['String']>;
  specifications?: InputMaybe<Array<SpecificationCreateInput>>;
  state?: InputMaybe<Scalars['String']>;
  status: AdBoardStatus;
  tags?: InputMaybe<Array<Scalars['String']>>;
  targetAudiences?: InputMaybe<Array<Scalars['String']>>;
  title: Scalars['String'];
  type?: InputMaybe<ScreenTypeCreateInput>;
  visible?: InputMaybe<Scalars['Boolean']>;
  workspace: WorkspaceCreateNestedOneWithoutAdBoardsInput;
};

export type AdBoardCreateWithoutBookingsInput = {
  aboutSpecifications?: InputMaybe<Array<SpecificationCreateInput>>;
  accessLabels?: InputMaybe<AccessLabelCreateNestedManyWithoutAdBoardsInput>;
  adBoardGroup: AdBoardGroupCreateNestedOneWithoutAdBoardInput;
  address: Scalars['String'];
  alias?: InputMaybe<Scalars['String']>;
  bookedSlots?: InputMaybe<SlotCreateNestedManyWithoutAdBoardInput>;
  category?: InputMaybe<BusinessCategoryCreateNestedOneWithoutAdBoardsInput>;
  city?: InputMaybe<Scalars['String']>;
  country?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  createdBy?: InputMaybe<UserCreateNestedOneWithoutAdBoardsInput>;
  description?: InputMaybe<Scalars['String']>;
  featuredImage?: InputMaybe<Scalars['String']>;
  galleryImgs?: InputMaybe<Array<Scalars['String']>>;
  href?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  map: MapCreateInput;
  notes?: InputMaybe<Array<Scalars['String']>>;
  orders?: InputMaybe<OrderCreateNestedManyWithoutAdBoardInput>;
  playbackTimes?: InputMaybe<Array<PlaybackTimeCreateInput>>;
  pricePerDay: Scalars['Int'];
  resolution?: InputMaybe<ResolutionCreateInput>;
  restrictedBusines?: InputMaybe<BusinessCategoryCreateNestedManyWithoutRestrictedByAdBoardsInput>;
  screenSize?: InputMaybe<ScreenSizeCreateInput>;
  slots?: InputMaybe<Scalars['String']>;
  specifications?: InputMaybe<Array<SpecificationCreateInput>>;
  state?: InputMaybe<Scalars['String']>;
  status: AdBoardStatus;
  tags?: InputMaybe<Array<Scalars['String']>>;
  targetAudiences?: InputMaybe<Array<Scalars['String']>>;
  title: Scalars['String'];
  type?: InputMaybe<ScreenTypeCreateInput>;
  visible?: InputMaybe<Scalars['Boolean']>;
  workspace: WorkspaceCreateNestedOneWithoutAdBoardsInput;
};

export type AdBoardCreateWithoutCategoryInput = {
  aboutSpecifications?: InputMaybe<Array<SpecificationCreateInput>>;
  accessLabels?: InputMaybe<AccessLabelCreateNestedManyWithoutAdBoardsInput>;
  adBoardGroup: AdBoardGroupCreateNestedOneWithoutAdBoardInput;
  address: Scalars['String'];
  alias?: InputMaybe<Scalars['String']>;
  bookedSlots?: InputMaybe<SlotCreateNestedManyWithoutAdBoardInput>;
  bookings?: InputMaybe<BookingCreateNestedManyWithoutAdBoardInput>;
  city?: InputMaybe<Scalars['String']>;
  country?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  createdBy?: InputMaybe<UserCreateNestedOneWithoutAdBoardsInput>;
  description?: InputMaybe<Scalars['String']>;
  featuredImage?: InputMaybe<Scalars['String']>;
  galleryImgs?: InputMaybe<Array<Scalars['String']>>;
  href?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  map: MapCreateInput;
  notes?: InputMaybe<Array<Scalars['String']>>;
  orders?: InputMaybe<OrderCreateNestedManyWithoutAdBoardInput>;
  playbackTimes?: InputMaybe<Array<PlaybackTimeCreateInput>>;
  pricePerDay: Scalars['Int'];
  resolution?: InputMaybe<ResolutionCreateInput>;
  restrictedBusines?: InputMaybe<BusinessCategoryCreateNestedManyWithoutRestrictedByAdBoardsInput>;
  screenSize?: InputMaybe<ScreenSizeCreateInput>;
  slots?: InputMaybe<Scalars['String']>;
  specifications?: InputMaybe<Array<SpecificationCreateInput>>;
  state?: InputMaybe<Scalars['String']>;
  status: AdBoardStatus;
  tags?: InputMaybe<Array<Scalars['String']>>;
  targetAudiences?: InputMaybe<Array<Scalars['String']>>;
  title: Scalars['String'];
  type?: InputMaybe<ScreenTypeCreateInput>;
  visible?: InputMaybe<Scalars['Boolean']>;
  workspace: WorkspaceCreateNestedOneWithoutAdBoardsInput;
};

export type AdBoardCreateWithoutCreatedByInput = {
  aboutSpecifications?: InputMaybe<Array<SpecificationCreateInput>>;
  accessLabels?: InputMaybe<AccessLabelCreateNestedManyWithoutAdBoardsInput>;
  adBoardGroup: AdBoardGroupCreateNestedOneWithoutAdBoardInput;
  address: Scalars['String'];
  alias?: InputMaybe<Scalars['String']>;
  bookedSlots?: InputMaybe<SlotCreateNestedManyWithoutAdBoardInput>;
  bookings?: InputMaybe<BookingCreateNestedManyWithoutAdBoardInput>;
  category?: InputMaybe<BusinessCategoryCreateNestedOneWithoutAdBoardsInput>;
  city?: InputMaybe<Scalars['String']>;
  country?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  description?: InputMaybe<Scalars['String']>;
  featuredImage?: InputMaybe<Scalars['String']>;
  galleryImgs?: InputMaybe<Array<Scalars['String']>>;
  href?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  map: MapCreateInput;
  notes?: InputMaybe<Array<Scalars['String']>>;
  orders?: InputMaybe<OrderCreateNestedManyWithoutAdBoardInput>;
  playbackTimes?: InputMaybe<Array<PlaybackTimeCreateInput>>;
  pricePerDay: Scalars['Int'];
  resolution?: InputMaybe<ResolutionCreateInput>;
  restrictedBusines?: InputMaybe<BusinessCategoryCreateNestedManyWithoutRestrictedByAdBoardsInput>;
  screenSize?: InputMaybe<ScreenSizeCreateInput>;
  slots?: InputMaybe<Scalars['String']>;
  specifications?: InputMaybe<Array<SpecificationCreateInput>>;
  state?: InputMaybe<Scalars['String']>;
  status: AdBoardStatus;
  tags?: InputMaybe<Array<Scalars['String']>>;
  targetAudiences?: InputMaybe<Array<Scalars['String']>>;
  title: Scalars['String'];
  type?: InputMaybe<ScreenTypeCreateInput>;
  visible?: InputMaybe<Scalars['Boolean']>;
  workspace: WorkspaceCreateNestedOneWithoutAdBoardsInput;
};

export type AdBoardCreateWithoutOrdersInput = {
  aboutSpecifications?: InputMaybe<Array<SpecificationCreateInput>>;
  accessLabels?: InputMaybe<AccessLabelCreateNestedManyWithoutAdBoardsInput>;
  adBoardGroup: AdBoardGroupCreateNestedOneWithoutAdBoardInput;
  address: Scalars['String'];
  alias?: InputMaybe<Scalars['String']>;
  bookedSlots?: InputMaybe<SlotCreateNestedManyWithoutAdBoardInput>;
  bookings?: InputMaybe<BookingCreateNestedManyWithoutAdBoardInput>;
  category?: InputMaybe<BusinessCategoryCreateNestedOneWithoutAdBoardsInput>;
  city?: InputMaybe<Scalars['String']>;
  country?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  createdBy?: InputMaybe<UserCreateNestedOneWithoutAdBoardsInput>;
  description?: InputMaybe<Scalars['String']>;
  featuredImage?: InputMaybe<Scalars['String']>;
  galleryImgs?: InputMaybe<Array<Scalars['String']>>;
  href?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  map: MapCreateInput;
  notes?: InputMaybe<Array<Scalars['String']>>;
  playbackTimes?: InputMaybe<Array<PlaybackTimeCreateInput>>;
  pricePerDay: Scalars['Int'];
  resolution?: InputMaybe<ResolutionCreateInput>;
  restrictedBusines?: InputMaybe<BusinessCategoryCreateNestedManyWithoutRestrictedByAdBoardsInput>;
  screenSize?: InputMaybe<ScreenSizeCreateInput>;
  slots?: InputMaybe<Scalars['String']>;
  specifications?: InputMaybe<Array<SpecificationCreateInput>>;
  state?: InputMaybe<Scalars['String']>;
  status: AdBoardStatus;
  tags?: InputMaybe<Array<Scalars['String']>>;
  targetAudiences?: InputMaybe<Array<Scalars['String']>>;
  title: Scalars['String'];
  type?: InputMaybe<ScreenTypeCreateInput>;
  visible?: InputMaybe<Scalars['Boolean']>;
  workspace: WorkspaceCreateNestedOneWithoutAdBoardsInput;
};

export type AdBoardCreateWithoutRestrictedBusinesInput = {
  aboutSpecifications?: InputMaybe<Array<SpecificationCreateInput>>;
  accessLabels?: InputMaybe<AccessLabelCreateNestedManyWithoutAdBoardsInput>;
  adBoardGroup: AdBoardGroupCreateNestedOneWithoutAdBoardInput;
  address: Scalars['String'];
  alias?: InputMaybe<Scalars['String']>;
  bookedSlots?: InputMaybe<SlotCreateNestedManyWithoutAdBoardInput>;
  bookings?: InputMaybe<BookingCreateNestedManyWithoutAdBoardInput>;
  category?: InputMaybe<BusinessCategoryCreateNestedOneWithoutAdBoardsInput>;
  city?: InputMaybe<Scalars['String']>;
  country?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  createdBy?: InputMaybe<UserCreateNestedOneWithoutAdBoardsInput>;
  description?: InputMaybe<Scalars['String']>;
  featuredImage?: InputMaybe<Scalars['String']>;
  galleryImgs?: InputMaybe<Array<Scalars['String']>>;
  href?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  map: MapCreateInput;
  notes?: InputMaybe<Array<Scalars['String']>>;
  orders?: InputMaybe<OrderCreateNestedManyWithoutAdBoardInput>;
  playbackTimes?: InputMaybe<Array<PlaybackTimeCreateInput>>;
  pricePerDay: Scalars['Int'];
  resolution?: InputMaybe<ResolutionCreateInput>;
  screenSize?: InputMaybe<ScreenSizeCreateInput>;
  slots?: InputMaybe<Scalars['String']>;
  specifications?: InputMaybe<Array<SpecificationCreateInput>>;
  state?: InputMaybe<Scalars['String']>;
  status: AdBoardStatus;
  tags?: InputMaybe<Array<Scalars['String']>>;
  targetAudiences?: InputMaybe<Array<Scalars['String']>>;
  title: Scalars['String'];
  type?: InputMaybe<ScreenTypeCreateInput>;
  visible?: InputMaybe<Scalars['Boolean']>;
  workspace: WorkspaceCreateNestedOneWithoutAdBoardsInput;
};

export type AdBoardCreateWithoutWorkspaceInput = {
  aboutSpecifications?: InputMaybe<Array<SpecificationCreateInput>>;
  accessLabels?: InputMaybe<AccessLabelCreateNestedManyWithoutAdBoardsInput>;
  adBoardGroup: AdBoardGroupCreateNestedOneWithoutAdBoardInput;
  address: Scalars['String'];
  alias?: InputMaybe<Scalars['String']>;
  bookedSlots?: InputMaybe<SlotCreateNestedManyWithoutAdBoardInput>;
  bookings?: InputMaybe<BookingCreateNestedManyWithoutAdBoardInput>;
  category?: InputMaybe<BusinessCategoryCreateNestedOneWithoutAdBoardsInput>;
  city?: InputMaybe<Scalars['String']>;
  country?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  createdBy?: InputMaybe<UserCreateNestedOneWithoutAdBoardsInput>;
  description?: InputMaybe<Scalars['String']>;
  featuredImage?: InputMaybe<Scalars['String']>;
  galleryImgs?: InputMaybe<Array<Scalars['String']>>;
  href?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  map: MapCreateInput;
  notes?: InputMaybe<Array<Scalars['String']>>;
  orders?: InputMaybe<OrderCreateNestedManyWithoutAdBoardInput>;
  playbackTimes?: InputMaybe<Array<PlaybackTimeCreateInput>>;
  pricePerDay: Scalars['Int'];
  resolution?: InputMaybe<ResolutionCreateInput>;
  restrictedBusines?: InputMaybe<BusinessCategoryCreateNestedManyWithoutRestrictedByAdBoardsInput>;
  screenSize?: InputMaybe<ScreenSizeCreateInput>;
  slots?: InputMaybe<Scalars['String']>;
  specifications?: InputMaybe<Array<SpecificationCreateInput>>;
  state?: InputMaybe<Scalars['String']>;
  status: AdBoardStatus;
  tags?: InputMaybe<Array<Scalars['String']>>;
  targetAudiences?: InputMaybe<Array<Scalars['String']>>;
  title: Scalars['String'];
  type?: InputMaybe<ScreenTypeCreateInput>;
  visible?: InputMaybe<Scalars['Boolean']>;
};

export type AdBoardGroup = {
  __typename?: 'AdBoardGroup';
  _count?: Maybe<AdBoardGroupCount>;
  adBoard?: Maybe<AdBoard>;
  displayName?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  name: Scalars['String'];
  pisignageGroupId?: Maybe<Scalars['String']>;
  pisignagePlayers: Array<PiSignagePlayer>;
  playlistIDs: Array<Scalars['String']>;
  playlists: Array<Playlist>;
  schedules: Array<Schedule>;
  workspace: Workspace;
  workspaceId: Scalars['String'];
};


export type AdBoardGroupAdBoardArgs = {
  where?: InputMaybe<AdBoardWhereInput>;
};


export type AdBoardGroupPisignagePlayersArgs = {
  cursor?: InputMaybe<PiSignagePlayerWhereUniqueInput>;
  distinct?: InputMaybe<Array<PiSignagePlayerScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<PiSignagePlayerOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<PiSignagePlayerWhereInput>;
};


export type AdBoardGroupPlaylistsArgs = {
  cursor?: InputMaybe<PlaylistWhereUniqueInput>;
  distinct?: InputMaybe<Array<PlaylistScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<PlaylistOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<PlaylistWhereInput>;
};

export type AdBoardGroupBy = {
  __typename?: 'AdBoardGroupBy';
  _avg?: Maybe<AdBoardAvgAggregate>;
  _count?: Maybe<AdBoardCountAggregate>;
  _max?: Maybe<AdBoardMaxAggregate>;
  _min?: Maybe<AdBoardMinAggregate>;
  _sum?: Maybe<AdBoardSumAggregate>;
  accessLabelsIDs?: Maybe<Array<Scalars['String']>>;
  adBoardGroupId: Scalars['String'];
  address: Scalars['String'];
  alias?: Maybe<Scalars['String']>;
  categoryId?: Maybe<Scalars['String']>;
  city?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  createdByUserId?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  featuredImage?: Maybe<Scalars['String']>;
  galleryImgs?: Maybe<Array<Scalars['String']>>;
  href?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  notes?: Maybe<Array<Scalars['String']>>;
  pricePerDay: Scalars['Int'];
  restrictedBusinessIds?: Maybe<Array<Scalars['String']>>;
  slots?: Maybe<Scalars['String']>;
  state?: Maybe<Scalars['String']>;
  status: AdBoardStatus;
  tags?: Maybe<Array<Scalars['String']>>;
  targetAudiences?: Maybe<Array<Scalars['String']>>;
  title: Scalars['String'];
  visible: Scalars['Boolean'];
  workspaceId: Scalars['String'];
};

export type AdBoardGroupCount = {
  __typename?: 'AdBoardGroupCount';
  pisignagePlayers: Scalars['Int'];
  playlists: Scalars['Int'];
};


export type AdBoardGroupCountPisignagePlayersArgs = {
  where?: InputMaybe<PiSignagePlayerWhereInput>;
};


export type AdBoardGroupCountPlaylistsArgs = {
  where?: InputMaybe<PlaylistWhereInput>;
};

export type AdBoardGroupCountAggregate = {
  __typename?: 'AdBoardGroupCountAggregate';
  _all: Scalars['Int'];
  displayName: Scalars['Int'];
  id: Scalars['Int'];
  name: Scalars['Int'];
  pisignageGroupId: Scalars['Int'];
  playlistIDs: Scalars['Int'];
  workspaceId: Scalars['Int'];
};

export type AdBoardGroupCountOrderByAggregateInput = {
  displayName?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  name?: InputMaybe<SortOrder>;
  pisignageGroupId?: InputMaybe<SortOrder>;
  playlistIDs?: InputMaybe<SortOrder>;
  workspaceId?: InputMaybe<SortOrder>;
};

export type AdBoardGroupCreateInput = {
  adBoard?: InputMaybe<AdBoardCreateNestedOneWithoutAdBoardGroupInput>;
  displayName?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
  pisignageGroupId?: InputMaybe<Scalars['String']>;
  pisignagePlayers?: InputMaybe<PiSignagePlayerCreateNestedManyWithoutAdBoardGroupInput>;
  playlists?: InputMaybe<PlaylistCreateNestedManyWithoutAdBoardGroupsInput>;
  schedules?: InputMaybe<Array<ScheduleCreateInput>>;
  workspace: WorkspaceCreateNestedOneWithoutAdBoardGroupsInput;
};

export type AdBoardGroupCreateManyInput = {
  displayName?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
  pisignageGroupId?: InputMaybe<Scalars['String']>;
  playlistIDs?: InputMaybe<Array<Scalars['String']>>;
  schedules?: InputMaybe<Array<ScheduleCreateInput>>;
  workspaceId: Scalars['String'];
};

export type AdBoardGroupCreateManyWorkspaceInput = {
  displayName?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
  pisignageGroupId?: InputMaybe<Scalars['String']>;
  playlistIDs?: InputMaybe<Array<Scalars['String']>>;
  schedules?: InputMaybe<Array<ScheduleCreateInput>>;
};

export type AdBoardGroupCreateManyWorkspaceInputEnvelope = {
  data: Array<AdBoardGroupCreateManyWorkspaceInput>;
};

export type AdBoardGroupCreateNestedManyWithoutPlaylistsInput = {
  connect?: InputMaybe<Array<AdBoardGroupWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<AdBoardGroupCreateOrConnectWithoutPlaylistsInput>>;
  create?: InputMaybe<Array<AdBoardGroupCreateWithoutPlaylistsInput>>;
};

export type AdBoardGroupCreateNestedManyWithoutWorkspaceInput = {
  connect?: InputMaybe<Array<AdBoardGroupWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<AdBoardGroupCreateOrConnectWithoutWorkspaceInput>>;
  create?: InputMaybe<Array<AdBoardGroupCreateWithoutWorkspaceInput>>;
  createMany?: InputMaybe<AdBoardGroupCreateManyWorkspaceInputEnvelope>;
};

export type AdBoardGroupCreateNestedOneWithoutAdBoardInput = {
  connect?: InputMaybe<AdBoardGroupWhereUniqueInput>;
  connectOrCreate?: InputMaybe<AdBoardGroupCreateOrConnectWithoutAdBoardInput>;
  create?: InputMaybe<AdBoardGroupCreateWithoutAdBoardInput>;
};

export type AdBoardGroupCreateNestedOneWithoutPisignagePlayersInput = {
  connect?: InputMaybe<AdBoardGroupWhereUniqueInput>;
  connectOrCreate?: InputMaybe<AdBoardGroupCreateOrConnectWithoutPisignagePlayersInput>;
  create?: InputMaybe<AdBoardGroupCreateWithoutPisignagePlayersInput>;
};

export type AdBoardGroupCreateOrConnectWithoutAdBoardInput = {
  create: AdBoardGroupCreateWithoutAdBoardInput;
  where: AdBoardGroupWhereUniqueInput;
};

export type AdBoardGroupCreateOrConnectWithoutPisignagePlayersInput = {
  create: AdBoardGroupCreateWithoutPisignagePlayersInput;
  where: AdBoardGroupWhereUniqueInput;
};

export type AdBoardGroupCreateOrConnectWithoutPlaylistsInput = {
  create: AdBoardGroupCreateWithoutPlaylistsInput;
  where: AdBoardGroupWhereUniqueInput;
};

export type AdBoardGroupCreateOrConnectWithoutWorkspaceInput = {
  create: AdBoardGroupCreateWithoutWorkspaceInput;
  where: AdBoardGroupWhereUniqueInput;
};

export type AdBoardGroupCreateWithoutAdBoardInput = {
  displayName?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
  pisignageGroupId?: InputMaybe<Scalars['String']>;
  pisignagePlayers?: InputMaybe<PiSignagePlayerCreateNestedManyWithoutAdBoardGroupInput>;
  playlists?: InputMaybe<PlaylistCreateNestedManyWithoutAdBoardGroupsInput>;
  schedules?: InputMaybe<Array<ScheduleCreateInput>>;
  workspace: WorkspaceCreateNestedOneWithoutAdBoardGroupsInput;
};

export type AdBoardGroupCreateWithoutPisignagePlayersInput = {
  adBoard?: InputMaybe<AdBoardCreateNestedOneWithoutAdBoardGroupInput>;
  displayName?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
  pisignageGroupId?: InputMaybe<Scalars['String']>;
  playlists?: InputMaybe<PlaylistCreateNestedManyWithoutAdBoardGroupsInput>;
  schedules?: InputMaybe<Array<ScheduleCreateInput>>;
  workspace: WorkspaceCreateNestedOneWithoutAdBoardGroupsInput;
};

export type AdBoardGroupCreateWithoutPlaylistsInput = {
  adBoard?: InputMaybe<AdBoardCreateNestedOneWithoutAdBoardGroupInput>;
  displayName?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
  pisignageGroupId?: InputMaybe<Scalars['String']>;
  pisignagePlayers?: InputMaybe<PiSignagePlayerCreateNestedManyWithoutAdBoardGroupInput>;
  schedules?: InputMaybe<Array<ScheduleCreateInput>>;
  workspace: WorkspaceCreateNestedOneWithoutAdBoardGroupsInput;
};

export type AdBoardGroupCreateWithoutWorkspaceInput = {
  adBoard?: InputMaybe<AdBoardCreateNestedOneWithoutAdBoardGroupInput>;
  displayName?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
  pisignageGroupId?: InputMaybe<Scalars['String']>;
  pisignagePlayers?: InputMaybe<PiSignagePlayerCreateNestedManyWithoutAdBoardGroupInput>;
  playlists?: InputMaybe<PlaylistCreateNestedManyWithoutAdBoardGroupsInput>;
  schedules?: InputMaybe<Array<ScheduleCreateInput>>;
};

export type AdBoardGroupGroupBy = {
  __typename?: 'AdBoardGroupGroupBy';
  _count?: Maybe<AdBoardGroupCountAggregate>;
  _max?: Maybe<AdBoardGroupMaxAggregate>;
  _min?: Maybe<AdBoardGroupMinAggregate>;
  displayName?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  name: Scalars['String'];
  pisignageGroupId?: Maybe<Scalars['String']>;
  playlistIDs?: Maybe<Array<Scalars['String']>>;
  workspaceId: Scalars['String'];
};

export type AdBoardGroupListRelationFilter = {
  every?: InputMaybe<AdBoardGroupWhereInput>;
  none?: InputMaybe<AdBoardGroupWhereInput>;
  some?: InputMaybe<AdBoardGroupWhereInput>;
};

export type AdBoardGroupMaxAggregate = {
  __typename?: 'AdBoardGroupMaxAggregate';
  displayName?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  pisignageGroupId?: Maybe<Scalars['String']>;
  workspaceId?: Maybe<Scalars['String']>;
};

export type AdBoardGroupMaxOrderByAggregateInput = {
  displayName?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  name?: InputMaybe<SortOrder>;
  pisignageGroupId?: InputMaybe<SortOrder>;
  workspaceId?: InputMaybe<SortOrder>;
};

export type AdBoardGroupMinAggregate = {
  __typename?: 'AdBoardGroupMinAggregate';
  displayName?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  pisignageGroupId?: Maybe<Scalars['String']>;
  workspaceId?: Maybe<Scalars['String']>;
};

export type AdBoardGroupMinOrderByAggregateInput = {
  displayName?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  name?: InputMaybe<SortOrder>;
  pisignageGroupId?: InputMaybe<SortOrder>;
  workspaceId?: InputMaybe<SortOrder>;
};

export type AdBoardGroupNullableRelationFilter = {
  is?: InputMaybe<AdBoardGroupWhereInput>;
  isNot?: InputMaybe<AdBoardGroupWhereInput>;
};

export type AdBoardGroupOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type AdBoardGroupOrderByWithAggregationInput = {
  _count?: InputMaybe<AdBoardGroupCountOrderByAggregateInput>;
  _max?: InputMaybe<AdBoardGroupMaxOrderByAggregateInput>;
  _min?: InputMaybe<AdBoardGroupMinOrderByAggregateInput>;
  displayName?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  name?: InputMaybe<SortOrder>;
  pisignageGroupId?: InputMaybe<SortOrder>;
  playlistIDs?: InputMaybe<SortOrder>;
  workspaceId?: InputMaybe<SortOrder>;
};

export type AdBoardGroupOrderByWithRelationInput = {
  adBoard?: InputMaybe<AdBoardOrderByWithRelationInput>;
  displayName?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  name?: InputMaybe<SortOrder>;
  pisignageGroupId?: InputMaybe<SortOrder>;
  pisignagePlayers?: InputMaybe<PiSignagePlayerOrderByRelationAggregateInput>;
  playlistIDs?: InputMaybe<SortOrder>;
  playlists?: InputMaybe<PlaylistOrderByRelationAggregateInput>;
  schedules?: InputMaybe<ScheduleOrderByCompositeAggregateInput>;
  workspace?: InputMaybe<WorkspaceOrderByWithRelationInput>;
  workspaceId?: InputMaybe<SortOrder>;
};

export type AdBoardGroupRelationFilter = {
  is?: InputMaybe<AdBoardGroupWhereInput>;
  isNot?: InputMaybe<AdBoardGroupWhereInput>;
};

export enum AdBoardGroupScalarFieldEnum {
  DisplayName = 'displayName',
  Id = 'id',
  Name = 'name',
  PisignageGroupId = 'pisignageGroupId',
  PlaylistIDs = 'playlistIDs',
  WorkspaceId = 'workspaceId'
}

export type AdBoardGroupScalarWhereInput = {
  AND?: InputMaybe<Array<AdBoardGroupScalarWhereInput>>;
  NOT?: InputMaybe<Array<AdBoardGroupScalarWhereInput>>;
  OR?: InputMaybe<Array<AdBoardGroupScalarWhereInput>>;
  displayName?: InputMaybe<StringNullableFilter>;
  id?: InputMaybe<StringFilter>;
  name?: InputMaybe<StringFilter>;
  pisignageGroupId?: InputMaybe<StringNullableFilter>;
  playlistIDs?: InputMaybe<StringNullableListFilter>;
  workspaceId?: InputMaybe<StringFilter>;
};

export type AdBoardGroupScalarWhereWithAggregatesInput = {
  AND?: InputMaybe<Array<AdBoardGroupScalarWhereWithAggregatesInput>>;
  NOT?: InputMaybe<Array<AdBoardGroupScalarWhereWithAggregatesInput>>;
  OR?: InputMaybe<Array<AdBoardGroupScalarWhereWithAggregatesInput>>;
  displayName?: InputMaybe<StringNullableWithAggregatesFilter>;
  id?: InputMaybe<StringWithAggregatesFilter>;
  name?: InputMaybe<StringWithAggregatesFilter>;
  pisignageGroupId?: InputMaybe<StringNullableWithAggregatesFilter>;
  playlistIDs?: InputMaybe<StringNullableListFilter>;
  workspaceId?: InputMaybe<StringWithAggregatesFilter>;
};

export type AdBoardGroupUpdateInput = {
  adBoard?: InputMaybe<AdBoardUpdateOneWithoutAdBoardGroupNestedInput>;
  displayName?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  pisignageGroupId?: InputMaybe<Scalars['String']>;
  pisignagePlayers?: InputMaybe<PiSignagePlayerUpdateManyWithoutAdBoardGroupNestedInput>;
  playlists?: InputMaybe<PlaylistUpdateManyWithoutAdBoardGroupsNestedInput>;
  schedules?: InputMaybe<Array<ScheduleCreateInput>>;
  workspace?: InputMaybe<WorkspaceUpdateOneRequiredWithoutAdBoardGroupsNestedInput>;
};

export type AdBoardGroupUpdateManyMutationInput = {
  displayName?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  pisignageGroupId?: InputMaybe<Scalars['String']>;
  schedules?: InputMaybe<Array<ScheduleCreateInput>>;
};

export type AdBoardGroupUpdateManyWithWhereWithoutPlaylistsInput = {
  data: AdBoardGroupUpdateManyMutationInput;
  where: AdBoardGroupScalarWhereInput;
};

export type AdBoardGroupUpdateManyWithWhereWithoutWorkspaceInput = {
  data: AdBoardGroupUpdateManyMutationInput;
  where: AdBoardGroupScalarWhereInput;
};

export type AdBoardGroupUpdateManyWithoutPlaylistsNestedInput = {
  connect?: InputMaybe<Array<AdBoardGroupWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<AdBoardGroupCreateOrConnectWithoutPlaylistsInput>>;
  create?: InputMaybe<Array<AdBoardGroupCreateWithoutPlaylistsInput>>;
  delete?: InputMaybe<Array<AdBoardGroupWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<AdBoardGroupScalarWhereInput>>;
  disconnect?: InputMaybe<Array<AdBoardGroupWhereUniqueInput>>;
  set?: InputMaybe<Array<AdBoardGroupWhereUniqueInput>>;
  update?: InputMaybe<Array<AdBoardGroupUpdateWithWhereUniqueWithoutPlaylistsInput>>;
  updateMany?: InputMaybe<Array<AdBoardGroupUpdateManyWithWhereWithoutPlaylistsInput>>;
  upsert?: InputMaybe<Array<AdBoardGroupUpsertWithWhereUniqueWithoutPlaylistsInput>>;
};

export type AdBoardGroupUpdateManyWithoutWorkspaceNestedInput = {
  connect?: InputMaybe<Array<AdBoardGroupWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<AdBoardGroupCreateOrConnectWithoutWorkspaceInput>>;
  create?: InputMaybe<Array<AdBoardGroupCreateWithoutWorkspaceInput>>;
  createMany?: InputMaybe<AdBoardGroupCreateManyWorkspaceInputEnvelope>;
  delete?: InputMaybe<Array<AdBoardGroupWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<AdBoardGroupScalarWhereInput>>;
  disconnect?: InputMaybe<Array<AdBoardGroupWhereUniqueInput>>;
  set?: InputMaybe<Array<AdBoardGroupWhereUniqueInput>>;
  update?: InputMaybe<Array<AdBoardGroupUpdateWithWhereUniqueWithoutWorkspaceInput>>;
  updateMany?: InputMaybe<Array<AdBoardGroupUpdateManyWithWhereWithoutWorkspaceInput>>;
  upsert?: InputMaybe<Array<AdBoardGroupUpsertWithWhereUniqueWithoutWorkspaceInput>>;
};

export type AdBoardGroupUpdateOneRequiredWithoutAdBoardNestedInput = {
  connect?: InputMaybe<AdBoardGroupWhereUniqueInput>;
  connectOrCreate?: InputMaybe<AdBoardGroupCreateOrConnectWithoutAdBoardInput>;
  create?: InputMaybe<AdBoardGroupCreateWithoutAdBoardInput>;
  update?: InputMaybe<AdBoardGroupUpdateToOneWithWhereWithoutAdBoardInput>;
  upsert?: InputMaybe<AdBoardGroupUpsertWithoutAdBoardInput>;
};

export type AdBoardGroupUpdateOneWithoutPisignagePlayersNestedInput = {
  connect?: InputMaybe<AdBoardGroupWhereUniqueInput>;
  connectOrCreate?: InputMaybe<AdBoardGroupCreateOrConnectWithoutPisignagePlayersInput>;
  create?: InputMaybe<AdBoardGroupCreateWithoutPisignagePlayersInput>;
  delete?: InputMaybe<AdBoardGroupWhereInput>;
  disconnect?: InputMaybe<Scalars['Boolean']>;
  update?: InputMaybe<AdBoardGroupUpdateToOneWithWhereWithoutPisignagePlayersInput>;
  upsert?: InputMaybe<AdBoardGroupUpsertWithoutPisignagePlayersInput>;
};

export type AdBoardGroupUpdateToOneWithWhereWithoutAdBoardInput = {
  data: AdBoardGroupUpdateWithoutAdBoardInput;
  where?: InputMaybe<AdBoardGroupWhereInput>;
};

export type AdBoardGroupUpdateToOneWithWhereWithoutPisignagePlayersInput = {
  data: AdBoardGroupUpdateWithoutPisignagePlayersInput;
  where?: InputMaybe<AdBoardGroupWhereInput>;
};

export type AdBoardGroupUpdateWithWhereUniqueWithoutPlaylistsInput = {
  data: AdBoardGroupUpdateWithoutPlaylistsInput;
  where: AdBoardGroupWhereUniqueInput;
};

export type AdBoardGroupUpdateWithWhereUniqueWithoutWorkspaceInput = {
  data: AdBoardGroupUpdateWithoutWorkspaceInput;
  where: AdBoardGroupWhereUniqueInput;
};

export type AdBoardGroupUpdateWithoutAdBoardInput = {
  displayName?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  pisignageGroupId?: InputMaybe<Scalars['String']>;
  pisignagePlayers?: InputMaybe<PiSignagePlayerUpdateManyWithoutAdBoardGroupNestedInput>;
  playlists?: InputMaybe<PlaylistUpdateManyWithoutAdBoardGroupsNestedInput>;
  schedules?: InputMaybe<Array<ScheduleCreateInput>>;
  workspace?: InputMaybe<WorkspaceUpdateOneRequiredWithoutAdBoardGroupsNestedInput>;
};

export type AdBoardGroupUpdateWithoutPisignagePlayersInput = {
  adBoard?: InputMaybe<AdBoardUpdateOneWithoutAdBoardGroupNestedInput>;
  displayName?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  pisignageGroupId?: InputMaybe<Scalars['String']>;
  playlists?: InputMaybe<PlaylistUpdateManyWithoutAdBoardGroupsNestedInput>;
  schedules?: InputMaybe<Array<ScheduleCreateInput>>;
  workspace?: InputMaybe<WorkspaceUpdateOneRequiredWithoutAdBoardGroupsNestedInput>;
};

export type AdBoardGroupUpdateWithoutPlaylistsInput = {
  adBoard?: InputMaybe<AdBoardUpdateOneWithoutAdBoardGroupNestedInput>;
  displayName?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  pisignageGroupId?: InputMaybe<Scalars['String']>;
  pisignagePlayers?: InputMaybe<PiSignagePlayerUpdateManyWithoutAdBoardGroupNestedInput>;
  schedules?: InputMaybe<Array<ScheduleCreateInput>>;
  workspace?: InputMaybe<WorkspaceUpdateOneRequiredWithoutAdBoardGroupsNestedInput>;
};

export type AdBoardGroupUpdateWithoutWorkspaceInput = {
  adBoard?: InputMaybe<AdBoardUpdateOneWithoutAdBoardGroupNestedInput>;
  displayName?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  pisignageGroupId?: InputMaybe<Scalars['String']>;
  pisignagePlayers?: InputMaybe<PiSignagePlayerUpdateManyWithoutAdBoardGroupNestedInput>;
  playlists?: InputMaybe<PlaylistUpdateManyWithoutAdBoardGroupsNestedInput>;
  schedules?: InputMaybe<Array<ScheduleCreateInput>>;
};

export type AdBoardGroupUpsertWithWhereUniqueWithoutPlaylistsInput = {
  create: AdBoardGroupCreateWithoutPlaylistsInput;
  update: AdBoardGroupUpdateWithoutPlaylistsInput;
  where: AdBoardGroupWhereUniqueInput;
};

export type AdBoardGroupUpsertWithWhereUniqueWithoutWorkspaceInput = {
  create: AdBoardGroupCreateWithoutWorkspaceInput;
  update: AdBoardGroupUpdateWithoutWorkspaceInput;
  where: AdBoardGroupWhereUniqueInput;
};

export type AdBoardGroupUpsertWithoutAdBoardInput = {
  create: AdBoardGroupCreateWithoutAdBoardInput;
  update: AdBoardGroupUpdateWithoutAdBoardInput;
  where?: InputMaybe<AdBoardGroupWhereInput>;
};

export type AdBoardGroupUpsertWithoutPisignagePlayersInput = {
  create: AdBoardGroupCreateWithoutPisignagePlayersInput;
  update: AdBoardGroupUpdateWithoutPisignagePlayersInput;
  where?: InputMaybe<AdBoardGroupWhereInput>;
};

export type AdBoardGroupWhereInput = {
  AND?: InputMaybe<Array<AdBoardGroupWhereInput>>;
  NOT?: InputMaybe<Array<AdBoardGroupWhereInput>>;
  OR?: InputMaybe<Array<AdBoardGroupWhereInput>>;
  adBoard?: InputMaybe<AdBoardNullableRelationFilter>;
  displayName?: InputMaybe<StringNullableFilter>;
  id?: InputMaybe<StringFilter>;
  name?: InputMaybe<StringFilter>;
  pisignageGroupId?: InputMaybe<StringNullableFilter>;
  pisignagePlayers?: InputMaybe<PiSignagePlayerListRelationFilter>;
  playlistIDs?: InputMaybe<StringNullableListFilter>;
  playlists?: InputMaybe<PlaylistListRelationFilter>;
  schedules?: InputMaybe<Array<ScheduleObjectEqualityInput>>;
  workspace?: InputMaybe<WorkspaceRelationFilter>;
  workspaceId?: InputMaybe<StringFilter>;
};

export type AdBoardGroupWhereUniqueInput = {
  AND?: InputMaybe<Array<AdBoardGroupWhereInput>>;
  NOT?: InputMaybe<Array<AdBoardGroupWhereInput>>;
  OR?: InputMaybe<Array<AdBoardGroupWhereInput>>;
  adBoard?: InputMaybe<AdBoardNullableRelationFilter>;
  displayName?: InputMaybe<StringNullableFilter>;
  id?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  pisignageGroupId?: InputMaybe<StringNullableFilter>;
  pisignagePlayers?: InputMaybe<PiSignagePlayerListRelationFilter>;
  playlistIDs?: InputMaybe<StringNullableListFilter>;
  playlists?: InputMaybe<PlaylistListRelationFilter>;
  schedules?: InputMaybe<Array<ScheduleObjectEqualityInput>>;
  workspace?: InputMaybe<WorkspaceRelationFilter>;
  workspaceId?: InputMaybe<StringFilter>;
};

export type AdBoardListRelationFilter = {
  every?: InputMaybe<AdBoardWhereInput>;
  none?: InputMaybe<AdBoardWhereInput>;
  some?: InputMaybe<AdBoardWhereInput>;
};

export type AdBoardMaxAggregate = {
  __typename?: 'AdBoardMaxAggregate';
  adBoardGroupId?: Maybe<Scalars['String']>;
  address?: Maybe<Scalars['String']>;
  alias?: Maybe<Scalars['String']>;
  categoryId?: Maybe<Scalars['String']>;
  city?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  createdByUserId?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  featuredImage?: Maybe<Scalars['String']>;
  href?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  pricePerDay?: Maybe<Scalars['Int']>;
  slots?: Maybe<Scalars['String']>;
  state?: Maybe<Scalars['String']>;
  status?: Maybe<AdBoardStatus>;
  title?: Maybe<Scalars['String']>;
  visible?: Maybe<Scalars['Boolean']>;
  workspaceId?: Maybe<Scalars['String']>;
};

export type AdBoardMaxOrderByAggregateInput = {
  adBoardGroupId?: InputMaybe<SortOrder>;
  address?: InputMaybe<SortOrder>;
  alias?: InputMaybe<SortOrder>;
  categoryId?: InputMaybe<SortOrder>;
  city?: InputMaybe<SortOrder>;
  country?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  createdByUserId?: InputMaybe<SortOrder>;
  description?: InputMaybe<SortOrder>;
  featuredImage?: InputMaybe<SortOrder>;
  href?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  pricePerDay?: InputMaybe<SortOrder>;
  slots?: InputMaybe<SortOrder>;
  state?: InputMaybe<SortOrder>;
  status?: InputMaybe<SortOrder>;
  title?: InputMaybe<SortOrder>;
  visible?: InputMaybe<SortOrder>;
  workspaceId?: InputMaybe<SortOrder>;
};

export type AdBoardMinAggregate = {
  __typename?: 'AdBoardMinAggregate';
  adBoardGroupId?: Maybe<Scalars['String']>;
  address?: Maybe<Scalars['String']>;
  alias?: Maybe<Scalars['String']>;
  categoryId?: Maybe<Scalars['String']>;
  city?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  createdByUserId?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  featuredImage?: Maybe<Scalars['String']>;
  href?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  pricePerDay?: Maybe<Scalars['Int']>;
  slots?: Maybe<Scalars['String']>;
  state?: Maybe<Scalars['String']>;
  status?: Maybe<AdBoardStatus>;
  title?: Maybe<Scalars['String']>;
  visible?: Maybe<Scalars['Boolean']>;
  workspaceId?: Maybe<Scalars['String']>;
};

export type AdBoardMinOrderByAggregateInput = {
  adBoardGroupId?: InputMaybe<SortOrder>;
  address?: InputMaybe<SortOrder>;
  alias?: InputMaybe<SortOrder>;
  categoryId?: InputMaybe<SortOrder>;
  city?: InputMaybe<SortOrder>;
  country?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  createdByUserId?: InputMaybe<SortOrder>;
  description?: InputMaybe<SortOrder>;
  featuredImage?: InputMaybe<SortOrder>;
  href?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  pricePerDay?: InputMaybe<SortOrder>;
  slots?: InputMaybe<SortOrder>;
  state?: InputMaybe<SortOrder>;
  status?: InputMaybe<SortOrder>;
  title?: InputMaybe<SortOrder>;
  visible?: InputMaybe<SortOrder>;
  workspaceId?: InputMaybe<SortOrder>;
};

export type AdBoardNullableRelationFilter = {
  is?: InputMaybe<AdBoardWhereInput>;
  isNot?: InputMaybe<AdBoardWhereInput>;
};

export type AdBoardOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type AdBoardOrderByWithAggregationInput = {
  _avg?: InputMaybe<AdBoardAvgOrderByAggregateInput>;
  _count?: InputMaybe<AdBoardCountOrderByAggregateInput>;
  _max?: InputMaybe<AdBoardMaxOrderByAggregateInput>;
  _min?: InputMaybe<AdBoardMinOrderByAggregateInput>;
  _sum?: InputMaybe<AdBoardSumOrderByAggregateInput>;
  accessLabelsIDs?: InputMaybe<SortOrder>;
  adBoardGroupId?: InputMaybe<SortOrder>;
  address?: InputMaybe<SortOrder>;
  alias?: InputMaybe<SortOrder>;
  categoryId?: InputMaybe<SortOrder>;
  city?: InputMaybe<SortOrder>;
  country?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  createdByUserId?: InputMaybe<SortOrder>;
  description?: InputMaybe<SortOrder>;
  featuredImage?: InputMaybe<SortOrder>;
  galleryImgs?: InputMaybe<SortOrder>;
  href?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  notes?: InputMaybe<SortOrder>;
  pricePerDay?: InputMaybe<SortOrder>;
  restrictedBusinessIds?: InputMaybe<SortOrder>;
  slots?: InputMaybe<SortOrder>;
  state?: InputMaybe<SortOrder>;
  status?: InputMaybe<SortOrder>;
  tags?: InputMaybe<SortOrder>;
  targetAudiences?: InputMaybe<SortOrder>;
  title?: InputMaybe<SortOrder>;
  visible?: InputMaybe<SortOrder>;
  workspaceId?: InputMaybe<SortOrder>;
};

export type AdBoardOrderByWithRelationInput = {
  aboutSpecifications?: InputMaybe<SpecificationOrderByCompositeAggregateInput>;
  accessLabels?: InputMaybe<AccessLabelOrderByRelationAggregateInput>;
  accessLabelsIDs?: InputMaybe<SortOrder>;
  adBoardGroup?: InputMaybe<AdBoardGroupOrderByWithRelationInput>;
  adBoardGroupId?: InputMaybe<SortOrder>;
  address?: InputMaybe<SortOrder>;
  alias?: InputMaybe<SortOrder>;
  bookedSlots?: InputMaybe<SlotOrderByRelationAggregateInput>;
  bookings?: InputMaybe<BookingOrderByRelationAggregateInput>;
  category?: InputMaybe<BusinessCategoryOrderByWithRelationInput>;
  categoryId?: InputMaybe<SortOrder>;
  city?: InputMaybe<SortOrder>;
  country?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  createdBy?: InputMaybe<UserOrderByWithRelationInput>;
  createdByUserId?: InputMaybe<SortOrder>;
  description?: InputMaybe<SortOrder>;
  featuredImage?: InputMaybe<SortOrder>;
  galleryImgs?: InputMaybe<SortOrder>;
  href?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  map?: InputMaybe<MapOrderByInput>;
  notes?: InputMaybe<SortOrder>;
  orders?: InputMaybe<OrderOrderByRelationAggregateInput>;
  playbackTimes?: InputMaybe<PlaybackTimeOrderByCompositeAggregateInput>;
  pricePerDay?: InputMaybe<SortOrder>;
  resolution?: InputMaybe<ResolutionOrderByInput>;
  restrictedBusines?: InputMaybe<BusinessCategoryOrderByRelationAggregateInput>;
  restrictedBusinessIds?: InputMaybe<SortOrder>;
  screenSize?: InputMaybe<ScreenSizeOrderByInput>;
  slots?: InputMaybe<SortOrder>;
  specifications?: InputMaybe<SpecificationOrderByCompositeAggregateInput>;
  state?: InputMaybe<SortOrder>;
  status?: InputMaybe<SortOrder>;
  tags?: InputMaybe<SortOrder>;
  targetAudiences?: InputMaybe<SortOrder>;
  title?: InputMaybe<SortOrder>;
  type?: InputMaybe<ScreenTypeOrderByInput>;
  visible?: InputMaybe<SortOrder>;
  workspace?: InputMaybe<WorkspaceOrderByWithRelationInput>;
  workspaceId?: InputMaybe<SortOrder>;
};

export type AdBoardRelationFilter = {
  is?: InputMaybe<AdBoardWhereInput>;
  isNot?: InputMaybe<AdBoardWhereInput>;
};

export enum AdBoardScalarFieldEnum {
  AccessLabelsIDs = 'accessLabelsIDs',
  AdBoardGroupId = 'adBoardGroupId',
  Address = 'address',
  Alias = 'alias',
  CategoryId = 'categoryId',
  City = 'city',
  Country = 'country',
  CreatedAt = 'createdAt',
  CreatedByUserId = 'createdByUserId',
  Description = 'description',
  FeaturedImage = 'featuredImage',
  GalleryImgs = 'galleryImgs',
  Href = 'href',
  Id = 'id',
  Notes = 'notes',
  PricePerDay = 'pricePerDay',
  RestrictedBusinessIds = 'restrictedBusinessIds',
  Slots = 'slots',
  State = 'state',
  Status = 'status',
  Tags = 'tags',
  TargetAudiences = 'targetAudiences',
  Title = 'title',
  Visible = 'visible',
  WorkspaceId = 'workspaceId'
}

export type AdBoardScalarWhereInput = {
  AND?: InputMaybe<Array<AdBoardScalarWhereInput>>;
  NOT?: InputMaybe<Array<AdBoardScalarWhereInput>>;
  OR?: InputMaybe<Array<AdBoardScalarWhereInput>>;
  accessLabelsIDs?: InputMaybe<StringNullableListFilter>;
  adBoardGroupId?: InputMaybe<StringFilter>;
  address?: InputMaybe<StringFilter>;
  alias?: InputMaybe<StringNullableFilter>;
  categoryId?: InputMaybe<StringNullableFilter>;
  city?: InputMaybe<StringNullableFilter>;
  country?: InputMaybe<StringNullableFilter>;
  createdAt?: InputMaybe<DateTimeNullableFilter>;
  createdByUserId?: InputMaybe<StringNullableFilter>;
  description?: InputMaybe<StringNullableFilter>;
  featuredImage?: InputMaybe<StringNullableFilter>;
  galleryImgs?: InputMaybe<StringNullableListFilter>;
  href?: InputMaybe<StringNullableFilter>;
  id?: InputMaybe<StringFilter>;
  notes?: InputMaybe<StringNullableListFilter>;
  pricePerDay?: InputMaybe<IntFilter>;
  restrictedBusinessIds?: InputMaybe<StringNullableListFilter>;
  slots?: InputMaybe<StringNullableFilter>;
  state?: InputMaybe<StringNullableFilter>;
  status?: InputMaybe<EnumAdBoardStatusFilter>;
  tags?: InputMaybe<StringNullableListFilter>;
  targetAudiences?: InputMaybe<StringNullableListFilter>;
  title?: InputMaybe<StringFilter>;
  visible?: InputMaybe<BoolFilter>;
  workspaceId?: InputMaybe<StringFilter>;
};

export type AdBoardScalarWhereWithAggregatesInput = {
  AND?: InputMaybe<Array<AdBoardScalarWhereWithAggregatesInput>>;
  NOT?: InputMaybe<Array<AdBoardScalarWhereWithAggregatesInput>>;
  OR?: InputMaybe<Array<AdBoardScalarWhereWithAggregatesInput>>;
  accessLabelsIDs?: InputMaybe<StringNullableListFilter>;
  adBoardGroupId?: InputMaybe<StringWithAggregatesFilter>;
  address?: InputMaybe<StringWithAggregatesFilter>;
  alias?: InputMaybe<StringNullableWithAggregatesFilter>;
  categoryId?: InputMaybe<StringNullableWithAggregatesFilter>;
  city?: InputMaybe<StringNullableWithAggregatesFilter>;
  country?: InputMaybe<StringNullableWithAggregatesFilter>;
  createdAt?: InputMaybe<DateTimeNullableWithAggregatesFilter>;
  createdByUserId?: InputMaybe<StringNullableWithAggregatesFilter>;
  description?: InputMaybe<StringNullableWithAggregatesFilter>;
  featuredImage?: InputMaybe<StringNullableWithAggregatesFilter>;
  galleryImgs?: InputMaybe<StringNullableListFilter>;
  href?: InputMaybe<StringNullableWithAggregatesFilter>;
  id?: InputMaybe<StringWithAggregatesFilter>;
  notes?: InputMaybe<StringNullableListFilter>;
  pricePerDay?: InputMaybe<IntWithAggregatesFilter>;
  restrictedBusinessIds?: InputMaybe<StringNullableListFilter>;
  slots?: InputMaybe<StringNullableWithAggregatesFilter>;
  state?: InputMaybe<StringNullableWithAggregatesFilter>;
  status?: InputMaybe<EnumAdBoardStatusWithAggregatesFilter>;
  tags?: InputMaybe<StringNullableListFilter>;
  targetAudiences?: InputMaybe<StringNullableListFilter>;
  title?: InputMaybe<StringWithAggregatesFilter>;
  visible?: InputMaybe<BoolWithAggregatesFilter>;
  workspaceId?: InputMaybe<StringWithAggregatesFilter>;
};

export enum AdBoardStatus {
  ComingSoon = 'COMING_SOON',
  Disabled = 'DISABLED',
  Enabled = 'ENABLED'
}

export type AdBoardSumAggregate = {
  __typename?: 'AdBoardSumAggregate';
  pricePerDay?: Maybe<Scalars['Int']>;
};

export type AdBoardSumOrderByAggregateInput = {
  pricePerDay?: InputMaybe<SortOrder>;
};

export type AdBoardUpdateInput = {
  aboutSpecifications?: InputMaybe<Array<SpecificationCreateInput>>;
  accessLabels?: InputMaybe<AccessLabelUpdateManyWithoutAdBoardsNestedInput>;
  adBoardGroup?: InputMaybe<AdBoardGroupUpdateOneRequiredWithoutAdBoardNestedInput>;
  address?: InputMaybe<Scalars['String']>;
  alias?: InputMaybe<Scalars['String']>;
  bookedSlots?: InputMaybe<SlotUpdateManyWithoutAdBoardNestedInput>;
  bookings?: InputMaybe<BookingUpdateManyWithoutAdBoardNestedInput>;
  category?: InputMaybe<BusinessCategoryUpdateOneWithoutAdBoardsNestedInput>;
  city?: InputMaybe<Scalars['String']>;
  country?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  createdBy?: InputMaybe<UserUpdateOneWithoutAdBoardsNestedInput>;
  description?: InputMaybe<Scalars['String']>;
  featuredImage?: InputMaybe<Scalars['String']>;
  galleryImgs?: InputMaybe<Array<Scalars['String']>>;
  href?: InputMaybe<Scalars['String']>;
  map?: InputMaybe<MapCreateInput>;
  notes?: InputMaybe<Array<Scalars['String']>>;
  orders?: InputMaybe<OrderUpdateManyWithoutAdBoardNestedInput>;
  playbackTimes?: InputMaybe<Array<PlaybackTimeCreateInput>>;
  pricePerDay?: InputMaybe<Scalars['Int']>;
  resolution?: InputMaybe<ResolutionCreateInput>;
  restrictedBusines?: InputMaybe<BusinessCategoryUpdateManyWithoutRestrictedByAdBoardsNestedInput>;
  screenSize?: InputMaybe<ScreenSizeCreateInput>;
  slots?: InputMaybe<Scalars['String']>;
  specifications?: InputMaybe<Array<SpecificationCreateInput>>;
  state?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<AdBoardStatus>;
  tags?: InputMaybe<Array<Scalars['String']>>;
  targetAudiences?: InputMaybe<Array<Scalars['String']>>;
  title?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<ScreenTypeCreateInput>;
  visible?: InputMaybe<Scalars['Boolean']>;
  workspace?: InputMaybe<WorkspaceUpdateOneRequiredWithoutAdBoardsNestedInput>;
};

export type AdBoardUpdateManyMutationInput = {
  aboutSpecifications?: InputMaybe<Array<SpecificationCreateInput>>;
  address?: InputMaybe<Scalars['String']>;
  alias?: InputMaybe<Scalars['String']>;
  city?: InputMaybe<Scalars['String']>;
  country?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  description?: InputMaybe<Scalars['String']>;
  featuredImage?: InputMaybe<Scalars['String']>;
  galleryImgs?: InputMaybe<Array<Scalars['String']>>;
  href?: InputMaybe<Scalars['String']>;
  map?: InputMaybe<MapCreateInput>;
  notes?: InputMaybe<Array<Scalars['String']>>;
  playbackTimes?: InputMaybe<Array<PlaybackTimeCreateInput>>;
  pricePerDay?: InputMaybe<Scalars['Int']>;
  resolution?: InputMaybe<ResolutionCreateInput>;
  screenSize?: InputMaybe<ScreenSizeCreateInput>;
  slots?: InputMaybe<Scalars['String']>;
  specifications?: InputMaybe<Array<SpecificationCreateInput>>;
  state?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<AdBoardStatus>;
  tags?: InputMaybe<Array<Scalars['String']>>;
  targetAudiences?: InputMaybe<Array<Scalars['String']>>;
  title?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<ScreenTypeCreateInput>;
  visible?: InputMaybe<Scalars['Boolean']>;
};

export type AdBoardUpdateManyWithWhereWithoutAccessLabelsInput = {
  data: AdBoardUpdateManyMutationInput;
  where: AdBoardScalarWhereInput;
};

export type AdBoardUpdateManyWithWhereWithoutCategoryInput = {
  data: AdBoardUpdateManyMutationInput;
  where: AdBoardScalarWhereInput;
};

export type AdBoardUpdateManyWithWhereWithoutCreatedByInput = {
  data: AdBoardUpdateManyMutationInput;
  where: AdBoardScalarWhereInput;
};

export type AdBoardUpdateManyWithWhereWithoutRestrictedBusinesInput = {
  data: AdBoardUpdateManyMutationInput;
  where: AdBoardScalarWhereInput;
};

export type AdBoardUpdateManyWithWhereWithoutWorkspaceInput = {
  data: AdBoardUpdateManyMutationInput;
  where: AdBoardScalarWhereInput;
};

export type AdBoardUpdateManyWithoutAccessLabelsNestedInput = {
  connect?: InputMaybe<Array<AdBoardWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<AdBoardCreateOrConnectWithoutAccessLabelsInput>>;
  create?: InputMaybe<Array<AdBoardCreateWithoutAccessLabelsInput>>;
  delete?: InputMaybe<Array<AdBoardWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<AdBoardScalarWhereInput>>;
  disconnect?: InputMaybe<Array<AdBoardWhereUniqueInput>>;
  set?: InputMaybe<Array<AdBoardWhereUniqueInput>>;
  update?: InputMaybe<Array<AdBoardUpdateWithWhereUniqueWithoutAccessLabelsInput>>;
  updateMany?: InputMaybe<Array<AdBoardUpdateManyWithWhereWithoutAccessLabelsInput>>;
  upsert?: InputMaybe<Array<AdBoardUpsertWithWhereUniqueWithoutAccessLabelsInput>>;
};

export type AdBoardUpdateManyWithoutCategoryNestedInput = {
  connect?: InputMaybe<Array<AdBoardWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<AdBoardCreateOrConnectWithoutCategoryInput>>;
  create?: InputMaybe<Array<AdBoardCreateWithoutCategoryInput>>;
  createMany?: InputMaybe<AdBoardCreateManyCategoryInputEnvelope>;
  delete?: InputMaybe<Array<AdBoardWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<AdBoardScalarWhereInput>>;
  disconnect?: InputMaybe<Array<AdBoardWhereUniqueInput>>;
  set?: InputMaybe<Array<AdBoardWhereUniqueInput>>;
  update?: InputMaybe<Array<AdBoardUpdateWithWhereUniqueWithoutCategoryInput>>;
  updateMany?: InputMaybe<Array<AdBoardUpdateManyWithWhereWithoutCategoryInput>>;
  upsert?: InputMaybe<Array<AdBoardUpsertWithWhereUniqueWithoutCategoryInput>>;
};

export type AdBoardUpdateManyWithoutCreatedByNestedInput = {
  connect?: InputMaybe<Array<AdBoardWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<AdBoardCreateOrConnectWithoutCreatedByInput>>;
  create?: InputMaybe<Array<AdBoardCreateWithoutCreatedByInput>>;
  createMany?: InputMaybe<AdBoardCreateManyCreatedByInputEnvelope>;
  delete?: InputMaybe<Array<AdBoardWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<AdBoardScalarWhereInput>>;
  disconnect?: InputMaybe<Array<AdBoardWhereUniqueInput>>;
  set?: InputMaybe<Array<AdBoardWhereUniqueInput>>;
  update?: InputMaybe<Array<AdBoardUpdateWithWhereUniqueWithoutCreatedByInput>>;
  updateMany?: InputMaybe<Array<AdBoardUpdateManyWithWhereWithoutCreatedByInput>>;
  upsert?: InputMaybe<Array<AdBoardUpsertWithWhereUniqueWithoutCreatedByInput>>;
};

export type AdBoardUpdateManyWithoutRestrictedBusinesNestedInput = {
  connect?: InputMaybe<Array<AdBoardWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<AdBoardCreateOrConnectWithoutRestrictedBusinesInput>>;
  create?: InputMaybe<Array<AdBoardCreateWithoutRestrictedBusinesInput>>;
  delete?: InputMaybe<Array<AdBoardWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<AdBoardScalarWhereInput>>;
  disconnect?: InputMaybe<Array<AdBoardWhereUniqueInput>>;
  set?: InputMaybe<Array<AdBoardWhereUniqueInput>>;
  update?: InputMaybe<Array<AdBoardUpdateWithWhereUniqueWithoutRestrictedBusinesInput>>;
  updateMany?: InputMaybe<Array<AdBoardUpdateManyWithWhereWithoutRestrictedBusinesInput>>;
  upsert?: InputMaybe<Array<AdBoardUpsertWithWhereUniqueWithoutRestrictedBusinesInput>>;
};

export type AdBoardUpdateManyWithoutWorkspaceNestedInput = {
  connect?: InputMaybe<Array<AdBoardWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<AdBoardCreateOrConnectWithoutWorkspaceInput>>;
  create?: InputMaybe<Array<AdBoardCreateWithoutWorkspaceInput>>;
  createMany?: InputMaybe<AdBoardCreateManyWorkspaceInputEnvelope>;
  delete?: InputMaybe<Array<AdBoardWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<AdBoardScalarWhereInput>>;
  disconnect?: InputMaybe<Array<AdBoardWhereUniqueInput>>;
  set?: InputMaybe<Array<AdBoardWhereUniqueInput>>;
  update?: InputMaybe<Array<AdBoardUpdateWithWhereUniqueWithoutWorkspaceInput>>;
  updateMany?: InputMaybe<Array<AdBoardUpdateManyWithWhereWithoutWorkspaceInput>>;
  upsert?: InputMaybe<Array<AdBoardUpsertWithWhereUniqueWithoutWorkspaceInput>>;
};

export type AdBoardUpdateOneRequiredWithoutBookedSlotsNestedInput = {
  connect?: InputMaybe<AdBoardWhereUniqueInput>;
  connectOrCreate?: InputMaybe<AdBoardCreateOrConnectWithoutBookedSlotsInput>;
  create?: InputMaybe<AdBoardCreateWithoutBookedSlotsInput>;
  update?: InputMaybe<AdBoardUpdateToOneWithWhereWithoutBookedSlotsInput>;
  upsert?: InputMaybe<AdBoardUpsertWithoutBookedSlotsInput>;
};

export type AdBoardUpdateOneRequiredWithoutBookingsNestedInput = {
  connect?: InputMaybe<AdBoardWhereUniqueInput>;
  connectOrCreate?: InputMaybe<AdBoardCreateOrConnectWithoutBookingsInput>;
  create?: InputMaybe<AdBoardCreateWithoutBookingsInput>;
  update?: InputMaybe<AdBoardUpdateToOneWithWhereWithoutBookingsInput>;
  upsert?: InputMaybe<AdBoardUpsertWithoutBookingsInput>;
};

export type AdBoardUpdateOneRequiredWithoutOrdersNestedInput = {
  connect?: InputMaybe<AdBoardWhereUniqueInput>;
  connectOrCreate?: InputMaybe<AdBoardCreateOrConnectWithoutOrdersInput>;
  create?: InputMaybe<AdBoardCreateWithoutOrdersInput>;
  update?: InputMaybe<AdBoardUpdateToOneWithWhereWithoutOrdersInput>;
  upsert?: InputMaybe<AdBoardUpsertWithoutOrdersInput>;
};

export type AdBoardUpdateOneWithoutAdBoardGroupNestedInput = {
  connect?: InputMaybe<AdBoardWhereUniqueInput>;
  connectOrCreate?: InputMaybe<AdBoardCreateOrConnectWithoutAdBoardGroupInput>;
  create?: InputMaybe<AdBoardCreateWithoutAdBoardGroupInput>;
  delete?: InputMaybe<AdBoardWhereInput>;
  disconnect?: InputMaybe<AdBoardWhereInput>;
  update?: InputMaybe<AdBoardUpdateToOneWithWhereWithoutAdBoardGroupInput>;
  upsert?: InputMaybe<AdBoardUpsertWithoutAdBoardGroupInput>;
};

export type AdBoardUpdateToOneWithWhereWithoutAdBoardGroupInput = {
  data: AdBoardUpdateWithoutAdBoardGroupInput;
  where?: InputMaybe<AdBoardWhereInput>;
};

export type AdBoardUpdateToOneWithWhereWithoutBookedSlotsInput = {
  data: AdBoardUpdateWithoutBookedSlotsInput;
  where?: InputMaybe<AdBoardWhereInput>;
};

export type AdBoardUpdateToOneWithWhereWithoutBookingsInput = {
  data: AdBoardUpdateWithoutBookingsInput;
  where?: InputMaybe<AdBoardWhereInput>;
};

export type AdBoardUpdateToOneWithWhereWithoutOrdersInput = {
  data: AdBoardUpdateWithoutOrdersInput;
  where?: InputMaybe<AdBoardWhereInput>;
};

export type AdBoardUpdateWithWhereUniqueWithoutAccessLabelsInput = {
  data: AdBoardUpdateWithoutAccessLabelsInput;
  where: AdBoardWhereUniqueInput;
};

export type AdBoardUpdateWithWhereUniqueWithoutCategoryInput = {
  data: AdBoardUpdateWithoutCategoryInput;
  where: AdBoardWhereUniqueInput;
};

export type AdBoardUpdateWithWhereUniqueWithoutCreatedByInput = {
  data: AdBoardUpdateWithoutCreatedByInput;
  where: AdBoardWhereUniqueInput;
};

export type AdBoardUpdateWithWhereUniqueWithoutRestrictedBusinesInput = {
  data: AdBoardUpdateWithoutRestrictedBusinesInput;
  where: AdBoardWhereUniqueInput;
};

export type AdBoardUpdateWithWhereUniqueWithoutWorkspaceInput = {
  data: AdBoardUpdateWithoutWorkspaceInput;
  where: AdBoardWhereUniqueInput;
};

export type AdBoardUpdateWithoutAccessLabelsInput = {
  aboutSpecifications?: InputMaybe<Array<SpecificationCreateInput>>;
  adBoardGroup?: InputMaybe<AdBoardGroupUpdateOneRequiredWithoutAdBoardNestedInput>;
  address?: InputMaybe<Scalars['String']>;
  alias?: InputMaybe<Scalars['String']>;
  bookedSlots?: InputMaybe<SlotUpdateManyWithoutAdBoardNestedInput>;
  bookings?: InputMaybe<BookingUpdateManyWithoutAdBoardNestedInput>;
  category?: InputMaybe<BusinessCategoryUpdateOneWithoutAdBoardsNestedInput>;
  city?: InputMaybe<Scalars['String']>;
  country?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  createdBy?: InputMaybe<UserUpdateOneWithoutAdBoardsNestedInput>;
  description?: InputMaybe<Scalars['String']>;
  featuredImage?: InputMaybe<Scalars['String']>;
  galleryImgs?: InputMaybe<Array<Scalars['String']>>;
  href?: InputMaybe<Scalars['String']>;
  map?: InputMaybe<MapCreateInput>;
  notes?: InputMaybe<Array<Scalars['String']>>;
  orders?: InputMaybe<OrderUpdateManyWithoutAdBoardNestedInput>;
  playbackTimes?: InputMaybe<Array<PlaybackTimeCreateInput>>;
  pricePerDay?: InputMaybe<Scalars['Int']>;
  resolution?: InputMaybe<ResolutionCreateInput>;
  restrictedBusines?: InputMaybe<BusinessCategoryUpdateManyWithoutRestrictedByAdBoardsNestedInput>;
  screenSize?: InputMaybe<ScreenSizeCreateInput>;
  slots?: InputMaybe<Scalars['String']>;
  specifications?: InputMaybe<Array<SpecificationCreateInput>>;
  state?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<AdBoardStatus>;
  tags?: InputMaybe<Array<Scalars['String']>>;
  targetAudiences?: InputMaybe<Array<Scalars['String']>>;
  title?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<ScreenTypeCreateInput>;
  visible?: InputMaybe<Scalars['Boolean']>;
  workspace?: InputMaybe<WorkspaceUpdateOneRequiredWithoutAdBoardsNestedInput>;
};

export type AdBoardUpdateWithoutAdBoardGroupInput = {
  aboutSpecifications?: InputMaybe<Array<SpecificationCreateInput>>;
  accessLabels?: InputMaybe<AccessLabelUpdateManyWithoutAdBoardsNestedInput>;
  address?: InputMaybe<Scalars['String']>;
  alias?: InputMaybe<Scalars['String']>;
  bookedSlots?: InputMaybe<SlotUpdateManyWithoutAdBoardNestedInput>;
  bookings?: InputMaybe<BookingUpdateManyWithoutAdBoardNestedInput>;
  category?: InputMaybe<BusinessCategoryUpdateOneWithoutAdBoardsNestedInput>;
  city?: InputMaybe<Scalars['String']>;
  country?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  createdBy?: InputMaybe<UserUpdateOneWithoutAdBoardsNestedInput>;
  description?: InputMaybe<Scalars['String']>;
  featuredImage?: InputMaybe<Scalars['String']>;
  galleryImgs?: InputMaybe<Array<Scalars['String']>>;
  href?: InputMaybe<Scalars['String']>;
  map?: InputMaybe<MapCreateInput>;
  notes?: InputMaybe<Array<Scalars['String']>>;
  orders?: InputMaybe<OrderUpdateManyWithoutAdBoardNestedInput>;
  playbackTimes?: InputMaybe<Array<PlaybackTimeCreateInput>>;
  pricePerDay?: InputMaybe<Scalars['Int']>;
  resolution?: InputMaybe<ResolutionCreateInput>;
  restrictedBusines?: InputMaybe<BusinessCategoryUpdateManyWithoutRestrictedByAdBoardsNestedInput>;
  screenSize?: InputMaybe<ScreenSizeCreateInput>;
  slots?: InputMaybe<Scalars['String']>;
  specifications?: InputMaybe<Array<SpecificationCreateInput>>;
  state?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<AdBoardStatus>;
  tags?: InputMaybe<Array<Scalars['String']>>;
  targetAudiences?: InputMaybe<Array<Scalars['String']>>;
  title?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<ScreenTypeCreateInput>;
  visible?: InputMaybe<Scalars['Boolean']>;
  workspace?: InputMaybe<WorkspaceUpdateOneRequiredWithoutAdBoardsNestedInput>;
};

export type AdBoardUpdateWithoutBookedSlotsInput = {
  aboutSpecifications?: InputMaybe<Array<SpecificationCreateInput>>;
  accessLabels?: InputMaybe<AccessLabelUpdateManyWithoutAdBoardsNestedInput>;
  adBoardGroup?: InputMaybe<AdBoardGroupUpdateOneRequiredWithoutAdBoardNestedInput>;
  address?: InputMaybe<Scalars['String']>;
  alias?: InputMaybe<Scalars['String']>;
  bookings?: InputMaybe<BookingUpdateManyWithoutAdBoardNestedInput>;
  category?: InputMaybe<BusinessCategoryUpdateOneWithoutAdBoardsNestedInput>;
  city?: InputMaybe<Scalars['String']>;
  country?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  createdBy?: InputMaybe<UserUpdateOneWithoutAdBoardsNestedInput>;
  description?: InputMaybe<Scalars['String']>;
  featuredImage?: InputMaybe<Scalars['String']>;
  galleryImgs?: InputMaybe<Array<Scalars['String']>>;
  href?: InputMaybe<Scalars['String']>;
  map?: InputMaybe<MapCreateInput>;
  notes?: InputMaybe<Array<Scalars['String']>>;
  orders?: InputMaybe<OrderUpdateManyWithoutAdBoardNestedInput>;
  playbackTimes?: InputMaybe<Array<PlaybackTimeCreateInput>>;
  pricePerDay?: InputMaybe<Scalars['Int']>;
  resolution?: InputMaybe<ResolutionCreateInput>;
  restrictedBusines?: InputMaybe<BusinessCategoryUpdateManyWithoutRestrictedByAdBoardsNestedInput>;
  screenSize?: InputMaybe<ScreenSizeCreateInput>;
  slots?: InputMaybe<Scalars['String']>;
  specifications?: InputMaybe<Array<SpecificationCreateInput>>;
  state?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<AdBoardStatus>;
  tags?: InputMaybe<Array<Scalars['String']>>;
  targetAudiences?: InputMaybe<Array<Scalars['String']>>;
  title?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<ScreenTypeCreateInput>;
  visible?: InputMaybe<Scalars['Boolean']>;
  workspace?: InputMaybe<WorkspaceUpdateOneRequiredWithoutAdBoardsNestedInput>;
};

export type AdBoardUpdateWithoutBookingsInput = {
  aboutSpecifications?: InputMaybe<Array<SpecificationCreateInput>>;
  accessLabels?: InputMaybe<AccessLabelUpdateManyWithoutAdBoardsNestedInput>;
  adBoardGroup?: InputMaybe<AdBoardGroupUpdateOneRequiredWithoutAdBoardNestedInput>;
  address?: InputMaybe<Scalars['String']>;
  alias?: InputMaybe<Scalars['String']>;
  bookedSlots?: InputMaybe<SlotUpdateManyWithoutAdBoardNestedInput>;
  category?: InputMaybe<BusinessCategoryUpdateOneWithoutAdBoardsNestedInput>;
  city?: InputMaybe<Scalars['String']>;
  country?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  createdBy?: InputMaybe<UserUpdateOneWithoutAdBoardsNestedInput>;
  description?: InputMaybe<Scalars['String']>;
  featuredImage?: InputMaybe<Scalars['String']>;
  galleryImgs?: InputMaybe<Array<Scalars['String']>>;
  href?: InputMaybe<Scalars['String']>;
  map?: InputMaybe<MapCreateInput>;
  notes?: InputMaybe<Array<Scalars['String']>>;
  orders?: InputMaybe<OrderUpdateManyWithoutAdBoardNestedInput>;
  playbackTimes?: InputMaybe<Array<PlaybackTimeCreateInput>>;
  pricePerDay?: InputMaybe<Scalars['Int']>;
  resolution?: InputMaybe<ResolutionCreateInput>;
  restrictedBusines?: InputMaybe<BusinessCategoryUpdateManyWithoutRestrictedByAdBoardsNestedInput>;
  screenSize?: InputMaybe<ScreenSizeCreateInput>;
  slots?: InputMaybe<Scalars['String']>;
  specifications?: InputMaybe<Array<SpecificationCreateInput>>;
  state?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<AdBoardStatus>;
  tags?: InputMaybe<Array<Scalars['String']>>;
  targetAudiences?: InputMaybe<Array<Scalars['String']>>;
  title?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<ScreenTypeCreateInput>;
  visible?: InputMaybe<Scalars['Boolean']>;
  workspace?: InputMaybe<WorkspaceUpdateOneRequiredWithoutAdBoardsNestedInput>;
};

export type AdBoardUpdateWithoutCategoryInput = {
  aboutSpecifications?: InputMaybe<Array<SpecificationCreateInput>>;
  accessLabels?: InputMaybe<AccessLabelUpdateManyWithoutAdBoardsNestedInput>;
  adBoardGroup?: InputMaybe<AdBoardGroupUpdateOneRequiredWithoutAdBoardNestedInput>;
  address?: InputMaybe<Scalars['String']>;
  alias?: InputMaybe<Scalars['String']>;
  bookedSlots?: InputMaybe<SlotUpdateManyWithoutAdBoardNestedInput>;
  bookings?: InputMaybe<BookingUpdateManyWithoutAdBoardNestedInput>;
  city?: InputMaybe<Scalars['String']>;
  country?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  createdBy?: InputMaybe<UserUpdateOneWithoutAdBoardsNestedInput>;
  description?: InputMaybe<Scalars['String']>;
  featuredImage?: InputMaybe<Scalars['String']>;
  galleryImgs?: InputMaybe<Array<Scalars['String']>>;
  href?: InputMaybe<Scalars['String']>;
  map?: InputMaybe<MapCreateInput>;
  notes?: InputMaybe<Array<Scalars['String']>>;
  orders?: InputMaybe<OrderUpdateManyWithoutAdBoardNestedInput>;
  playbackTimes?: InputMaybe<Array<PlaybackTimeCreateInput>>;
  pricePerDay?: InputMaybe<Scalars['Int']>;
  resolution?: InputMaybe<ResolutionCreateInput>;
  restrictedBusines?: InputMaybe<BusinessCategoryUpdateManyWithoutRestrictedByAdBoardsNestedInput>;
  screenSize?: InputMaybe<ScreenSizeCreateInput>;
  slots?: InputMaybe<Scalars['String']>;
  specifications?: InputMaybe<Array<SpecificationCreateInput>>;
  state?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<AdBoardStatus>;
  tags?: InputMaybe<Array<Scalars['String']>>;
  targetAudiences?: InputMaybe<Array<Scalars['String']>>;
  title?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<ScreenTypeCreateInput>;
  visible?: InputMaybe<Scalars['Boolean']>;
  workspace?: InputMaybe<WorkspaceUpdateOneRequiredWithoutAdBoardsNestedInput>;
};

export type AdBoardUpdateWithoutCreatedByInput = {
  aboutSpecifications?: InputMaybe<Array<SpecificationCreateInput>>;
  accessLabels?: InputMaybe<AccessLabelUpdateManyWithoutAdBoardsNestedInput>;
  adBoardGroup?: InputMaybe<AdBoardGroupUpdateOneRequiredWithoutAdBoardNestedInput>;
  address?: InputMaybe<Scalars['String']>;
  alias?: InputMaybe<Scalars['String']>;
  bookedSlots?: InputMaybe<SlotUpdateManyWithoutAdBoardNestedInput>;
  bookings?: InputMaybe<BookingUpdateManyWithoutAdBoardNestedInput>;
  category?: InputMaybe<BusinessCategoryUpdateOneWithoutAdBoardsNestedInput>;
  city?: InputMaybe<Scalars['String']>;
  country?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  description?: InputMaybe<Scalars['String']>;
  featuredImage?: InputMaybe<Scalars['String']>;
  galleryImgs?: InputMaybe<Array<Scalars['String']>>;
  href?: InputMaybe<Scalars['String']>;
  map?: InputMaybe<MapCreateInput>;
  notes?: InputMaybe<Array<Scalars['String']>>;
  orders?: InputMaybe<OrderUpdateManyWithoutAdBoardNestedInput>;
  playbackTimes?: InputMaybe<Array<PlaybackTimeCreateInput>>;
  pricePerDay?: InputMaybe<Scalars['Int']>;
  resolution?: InputMaybe<ResolutionCreateInput>;
  restrictedBusines?: InputMaybe<BusinessCategoryUpdateManyWithoutRestrictedByAdBoardsNestedInput>;
  screenSize?: InputMaybe<ScreenSizeCreateInput>;
  slots?: InputMaybe<Scalars['String']>;
  specifications?: InputMaybe<Array<SpecificationCreateInput>>;
  state?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<AdBoardStatus>;
  tags?: InputMaybe<Array<Scalars['String']>>;
  targetAudiences?: InputMaybe<Array<Scalars['String']>>;
  title?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<ScreenTypeCreateInput>;
  visible?: InputMaybe<Scalars['Boolean']>;
  workspace?: InputMaybe<WorkspaceUpdateOneRequiredWithoutAdBoardsNestedInput>;
};

export type AdBoardUpdateWithoutOrdersInput = {
  aboutSpecifications?: InputMaybe<Array<SpecificationCreateInput>>;
  accessLabels?: InputMaybe<AccessLabelUpdateManyWithoutAdBoardsNestedInput>;
  adBoardGroup?: InputMaybe<AdBoardGroupUpdateOneRequiredWithoutAdBoardNestedInput>;
  address?: InputMaybe<Scalars['String']>;
  alias?: InputMaybe<Scalars['String']>;
  bookedSlots?: InputMaybe<SlotUpdateManyWithoutAdBoardNestedInput>;
  bookings?: InputMaybe<BookingUpdateManyWithoutAdBoardNestedInput>;
  category?: InputMaybe<BusinessCategoryUpdateOneWithoutAdBoardsNestedInput>;
  city?: InputMaybe<Scalars['String']>;
  country?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  createdBy?: InputMaybe<UserUpdateOneWithoutAdBoardsNestedInput>;
  description?: InputMaybe<Scalars['String']>;
  featuredImage?: InputMaybe<Scalars['String']>;
  galleryImgs?: InputMaybe<Array<Scalars['String']>>;
  href?: InputMaybe<Scalars['String']>;
  map?: InputMaybe<MapCreateInput>;
  notes?: InputMaybe<Array<Scalars['String']>>;
  playbackTimes?: InputMaybe<Array<PlaybackTimeCreateInput>>;
  pricePerDay?: InputMaybe<Scalars['Int']>;
  resolution?: InputMaybe<ResolutionCreateInput>;
  restrictedBusines?: InputMaybe<BusinessCategoryUpdateManyWithoutRestrictedByAdBoardsNestedInput>;
  screenSize?: InputMaybe<ScreenSizeCreateInput>;
  slots?: InputMaybe<Scalars['String']>;
  specifications?: InputMaybe<Array<SpecificationCreateInput>>;
  state?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<AdBoardStatus>;
  tags?: InputMaybe<Array<Scalars['String']>>;
  targetAudiences?: InputMaybe<Array<Scalars['String']>>;
  title?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<ScreenTypeCreateInput>;
  visible?: InputMaybe<Scalars['Boolean']>;
  workspace?: InputMaybe<WorkspaceUpdateOneRequiredWithoutAdBoardsNestedInput>;
};

export type AdBoardUpdateWithoutRestrictedBusinesInput = {
  aboutSpecifications?: InputMaybe<Array<SpecificationCreateInput>>;
  accessLabels?: InputMaybe<AccessLabelUpdateManyWithoutAdBoardsNestedInput>;
  adBoardGroup?: InputMaybe<AdBoardGroupUpdateOneRequiredWithoutAdBoardNestedInput>;
  address?: InputMaybe<Scalars['String']>;
  alias?: InputMaybe<Scalars['String']>;
  bookedSlots?: InputMaybe<SlotUpdateManyWithoutAdBoardNestedInput>;
  bookings?: InputMaybe<BookingUpdateManyWithoutAdBoardNestedInput>;
  category?: InputMaybe<BusinessCategoryUpdateOneWithoutAdBoardsNestedInput>;
  city?: InputMaybe<Scalars['String']>;
  country?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  createdBy?: InputMaybe<UserUpdateOneWithoutAdBoardsNestedInput>;
  description?: InputMaybe<Scalars['String']>;
  featuredImage?: InputMaybe<Scalars['String']>;
  galleryImgs?: InputMaybe<Array<Scalars['String']>>;
  href?: InputMaybe<Scalars['String']>;
  map?: InputMaybe<MapCreateInput>;
  notes?: InputMaybe<Array<Scalars['String']>>;
  orders?: InputMaybe<OrderUpdateManyWithoutAdBoardNestedInput>;
  playbackTimes?: InputMaybe<Array<PlaybackTimeCreateInput>>;
  pricePerDay?: InputMaybe<Scalars['Int']>;
  resolution?: InputMaybe<ResolutionCreateInput>;
  screenSize?: InputMaybe<ScreenSizeCreateInput>;
  slots?: InputMaybe<Scalars['String']>;
  specifications?: InputMaybe<Array<SpecificationCreateInput>>;
  state?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<AdBoardStatus>;
  tags?: InputMaybe<Array<Scalars['String']>>;
  targetAudiences?: InputMaybe<Array<Scalars['String']>>;
  title?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<ScreenTypeCreateInput>;
  visible?: InputMaybe<Scalars['Boolean']>;
  workspace?: InputMaybe<WorkspaceUpdateOneRequiredWithoutAdBoardsNestedInput>;
};

export type AdBoardUpdateWithoutWorkspaceInput = {
  aboutSpecifications?: InputMaybe<Array<SpecificationCreateInput>>;
  accessLabels?: InputMaybe<AccessLabelUpdateManyWithoutAdBoardsNestedInput>;
  adBoardGroup?: InputMaybe<AdBoardGroupUpdateOneRequiredWithoutAdBoardNestedInput>;
  address?: InputMaybe<Scalars['String']>;
  alias?: InputMaybe<Scalars['String']>;
  bookedSlots?: InputMaybe<SlotUpdateManyWithoutAdBoardNestedInput>;
  bookings?: InputMaybe<BookingUpdateManyWithoutAdBoardNestedInput>;
  category?: InputMaybe<BusinessCategoryUpdateOneWithoutAdBoardsNestedInput>;
  city?: InputMaybe<Scalars['String']>;
  country?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  createdBy?: InputMaybe<UserUpdateOneWithoutAdBoardsNestedInput>;
  description?: InputMaybe<Scalars['String']>;
  featuredImage?: InputMaybe<Scalars['String']>;
  galleryImgs?: InputMaybe<Array<Scalars['String']>>;
  href?: InputMaybe<Scalars['String']>;
  map?: InputMaybe<MapCreateInput>;
  notes?: InputMaybe<Array<Scalars['String']>>;
  orders?: InputMaybe<OrderUpdateManyWithoutAdBoardNestedInput>;
  playbackTimes?: InputMaybe<Array<PlaybackTimeCreateInput>>;
  pricePerDay?: InputMaybe<Scalars['Int']>;
  resolution?: InputMaybe<ResolutionCreateInput>;
  restrictedBusines?: InputMaybe<BusinessCategoryUpdateManyWithoutRestrictedByAdBoardsNestedInput>;
  screenSize?: InputMaybe<ScreenSizeCreateInput>;
  slots?: InputMaybe<Scalars['String']>;
  specifications?: InputMaybe<Array<SpecificationCreateInput>>;
  state?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<AdBoardStatus>;
  tags?: InputMaybe<Array<Scalars['String']>>;
  targetAudiences?: InputMaybe<Array<Scalars['String']>>;
  title?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<ScreenTypeCreateInput>;
  visible?: InputMaybe<Scalars['Boolean']>;
};

export type AdBoardUpsertWithWhereUniqueWithoutAccessLabelsInput = {
  create: AdBoardCreateWithoutAccessLabelsInput;
  update: AdBoardUpdateWithoutAccessLabelsInput;
  where: AdBoardWhereUniqueInput;
};

export type AdBoardUpsertWithWhereUniqueWithoutCategoryInput = {
  create: AdBoardCreateWithoutCategoryInput;
  update: AdBoardUpdateWithoutCategoryInput;
  where: AdBoardWhereUniqueInput;
};

export type AdBoardUpsertWithWhereUniqueWithoutCreatedByInput = {
  create: AdBoardCreateWithoutCreatedByInput;
  update: AdBoardUpdateWithoutCreatedByInput;
  where: AdBoardWhereUniqueInput;
};

export type AdBoardUpsertWithWhereUniqueWithoutRestrictedBusinesInput = {
  create: AdBoardCreateWithoutRestrictedBusinesInput;
  update: AdBoardUpdateWithoutRestrictedBusinesInput;
  where: AdBoardWhereUniqueInput;
};

export type AdBoardUpsertWithWhereUniqueWithoutWorkspaceInput = {
  create: AdBoardCreateWithoutWorkspaceInput;
  update: AdBoardUpdateWithoutWorkspaceInput;
  where: AdBoardWhereUniqueInput;
};

export type AdBoardUpsertWithoutAdBoardGroupInput = {
  create: AdBoardCreateWithoutAdBoardGroupInput;
  update: AdBoardUpdateWithoutAdBoardGroupInput;
  where?: InputMaybe<AdBoardWhereInput>;
};

export type AdBoardUpsertWithoutBookedSlotsInput = {
  create: AdBoardCreateWithoutBookedSlotsInput;
  update: AdBoardUpdateWithoutBookedSlotsInput;
  where?: InputMaybe<AdBoardWhereInput>;
};

export type AdBoardUpsertWithoutBookingsInput = {
  create: AdBoardCreateWithoutBookingsInput;
  update: AdBoardUpdateWithoutBookingsInput;
  where?: InputMaybe<AdBoardWhereInput>;
};

export type AdBoardUpsertWithoutOrdersInput = {
  create: AdBoardCreateWithoutOrdersInput;
  update: AdBoardUpdateWithoutOrdersInput;
  where?: InputMaybe<AdBoardWhereInput>;
};

export type AdBoardWhereInput = {
  AND?: InputMaybe<Array<AdBoardWhereInput>>;
  NOT?: InputMaybe<Array<AdBoardWhereInput>>;
  OR?: InputMaybe<Array<AdBoardWhereInput>>;
  aboutSpecifications?: InputMaybe<Array<SpecificationObjectEqualityInput>>;
  accessLabels?: InputMaybe<AccessLabelListRelationFilter>;
  accessLabelsIDs?: InputMaybe<StringNullableListFilter>;
  adBoardGroup?: InputMaybe<AdBoardGroupRelationFilter>;
  adBoardGroupId?: InputMaybe<StringFilter>;
  address?: InputMaybe<StringFilter>;
  alias?: InputMaybe<StringNullableFilter>;
  bookedSlots?: InputMaybe<SlotListRelationFilter>;
  bookings?: InputMaybe<BookingListRelationFilter>;
  category?: InputMaybe<BusinessCategoryNullableRelationFilter>;
  categoryId?: InputMaybe<StringNullableFilter>;
  city?: InputMaybe<StringNullableFilter>;
  country?: InputMaybe<StringNullableFilter>;
  createdAt?: InputMaybe<DateTimeNullableFilter>;
  createdBy?: InputMaybe<UserNullableRelationFilter>;
  createdByUserId?: InputMaybe<StringNullableFilter>;
  description?: InputMaybe<StringNullableFilter>;
  featuredImage?: InputMaybe<StringNullableFilter>;
  galleryImgs?: InputMaybe<StringNullableListFilter>;
  href?: InputMaybe<StringNullableFilter>;
  id?: InputMaybe<StringFilter>;
  map?: InputMaybe<MapCompositeFilter>;
  notes?: InputMaybe<StringNullableListFilter>;
  orders?: InputMaybe<OrderListRelationFilter>;
  playbackTimes?: InputMaybe<Array<PlaybackTimeObjectEqualityInput>>;
  pricePerDay?: InputMaybe<IntFilter>;
  resolution?: InputMaybe<ResolutionNullableCompositeFilter>;
  restrictedBusines?: InputMaybe<BusinessCategoryListRelationFilter>;
  restrictedBusinessIds?: InputMaybe<StringNullableListFilter>;
  screenSize?: InputMaybe<ScreenSizeNullableCompositeFilter>;
  slots?: InputMaybe<StringNullableFilter>;
  specifications?: InputMaybe<Array<SpecificationObjectEqualityInput>>;
  state?: InputMaybe<StringNullableFilter>;
  status?: InputMaybe<EnumAdBoardStatusFilter>;
  tags?: InputMaybe<StringNullableListFilter>;
  targetAudiences?: InputMaybe<StringNullableListFilter>;
  title?: InputMaybe<StringFilter>;
  type?: InputMaybe<ScreenTypeNullableCompositeFilter>;
  visible?: InputMaybe<BoolFilter>;
  workspace?: InputMaybe<WorkspaceRelationFilter>;
  workspaceId?: InputMaybe<StringFilter>;
};

export type AdBoardWhereUniqueInput = {
  AND?: InputMaybe<Array<AdBoardWhereInput>>;
  NOT?: InputMaybe<Array<AdBoardWhereInput>>;
  OR?: InputMaybe<Array<AdBoardWhereInput>>;
  aboutSpecifications?: InputMaybe<Array<SpecificationObjectEqualityInput>>;
  accessLabels?: InputMaybe<AccessLabelListRelationFilter>;
  accessLabelsIDs?: InputMaybe<StringNullableListFilter>;
  adBoardGroup?: InputMaybe<AdBoardGroupRelationFilter>;
  adBoardGroupId?: InputMaybe<Scalars['String']>;
  address?: InputMaybe<StringFilter>;
  alias?: InputMaybe<StringNullableFilter>;
  bookedSlots?: InputMaybe<SlotListRelationFilter>;
  bookings?: InputMaybe<BookingListRelationFilter>;
  category?: InputMaybe<BusinessCategoryNullableRelationFilter>;
  categoryId?: InputMaybe<StringNullableFilter>;
  city?: InputMaybe<StringNullableFilter>;
  country?: InputMaybe<StringNullableFilter>;
  createdAt?: InputMaybe<DateTimeNullableFilter>;
  createdBy?: InputMaybe<UserNullableRelationFilter>;
  createdByUserId?: InputMaybe<StringNullableFilter>;
  description?: InputMaybe<StringNullableFilter>;
  featuredImage?: InputMaybe<StringNullableFilter>;
  galleryImgs?: InputMaybe<StringNullableListFilter>;
  href?: InputMaybe<StringNullableFilter>;
  id?: InputMaybe<Scalars['String']>;
  map?: InputMaybe<MapCompositeFilter>;
  notes?: InputMaybe<StringNullableListFilter>;
  orders?: InputMaybe<OrderListRelationFilter>;
  playbackTimes?: InputMaybe<Array<PlaybackTimeObjectEqualityInput>>;
  pricePerDay?: InputMaybe<IntFilter>;
  resolution?: InputMaybe<ResolutionNullableCompositeFilter>;
  restrictedBusines?: InputMaybe<BusinessCategoryListRelationFilter>;
  restrictedBusinessIds?: InputMaybe<StringNullableListFilter>;
  screenSize?: InputMaybe<ScreenSizeNullableCompositeFilter>;
  slots?: InputMaybe<StringNullableFilter>;
  specifications?: InputMaybe<Array<SpecificationObjectEqualityInput>>;
  state?: InputMaybe<StringNullableFilter>;
  status?: InputMaybe<EnumAdBoardStatusFilter>;
  tags?: InputMaybe<StringNullableListFilter>;
  targetAudiences?: InputMaybe<StringNullableListFilter>;
  title?: InputMaybe<StringFilter>;
  type?: InputMaybe<ScreenTypeNullableCompositeFilter>;
  visible?: InputMaybe<BoolFilter>;
  workspace?: InputMaybe<WorkspaceRelationFilter>;
  workspaceId?: InputMaybe<StringFilter>;
};

export type AffectedRowsOutput = {
  __typename?: 'AffectedRowsOutput';
  count: Scalars['Int'];
};

export type AggregateAccessLabel = {
  __typename?: 'AggregateAccessLabel';
  _count?: Maybe<AccessLabelCountAggregate>;
  _max?: Maybe<AccessLabelMaxAggregate>;
  _min?: Maybe<AccessLabelMinAggregate>;
};

export type AggregateAdBoard = {
  __typename?: 'AggregateAdBoard';
  _avg?: Maybe<AdBoardAvgAggregate>;
  _count?: Maybe<AdBoardCountAggregate>;
  _max?: Maybe<AdBoardMaxAggregate>;
  _min?: Maybe<AdBoardMinAggregate>;
  _sum?: Maybe<AdBoardSumAggregate>;
};

export type AggregateAdBoardGroup = {
  __typename?: 'AggregateAdBoardGroup';
  _count?: Maybe<AdBoardGroupCountAggregate>;
  _max?: Maybe<AdBoardGroupMaxAggregate>;
  _min?: Maybe<AdBoardGroupMinAggregate>;
};

export type AggregateAudit = {
  __typename?: 'AggregateAudit';
  _count?: Maybe<AuditCountAggregate>;
  _max?: Maybe<AuditMaxAggregate>;
  _min?: Maybe<AuditMinAggregate>;
};

export type AggregateBooking = {
  __typename?: 'AggregateBooking';
  _count?: Maybe<BookingCountAggregate>;
  _max?: Maybe<BookingMaxAggregate>;
  _min?: Maybe<BookingMinAggregate>;
};

export type AggregateBusinessCategory = {
  __typename?: 'AggregateBusinessCategory';
  _count?: Maybe<BusinessCategoryCountAggregate>;
  _max?: Maybe<BusinessCategoryMaxAggregate>;
  _min?: Maybe<BusinessCategoryMinAggregate>;
};

export type AggregateCampaign = {
  __typename?: 'AggregateCampaign';
  _count?: Maybe<CampaignCountAggregate>;
  _max?: Maybe<CampaignMaxAggregate>;
  _min?: Maybe<CampaignMinAggregate>;
};

export type AggregateChangelog = {
  __typename?: 'AggregateChangelog';
  _count?: Maybe<ChangelogCountAggregate>;
  _max?: Maybe<ChangelogMaxAggregate>;
  _min?: Maybe<ChangelogMinAggregate>;
};

export type AggregateFile = {
  __typename?: 'AggregateFile';
  _avg?: Maybe<FileAvgAggregate>;
  _count?: Maybe<FileCountAggregate>;
  _max?: Maybe<FileMaxAggregate>;
  _min?: Maybe<FileMinAggregate>;
  _sum?: Maybe<FileSumAggregate>;
};

export type AggregateMembership = {
  __typename?: 'AggregateMembership';
  _count?: Maybe<MembershipCountAggregate>;
  _max?: Maybe<MembershipMaxAggregate>;
  _min?: Maybe<MembershipMinAggregate>;
};

export type AggregateOrder = {
  __typename?: 'AggregateOrder';
  _avg?: Maybe<OrderAvgAggregate>;
  _count?: Maybe<OrderCountAggregate>;
  _max?: Maybe<OrderMaxAggregate>;
  _min?: Maybe<OrderMinAggregate>;
  _sum?: Maybe<OrderSumAggregate>;
};

export type AggregatePayout = {
  __typename?: 'AggregatePayout';
  _avg?: Maybe<PayoutAvgAggregate>;
  _count?: Maybe<PayoutCountAggregate>;
  _max?: Maybe<PayoutMaxAggregate>;
  _min?: Maybe<PayoutMinAggregate>;
  _sum?: Maybe<PayoutSumAggregate>;
};

export type AggregatePiSignagePlayer = {
  __typename?: 'AggregatePiSignagePlayer';
  _count?: Maybe<PiSignagePlayerCountAggregate>;
  _max?: Maybe<PiSignagePlayerMaxAggregate>;
  _min?: Maybe<PiSignagePlayerMinAggregate>;
};

export type AggregatePlaylist = {
  __typename?: 'AggregatePlaylist';
  _count?: Maybe<PlaylistCountAggregate>;
  _max?: Maybe<PlaylistMaxAggregate>;
  _min?: Maybe<PlaylistMinAggregate>;
};

export type AggregateRole = {
  __typename?: 'AggregateRole';
  _count?: Maybe<RoleCountAggregate>;
  _max?: Maybe<RoleMaxAggregate>;
  _min?: Maybe<RoleMinAggregate>;
};

export type AggregateSlot = {
  __typename?: 'AggregateSlot';
  _avg?: Maybe<SlotAvgAggregate>;
  _count?: Maybe<SlotCountAggregate>;
  _max?: Maybe<SlotMaxAggregate>;
  _min?: Maybe<SlotMinAggregate>;
  _sum?: Maybe<SlotSumAggregate>;
};

export type AggregateTransaction = {
  __typename?: 'AggregateTransaction';
  _avg?: Maybe<TransactionAvgAggregate>;
  _count?: Maybe<TransactionCountAggregate>;
  _max?: Maybe<TransactionMaxAggregate>;
  _min?: Maybe<TransactionMinAggregate>;
  _sum?: Maybe<TransactionSumAggregate>;
};

export type AggregateUser = {
  __typename?: 'AggregateUser';
  _count?: Maybe<UserCountAggregate>;
  _max?: Maybe<UserMaxAggregate>;
  _min?: Maybe<UserMinAggregate>;
};

export type AggregateWorkspace = {
  __typename?: 'AggregateWorkspace';
  _count?: Maybe<WorkspaceCountAggregate>;
  _max?: Maybe<WorkspaceMaxAggregate>;
  _min?: Maybe<WorkspaceMinAggregate>;
};

export type Audit = {
  __typename?: 'Audit';
  action: Scalars['String'];
  createdAt: Scalars['DateTime'];
  entity?: Maybe<Entity>;
  id: Scalars['String'];
  message: Scalars['String'];
  updates?: Maybe<Scalars['JSON']>;
  user: User;
  userId: Scalars['String'];
  workspace?: Maybe<Workspace>;
  workspaceId?: Maybe<Scalars['String']>;
};


export type AuditWorkspaceArgs = {
  where?: InputMaybe<WorkspaceWhereInput>;
};

export type AuditCountAggregate = {
  __typename?: 'AuditCountAggregate';
  _all: Scalars['Int'];
  action: Scalars['Int'];
  createdAt: Scalars['Int'];
  id: Scalars['Int'];
  message: Scalars['Int'];
  updates: Scalars['Int'];
  userId: Scalars['Int'];
  workspaceId: Scalars['Int'];
};

export type AuditCountOrderByAggregateInput = {
  action?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  message?: InputMaybe<SortOrder>;
  updates?: InputMaybe<SortOrder>;
  userId?: InputMaybe<SortOrder>;
  workspaceId?: InputMaybe<SortOrder>;
};

export type AuditCreateInput = {
  action: Scalars['String'];
  createdAt?: InputMaybe<Scalars['DateTime']>;
  entity?: InputMaybe<EntityCreateInput>;
  id?: InputMaybe<Scalars['String']>;
  message: Scalars['String'];
  updates?: InputMaybe<Scalars['JSON']>;
  user: UserCreateNestedOneWithoutAuditsInput;
  workspace?: InputMaybe<WorkspaceCreateNestedOneWithoutAuditsInput>;
};

export type AuditCreateManyInput = {
  action: Scalars['String'];
  createdAt?: InputMaybe<Scalars['DateTime']>;
  entity?: InputMaybe<EntityCreateInput>;
  id?: InputMaybe<Scalars['String']>;
  message: Scalars['String'];
  updates?: InputMaybe<Scalars['JSON']>;
  userId: Scalars['String'];
  workspaceId?: InputMaybe<Scalars['String']>;
};

export type AuditCreateManyUserInput = {
  action: Scalars['String'];
  createdAt?: InputMaybe<Scalars['DateTime']>;
  entity?: InputMaybe<EntityCreateInput>;
  id?: InputMaybe<Scalars['String']>;
  message: Scalars['String'];
  updates?: InputMaybe<Scalars['JSON']>;
  workspaceId?: InputMaybe<Scalars['String']>;
};

export type AuditCreateManyUserInputEnvelope = {
  data: Array<AuditCreateManyUserInput>;
};

export type AuditCreateManyWorkspaceInput = {
  action: Scalars['String'];
  createdAt?: InputMaybe<Scalars['DateTime']>;
  entity?: InputMaybe<EntityCreateInput>;
  id?: InputMaybe<Scalars['String']>;
  message: Scalars['String'];
  updates?: InputMaybe<Scalars['JSON']>;
  userId: Scalars['String'];
};

export type AuditCreateManyWorkspaceInputEnvelope = {
  data: Array<AuditCreateManyWorkspaceInput>;
};

export type AuditCreateNestedManyWithoutUserInput = {
  connect?: InputMaybe<Array<AuditWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<AuditCreateOrConnectWithoutUserInput>>;
  create?: InputMaybe<Array<AuditCreateWithoutUserInput>>;
  createMany?: InputMaybe<AuditCreateManyUserInputEnvelope>;
};

export type AuditCreateNestedManyWithoutWorkspaceInput = {
  connect?: InputMaybe<Array<AuditWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<AuditCreateOrConnectWithoutWorkspaceInput>>;
  create?: InputMaybe<Array<AuditCreateWithoutWorkspaceInput>>;
  createMany?: InputMaybe<AuditCreateManyWorkspaceInputEnvelope>;
};

export type AuditCreateOrConnectWithoutUserInput = {
  create: AuditCreateWithoutUserInput;
  where: AuditWhereUniqueInput;
};

export type AuditCreateOrConnectWithoutWorkspaceInput = {
  create: AuditCreateWithoutWorkspaceInput;
  where: AuditWhereUniqueInput;
};

export type AuditCreateWithoutUserInput = {
  action: Scalars['String'];
  createdAt?: InputMaybe<Scalars['DateTime']>;
  entity?: InputMaybe<EntityCreateInput>;
  id?: InputMaybe<Scalars['String']>;
  message: Scalars['String'];
  updates?: InputMaybe<Scalars['JSON']>;
  workspace?: InputMaybe<WorkspaceCreateNestedOneWithoutAuditsInput>;
};

export type AuditCreateWithoutWorkspaceInput = {
  action: Scalars['String'];
  createdAt?: InputMaybe<Scalars['DateTime']>;
  entity?: InputMaybe<EntityCreateInput>;
  id?: InputMaybe<Scalars['String']>;
  message: Scalars['String'];
  updates?: InputMaybe<Scalars['JSON']>;
  user: UserCreateNestedOneWithoutAuditsInput;
};

export type AuditGroupBy = {
  __typename?: 'AuditGroupBy';
  _count?: Maybe<AuditCountAggregate>;
  _max?: Maybe<AuditMaxAggregate>;
  _min?: Maybe<AuditMinAggregate>;
  action: Scalars['String'];
  createdAt: Scalars['DateTime'];
  id: Scalars['String'];
  message: Scalars['String'];
  updates?: Maybe<Scalars['JSON']>;
  userId: Scalars['String'];
  workspaceId?: Maybe<Scalars['String']>;
};

export type AuditListRelationFilter = {
  every?: InputMaybe<AuditWhereInput>;
  none?: InputMaybe<AuditWhereInput>;
  some?: InputMaybe<AuditWhereInput>;
};

export type AuditMaxAggregate = {
  __typename?: 'AuditMaxAggregate';
  action?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  message?: Maybe<Scalars['String']>;
  userId?: Maybe<Scalars['String']>;
  workspaceId?: Maybe<Scalars['String']>;
};

export type AuditMaxOrderByAggregateInput = {
  action?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  message?: InputMaybe<SortOrder>;
  userId?: InputMaybe<SortOrder>;
  workspaceId?: InputMaybe<SortOrder>;
};

export type AuditMinAggregate = {
  __typename?: 'AuditMinAggregate';
  action?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  message?: Maybe<Scalars['String']>;
  userId?: Maybe<Scalars['String']>;
  workspaceId?: Maybe<Scalars['String']>;
};

export type AuditMinOrderByAggregateInput = {
  action?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  message?: InputMaybe<SortOrder>;
  userId?: InputMaybe<SortOrder>;
  workspaceId?: InputMaybe<SortOrder>;
};

export type AuditOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type AuditOrderByWithAggregationInput = {
  _count?: InputMaybe<AuditCountOrderByAggregateInput>;
  _max?: InputMaybe<AuditMaxOrderByAggregateInput>;
  _min?: InputMaybe<AuditMinOrderByAggregateInput>;
  action?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  message?: InputMaybe<SortOrder>;
  updates?: InputMaybe<SortOrder>;
  userId?: InputMaybe<SortOrder>;
  workspaceId?: InputMaybe<SortOrder>;
};

export type AuditOrderByWithRelationInput = {
  action?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  entity?: InputMaybe<EntityOrderByInput>;
  id?: InputMaybe<SortOrder>;
  message?: InputMaybe<SortOrder>;
  updates?: InputMaybe<SortOrder>;
  user?: InputMaybe<UserOrderByWithRelationInput>;
  userId?: InputMaybe<SortOrder>;
  workspace?: InputMaybe<WorkspaceOrderByWithRelationInput>;
  workspaceId?: InputMaybe<SortOrder>;
};

export enum AuditScalarFieldEnum {
  Action = 'action',
  CreatedAt = 'createdAt',
  Id = 'id',
  Message = 'message',
  Updates = 'updates',
  UserId = 'userId',
  WorkspaceId = 'workspaceId'
}

export type AuditScalarWhereInput = {
  AND?: InputMaybe<Array<AuditScalarWhereInput>>;
  NOT?: InputMaybe<Array<AuditScalarWhereInput>>;
  OR?: InputMaybe<Array<AuditScalarWhereInput>>;
  action?: InputMaybe<StringFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  id?: InputMaybe<StringFilter>;
  message?: InputMaybe<StringFilter>;
  updates?: InputMaybe<JsonNullableFilter>;
  userId?: InputMaybe<StringFilter>;
  workspaceId?: InputMaybe<StringNullableFilter>;
};

export type AuditScalarWhereWithAggregatesInput = {
  AND?: InputMaybe<Array<AuditScalarWhereWithAggregatesInput>>;
  NOT?: InputMaybe<Array<AuditScalarWhereWithAggregatesInput>>;
  OR?: InputMaybe<Array<AuditScalarWhereWithAggregatesInput>>;
  action?: InputMaybe<StringWithAggregatesFilter>;
  createdAt?: InputMaybe<DateTimeWithAggregatesFilter>;
  id?: InputMaybe<StringWithAggregatesFilter>;
  message?: InputMaybe<StringWithAggregatesFilter>;
  updates?: InputMaybe<JsonNullableWithAggregatesFilter>;
  userId?: InputMaybe<StringWithAggregatesFilter>;
  workspaceId?: InputMaybe<StringNullableWithAggregatesFilter>;
};

export type AuditUpdateInput = {
  action?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  entity?: InputMaybe<EntityCreateInput>;
  message?: InputMaybe<Scalars['String']>;
  updates?: InputMaybe<Scalars['JSON']>;
  user?: InputMaybe<UserUpdateOneRequiredWithoutAuditsNestedInput>;
  workspace?: InputMaybe<WorkspaceUpdateOneWithoutAuditsNestedInput>;
};

export type AuditUpdateManyMutationInput = {
  action?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  entity?: InputMaybe<EntityCreateInput>;
  message?: InputMaybe<Scalars['String']>;
  updates?: InputMaybe<Scalars['JSON']>;
};

export type AuditUpdateManyWithWhereWithoutUserInput = {
  data: AuditUpdateManyMutationInput;
  where: AuditScalarWhereInput;
};

export type AuditUpdateManyWithWhereWithoutWorkspaceInput = {
  data: AuditUpdateManyMutationInput;
  where: AuditScalarWhereInput;
};

export type AuditUpdateManyWithoutUserNestedInput = {
  connect?: InputMaybe<Array<AuditWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<AuditCreateOrConnectWithoutUserInput>>;
  create?: InputMaybe<Array<AuditCreateWithoutUserInput>>;
  createMany?: InputMaybe<AuditCreateManyUserInputEnvelope>;
  delete?: InputMaybe<Array<AuditWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<AuditScalarWhereInput>>;
  disconnect?: InputMaybe<Array<AuditWhereUniqueInput>>;
  set?: InputMaybe<Array<AuditWhereUniqueInput>>;
  update?: InputMaybe<Array<AuditUpdateWithWhereUniqueWithoutUserInput>>;
  updateMany?: InputMaybe<Array<AuditUpdateManyWithWhereWithoutUserInput>>;
  upsert?: InputMaybe<Array<AuditUpsertWithWhereUniqueWithoutUserInput>>;
};

export type AuditUpdateManyWithoutWorkspaceNestedInput = {
  connect?: InputMaybe<Array<AuditWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<AuditCreateOrConnectWithoutWorkspaceInput>>;
  create?: InputMaybe<Array<AuditCreateWithoutWorkspaceInput>>;
  createMany?: InputMaybe<AuditCreateManyWorkspaceInputEnvelope>;
  delete?: InputMaybe<Array<AuditWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<AuditScalarWhereInput>>;
  disconnect?: InputMaybe<Array<AuditWhereUniqueInput>>;
  set?: InputMaybe<Array<AuditWhereUniqueInput>>;
  update?: InputMaybe<Array<AuditUpdateWithWhereUniqueWithoutWorkspaceInput>>;
  updateMany?: InputMaybe<Array<AuditUpdateManyWithWhereWithoutWorkspaceInput>>;
  upsert?: InputMaybe<Array<AuditUpsertWithWhereUniqueWithoutWorkspaceInput>>;
};

export type AuditUpdateWithWhereUniqueWithoutUserInput = {
  data: AuditUpdateWithoutUserInput;
  where: AuditWhereUniqueInput;
};

export type AuditUpdateWithWhereUniqueWithoutWorkspaceInput = {
  data: AuditUpdateWithoutWorkspaceInput;
  where: AuditWhereUniqueInput;
};

export type AuditUpdateWithoutUserInput = {
  action?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  entity?: InputMaybe<EntityCreateInput>;
  message?: InputMaybe<Scalars['String']>;
  updates?: InputMaybe<Scalars['JSON']>;
  workspace?: InputMaybe<WorkspaceUpdateOneWithoutAuditsNestedInput>;
};

export type AuditUpdateWithoutWorkspaceInput = {
  action?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  entity?: InputMaybe<EntityCreateInput>;
  message?: InputMaybe<Scalars['String']>;
  updates?: InputMaybe<Scalars['JSON']>;
  user?: InputMaybe<UserUpdateOneRequiredWithoutAuditsNestedInput>;
};

export type AuditUpsertWithWhereUniqueWithoutUserInput = {
  create: AuditCreateWithoutUserInput;
  update: AuditUpdateWithoutUserInput;
  where: AuditWhereUniqueInput;
};

export type AuditUpsertWithWhereUniqueWithoutWorkspaceInput = {
  create: AuditCreateWithoutWorkspaceInput;
  update: AuditUpdateWithoutWorkspaceInput;
  where: AuditWhereUniqueInput;
};

export type AuditWhereInput = {
  AND?: InputMaybe<Array<AuditWhereInput>>;
  NOT?: InputMaybe<Array<AuditWhereInput>>;
  OR?: InputMaybe<Array<AuditWhereInput>>;
  action?: InputMaybe<StringFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  entity?: InputMaybe<EntityNullableCompositeFilter>;
  id?: InputMaybe<StringFilter>;
  message?: InputMaybe<StringFilter>;
  updates?: InputMaybe<JsonNullableFilter>;
  user?: InputMaybe<UserRelationFilter>;
  userId?: InputMaybe<StringFilter>;
  workspace?: InputMaybe<WorkspaceNullableRelationFilter>;
  workspaceId?: InputMaybe<StringNullableFilter>;
};

export type AuditWhereUniqueInput = {
  AND?: InputMaybe<Array<AuditWhereInput>>;
  NOT?: InputMaybe<Array<AuditWhereInput>>;
  OR?: InputMaybe<Array<AuditWhereInput>>;
  action?: InputMaybe<StringFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  entity?: InputMaybe<EntityNullableCompositeFilter>;
  id?: InputMaybe<Scalars['String']>;
  message?: InputMaybe<StringFilter>;
  updates?: InputMaybe<JsonNullableFilter>;
  user?: InputMaybe<UserRelationFilter>;
  userId?: InputMaybe<StringFilter>;
  workspace?: InputMaybe<WorkspaceNullableRelationFilter>;
  workspaceId?: InputMaybe<StringNullableFilter>;
};

export type Booking = {
  __typename?: 'Booking';
  _count?: Maybe<BookingCount>;
  accessLabelIDs: Array<Scalars['String']>;
  accessLabels: Array<AccessLabel>;
  adBoard: AdBoard;
  adBoardId: Scalars['String'];
  additionalInformation?: Maybe<Scalars['String']>;
  assets: Array<File>;
  assetsIDs: Array<Scalars['String']>;
  bookedSlots: Array<Slot>;
  bookingCode: Scalars['String'];
  bookingDate: Scalars['DateTime'];
  bookingDetails: BookingDetails;
  bookingStatus: BookingStatus;
  campaign?: Maybe<Campaign>;
  campaignId?: Maybe<Scalars['String']>;
  changelogs: Array<Changelog>;
  id: Scalars['String'];
  origin?: Maybe<Scalars['String']>;
  payment?: Maybe<BookingPayment>;
  payouts: Array<Payout>;
  pisignage?: Maybe<BookingPisignageData>;
  priceSummary?: Maybe<OrderPriceSummary>;
  proofs: Array<File>;
  refund?: Maybe<BookingRefund>;
  selectedDates: OrderSelectedDate;
  sharedUserIds: Array<Scalars['String']>;
  sharedUsers: Array<User>;
  user: User;
  userId: Scalars['String'];
  workspace?: Maybe<Workspace>;
  workspaceId?: Maybe<Scalars['String']>;
};


export type BookingAccessLabelsArgs = {
  cursor?: InputMaybe<AccessLabelWhereUniqueInput>;
  distinct?: InputMaybe<Array<AccessLabelScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<AccessLabelOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<AccessLabelWhereInput>;
};


export type BookingAssetsArgs = {
  cursor?: InputMaybe<FileWhereUniqueInput>;
  distinct?: InputMaybe<Array<FileScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<FileOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<FileWhereInput>;
};


export type BookingBookedSlotsArgs = {
  cursor?: InputMaybe<SlotWhereUniqueInput>;
  distinct?: InputMaybe<Array<SlotScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<SlotOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<SlotWhereInput>;
};


export type BookingCampaignArgs = {
  where?: InputMaybe<CampaignWhereInput>;
};


export type BookingChangelogsArgs = {
  cursor?: InputMaybe<ChangelogWhereUniqueInput>;
  distinct?: InputMaybe<Array<ChangelogScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<ChangelogOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<ChangelogWhereInput>;
};


export type BookingPayoutsArgs = {
  cursor?: InputMaybe<PayoutWhereUniqueInput>;
  distinct?: InputMaybe<Array<PayoutScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<PayoutOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<PayoutWhereInput>;
};


export type BookingProofsArgs = {
  cursor?: InputMaybe<FileWhereUniqueInput>;
  distinct?: InputMaybe<Array<FileScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<FileOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<FileWhereInput>;
};


export type BookingSharedUsersArgs = {
  cursor?: InputMaybe<UserWhereUniqueInput>;
  distinct?: InputMaybe<Array<UserScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<UserOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<UserWhereInput>;
};


export type BookingWorkspaceArgs = {
  where?: InputMaybe<WorkspaceWhereInput>;
};

export type BookingCount = {
  __typename?: 'BookingCount';
  accessLabels: Scalars['Int'];
  assets: Scalars['Int'];
  bookedSlots: Scalars['Int'];
  changelogs: Scalars['Int'];
  payouts: Scalars['Int'];
  proofs: Scalars['Int'];
  sharedUsers: Scalars['Int'];
};


export type BookingCountAccessLabelsArgs = {
  where?: InputMaybe<AccessLabelWhereInput>;
};


export type BookingCountAssetsArgs = {
  where?: InputMaybe<FileWhereInput>;
};


export type BookingCountBookedSlotsArgs = {
  where?: InputMaybe<SlotWhereInput>;
};


export type BookingCountChangelogsArgs = {
  where?: InputMaybe<ChangelogWhereInput>;
};


export type BookingCountPayoutsArgs = {
  where?: InputMaybe<PayoutWhereInput>;
};


export type BookingCountProofsArgs = {
  where?: InputMaybe<FileWhereInput>;
};


export type BookingCountSharedUsersArgs = {
  where?: InputMaybe<UserWhereInput>;
};

export type BookingCountAggregate = {
  __typename?: 'BookingCountAggregate';
  _all: Scalars['Int'];
  accessLabelIDs: Scalars['Int'];
  adBoardId: Scalars['Int'];
  additionalInformation: Scalars['Int'];
  assetsIDs: Scalars['Int'];
  bookingCode: Scalars['Int'];
  bookingDate: Scalars['Int'];
  bookingStatus: Scalars['Int'];
  campaignId: Scalars['Int'];
  id: Scalars['Int'];
  origin: Scalars['Int'];
  sharedUserIds: Scalars['Int'];
  userId: Scalars['Int'];
  workspaceId: Scalars['Int'];
};

export type BookingCountOrderByAggregateInput = {
  accessLabelIDs?: InputMaybe<SortOrder>;
  adBoardId?: InputMaybe<SortOrder>;
  additionalInformation?: InputMaybe<SortOrder>;
  assetsIDs?: InputMaybe<SortOrder>;
  bookingCode?: InputMaybe<SortOrder>;
  bookingDate?: InputMaybe<SortOrder>;
  bookingStatus?: InputMaybe<SortOrder>;
  campaignId?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  origin?: InputMaybe<SortOrder>;
  sharedUserIds?: InputMaybe<SortOrder>;
  userId?: InputMaybe<SortOrder>;
  workspaceId?: InputMaybe<SortOrder>;
};

export type BookingCreateInput = {
  accessLabels?: InputMaybe<AccessLabelCreateNestedManyWithoutBookingsInput>;
  adBoard: AdBoardCreateNestedOneWithoutBookingsInput;
  additionalInformation?: InputMaybe<Scalars['String']>;
  assets?: InputMaybe<FileCreateNestedManyWithoutBookingsInput>;
  bookedSlots?: InputMaybe<SlotCreateNestedManyWithoutBookingInput>;
  bookingCode: Scalars['String'];
  bookingDate?: InputMaybe<Scalars['DateTime']>;
  bookingDetails: BookingDetailsCreateInput;
  bookingStatus: BookingStatus;
  campaign?: InputMaybe<CampaignCreateNestedOneWithoutBookingsInput>;
  changelogs?: InputMaybe<ChangelogCreateNestedManyWithoutBookingInput>;
  id?: InputMaybe<Scalars['String']>;
  origin?: InputMaybe<Scalars['String']>;
  payment?: InputMaybe<BookingPaymentCreateInput>;
  payouts?: InputMaybe<PayoutCreateNestedManyWithoutBookingInput>;
  pisignage?: InputMaybe<BookingPisignageDataCreateInput>;
  priceSummary?: InputMaybe<OrderPriceSummaryCreateInput>;
  proofs?: InputMaybe<FileCreateNestedManyWithoutProofBookingInput>;
  refund?: InputMaybe<BookingRefundCreateInput>;
  selectedDates: OrderSelectedDateCreateInput;
  sharedUsers?: InputMaybe<UserCreateNestedManyWithoutSharedBookingsInput>;
  user: UserCreateNestedOneWithoutBookingsInput;
  workspace?: InputMaybe<WorkspaceCreateNestedOneWithoutBookingsInput>;
};

export type BookingCreateManyAdBoardInput = {
  accessLabelIDs?: InputMaybe<Array<Scalars['String']>>;
  additionalInformation?: InputMaybe<Scalars['String']>;
  assetsIDs?: InputMaybe<Array<Scalars['String']>>;
  bookingCode: Scalars['String'];
  bookingDate?: InputMaybe<Scalars['DateTime']>;
  bookingDetails: BookingDetailsCreateInput;
  bookingStatus: BookingStatus;
  campaignId?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  origin?: InputMaybe<Scalars['String']>;
  payment?: InputMaybe<BookingPaymentCreateInput>;
  pisignage?: InputMaybe<BookingPisignageDataCreateInput>;
  priceSummary?: InputMaybe<OrderPriceSummaryCreateInput>;
  refund?: InputMaybe<BookingRefundCreateInput>;
  selectedDates: OrderSelectedDateCreateInput;
  sharedUserIds?: InputMaybe<Array<Scalars['String']>>;
  userId: Scalars['String'];
  workspaceId?: InputMaybe<Scalars['String']>;
};

export type BookingCreateManyAdBoardInputEnvelope = {
  data: Array<BookingCreateManyAdBoardInput>;
};

export type BookingCreateManyCampaignInput = {
  accessLabelIDs?: InputMaybe<Array<Scalars['String']>>;
  adBoardId: Scalars['String'];
  additionalInformation?: InputMaybe<Scalars['String']>;
  assetsIDs?: InputMaybe<Array<Scalars['String']>>;
  bookingCode: Scalars['String'];
  bookingDate?: InputMaybe<Scalars['DateTime']>;
  bookingDetails: BookingDetailsCreateInput;
  bookingStatus: BookingStatus;
  id?: InputMaybe<Scalars['String']>;
  origin?: InputMaybe<Scalars['String']>;
  payment?: InputMaybe<BookingPaymentCreateInput>;
  pisignage?: InputMaybe<BookingPisignageDataCreateInput>;
  priceSummary?: InputMaybe<OrderPriceSummaryCreateInput>;
  refund?: InputMaybe<BookingRefundCreateInput>;
  selectedDates: OrderSelectedDateCreateInput;
  sharedUserIds?: InputMaybe<Array<Scalars['String']>>;
  userId: Scalars['String'];
  workspaceId?: InputMaybe<Scalars['String']>;
};

export type BookingCreateManyCampaignInputEnvelope = {
  data: Array<BookingCreateManyCampaignInput>;
};

export type BookingCreateManyInput = {
  accessLabelIDs?: InputMaybe<Array<Scalars['String']>>;
  adBoardId: Scalars['String'];
  additionalInformation?: InputMaybe<Scalars['String']>;
  assetsIDs?: InputMaybe<Array<Scalars['String']>>;
  bookingCode: Scalars['String'];
  bookingDate?: InputMaybe<Scalars['DateTime']>;
  bookingDetails: BookingDetailsCreateInput;
  bookingStatus: BookingStatus;
  campaignId?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  origin?: InputMaybe<Scalars['String']>;
  payment?: InputMaybe<BookingPaymentCreateInput>;
  pisignage?: InputMaybe<BookingPisignageDataCreateInput>;
  priceSummary?: InputMaybe<OrderPriceSummaryCreateInput>;
  refund?: InputMaybe<BookingRefundCreateInput>;
  selectedDates: OrderSelectedDateCreateInput;
  sharedUserIds?: InputMaybe<Array<Scalars['String']>>;
  userId: Scalars['String'];
  workspaceId?: InputMaybe<Scalars['String']>;
};

export type BookingCreateManyUserInput = {
  accessLabelIDs?: InputMaybe<Array<Scalars['String']>>;
  adBoardId: Scalars['String'];
  additionalInformation?: InputMaybe<Scalars['String']>;
  assetsIDs?: InputMaybe<Array<Scalars['String']>>;
  bookingCode: Scalars['String'];
  bookingDate?: InputMaybe<Scalars['DateTime']>;
  bookingDetails: BookingDetailsCreateInput;
  bookingStatus: BookingStatus;
  campaignId?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  origin?: InputMaybe<Scalars['String']>;
  payment?: InputMaybe<BookingPaymentCreateInput>;
  pisignage?: InputMaybe<BookingPisignageDataCreateInput>;
  priceSummary?: InputMaybe<OrderPriceSummaryCreateInput>;
  refund?: InputMaybe<BookingRefundCreateInput>;
  selectedDates: OrderSelectedDateCreateInput;
  sharedUserIds?: InputMaybe<Array<Scalars['String']>>;
  workspaceId?: InputMaybe<Scalars['String']>;
};

export type BookingCreateManyUserInputEnvelope = {
  data: Array<BookingCreateManyUserInput>;
};

export type BookingCreateManyWorkspaceInput = {
  accessLabelIDs?: InputMaybe<Array<Scalars['String']>>;
  adBoardId: Scalars['String'];
  additionalInformation?: InputMaybe<Scalars['String']>;
  assetsIDs?: InputMaybe<Array<Scalars['String']>>;
  bookingCode: Scalars['String'];
  bookingDate?: InputMaybe<Scalars['DateTime']>;
  bookingDetails: BookingDetailsCreateInput;
  bookingStatus: BookingStatus;
  campaignId?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  origin?: InputMaybe<Scalars['String']>;
  payment?: InputMaybe<BookingPaymentCreateInput>;
  pisignage?: InputMaybe<BookingPisignageDataCreateInput>;
  priceSummary?: InputMaybe<OrderPriceSummaryCreateInput>;
  refund?: InputMaybe<BookingRefundCreateInput>;
  selectedDates: OrderSelectedDateCreateInput;
  sharedUserIds?: InputMaybe<Array<Scalars['String']>>;
  userId: Scalars['String'];
};

export type BookingCreateManyWorkspaceInputEnvelope = {
  data: Array<BookingCreateManyWorkspaceInput>;
};

export type BookingCreateNestedManyWithoutAccessLabelsInput = {
  connect?: InputMaybe<Array<BookingWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<BookingCreateOrConnectWithoutAccessLabelsInput>>;
  create?: InputMaybe<Array<BookingCreateWithoutAccessLabelsInput>>;
};

export type BookingCreateNestedManyWithoutAdBoardInput = {
  connect?: InputMaybe<Array<BookingWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<BookingCreateOrConnectWithoutAdBoardInput>>;
  create?: InputMaybe<Array<BookingCreateWithoutAdBoardInput>>;
  createMany?: InputMaybe<BookingCreateManyAdBoardInputEnvelope>;
};

export type BookingCreateNestedManyWithoutAssetsInput = {
  connect?: InputMaybe<Array<BookingWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<BookingCreateOrConnectWithoutAssetsInput>>;
  create?: InputMaybe<Array<BookingCreateWithoutAssetsInput>>;
};

export type BookingCreateNestedManyWithoutCampaignInput = {
  connect?: InputMaybe<Array<BookingWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<BookingCreateOrConnectWithoutCampaignInput>>;
  create?: InputMaybe<Array<BookingCreateWithoutCampaignInput>>;
  createMany?: InputMaybe<BookingCreateManyCampaignInputEnvelope>;
};

export type BookingCreateNestedManyWithoutSharedUsersInput = {
  connect?: InputMaybe<Array<BookingWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<BookingCreateOrConnectWithoutSharedUsersInput>>;
  create?: InputMaybe<Array<BookingCreateWithoutSharedUsersInput>>;
};

export type BookingCreateNestedManyWithoutUserInput = {
  connect?: InputMaybe<Array<BookingWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<BookingCreateOrConnectWithoutUserInput>>;
  create?: InputMaybe<Array<BookingCreateWithoutUserInput>>;
  createMany?: InputMaybe<BookingCreateManyUserInputEnvelope>;
};

export type BookingCreateNestedManyWithoutWorkspaceInput = {
  connect?: InputMaybe<Array<BookingWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<BookingCreateOrConnectWithoutWorkspaceInput>>;
  create?: InputMaybe<Array<BookingCreateWithoutWorkspaceInput>>;
  createMany?: InputMaybe<BookingCreateManyWorkspaceInputEnvelope>;
};

export type BookingCreateNestedOneWithoutBookedSlotsInput = {
  connect?: InputMaybe<BookingWhereUniqueInput>;
  connectOrCreate?: InputMaybe<BookingCreateOrConnectWithoutBookedSlotsInput>;
  create?: InputMaybe<BookingCreateWithoutBookedSlotsInput>;
};

export type BookingCreateNestedOneWithoutChangelogsInput = {
  connect?: InputMaybe<BookingWhereUniqueInput>;
  connectOrCreate?: InputMaybe<BookingCreateOrConnectWithoutChangelogsInput>;
  create?: InputMaybe<BookingCreateWithoutChangelogsInput>;
};

export type BookingCreateNestedOneWithoutPayoutsInput = {
  connect?: InputMaybe<BookingWhereUniqueInput>;
  connectOrCreate?: InputMaybe<BookingCreateOrConnectWithoutPayoutsInput>;
  create?: InputMaybe<BookingCreateWithoutPayoutsInput>;
};

export type BookingCreateNestedOneWithoutProofsInput = {
  connect?: InputMaybe<BookingWhereUniqueInput>;
  connectOrCreate?: InputMaybe<BookingCreateOrConnectWithoutProofsInput>;
  create?: InputMaybe<BookingCreateWithoutProofsInput>;
};

export type BookingCreateOrConnectWithoutAccessLabelsInput = {
  create: BookingCreateWithoutAccessLabelsInput;
  where: BookingWhereUniqueInput;
};

export type BookingCreateOrConnectWithoutAdBoardInput = {
  create: BookingCreateWithoutAdBoardInput;
  where: BookingWhereUniqueInput;
};

export type BookingCreateOrConnectWithoutAssetsInput = {
  create: BookingCreateWithoutAssetsInput;
  where: BookingWhereUniqueInput;
};

export type BookingCreateOrConnectWithoutBookedSlotsInput = {
  create: BookingCreateWithoutBookedSlotsInput;
  where: BookingWhereUniqueInput;
};

export type BookingCreateOrConnectWithoutCampaignInput = {
  create: BookingCreateWithoutCampaignInput;
  where: BookingWhereUniqueInput;
};

export type BookingCreateOrConnectWithoutChangelogsInput = {
  create: BookingCreateWithoutChangelogsInput;
  where: BookingWhereUniqueInput;
};

export type BookingCreateOrConnectWithoutPayoutsInput = {
  create: BookingCreateWithoutPayoutsInput;
  where: BookingWhereUniqueInput;
};

export type BookingCreateOrConnectWithoutProofsInput = {
  create: BookingCreateWithoutProofsInput;
  where: BookingWhereUniqueInput;
};

export type BookingCreateOrConnectWithoutSharedUsersInput = {
  create: BookingCreateWithoutSharedUsersInput;
  where: BookingWhereUniqueInput;
};

export type BookingCreateOrConnectWithoutUserInput = {
  create: BookingCreateWithoutUserInput;
  where: BookingWhereUniqueInput;
};

export type BookingCreateOrConnectWithoutWorkspaceInput = {
  create: BookingCreateWithoutWorkspaceInput;
  where: BookingWhereUniqueInput;
};

export type BookingCreateWithoutAccessLabelsInput = {
  adBoard: AdBoardCreateNestedOneWithoutBookingsInput;
  additionalInformation?: InputMaybe<Scalars['String']>;
  assets?: InputMaybe<FileCreateNestedManyWithoutBookingsInput>;
  bookedSlots?: InputMaybe<SlotCreateNestedManyWithoutBookingInput>;
  bookingCode: Scalars['String'];
  bookingDate?: InputMaybe<Scalars['DateTime']>;
  bookingDetails: BookingDetailsCreateInput;
  bookingStatus: BookingStatus;
  campaign?: InputMaybe<CampaignCreateNestedOneWithoutBookingsInput>;
  changelogs?: InputMaybe<ChangelogCreateNestedManyWithoutBookingInput>;
  id?: InputMaybe<Scalars['String']>;
  origin?: InputMaybe<Scalars['String']>;
  payment?: InputMaybe<BookingPaymentCreateInput>;
  payouts?: InputMaybe<PayoutCreateNestedManyWithoutBookingInput>;
  pisignage?: InputMaybe<BookingPisignageDataCreateInput>;
  priceSummary?: InputMaybe<OrderPriceSummaryCreateInput>;
  proofs?: InputMaybe<FileCreateNestedManyWithoutProofBookingInput>;
  refund?: InputMaybe<BookingRefundCreateInput>;
  selectedDates: OrderSelectedDateCreateInput;
  sharedUsers?: InputMaybe<UserCreateNestedManyWithoutSharedBookingsInput>;
  user: UserCreateNestedOneWithoutBookingsInput;
  workspace?: InputMaybe<WorkspaceCreateNestedOneWithoutBookingsInput>;
};

export type BookingCreateWithoutAdBoardInput = {
  accessLabels?: InputMaybe<AccessLabelCreateNestedManyWithoutBookingsInput>;
  additionalInformation?: InputMaybe<Scalars['String']>;
  assets?: InputMaybe<FileCreateNestedManyWithoutBookingsInput>;
  bookedSlots?: InputMaybe<SlotCreateNestedManyWithoutBookingInput>;
  bookingCode: Scalars['String'];
  bookingDate?: InputMaybe<Scalars['DateTime']>;
  bookingDetails: BookingDetailsCreateInput;
  bookingStatus: BookingStatus;
  campaign?: InputMaybe<CampaignCreateNestedOneWithoutBookingsInput>;
  changelogs?: InputMaybe<ChangelogCreateNestedManyWithoutBookingInput>;
  id?: InputMaybe<Scalars['String']>;
  origin?: InputMaybe<Scalars['String']>;
  payment?: InputMaybe<BookingPaymentCreateInput>;
  payouts?: InputMaybe<PayoutCreateNestedManyWithoutBookingInput>;
  pisignage?: InputMaybe<BookingPisignageDataCreateInput>;
  priceSummary?: InputMaybe<OrderPriceSummaryCreateInput>;
  proofs?: InputMaybe<FileCreateNestedManyWithoutProofBookingInput>;
  refund?: InputMaybe<BookingRefundCreateInput>;
  selectedDates: OrderSelectedDateCreateInput;
  sharedUsers?: InputMaybe<UserCreateNestedManyWithoutSharedBookingsInput>;
  user: UserCreateNestedOneWithoutBookingsInput;
  workspace?: InputMaybe<WorkspaceCreateNestedOneWithoutBookingsInput>;
};

export type BookingCreateWithoutAssetsInput = {
  accessLabels?: InputMaybe<AccessLabelCreateNestedManyWithoutBookingsInput>;
  adBoard: AdBoardCreateNestedOneWithoutBookingsInput;
  additionalInformation?: InputMaybe<Scalars['String']>;
  bookedSlots?: InputMaybe<SlotCreateNestedManyWithoutBookingInput>;
  bookingCode: Scalars['String'];
  bookingDate?: InputMaybe<Scalars['DateTime']>;
  bookingDetails: BookingDetailsCreateInput;
  bookingStatus: BookingStatus;
  campaign?: InputMaybe<CampaignCreateNestedOneWithoutBookingsInput>;
  changelogs?: InputMaybe<ChangelogCreateNestedManyWithoutBookingInput>;
  id?: InputMaybe<Scalars['String']>;
  origin?: InputMaybe<Scalars['String']>;
  payment?: InputMaybe<BookingPaymentCreateInput>;
  payouts?: InputMaybe<PayoutCreateNestedManyWithoutBookingInput>;
  pisignage?: InputMaybe<BookingPisignageDataCreateInput>;
  priceSummary?: InputMaybe<OrderPriceSummaryCreateInput>;
  proofs?: InputMaybe<FileCreateNestedManyWithoutProofBookingInput>;
  refund?: InputMaybe<BookingRefundCreateInput>;
  selectedDates: OrderSelectedDateCreateInput;
  sharedUsers?: InputMaybe<UserCreateNestedManyWithoutSharedBookingsInput>;
  user: UserCreateNestedOneWithoutBookingsInput;
  workspace?: InputMaybe<WorkspaceCreateNestedOneWithoutBookingsInput>;
};

export type BookingCreateWithoutBookedSlotsInput = {
  accessLabels?: InputMaybe<AccessLabelCreateNestedManyWithoutBookingsInput>;
  adBoard: AdBoardCreateNestedOneWithoutBookingsInput;
  additionalInformation?: InputMaybe<Scalars['String']>;
  assets?: InputMaybe<FileCreateNestedManyWithoutBookingsInput>;
  bookingCode: Scalars['String'];
  bookingDate?: InputMaybe<Scalars['DateTime']>;
  bookingDetails: BookingDetailsCreateInput;
  bookingStatus: BookingStatus;
  campaign?: InputMaybe<CampaignCreateNestedOneWithoutBookingsInput>;
  changelogs?: InputMaybe<ChangelogCreateNestedManyWithoutBookingInput>;
  id?: InputMaybe<Scalars['String']>;
  origin?: InputMaybe<Scalars['String']>;
  payment?: InputMaybe<BookingPaymentCreateInput>;
  payouts?: InputMaybe<PayoutCreateNestedManyWithoutBookingInput>;
  pisignage?: InputMaybe<BookingPisignageDataCreateInput>;
  priceSummary?: InputMaybe<OrderPriceSummaryCreateInput>;
  proofs?: InputMaybe<FileCreateNestedManyWithoutProofBookingInput>;
  refund?: InputMaybe<BookingRefundCreateInput>;
  selectedDates: OrderSelectedDateCreateInput;
  sharedUsers?: InputMaybe<UserCreateNestedManyWithoutSharedBookingsInput>;
  user: UserCreateNestedOneWithoutBookingsInput;
  workspace?: InputMaybe<WorkspaceCreateNestedOneWithoutBookingsInput>;
};

export type BookingCreateWithoutCampaignInput = {
  accessLabels?: InputMaybe<AccessLabelCreateNestedManyWithoutBookingsInput>;
  adBoard: AdBoardCreateNestedOneWithoutBookingsInput;
  additionalInformation?: InputMaybe<Scalars['String']>;
  assets?: InputMaybe<FileCreateNestedManyWithoutBookingsInput>;
  bookedSlots?: InputMaybe<SlotCreateNestedManyWithoutBookingInput>;
  bookingCode: Scalars['String'];
  bookingDate?: InputMaybe<Scalars['DateTime']>;
  bookingDetails: BookingDetailsCreateInput;
  bookingStatus: BookingStatus;
  changelogs?: InputMaybe<ChangelogCreateNestedManyWithoutBookingInput>;
  id?: InputMaybe<Scalars['String']>;
  origin?: InputMaybe<Scalars['String']>;
  payment?: InputMaybe<BookingPaymentCreateInput>;
  payouts?: InputMaybe<PayoutCreateNestedManyWithoutBookingInput>;
  pisignage?: InputMaybe<BookingPisignageDataCreateInput>;
  priceSummary?: InputMaybe<OrderPriceSummaryCreateInput>;
  proofs?: InputMaybe<FileCreateNestedManyWithoutProofBookingInput>;
  refund?: InputMaybe<BookingRefundCreateInput>;
  selectedDates: OrderSelectedDateCreateInput;
  sharedUsers?: InputMaybe<UserCreateNestedManyWithoutSharedBookingsInput>;
  user: UserCreateNestedOneWithoutBookingsInput;
  workspace?: InputMaybe<WorkspaceCreateNestedOneWithoutBookingsInput>;
};

export type BookingCreateWithoutChangelogsInput = {
  accessLabels?: InputMaybe<AccessLabelCreateNestedManyWithoutBookingsInput>;
  adBoard: AdBoardCreateNestedOneWithoutBookingsInput;
  additionalInformation?: InputMaybe<Scalars['String']>;
  assets?: InputMaybe<FileCreateNestedManyWithoutBookingsInput>;
  bookedSlots?: InputMaybe<SlotCreateNestedManyWithoutBookingInput>;
  bookingCode: Scalars['String'];
  bookingDate?: InputMaybe<Scalars['DateTime']>;
  bookingDetails: BookingDetailsCreateInput;
  bookingStatus: BookingStatus;
  campaign?: InputMaybe<CampaignCreateNestedOneWithoutBookingsInput>;
  id?: InputMaybe<Scalars['String']>;
  origin?: InputMaybe<Scalars['String']>;
  payment?: InputMaybe<BookingPaymentCreateInput>;
  payouts?: InputMaybe<PayoutCreateNestedManyWithoutBookingInput>;
  pisignage?: InputMaybe<BookingPisignageDataCreateInput>;
  priceSummary?: InputMaybe<OrderPriceSummaryCreateInput>;
  proofs?: InputMaybe<FileCreateNestedManyWithoutProofBookingInput>;
  refund?: InputMaybe<BookingRefundCreateInput>;
  selectedDates: OrderSelectedDateCreateInput;
  sharedUsers?: InputMaybe<UserCreateNestedManyWithoutSharedBookingsInput>;
  user: UserCreateNestedOneWithoutBookingsInput;
  workspace?: InputMaybe<WorkspaceCreateNestedOneWithoutBookingsInput>;
};

export type BookingCreateWithoutPayoutsInput = {
  accessLabels?: InputMaybe<AccessLabelCreateNestedManyWithoutBookingsInput>;
  adBoard: AdBoardCreateNestedOneWithoutBookingsInput;
  additionalInformation?: InputMaybe<Scalars['String']>;
  assets?: InputMaybe<FileCreateNestedManyWithoutBookingsInput>;
  bookedSlots?: InputMaybe<SlotCreateNestedManyWithoutBookingInput>;
  bookingCode: Scalars['String'];
  bookingDate?: InputMaybe<Scalars['DateTime']>;
  bookingDetails: BookingDetailsCreateInput;
  bookingStatus: BookingStatus;
  campaign?: InputMaybe<CampaignCreateNestedOneWithoutBookingsInput>;
  changelogs?: InputMaybe<ChangelogCreateNestedManyWithoutBookingInput>;
  id?: InputMaybe<Scalars['String']>;
  origin?: InputMaybe<Scalars['String']>;
  payment?: InputMaybe<BookingPaymentCreateInput>;
  pisignage?: InputMaybe<BookingPisignageDataCreateInput>;
  priceSummary?: InputMaybe<OrderPriceSummaryCreateInput>;
  proofs?: InputMaybe<FileCreateNestedManyWithoutProofBookingInput>;
  refund?: InputMaybe<BookingRefundCreateInput>;
  selectedDates: OrderSelectedDateCreateInput;
  sharedUsers?: InputMaybe<UserCreateNestedManyWithoutSharedBookingsInput>;
  user: UserCreateNestedOneWithoutBookingsInput;
  workspace?: InputMaybe<WorkspaceCreateNestedOneWithoutBookingsInput>;
};

export type BookingCreateWithoutProofsInput = {
  accessLabels?: InputMaybe<AccessLabelCreateNestedManyWithoutBookingsInput>;
  adBoard: AdBoardCreateNestedOneWithoutBookingsInput;
  additionalInformation?: InputMaybe<Scalars['String']>;
  assets?: InputMaybe<FileCreateNestedManyWithoutBookingsInput>;
  bookedSlots?: InputMaybe<SlotCreateNestedManyWithoutBookingInput>;
  bookingCode: Scalars['String'];
  bookingDate?: InputMaybe<Scalars['DateTime']>;
  bookingDetails: BookingDetailsCreateInput;
  bookingStatus: BookingStatus;
  campaign?: InputMaybe<CampaignCreateNestedOneWithoutBookingsInput>;
  changelogs?: InputMaybe<ChangelogCreateNestedManyWithoutBookingInput>;
  id?: InputMaybe<Scalars['String']>;
  origin?: InputMaybe<Scalars['String']>;
  payment?: InputMaybe<BookingPaymentCreateInput>;
  payouts?: InputMaybe<PayoutCreateNestedManyWithoutBookingInput>;
  pisignage?: InputMaybe<BookingPisignageDataCreateInput>;
  priceSummary?: InputMaybe<OrderPriceSummaryCreateInput>;
  refund?: InputMaybe<BookingRefundCreateInput>;
  selectedDates: OrderSelectedDateCreateInput;
  sharedUsers?: InputMaybe<UserCreateNestedManyWithoutSharedBookingsInput>;
  user: UserCreateNestedOneWithoutBookingsInput;
  workspace?: InputMaybe<WorkspaceCreateNestedOneWithoutBookingsInput>;
};

export type BookingCreateWithoutSharedUsersInput = {
  accessLabels?: InputMaybe<AccessLabelCreateNestedManyWithoutBookingsInput>;
  adBoard: AdBoardCreateNestedOneWithoutBookingsInput;
  additionalInformation?: InputMaybe<Scalars['String']>;
  assets?: InputMaybe<FileCreateNestedManyWithoutBookingsInput>;
  bookedSlots?: InputMaybe<SlotCreateNestedManyWithoutBookingInput>;
  bookingCode: Scalars['String'];
  bookingDate?: InputMaybe<Scalars['DateTime']>;
  bookingDetails: BookingDetailsCreateInput;
  bookingStatus: BookingStatus;
  campaign?: InputMaybe<CampaignCreateNestedOneWithoutBookingsInput>;
  changelogs?: InputMaybe<ChangelogCreateNestedManyWithoutBookingInput>;
  id?: InputMaybe<Scalars['String']>;
  origin?: InputMaybe<Scalars['String']>;
  payment?: InputMaybe<BookingPaymentCreateInput>;
  payouts?: InputMaybe<PayoutCreateNestedManyWithoutBookingInput>;
  pisignage?: InputMaybe<BookingPisignageDataCreateInput>;
  priceSummary?: InputMaybe<OrderPriceSummaryCreateInput>;
  proofs?: InputMaybe<FileCreateNestedManyWithoutProofBookingInput>;
  refund?: InputMaybe<BookingRefundCreateInput>;
  selectedDates: OrderSelectedDateCreateInput;
  user: UserCreateNestedOneWithoutBookingsInput;
  workspace?: InputMaybe<WorkspaceCreateNestedOneWithoutBookingsInput>;
};

export type BookingCreateWithoutUserInput = {
  accessLabels?: InputMaybe<AccessLabelCreateNestedManyWithoutBookingsInput>;
  adBoard: AdBoardCreateNestedOneWithoutBookingsInput;
  additionalInformation?: InputMaybe<Scalars['String']>;
  assets?: InputMaybe<FileCreateNestedManyWithoutBookingsInput>;
  bookedSlots?: InputMaybe<SlotCreateNestedManyWithoutBookingInput>;
  bookingCode: Scalars['String'];
  bookingDate?: InputMaybe<Scalars['DateTime']>;
  bookingDetails: BookingDetailsCreateInput;
  bookingStatus: BookingStatus;
  campaign?: InputMaybe<CampaignCreateNestedOneWithoutBookingsInput>;
  changelogs?: InputMaybe<ChangelogCreateNestedManyWithoutBookingInput>;
  id?: InputMaybe<Scalars['String']>;
  origin?: InputMaybe<Scalars['String']>;
  payment?: InputMaybe<BookingPaymentCreateInput>;
  payouts?: InputMaybe<PayoutCreateNestedManyWithoutBookingInput>;
  pisignage?: InputMaybe<BookingPisignageDataCreateInput>;
  priceSummary?: InputMaybe<OrderPriceSummaryCreateInput>;
  proofs?: InputMaybe<FileCreateNestedManyWithoutProofBookingInput>;
  refund?: InputMaybe<BookingRefundCreateInput>;
  selectedDates: OrderSelectedDateCreateInput;
  sharedUsers?: InputMaybe<UserCreateNestedManyWithoutSharedBookingsInput>;
  workspace?: InputMaybe<WorkspaceCreateNestedOneWithoutBookingsInput>;
};

export type BookingCreateWithoutWorkspaceInput = {
  accessLabels?: InputMaybe<AccessLabelCreateNestedManyWithoutBookingsInput>;
  adBoard: AdBoardCreateNestedOneWithoutBookingsInput;
  additionalInformation?: InputMaybe<Scalars['String']>;
  assets?: InputMaybe<FileCreateNestedManyWithoutBookingsInput>;
  bookedSlots?: InputMaybe<SlotCreateNestedManyWithoutBookingInput>;
  bookingCode: Scalars['String'];
  bookingDate?: InputMaybe<Scalars['DateTime']>;
  bookingDetails: BookingDetailsCreateInput;
  bookingStatus: BookingStatus;
  campaign?: InputMaybe<CampaignCreateNestedOneWithoutBookingsInput>;
  changelogs?: InputMaybe<ChangelogCreateNestedManyWithoutBookingInput>;
  id?: InputMaybe<Scalars['String']>;
  origin?: InputMaybe<Scalars['String']>;
  payment?: InputMaybe<BookingPaymentCreateInput>;
  payouts?: InputMaybe<PayoutCreateNestedManyWithoutBookingInput>;
  pisignage?: InputMaybe<BookingPisignageDataCreateInput>;
  priceSummary?: InputMaybe<OrderPriceSummaryCreateInput>;
  proofs?: InputMaybe<FileCreateNestedManyWithoutProofBookingInput>;
  refund?: InputMaybe<BookingRefundCreateInput>;
  selectedDates: OrderSelectedDateCreateInput;
  sharedUsers?: InputMaybe<UserCreateNestedManyWithoutSharedBookingsInput>;
  user: UserCreateNestedOneWithoutBookingsInput;
};

export type BookingCustomer = {
  __typename?: 'BookingCustomer';
  customerDetails?: Maybe<PaymentCustomerDetails>;
  customerId: Scalars['String'];
};

export type BookingCustomerCreateInput = {
  customerDetails?: InputMaybe<PaymentCustomerDetailsCreateInput>;
  customerId: Scalars['String'];
};

export type BookingCustomerNullableCompositeFilter = {
  equals?: InputMaybe<BookingCustomerObjectEqualityInput>;
  is?: InputMaybe<BookingCustomerWhereInput>;
  isNot?: InputMaybe<BookingCustomerWhereInput>;
  isSet?: InputMaybe<Scalars['Boolean']>;
};

export type BookingCustomerObjectEqualityInput = {
  customerDetails?: InputMaybe<PaymentCustomerDetailsObjectEqualityInput>;
  customerId: Scalars['String'];
};

export type BookingCustomerOrderByInput = {
  customerDetails?: InputMaybe<PaymentCustomerDetailsOrderByInput>;
  customerId?: InputMaybe<SortOrder>;
};

export type BookingCustomerWhereInput = {
  AND?: InputMaybe<Array<BookingCustomerWhereInput>>;
  NOT?: InputMaybe<Array<BookingCustomerWhereInput>>;
  OR?: InputMaybe<Array<BookingCustomerWhereInput>>;
  customerDetails?: InputMaybe<PaymentCustomerDetailsNullableCompositeFilter>;
  customerId?: InputMaybe<StringFilter>;
};

export type BookingDetails = {
  __typename?: 'BookingDetails';
  additionalInformation?: Maybe<Scalars['String']>;
  email: Scalars['String'];
  name: Scalars['String'];
  phone?: Maybe<Scalars['String']>;
};

export type BookingDetailsCompositeFilter = {
  equals?: InputMaybe<BookingDetailsObjectEqualityInput>;
  is?: InputMaybe<BookingDetailsWhereInput>;
  isNot?: InputMaybe<BookingDetailsWhereInput>;
};

export type BookingDetailsCreateInput = {
  additionalInformation?: InputMaybe<Scalars['String']>;
  email: Scalars['String'];
  name: Scalars['String'];
  phone?: InputMaybe<Scalars['String']>;
};

export type BookingDetailsInput = {
  email: Scalars['String'];
  name: Scalars['String'];
  phone: Scalars['String'];
};

export type BookingDetailsObjectEqualityInput = {
  additionalInformation?: InputMaybe<Scalars['String']>;
  email: Scalars['String'];
  name: Scalars['String'];
  phone?: InputMaybe<Scalars['String']>;
};

export type BookingDetailsOrderByInput = {
  additionalInformation?: InputMaybe<SortOrder>;
  email?: InputMaybe<SortOrder>;
  name?: InputMaybe<SortOrder>;
  phone?: InputMaybe<SortOrder>;
};

export type BookingDetailsWhereInput = {
  AND?: InputMaybe<Array<BookingDetailsWhereInput>>;
  NOT?: InputMaybe<Array<BookingDetailsWhereInput>>;
  OR?: InputMaybe<Array<BookingDetailsWhereInput>>;
  additionalInformation?: InputMaybe<StringNullableFilter>;
  email?: InputMaybe<StringFilter>;
  name?: InputMaybe<StringFilter>;
  phone?: InputMaybe<StringNullableFilter>;
};

export type BookingGroupBy = {
  __typename?: 'BookingGroupBy';
  _count?: Maybe<BookingCountAggregate>;
  _max?: Maybe<BookingMaxAggregate>;
  _min?: Maybe<BookingMinAggregate>;
  accessLabelIDs?: Maybe<Array<Scalars['String']>>;
  adBoardId: Scalars['String'];
  additionalInformation?: Maybe<Scalars['String']>;
  assetsIDs?: Maybe<Array<Scalars['String']>>;
  bookingCode: Scalars['String'];
  bookingDate: Scalars['DateTime'];
  bookingStatus: BookingStatus;
  campaignId?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  origin?: Maybe<Scalars['String']>;
  sharedUserIds?: Maybe<Array<Scalars['String']>>;
  userId: Scalars['String'];
  workspaceId?: Maybe<Scalars['String']>;
};

export type BookingListRelationFilter = {
  every?: InputMaybe<BookingWhereInput>;
  none?: InputMaybe<BookingWhereInput>;
  some?: InputMaybe<BookingWhereInput>;
};

export type BookingMaxAggregate = {
  __typename?: 'BookingMaxAggregate';
  adBoardId?: Maybe<Scalars['String']>;
  additionalInformation?: Maybe<Scalars['String']>;
  bookingCode?: Maybe<Scalars['String']>;
  bookingDate?: Maybe<Scalars['DateTime']>;
  bookingStatus?: Maybe<BookingStatus>;
  campaignId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  origin?: Maybe<Scalars['String']>;
  userId?: Maybe<Scalars['String']>;
  workspaceId?: Maybe<Scalars['String']>;
};

export type BookingMaxOrderByAggregateInput = {
  adBoardId?: InputMaybe<SortOrder>;
  additionalInformation?: InputMaybe<SortOrder>;
  bookingCode?: InputMaybe<SortOrder>;
  bookingDate?: InputMaybe<SortOrder>;
  bookingStatus?: InputMaybe<SortOrder>;
  campaignId?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  origin?: InputMaybe<SortOrder>;
  userId?: InputMaybe<SortOrder>;
  workspaceId?: InputMaybe<SortOrder>;
};

export type BookingMinAggregate = {
  __typename?: 'BookingMinAggregate';
  adBoardId?: Maybe<Scalars['String']>;
  additionalInformation?: Maybe<Scalars['String']>;
  bookingCode?: Maybe<Scalars['String']>;
  bookingDate?: Maybe<Scalars['DateTime']>;
  bookingStatus?: Maybe<BookingStatus>;
  campaignId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  origin?: Maybe<Scalars['String']>;
  userId?: Maybe<Scalars['String']>;
  workspaceId?: Maybe<Scalars['String']>;
};

export type BookingMinOrderByAggregateInput = {
  adBoardId?: InputMaybe<SortOrder>;
  additionalInformation?: InputMaybe<SortOrder>;
  bookingCode?: InputMaybe<SortOrder>;
  bookingDate?: InputMaybe<SortOrder>;
  bookingStatus?: InputMaybe<SortOrder>;
  campaignId?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  origin?: InputMaybe<SortOrder>;
  userId?: InputMaybe<SortOrder>;
  workspaceId?: InputMaybe<SortOrder>;
};

export type BookingNullableRelationFilter = {
  is?: InputMaybe<BookingWhereInput>;
  isNot?: InputMaybe<BookingWhereInput>;
};

export type BookingOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type BookingOrderByWithAggregationInput = {
  _count?: InputMaybe<BookingCountOrderByAggregateInput>;
  _max?: InputMaybe<BookingMaxOrderByAggregateInput>;
  _min?: InputMaybe<BookingMinOrderByAggregateInput>;
  accessLabelIDs?: InputMaybe<SortOrder>;
  adBoardId?: InputMaybe<SortOrder>;
  additionalInformation?: InputMaybe<SortOrder>;
  assetsIDs?: InputMaybe<SortOrder>;
  bookingCode?: InputMaybe<SortOrder>;
  bookingDate?: InputMaybe<SortOrder>;
  bookingStatus?: InputMaybe<SortOrder>;
  campaignId?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  origin?: InputMaybe<SortOrder>;
  sharedUserIds?: InputMaybe<SortOrder>;
  userId?: InputMaybe<SortOrder>;
  workspaceId?: InputMaybe<SortOrder>;
};

export type BookingOrderByWithRelationInput = {
  accessLabelIDs?: InputMaybe<SortOrder>;
  accessLabels?: InputMaybe<AccessLabelOrderByRelationAggregateInput>;
  adBoard?: InputMaybe<AdBoardOrderByWithRelationInput>;
  adBoardId?: InputMaybe<SortOrder>;
  additionalInformation?: InputMaybe<SortOrder>;
  assets?: InputMaybe<FileOrderByRelationAggregateInput>;
  assetsIDs?: InputMaybe<SortOrder>;
  bookedSlots?: InputMaybe<SlotOrderByRelationAggregateInput>;
  bookingCode?: InputMaybe<SortOrder>;
  bookingDate?: InputMaybe<SortOrder>;
  bookingDetails?: InputMaybe<BookingDetailsOrderByInput>;
  bookingStatus?: InputMaybe<SortOrder>;
  campaign?: InputMaybe<CampaignOrderByWithRelationInput>;
  campaignId?: InputMaybe<SortOrder>;
  changelogs?: InputMaybe<ChangelogOrderByRelationAggregateInput>;
  id?: InputMaybe<SortOrder>;
  origin?: InputMaybe<SortOrder>;
  payment?: InputMaybe<BookingPaymentOrderByInput>;
  payouts?: InputMaybe<PayoutOrderByRelationAggregateInput>;
  pisignage?: InputMaybe<BookingPisignageDataOrderByInput>;
  priceSummary?: InputMaybe<OrderPriceSummaryOrderByInput>;
  proofs?: InputMaybe<FileOrderByRelationAggregateInput>;
  refund?: InputMaybe<BookingRefundOrderByInput>;
  selectedDates?: InputMaybe<OrderSelectedDateOrderByInput>;
  sharedUserIds?: InputMaybe<SortOrder>;
  sharedUsers?: InputMaybe<UserOrderByRelationAggregateInput>;
  user?: InputMaybe<UserOrderByWithRelationInput>;
  userId?: InputMaybe<SortOrder>;
  workspace?: InputMaybe<WorkspaceOrderByWithRelationInput>;
  workspaceId?: InputMaybe<SortOrder>;
};

export type BookingPayment = {
  __typename?: 'BookingPayment';
  customer?: Maybe<BookingCustomer>;
  paymentGateway: PaymentGatewayName;
  paymentId: Scalars['String'];
  razorpay?: Maybe<Scalars['JSON']>;
  sessionId?: Maybe<Scalars['String']>;
  stripe?: Maybe<Scalars['JSON']>;
  totalDetails?: Maybe<PaymentTotalDetails>;
};

export type BookingPaymentCreateInput = {
  customer?: InputMaybe<BookingCustomerCreateInput>;
  paymentGateway: PaymentGatewayName;
  paymentId: Scalars['String'];
  razorpay?: InputMaybe<Scalars['JSON']>;
  sessionId?: InputMaybe<Scalars['String']>;
  stripe?: InputMaybe<Scalars['JSON']>;
  totalDetails?: InputMaybe<PaymentTotalDetailsCreateInput>;
};

export type BookingPaymentNullableCompositeFilter = {
  equals?: InputMaybe<BookingPaymentObjectEqualityInput>;
  is?: InputMaybe<BookingPaymentWhereInput>;
  isNot?: InputMaybe<BookingPaymentWhereInput>;
  isSet?: InputMaybe<Scalars['Boolean']>;
};

export type BookingPaymentObjectEqualityInput = {
  customer?: InputMaybe<BookingCustomerObjectEqualityInput>;
  paymentGateway: PaymentGatewayName;
  paymentId: Scalars['String'];
  razorpay?: InputMaybe<Scalars['JSON']>;
  sessionId?: InputMaybe<Scalars['String']>;
  stripe?: InputMaybe<Scalars['JSON']>;
  totalDetails?: InputMaybe<PaymentTotalDetailsObjectEqualityInput>;
};

export type BookingPaymentOrderByInput = {
  customer?: InputMaybe<BookingCustomerOrderByInput>;
  paymentGateway?: InputMaybe<SortOrder>;
  paymentId?: InputMaybe<SortOrder>;
  razorpay?: InputMaybe<SortOrder>;
  sessionId?: InputMaybe<SortOrder>;
  stripe?: InputMaybe<SortOrder>;
  totalDetails?: InputMaybe<PaymentTotalDetailsOrderByInput>;
};

export type BookingPaymentWhereInput = {
  AND?: InputMaybe<Array<BookingPaymentWhereInput>>;
  NOT?: InputMaybe<Array<BookingPaymentWhereInput>>;
  OR?: InputMaybe<Array<BookingPaymentWhereInput>>;
  customer?: InputMaybe<BookingCustomerNullableCompositeFilter>;
  paymentGateway?: InputMaybe<EnumPaymentGatewayNameFilter>;
  paymentId?: InputMaybe<StringFilter>;
  razorpay?: InputMaybe<JsonNullableFilter>;
  sessionId?: InputMaybe<StringNullableFilter>;
  stripe?: InputMaybe<JsonNullableFilter>;
  totalDetails?: InputMaybe<PaymentTotalDetailsNullableCompositeFilter>;
};

export type BookingPisignageData = {
  __typename?: 'BookingPisignageData';
  deployedFileName?: Maybe<Scalars['String']>;
  playlistId?: Maybe<Scalars['String']>;
};

export type BookingPisignageDataCreateInput = {
  deployedFileName?: InputMaybe<Scalars['String']>;
  playlistId?: InputMaybe<Scalars['String']>;
};

export type BookingPisignageDataNullableCompositeFilter = {
  equals?: InputMaybe<BookingPisignageDataObjectEqualityInput>;
  is?: InputMaybe<BookingPisignageDataWhereInput>;
  isNot?: InputMaybe<BookingPisignageDataWhereInput>;
  isSet?: InputMaybe<Scalars['Boolean']>;
};

export type BookingPisignageDataObjectEqualityInput = {
  deployedFileName?: InputMaybe<Scalars['String']>;
  playlistId?: InputMaybe<Scalars['String']>;
};

export type BookingPisignageDataOrderByInput = {
  deployedFileName?: InputMaybe<SortOrder>;
  playlistId?: InputMaybe<SortOrder>;
};

export type BookingPisignageDataWhereInput = {
  AND?: InputMaybe<Array<BookingPisignageDataWhereInput>>;
  NOT?: InputMaybe<Array<BookingPisignageDataWhereInput>>;
  OR?: InputMaybe<Array<BookingPisignageDataWhereInput>>;
  deployedFileName?: InputMaybe<StringNullableFilter>;
  playlistId?: InputMaybe<StringNullableFilter>;
};

export type BookingRefund = {
  __typename?: 'BookingRefund';
  createdByUserId: Scalars['String'];
  id: Scalars['String'];
  razorpay?: Maybe<Scalars['JSON']>;
  stripe?: Maybe<Scalars['JSON']>;
};

export type BookingRefundCreateInput = {
  createdByUserId: Scalars['String'];
  id: Scalars['String'];
  razorpay?: InputMaybe<Scalars['JSON']>;
  stripe?: InputMaybe<Scalars['JSON']>;
};

export type BookingRefundNullableCompositeFilter = {
  equals?: InputMaybe<BookingRefundObjectEqualityInput>;
  is?: InputMaybe<BookingRefundWhereInput>;
  isNot?: InputMaybe<BookingRefundWhereInput>;
  isSet?: InputMaybe<Scalars['Boolean']>;
};

export type BookingRefundObjectEqualityInput = {
  createdByUserId: Scalars['String'];
  id: Scalars['String'];
  razorpay?: InputMaybe<Scalars['JSON']>;
  stripe?: InputMaybe<Scalars['JSON']>;
};

export type BookingRefundOrderByCompositeAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type BookingRefundOrderByInput = {
  createdByUserId?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  razorpay?: InputMaybe<SortOrder>;
  stripe?: InputMaybe<SortOrder>;
};

export type BookingRefundWhereInput = {
  AND?: InputMaybe<Array<BookingRefundWhereInput>>;
  NOT?: InputMaybe<Array<BookingRefundWhereInput>>;
  OR?: InputMaybe<Array<BookingRefundWhereInput>>;
  createdByUserId?: InputMaybe<StringFilter>;
  id?: InputMaybe<StringFilter>;
  razorpay?: InputMaybe<JsonNullableFilter>;
  stripe?: InputMaybe<JsonNullableFilter>;
};

export type BookingRelationFilter = {
  is?: InputMaybe<BookingWhereInput>;
  isNot?: InputMaybe<BookingWhereInput>;
};

export type BookingRequest = {
  assets: Array<Scalars['String']>;
  bookingDetails: BookingDetailsInput;
  orderId: Scalars['String'];
};

export enum BookingScalarFieldEnum {
  AccessLabelIDs = 'accessLabelIDs',
  AdBoardId = 'adBoardId',
  AdditionalInformation = 'additionalInformation',
  AssetsIDs = 'assetsIDs',
  BookingCode = 'bookingCode',
  BookingDate = 'bookingDate',
  BookingStatus = 'bookingStatus',
  CampaignId = 'campaignId',
  Id = 'id',
  Origin = 'origin',
  SharedUserIds = 'sharedUserIds',
  UserId = 'userId',
  WorkspaceId = 'workspaceId'
}

export type BookingScalarWhereInput = {
  AND?: InputMaybe<Array<BookingScalarWhereInput>>;
  NOT?: InputMaybe<Array<BookingScalarWhereInput>>;
  OR?: InputMaybe<Array<BookingScalarWhereInput>>;
  accessLabelIDs?: InputMaybe<StringNullableListFilter>;
  adBoardId?: InputMaybe<StringFilter>;
  additionalInformation?: InputMaybe<StringNullableFilter>;
  assetsIDs?: InputMaybe<StringNullableListFilter>;
  bookingCode?: InputMaybe<StringFilter>;
  bookingDate?: InputMaybe<DateTimeFilter>;
  bookingStatus?: InputMaybe<EnumBookingStatusFilter>;
  campaignId?: InputMaybe<StringNullableFilter>;
  id?: InputMaybe<StringFilter>;
  origin?: InputMaybe<StringNullableFilter>;
  sharedUserIds?: InputMaybe<StringNullableListFilter>;
  userId?: InputMaybe<StringFilter>;
  workspaceId?: InputMaybe<StringNullableFilter>;
};

export type BookingScalarWhereWithAggregatesInput = {
  AND?: InputMaybe<Array<BookingScalarWhereWithAggregatesInput>>;
  NOT?: InputMaybe<Array<BookingScalarWhereWithAggregatesInput>>;
  OR?: InputMaybe<Array<BookingScalarWhereWithAggregatesInput>>;
  accessLabelIDs?: InputMaybe<StringNullableListFilter>;
  adBoardId?: InputMaybe<StringWithAggregatesFilter>;
  additionalInformation?: InputMaybe<StringNullableWithAggregatesFilter>;
  assetsIDs?: InputMaybe<StringNullableListFilter>;
  bookingCode?: InputMaybe<StringWithAggregatesFilter>;
  bookingDate?: InputMaybe<DateTimeWithAggregatesFilter>;
  bookingStatus?: InputMaybe<EnumBookingStatusWithAggregatesFilter>;
  campaignId?: InputMaybe<StringNullableWithAggregatesFilter>;
  id?: InputMaybe<StringWithAggregatesFilter>;
  origin?: InputMaybe<StringNullableWithAggregatesFilter>;
  sharedUserIds?: InputMaybe<StringNullableListFilter>;
  userId?: InputMaybe<StringWithAggregatesFilter>;
  workspaceId?: InputMaybe<StringNullableWithAggregatesFilter>;
};

export type BookingSlot = {
  __typename?: 'BookingSlot';
  slots: Scalars['JSONObject'];
};

export enum BookingStatus {
  Approved = 'APPROVED',
  Cancelled = 'CANCELLED',
  Completed = 'COMPLETED',
  Deployed = 'DEPLOYED',
  Live = 'LIVE',
  PaymentPending = 'PAYMENT_PENDING',
  PendingApproval = 'PENDING_APPROVAL',
  Prepared = 'PREPARED',
  Rejected = 'REJECTED',
  Scheduled = 'SCHEDULED',
  SystemRejected = 'SYSTEM_REJECTED'
}

export type BookingUpdateInput = {
  accessLabels?: InputMaybe<AccessLabelUpdateManyWithoutBookingsNestedInput>;
  adBoard?: InputMaybe<AdBoardUpdateOneRequiredWithoutBookingsNestedInput>;
  additionalInformation?: InputMaybe<Scalars['String']>;
  assets?: InputMaybe<FileUpdateManyWithoutBookingsNestedInput>;
  bookedSlots?: InputMaybe<SlotUpdateManyWithoutBookingNestedInput>;
  bookingCode?: InputMaybe<Scalars['String']>;
  bookingDate?: InputMaybe<Scalars['DateTime']>;
  bookingDetails?: InputMaybe<BookingDetailsCreateInput>;
  bookingStatus?: InputMaybe<BookingStatus>;
  campaign?: InputMaybe<CampaignUpdateOneWithoutBookingsNestedInput>;
  changelogs?: InputMaybe<ChangelogUpdateManyWithoutBookingNestedInput>;
  origin?: InputMaybe<Scalars['String']>;
  payment?: InputMaybe<BookingPaymentCreateInput>;
  payouts?: InputMaybe<PayoutUpdateManyWithoutBookingNestedInput>;
  pisignage?: InputMaybe<BookingPisignageDataCreateInput>;
  priceSummary?: InputMaybe<OrderPriceSummaryCreateInput>;
  proofs?: InputMaybe<FileUpdateManyWithoutProofBookingNestedInput>;
  refund?: InputMaybe<BookingRefundCreateInput>;
  selectedDates?: InputMaybe<OrderSelectedDateCreateInput>;
  sharedUsers?: InputMaybe<UserUpdateManyWithoutSharedBookingsNestedInput>;
  user?: InputMaybe<UserUpdateOneRequiredWithoutBookingsNestedInput>;
  workspace?: InputMaybe<WorkspaceUpdateOneWithoutBookingsNestedInput>;
};

export type BookingUpdateManyMutationInput = {
  additionalInformation?: InputMaybe<Scalars['String']>;
  bookingCode?: InputMaybe<Scalars['String']>;
  bookingDate?: InputMaybe<Scalars['DateTime']>;
  bookingDetails?: InputMaybe<BookingDetailsCreateInput>;
  bookingStatus?: InputMaybe<BookingStatus>;
  origin?: InputMaybe<Scalars['String']>;
  payment?: InputMaybe<BookingPaymentCreateInput>;
  pisignage?: InputMaybe<BookingPisignageDataCreateInput>;
  priceSummary?: InputMaybe<OrderPriceSummaryCreateInput>;
  refund?: InputMaybe<BookingRefundCreateInput>;
  selectedDates?: InputMaybe<OrderSelectedDateCreateInput>;
};

export type BookingUpdateManyWithWhereWithoutAccessLabelsInput = {
  data: BookingUpdateManyMutationInput;
  where: BookingScalarWhereInput;
};

export type BookingUpdateManyWithWhereWithoutAdBoardInput = {
  data: BookingUpdateManyMutationInput;
  where: BookingScalarWhereInput;
};

export type BookingUpdateManyWithWhereWithoutAssetsInput = {
  data: BookingUpdateManyMutationInput;
  where: BookingScalarWhereInput;
};

export type BookingUpdateManyWithWhereWithoutCampaignInput = {
  data: BookingUpdateManyMutationInput;
  where: BookingScalarWhereInput;
};

export type BookingUpdateManyWithWhereWithoutSharedUsersInput = {
  data: BookingUpdateManyMutationInput;
  where: BookingScalarWhereInput;
};

export type BookingUpdateManyWithWhereWithoutUserInput = {
  data: BookingUpdateManyMutationInput;
  where: BookingScalarWhereInput;
};

export type BookingUpdateManyWithWhereWithoutWorkspaceInput = {
  data: BookingUpdateManyMutationInput;
  where: BookingScalarWhereInput;
};

export type BookingUpdateManyWithoutAccessLabelsNestedInput = {
  connect?: InputMaybe<Array<BookingWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<BookingCreateOrConnectWithoutAccessLabelsInput>>;
  create?: InputMaybe<Array<BookingCreateWithoutAccessLabelsInput>>;
  delete?: InputMaybe<Array<BookingWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<BookingScalarWhereInput>>;
  disconnect?: InputMaybe<Array<BookingWhereUniqueInput>>;
  set?: InputMaybe<Array<BookingWhereUniqueInput>>;
  update?: InputMaybe<Array<BookingUpdateWithWhereUniqueWithoutAccessLabelsInput>>;
  updateMany?: InputMaybe<Array<BookingUpdateManyWithWhereWithoutAccessLabelsInput>>;
  upsert?: InputMaybe<Array<BookingUpsertWithWhereUniqueWithoutAccessLabelsInput>>;
};

export type BookingUpdateManyWithoutAdBoardNestedInput = {
  connect?: InputMaybe<Array<BookingWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<BookingCreateOrConnectWithoutAdBoardInput>>;
  create?: InputMaybe<Array<BookingCreateWithoutAdBoardInput>>;
  createMany?: InputMaybe<BookingCreateManyAdBoardInputEnvelope>;
  delete?: InputMaybe<Array<BookingWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<BookingScalarWhereInput>>;
  disconnect?: InputMaybe<Array<BookingWhereUniqueInput>>;
  set?: InputMaybe<Array<BookingWhereUniqueInput>>;
  update?: InputMaybe<Array<BookingUpdateWithWhereUniqueWithoutAdBoardInput>>;
  updateMany?: InputMaybe<Array<BookingUpdateManyWithWhereWithoutAdBoardInput>>;
  upsert?: InputMaybe<Array<BookingUpsertWithWhereUniqueWithoutAdBoardInput>>;
};

export type BookingUpdateManyWithoutAssetsNestedInput = {
  connect?: InputMaybe<Array<BookingWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<BookingCreateOrConnectWithoutAssetsInput>>;
  create?: InputMaybe<Array<BookingCreateWithoutAssetsInput>>;
  delete?: InputMaybe<Array<BookingWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<BookingScalarWhereInput>>;
  disconnect?: InputMaybe<Array<BookingWhereUniqueInput>>;
  set?: InputMaybe<Array<BookingWhereUniqueInput>>;
  update?: InputMaybe<Array<BookingUpdateWithWhereUniqueWithoutAssetsInput>>;
  updateMany?: InputMaybe<Array<BookingUpdateManyWithWhereWithoutAssetsInput>>;
  upsert?: InputMaybe<Array<BookingUpsertWithWhereUniqueWithoutAssetsInput>>;
};

export type BookingUpdateManyWithoutCampaignNestedInput = {
  connect?: InputMaybe<Array<BookingWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<BookingCreateOrConnectWithoutCampaignInput>>;
  create?: InputMaybe<Array<BookingCreateWithoutCampaignInput>>;
  createMany?: InputMaybe<BookingCreateManyCampaignInputEnvelope>;
  delete?: InputMaybe<Array<BookingWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<BookingScalarWhereInput>>;
  disconnect?: InputMaybe<Array<BookingWhereUniqueInput>>;
  set?: InputMaybe<Array<BookingWhereUniqueInput>>;
  update?: InputMaybe<Array<BookingUpdateWithWhereUniqueWithoutCampaignInput>>;
  updateMany?: InputMaybe<Array<BookingUpdateManyWithWhereWithoutCampaignInput>>;
  upsert?: InputMaybe<Array<BookingUpsertWithWhereUniqueWithoutCampaignInput>>;
};

export type BookingUpdateManyWithoutSharedUsersNestedInput = {
  connect?: InputMaybe<Array<BookingWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<BookingCreateOrConnectWithoutSharedUsersInput>>;
  create?: InputMaybe<Array<BookingCreateWithoutSharedUsersInput>>;
  delete?: InputMaybe<Array<BookingWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<BookingScalarWhereInput>>;
  disconnect?: InputMaybe<Array<BookingWhereUniqueInput>>;
  set?: InputMaybe<Array<BookingWhereUniqueInput>>;
  update?: InputMaybe<Array<BookingUpdateWithWhereUniqueWithoutSharedUsersInput>>;
  updateMany?: InputMaybe<Array<BookingUpdateManyWithWhereWithoutSharedUsersInput>>;
  upsert?: InputMaybe<Array<BookingUpsertWithWhereUniqueWithoutSharedUsersInput>>;
};

export type BookingUpdateManyWithoutUserNestedInput = {
  connect?: InputMaybe<Array<BookingWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<BookingCreateOrConnectWithoutUserInput>>;
  create?: InputMaybe<Array<BookingCreateWithoutUserInput>>;
  createMany?: InputMaybe<BookingCreateManyUserInputEnvelope>;
  delete?: InputMaybe<Array<BookingWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<BookingScalarWhereInput>>;
  disconnect?: InputMaybe<Array<BookingWhereUniqueInput>>;
  set?: InputMaybe<Array<BookingWhereUniqueInput>>;
  update?: InputMaybe<Array<BookingUpdateWithWhereUniqueWithoutUserInput>>;
  updateMany?: InputMaybe<Array<BookingUpdateManyWithWhereWithoutUserInput>>;
  upsert?: InputMaybe<Array<BookingUpsertWithWhereUniqueWithoutUserInput>>;
};

export type BookingUpdateManyWithoutWorkspaceNestedInput = {
  connect?: InputMaybe<Array<BookingWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<BookingCreateOrConnectWithoutWorkspaceInput>>;
  create?: InputMaybe<Array<BookingCreateWithoutWorkspaceInput>>;
  createMany?: InputMaybe<BookingCreateManyWorkspaceInputEnvelope>;
  delete?: InputMaybe<Array<BookingWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<BookingScalarWhereInput>>;
  disconnect?: InputMaybe<Array<BookingWhereUniqueInput>>;
  set?: InputMaybe<Array<BookingWhereUniqueInput>>;
  update?: InputMaybe<Array<BookingUpdateWithWhereUniqueWithoutWorkspaceInput>>;
  updateMany?: InputMaybe<Array<BookingUpdateManyWithWhereWithoutWorkspaceInput>>;
  upsert?: InputMaybe<Array<BookingUpsertWithWhereUniqueWithoutWorkspaceInput>>;
};

export type BookingUpdateOneRequiredWithoutPayoutsNestedInput = {
  connect?: InputMaybe<BookingWhereUniqueInput>;
  connectOrCreate?: InputMaybe<BookingCreateOrConnectWithoutPayoutsInput>;
  create?: InputMaybe<BookingCreateWithoutPayoutsInput>;
  update?: InputMaybe<BookingUpdateToOneWithWhereWithoutPayoutsInput>;
  upsert?: InputMaybe<BookingUpsertWithoutPayoutsInput>;
};

export type BookingUpdateOneWithoutBookedSlotsNestedInput = {
  connect?: InputMaybe<BookingWhereUniqueInput>;
  connectOrCreate?: InputMaybe<BookingCreateOrConnectWithoutBookedSlotsInput>;
  create?: InputMaybe<BookingCreateWithoutBookedSlotsInput>;
  delete?: InputMaybe<BookingWhereInput>;
  disconnect?: InputMaybe<Scalars['Boolean']>;
  update?: InputMaybe<BookingUpdateToOneWithWhereWithoutBookedSlotsInput>;
  upsert?: InputMaybe<BookingUpsertWithoutBookedSlotsInput>;
};

export type BookingUpdateOneWithoutChangelogsNestedInput = {
  connect?: InputMaybe<BookingWhereUniqueInput>;
  connectOrCreate?: InputMaybe<BookingCreateOrConnectWithoutChangelogsInput>;
  create?: InputMaybe<BookingCreateWithoutChangelogsInput>;
  delete?: InputMaybe<BookingWhereInput>;
  disconnect?: InputMaybe<Scalars['Boolean']>;
  update?: InputMaybe<BookingUpdateToOneWithWhereWithoutChangelogsInput>;
  upsert?: InputMaybe<BookingUpsertWithoutChangelogsInput>;
};

export type BookingUpdateOneWithoutProofsNestedInput = {
  connect?: InputMaybe<BookingWhereUniqueInput>;
  connectOrCreate?: InputMaybe<BookingCreateOrConnectWithoutProofsInput>;
  create?: InputMaybe<BookingCreateWithoutProofsInput>;
  delete?: InputMaybe<BookingWhereInput>;
  disconnect?: InputMaybe<Scalars['Boolean']>;
  update?: InputMaybe<BookingUpdateToOneWithWhereWithoutProofsInput>;
  upsert?: InputMaybe<BookingUpsertWithoutProofsInput>;
};

export type BookingUpdateToOneWithWhereWithoutBookedSlotsInput = {
  data: BookingUpdateWithoutBookedSlotsInput;
  where?: InputMaybe<BookingWhereInput>;
};

export type BookingUpdateToOneWithWhereWithoutChangelogsInput = {
  data: BookingUpdateWithoutChangelogsInput;
  where?: InputMaybe<BookingWhereInput>;
};

export type BookingUpdateToOneWithWhereWithoutPayoutsInput = {
  data: BookingUpdateWithoutPayoutsInput;
  where?: InputMaybe<BookingWhereInput>;
};

export type BookingUpdateToOneWithWhereWithoutProofsInput = {
  data: BookingUpdateWithoutProofsInput;
  where?: InputMaybe<BookingWhereInput>;
};

export type BookingUpdateWithWhereUniqueWithoutAccessLabelsInput = {
  data: BookingUpdateWithoutAccessLabelsInput;
  where: BookingWhereUniqueInput;
};

export type BookingUpdateWithWhereUniqueWithoutAdBoardInput = {
  data: BookingUpdateWithoutAdBoardInput;
  where: BookingWhereUniqueInput;
};

export type BookingUpdateWithWhereUniqueWithoutAssetsInput = {
  data: BookingUpdateWithoutAssetsInput;
  where: BookingWhereUniqueInput;
};

export type BookingUpdateWithWhereUniqueWithoutCampaignInput = {
  data: BookingUpdateWithoutCampaignInput;
  where: BookingWhereUniqueInput;
};

export type BookingUpdateWithWhereUniqueWithoutSharedUsersInput = {
  data: BookingUpdateWithoutSharedUsersInput;
  where: BookingWhereUniqueInput;
};

export type BookingUpdateWithWhereUniqueWithoutUserInput = {
  data: BookingUpdateWithoutUserInput;
  where: BookingWhereUniqueInput;
};

export type BookingUpdateWithWhereUniqueWithoutWorkspaceInput = {
  data: BookingUpdateWithoutWorkspaceInput;
  where: BookingWhereUniqueInput;
};

export type BookingUpdateWithoutAccessLabelsInput = {
  adBoard?: InputMaybe<AdBoardUpdateOneRequiredWithoutBookingsNestedInput>;
  additionalInformation?: InputMaybe<Scalars['String']>;
  assets?: InputMaybe<FileUpdateManyWithoutBookingsNestedInput>;
  bookedSlots?: InputMaybe<SlotUpdateManyWithoutBookingNestedInput>;
  bookingCode?: InputMaybe<Scalars['String']>;
  bookingDate?: InputMaybe<Scalars['DateTime']>;
  bookingDetails?: InputMaybe<BookingDetailsCreateInput>;
  bookingStatus?: InputMaybe<BookingStatus>;
  campaign?: InputMaybe<CampaignUpdateOneWithoutBookingsNestedInput>;
  changelogs?: InputMaybe<ChangelogUpdateManyWithoutBookingNestedInput>;
  origin?: InputMaybe<Scalars['String']>;
  payment?: InputMaybe<BookingPaymentCreateInput>;
  payouts?: InputMaybe<PayoutUpdateManyWithoutBookingNestedInput>;
  pisignage?: InputMaybe<BookingPisignageDataCreateInput>;
  priceSummary?: InputMaybe<OrderPriceSummaryCreateInput>;
  proofs?: InputMaybe<FileUpdateManyWithoutProofBookingNestedInput>;
  refund?: InputMaybe<BookingRefundCreateInput>;
  selectedDates?: InputMaybe<OrderSelectedDateCreateInput>;
  sharedUsers?: InputMaybe<UserUpdateManyWithoutSharedBookingsNestedInput>;
  user?: InputMaybe<UserUpdateOneRequiredWithoutBookingsNestedInput>;
  workspace?: InputMaybe<WorkspaceUpdateOneWithoutBookingsNestedInput>;
};

export type BookingUpdateWithoutAdBoardInput = {
  accessLabels?: InputMaybe<AccessLabelUpdateManyWithoutBookingsNestedInput>;
  additionalInformation?: InputMaybe<Scalars['String']>;
  assets?: InputMaybe<FileUpdateManyWithoutBookingsNestedInput>;
  bookedSlots?: InputMaybe<SlotUpdateManyWithoutBookingNestedInput>;
  bookingCode?: InputMaybe<Scalars['String']>;
  bookingDate?: InputMaybe<Scalars['DateTime']>;
  bookingDetails?: InputMaybe<BookingDetailsCreateInput>;
  bookingStatus?: InputMaybe<BookingStatus>;
  campaign?: InputMaybe<CampaignUpdateOneWithoutBookingsNestedInput>;
  changelogs?: InputMaybe<ChangelogUpdateManyWithoutBookingNestedInput>;
  origin?: InputMaybe<Scalars['String']>;
  payment?: InputMaybe<BookingPaymentCreateInput>;
  payouts?: InputMaybe<PayoutUpdateManyWithoutBookingNestedInput>;
  pisignage?: InputMaybe<BookingPisignageDataCreateInput>;
  priceSummary?: InputMaybe<OrderPriceSummaryCreateInput>;
  proofs?: InputMaybe<FileUpdateManyWithoutProofBookingNestedInput>;
  refund?: InputMaybe<BookingRefundCreateInput>;
  selectedDates?: InputMaybe<OrderSelectedDateCreateInput>;
  sharedUsers?: InputMaybe<UserUpdateManyWithoutSharedBookingsNestedInput>;
  user?: InputMaybe<UserUpdateOneRequiredWithoutBookingsNestedInput>;
  workspace?: InputMaybe<WorkspaceUpdateOneWithoutBookingsNestedInput>;
};

export type BookingUpdateWithoutAssetsInput = {
  accessLabels?: InputMaybe<AccessLabelUpdateManyWithoutBookingsNestedInput>;
  adBoard?: InputMaybe<AdBoardUpdateOneRequiredWithoutBookingsNestedInput>;
  additionalInformation?: InputMaybe<Scalars['String']>;
  bookedSlots?: InputMaybe<SlotUpdateManyWithoutBookingNestedInput>;
  bookingCode?: InputMaybe<Scalars['String']>;
  bookingDate?: InputMaybe<Scalars['DateTime']>;
  bookingDetails?: InputMaybe<BookingDetailsCreateInput>;
  bookingStatus?: InputMaybe<BookingStatus>;
  campaign?: InputMaybe<CampaignUpdateOneWithoutBookingsNestedInput>;
  changelogs?: InputMaybe<ChangelogUpdateManyWithoutBookingNestedInput>;
  origin?: InputMaybe<Scalars['String']>;
  payment?: InputMaybe<BookingPaymentCreateInput>;
  payouts?: InputMaybe<PayoutUpdateManyWithoutBookingNestedInput>;
  pisignage?: InputMaybe<BookingPisignageDataCreateInput>;
  priceSummary?: InputMaybe<OrderPriceSummaryCreateInput>;
  proofs?: InputMaybe<FileUpdateManyWithoutProofBookingNestedInput>;
  refund?: InputMaybe<BookingRefundCreateInput>;
  selectedDates?: InputMaybe<OrderSelectedDateCreateInput>;
  sharedUsers?: InputMaybe<UserUpdateManyWithoutSharedBookingsNestedInput>;
  user?: InputMaybe<UserUpdateOneRequiredWithoutBookingsNestedInput>;
  workspace?: InputMaybe<WorkspaceUpdateOneWithoutBookingsNestedInput>;
};

export type BookingUpdateWithoutBookedSlotsInput = {
  accessLabels?: InputMaybe<AccessLabelUpdateManyWithoutBookingsNestedInput>;
  adBoard?: InputMaybe<AdBoardUpdateOneRequiredWithoutBookingsNestedInput>;
  additionalInformation?: InputMaybe<Scalars['String']>;
  assets?: InputMaybe<FileUpdateManyWithoutBookingsNestedInput>;
  bookingCode?: InputMaybe<Scalars['String']>;
  bookingDate?: InputMaybe<Scalars['DateTime']>;
  bookingDetails?: InputMaybe<BookingDetailsCreateInput>;
  bookingStatus?: InputMaybe<BookingStatus>;
  campaign?: InputMaybe<CampaignUpdateOneWithoutBookingsNestedInput>;
  changelogs?: InputMaybe<ChangelogUpdateManyWithoutBookingNestedInput>;
  origin?: InputMaybe<Scalars['String']>;
  payment?: InputMaybe<BookingPaymentCreateInput>;
  payouts?: InputMaybe<PayoutUpdateManyWithoutBookingNestedInput>;
  pisignage?: InputMaybe<BookingPisignageDataCreateInput>;
  priceSummary?: InputMaybe<OrderPriceSummaryCreateInput>;
  proofs?: InputMaybe<FileUpdateManyWithoutProofBookingNestedInput>;
  refund?: InputMaybe<BookingRefundCreateInput>;
  selectedDates?: InputMaybe<OrderSelectedDateCreateInput>;
  sharedUsers?: InputMaybe<UserUpdateManyWithoutSharedBookingsNestedInput>;
  user?: InputMaybe<UserUpdateOneRequiredWithoutBookingsNestedInput>;
  workspace?: InputMaybe<WorkspaceUpdateOneWithoutBookingsNestedInput>;
};

export type BookingUpdateWithoutCampaignInput = {
  accessLabels?: InputMaybe<AccessLabelUpdateManyWithoutBookingsNestedInput>;
  adBoard?: InputMaybe<AdBoardUpdateOneRequiredWithoutBookingsNestedInput>;
  additionalInformation?: InputMaybe<Scalars['String']>;
  assets?: InputMaybe<FileUpdateManyWithoutBookingsNestedInput>;
  bookedSlots?: InputMaybe<SlotUpdateManyWithoutBookingNestedInput>;
  bookingCode?: InputMaybe<Scalars['String']>;
  bookingDate?: InputMaybe<Scalars['DateTime']>;
  bookingDetails?: InputMaybe<BookingDetailsCreateInput>;
  bookingStatus?: InputMaybe<BookingStatus>;
  changelogs?: InputMaybe<ChangelogUpdateManyWithoutBookingNestedInput>;
  origin?: InputMaybe<Scalars['String']>;
  payment?: InputMaybe<BookingPaymentCreateInput>;
  payouts?: InputMaybe<PayoutUpdateManyWithoutBookingNestedInput>;
  pisignage?: InputMaybe<BookingPisignageDataCreateInput>;
  priceSummary?: InputMaybe<OrderPriceSummaryCreateInput>;
  proofs?: InputMaybe<FileUpdateManyWithoutProofBookingNestedInput>;
  refund?: InputMaybe<BookingRefundCreateInput>;
  selectedDates?: InputMaybe<OrderSelectedDateCreateInput>;
  sharedUsers?: InputMaybe<UserUpdateManyWithoutSharedBookingsNestedInput>;
  user?: InputMaybe<UserUpdateOneRequiredWithoutBookingsNestedInput>;
  workspace?: InputMaybe<WorkspaceUpdateOneWithoutBookingsNestedInput>;
};

export type BookingUpdateWithoutChangelogsInput = {
  accessLabels?: InputMaybe<AccessLabelUpdateManyWithoutBookingsNestedInput>;
  adBoard?: InputMaybe<AdBoardUpdateOneRequiredWithoutBookingsNestedInput>;
  additionalInformation?: InputMaybe<Scalars['String']>;
  assets?: InputMaybe<FileUpdateManyWithoutBookingsNestedInput>;
  bookedSlots?: InputMaybe<SlotUpdateManyWithoutBookingNestedInput>;
  bookingCode?: InputMaybe<Scalars['String']>;
  bookingDate?: InputMaybe<Scalars['DateTime']>;
  bookingDetails?: InputMaybe<BookingDetailsCreateInput>;
  bookingStatus?: InputMaybe<BookingStatus>;
  campaign?: InputMaybe<CampaignUpdateOneWithoutBookingsNestedInput>;
  origin?: InputMaybe<Scalars['String']>;
  payment?: InputMaybe<BookingPaymentCreateInput>;
  payouts?: InputMaybe<PayoutUpdateManyWithoutBookingNestedInput>;
  pisignage?: InputMaybe<BookingPisignageDataCreateInput>;
  priceSummary?: InputMaybe<OrderPriceSummaryCreateInput>;
  proofs?: InputMaybe<FileUpdateManyWithoutProofBookingNestedInput>;
  refund?: InputMaybe<BookingRefundCreateInput>;
  selectedDates?: InputMaybe<OrderSelectedDateCreateInput>;
  sharedUsers?: InputMaybe<UserUpdateManyWithoutSharedBookingsNestedInput>;
  user?: InputMaybe<UserUpdateOneRequiredWithoutBookingsNestedInput>;
  workspace?: InputMaybe<WorkspaceUpdateOneWithoutBookingsNestedInput>;
};

export type BookingUpdateWithoutPayoutsInput = {
  accessLabels?: InputMaybe<AccessLabelUpdateManyWithoutBookingsNestedInput>;
  adBoard?: InputMaybe<AdBoardUpdateOneRequiredWithoutBookingsNestedInput>;
  additionalInformation?: InputMaybe<Scalars['String']>;
  assets?: InputMaybe<FileUpdateManyWithoutBookingsNestedInput>;
  bookedSlots?: InputMaybe<SlotUpdateManyWithoutBookingNestedInput>;
  bookingCode?: InputMaybe<Scalars['String']>;
  bookingDate?: InputMaybe<Scalars['DateTime']>;
  bookingDetails?: InputMaybe<BookingDetailsCreateInput>;
  bookingStatus?: InputMaybe<BookingStatus>;
  campaign?: InputMaybe<CampaignUpdateOneWithoutBookingsNestedInput>;
  changelogs?: InputMaybe<ChangelogUpdateManyWithoutBookingNestedInput>;
  origin?: InputMaybe<Scalars['String']>;
  payment?: InputMaybe<BookingPaymentCreateInput>;
  pisignage?: InputMaybe<BookingPisignageDataCreateInput>;
  priceSummary?: InputMaybe<OrderPriceSummaryCreateInput>;
  proofs?: InputMaybe<FileUpdateManyWithoutProofBookingNestedInput>;
  refund?: InputMaybe<BookingRefundCreateInput>;
  selectedDates?: InputMaybe<OrderSelectedDateCreateInput>;
  sharedUsers?: InputMaybe<UserUpdateManyWithoutSharedBookingsNestedInput>;
  user?: InputMaybe<UserUpdateOneRequiredWithoutBookingsNestedInput>;
  workspace?: InputMaybe<WorkspaceUpdateOneWithoutBookingsNestedInput>;
};

export type BookingUpdateWithoutProofsInput = {
  accessLabels?: InputMaybe<AccessLabelUpdateManyWithoutBookingsNestedInput>;
  adBoard?: InputMaybe<AdBoardUpdateOneRequiredWithoutBookingsNestedInput>;
  additionalInformation?: InputMaybe<Scalars['String']>;
  assets?: InputMaybe<FileUpdateManyWithoutBookingsNestedInput>;
  bookedSlots?: InputMaybe<SlotUpdateManyWithoutBookingNestedInput>;
  bookingCode?: InputMaybe<Scalars['String']>;
  bookingDate?: InputMaybe<Scalars['DateTime']>;
  bookingDetails?: InputMaybe<BookingDetailsCreateInput>;
  bookingStatus?: InputMaybe<BookingStatus>;
  campaign?: InputMaybe<CampaignUpdateOneWithoutBookingsNestedInput>;
  changelogs?: InputMaybe<ChangelogUpdateManyWithoutBookingNestedInput>;
  origin?: InputMaybe<Scalars['String']>;
  payment?: InputMaybe<BookingPaymentCreateInput>;
  payouts?: InputMaybe<PayoutUpdateManyWithoutBookingNestedInput>;
  pisignage?: InputMaybe<BookingPisignageDataCreateInput>;
  priceSummary?: InputMaybe<OrderPriceSummaryCreateInput>;
  refund?: InputMaybe<BookingRefundCreateInput>;
  selectedDates?: InputMaybe<OrderSelectedDateCreateInput>;
  sharedUsers?: InputMaybe<UserUpdateManyWithoutSharedBookingsNestedInput>;
  user?: InputMaybe<UserUpdateOneRequiredWithoutBookingsNestedInput>;
  workspace?: InputMaybe<WorkspaceUpdateOneWithoutBookingsNestedInput>;
};

export type BookingUpdateWithoutSharedUsersInput = {
  accessLabels?: InputMaybe<AccessLabelUpdateManyWithoutBookingsNestedInput>;
  adBoard?: InputMaybe<AdBoardUpdateOneRequiredWithoutBookingsNestedInput>;
  additionalInformation?: InputMaybe<Scalars['String']>;
  assets?: InputMaybe<FileUpdateManyWithoutBookingsNestedInput>;
  bookedSlots?: InputMaybe<SlotUpdateManyWithoutBookingNestedInput>;
  bookingCode?: InputMaybe<Scalars['String']>;
  bookingDate?: InputMaybe<Scalars['DateTime']>;
  bookingDetails?: InputMaybe<BookingDetailsCreateInput>;
  bookingStatus?: InputMaybe<BookingStatus>;
  campaign?: InputMaybe<CampaignUpdateOneWithoutBookingsNestedInput>;
  changelogs?: InputMaybe<ChangelogUpdateManyWithoutBookingNestedInput>;
  origin?: InputMaybe<Scalars['String']>;
  payment?: InputMaybe<BookingPaymentCreateInput>;
  payouts?: InputMaybe<PayoutUpdateManyWithoutBookingNestedInput>;
  pisignage?: InputMaybe<BookingPisignageDataCreateInput>;
  priceSummary?: InputMaybe<OrderPriceSummaryCreateInput>;
  proofs?: InputMaybe<FileUpdateManyWithoutProofBookingNestedInput>;
  refund?: InputMaybe<BookingRefundCreateInput>;
  selectedDates?: InputMaybe<OrderSelectedDateCreateInput>;
  user?: InputMaybe<UserUpdateOneRequiredWithoutBookingsNestedInput>;
  workspace?: InputMaybe<WorkspaceUpdateOneWithoutBookingsNestedInput>;
};

export type BookingUpdateWithoutUserInput = {
  accessLabels?: InputMaybe<AccessLabelUpdateManyWithoutBookingsNestedInput>;
  adBoard?: InputMaybe<AdBoardUpdateOneRequiredWithoutBookingsNestedInput>;
  additionalInformation?: InputMaybe<Scalars['String']>;
  assets?: InputMaybe<FileUpdateManyWithoutBookingsNestedInput>;
  bookedSlots?: InputMaybe<SlotUpdateManyWithoutBookingNestedInput>;
  bookingCode?: InputMaybe<Scalars['String']>;
  bookingDate?: InputMaybe<Scalars['DateTime']>;
  bookingDetails?: InputMaybe<BookingDetailsCreateInput>;
  bookingStatus?: InputMaybe<BookingStatus>;
  campaign?: InputMaybe<CampaignUpdateOneWithoutBookingsNestedInput>;
  changelogs?: InputMaybe<ChangelogUpdateManyWithoutBookingNestedInput>;
  origin?: InputMaybe<Scalars['String']>;
  payment?: InputMaybe<BookingPaymentCreateInput>;
  payouts?: InputMaybe<PayoutUpdateManyWithoutBookingNestedInput>;
  pisignage?: InputMaybe<BookingPisignageDataCreateInput>;
  priceSummary?: InputMaybe<OrderPriceSummaryCreateInput>;
  proofs?: InputMaybe<FileUpdateManyWithoutProofBookingNestedInput>;
  refund?: InputMaybe<BookingRefundCreateInput>;
  selectedDates?: InputMaybe<OrderSelectedDateCreateInput>;
  sharedUsers?: InputMaybe<UserUpdateManyWithoutSharedBookingsNestedInput>;
  workspace?: InputMaybe<WorkspaceUpdateOneWithoutBookingsNestedInput>;
};

export type BookingUpdateWithoutWorkspaceInput = {
  accessLabels?: InputMaybe<AccessLabelUpdateManyWithoutBookingsNestedInput>;
  adBoard?: InputMaybe<AdBoardUpdateOneRequiredWithoutBookingsNestedInput>;
  additionalInformation?: InputMaybe<Scalars['String']>;
  assets?: InputMaybe<FileUpdateManyWithoutBookingsNestedInput>;
  bookedSlots?: InputMaybe<SlotUpdateManyWithoutBookingNestedInput>;
  bookingCode?: InputMaybe<Scalars['String']>;
  bookingDate?: InputMaybe<Scalars['DateTime']>;
  bookingDetails?: InputMaybe<BookingDetailsCreateInput>;
  bookingStatus?: InputMaybe<BookingStatus>;
  campaign?: InputMaybe<CampaignUpdateOneWithoutBookingsNestedInput>;
  changelogs?: InputMaybe<ChangelogUpdateManyWithoutBookingNestedInput>;
  origin?: InputMaybe<Scalars['String']>;
  payment?: InputMaybe<BookingPaymentCreateInput>;
  payouts?: InputMaybe<PayoutUpdateManyWithoutBookingNestedInput>;
  pisignage?: InputMaybe<BookingPisignageDataCreateInput>;
  priceSummary?: InputMaybe<OrderPriceSummaryCreateInput>;
  proofs?: InputMaybe<FileUpdateManyWithoutProofBookingNestedInput>;
  refund?: InputMaybe<BookingRefundCreateInput>;
  selectedDates?: InputMaybe<OrderSelectedDateCreateInput>;
  sharedUsers?: InputMaybe<UserUpdateManyWithoutSharedBookingsNestedInput>;
  user?: InputMaybe<UserUpdateOneRequiredWithoutBookingsNestedInput>;
};

export type BookingUpsertWithWhereUniqueWithoutAccessLabelsInput = {
  create: BookingCreateWithoutAccessLabelsInput;
  update: BookingUpdateWithoutAccessLabelsInput;
  where: BookingWhereUniqueInput;
};

export type BookingUpsertWithWhereUniqueWithoutAdBoardInput = {
  create: BookingCreateWithoutAdBoardInput;
  update: BookingUpdateWithoutAdBoardInput;
  where: BookingWhereUniqueInput;
};

export type BookingUpsertWithWhereUniqueWithoutAssetsInput = {
  create: BookingCreateWithoutAssetsInput;
  update: BookingUpdateWithoutAssetsInput;
  where: BookingWhereUniqueInput;
};

export type BookingUpsertWithWhereUniqueWithoutCampaignInput = {
  create: BookingCreateWithoutCampaignInput;
  update: BookingUpdateWithoutCampaignInput;
  where: BookingWhereUniqueInput;
};

export type BookingUpsertWithWhereUniqueWithoutSharedUsersInput = {
  create: BookingCreateWithoutSharedUsersInput;
  update: BookingUpdateWithoutSharedUsersInput;
  where: BookingWhereUniqueInput;
};

export type BookingUpsertWithWhereUniqueWithoutUserInput = {
  create: BookingCreateWithoutUserInput;
  update: BookingUpdateWithoutUserInput;
  where: BookingWhereUniqueInput;
};

export type BookingUpsertWithWhereUniqueWithoutWorkspaceInput = {
  create: BookingCreateWithoutWorkspaceInput;
  update: BookingUpdateWithoutWorkspaceInput;
  where: BookingWhereUniqueInput;
};

export type BookingUpsertWithoutBookedSlotsInput = {
  create: BookingCreateWithoutBookedSlotsInput;
  update: BookingUpdateWithoutBookedSlotsInput;
  where?: InputMaybe<BookingWhereInput>;
};

export type BookingUpsertWithoutChangelogsInput = {
  create: BookingCreateWithoutChangelogsInput;
  update: BookingUpdateWithoutChangelogsInput;
  where?: InputMaybe<BookingWhereInput>;
};

export type BookingUpsertWithoutPayoutsInput = {
  create: BookingCreateWithoutPayoutsInput;
  update: BookingUpdateWithoutPayoutsInput;
  where?: InputMaybe<BookingWhereInput>;
};

export type BookingUpsertWithoutProofsInput = {
  create: BookingCreateWithoutProofsInput;
  update: BookingUpdateWithoutProofsInput;
  where?: InputMaybe<BookingWhereInput>;
};

export type BookingWhereInput = {
  AND?: InputMaybe<Array<BookingWhereInput>>;
  NOT?: InputMaybe<Array<BookingWhereInput>>;
  OR?: InputMaybe<Array<BookingWhereInput>>;
  accessLabelIDs?: InputMaybe<StringNullableListFilter>;
  accessLabels?: InputMaybe<AccessLabelListRelationFilter>;
  adBoard?: InputMaybe<AdBoardRelationFilter>;
  adBoardId?: InputMaybe<StringFilter>;
  additionalInformation?: InputMaybe<StringNullableFilter>;
  assets?: InputMaybe<FileListRelationFilter>;
  assetsIDs?: InputMaybe<StringNullableListFilter>;
  bookedSlots?: InputMaybe<SlotListRelationFilter>;
  bookingCode?: InputMaybe<StringFilter>;
  bookingDate?: InputMaybe<DateTimeFilter>;
  bookingDetails?: InputMaybe<BookingDetailsCompositeFilter>;
  bookingStatus?: InputMaybe<EnumBookingStatusFilter>;
  campaign?: InputMaybe<CampaignNullableRelationFilter>;
  campaignId?: InputMaybe<StringNullableFilter>;
  changelogs?: InputMaybe<ChangelogListRelationFilter>;
  id?: InputMaybe<StringFilter>;
  origin?: InputMaybe<StringNullableFilter>;
  payment?: InputMaybe<BookingPaymentNullableCompositeFilter>;
  payouts?: InputMaybe<PayoutListRelationFilter>;
  pisignage?: InputMaybe<BookingPisignageDataNullableCompositeFilter>;
  priceSummary?: InputMaybe<OrderPriceSummaryNullableCompositeFilter>;
  proofs?: InputMaybe<FileListRelationFilter>;
  refund?: InputMaybe<BookingRefundNullableCompositeFilter>;
  selectedDates?: InputMaybe<OrderSelectedDateCompositeFilter>;
  sharedUserIds?: InputMaybe<StringNullableListFilter>;
  sharedUsers?: InputMaybe<UserListRelationFilter>;
  user?: InputMaybe<UserRelationFilter>;
  userId?: InputMaybe<StringFilter>;
  workspace?: InputMaybe<WorkspaceNullableRelationFilter>;
  workspaceId?: InputMaybe<StringNullableFilter>;
};

export type BookingWhereUniqueInput = {
  AND?: InputMaybe<Array<BookingWhereInput>>;
  NOT?: InputMaybe<Array<BookingWhereInput>>;
  OR?: InputMaybe<Array<BookingWhereInput>>;
  accessLabelIDs?: InputMaybe<StringNullableListFilter>;
  accessLabels?: InputMaybe<AccessLabelListRelationFilter>;
  adBoard?: InputMaybe<AdBoardRelationFilter>;
  adBoardId?: InputMaybe<StringFilter>;
  additionalInformation?: InputMaybe<StringNullableFilter>;
  assets?: InputMaybe<FileListRelationFilter>;
  assetsIDs?: InputMaybe<StringNullableListFilter>;
  bookedSlots?: InputMaybe<SlotListRelationFilter>;
  bookingCode?: InputMaybe<Scalars['String']>;
  bookingDate?: InputMaybe<DateTimeFilter>;
  bookingDetails?: InputMaybe<BookingDetailsCompositeFilter>;
  bookingStatus?: InputMaybe<EnumBookingStatusFilter>;
  campaign?: InputMaybe<CampaignNullableRelationFilter>;
  campaignId?: InputMaybe<StringNullableFilter>;
  changelogs?: InputMaybe<ChangelogListRelationFilter>;
  id?: InputMaybe<Scalars['String']>;
  origin?: InputMaybe<StringNullableFilter>;
  payment?: InputMaybe<BookingPaymentNullableCompositeFilter>;
  payouts?: InputMaybe<PayoutListRelationFilter>;
  pisignage?: InputMaybe<BookingPisignageDataNullableCompositeFilter>;
  priceSummary?: InputMaybe<OrderPriceSummaryNullableCompositeFilter>;
  proofs?: InputMaybe<FileListRelationFilter>;
  refund?: InputMaybe<BookingRefundNullableCompositeFilter>;
  selectedDates?: InputMaybe<OrderSelectedDateCompositeFilter>;
  sharedUserIds?: InputMaybe<StringNullableListFilter>;
  sharedUsers?: InputMaybe<UserListRelationFilter>;
  user?: InputMaybe<UserRelationFilter>;
  userId?: InputMaybe<StringFilter>;
  workspace?: InputMaybe<WorkspaceNullableRelationFilter>;
  workspaceId?: InputMaybe<StringNullableFilter>;
};

export type BoolFilter = {
  equals?: InputMaybe<Scalars['Boolean']>;
  not?: InputMaybe<NestedBoolFilter>;
};

export type BoolNullableFilter = {
  equals?: InputMaybe<Scalars['Boolean']>;
  isSet?: InputMaybe<Scalars['Boolean']>;
  not?: InputMaybe<NestedBoolNullableFilter>;
};

export type BoolNullableWithAggregatesFilter = {
  _count?: InputMaybe<NestedIntNullableFilter>;
  _max?: InputMaybe<NestedBoolNullableFilter>;
  _min?: InputMaybe<NestedBoolNullableFilter>;
  equals?: InputMaybe<Scalars['Boolean']>;
  isSet?: InputMaybe<Scalars['Boolean']>;
  not?: InputMaybe<NestedBoolNullableWithAggregatesFilter>;
};

export type BoolWithAggregatesFilter = {
  _count?: InputMaybe<NestedIntFilter>;
  _max?: InputMaybe<NestedBoolFilter>;
  _min?: InputMaybe<NestedBoolFilter>;
  equals?: InputMaybe<Scalars['Boolean']>;
  not?: InputMaybe<NestedBoolWithAggregatesFilter>;
};

export type BusinessCategory = {
  __typename?: 'BusinessCategory';
  _count?: Maybe<BusinessCategoryCount>;
  adBoards: Array<AdBoard>;
  campaigns: Array<Campaign>;
  description?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  name: Scalars['String'];
  restrictedByAdBoardIds: Array<Scalars['String']>;
  restrictedByAdBoards: Array<AdBoard>;
};


export type BusinessCategoryAdBoardsArgs = {
  cursor?: InputMaybe<AdBoardWhereUniqueInput>;
  distinct?: InputMaybe<Array<AdBoardScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<AdBoardOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<AdBoardWhereInput>;
};


export type BusinessCategoryCampaignsArgs = {
  cursor?: InputMaybe<CampaignWhereUniqueInput>;
  distinct?: InputMaybe<Array<CampaignScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<CampaignOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<CampaignWhereInput>;
};


export type BusinessCategoryRestrictedByAdBoardsArgs = {
  cursor?: InputMaybe<AdBoardWhereUniqueInput>;
  distinct?: InputMaybe<Array<AdBoardScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<AdBoardOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<AdBoardWhereInput>;
};

export type BusinessCategoryCount = {
  __typename?: 'BusinessCategoryCount';
  adBoards: Scalars['Int'];
  campaigns: Scalars['Int'];
  restrictedByAdBoards: Scalars['Int'];
};


export type BusinessCategoryCountAdBoardsArgs = {
  where?: InputMaybe<AdBoardWhereInput>;
};


export type BusinessCategoryCountCampaignsArgs = {
  where?: InputMaybe<CampaignWhereInput>;
};


export type BusinessCategoryCountRestrictedByAdBoardsArgs = {
  where?: InputMaybe<AdBoardWhereInput>;
};

export type BusinessCategoryCountAggregate = {
  __typename?: 'BusinessCategoryCountAggregate';
  _all: Scalars['Int'];
  description: Scalars['Int'];
  id: Scalars['Int'];
  name: Scalars['Int'];
  restrictedByAdBoardIds: Scalars['Int'];
};

export type BusinessCategoryCountOrderByAggregateInput = {
  description?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  name?: InputMaybe<SortOrder>;
  restrictedByAdBoardIds?: InputMaybe<SortOrder>;
};

export type BusinessCategoryCreateInput = {
  adBoards?: InputMaybe<AdBoardCreateNestedManyWithoutCategoryInput>;
  campaigns?: InputMaybe<CampaignCreateNestedManyWithoutBusinessCategoryInput>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
  restrictedByAdBoards?: InputMaybe<AdBoardCreateNestedManyWithoutRestrictedBusinesInput>;
};

export type BusinessCategoryCreateManyInput = {
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
  restrictedByAdBoardIds?: InputMaybe<Array<Scalars['String']>>;
};

export type BusinessCategoryCreateNestedManyWithoutRestrictedByAdBoardsInput = {
  connect?: InputMaybe<Array<BusinessCategoryWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<BusinessCategoryCreateOrConnectWithoutRestrictedByAdBoardsInput>>;
  create?: InputMaybe<Array<BusinessCategoryCreateWithoutRestrictedByAdBoardsInput>>;
};

export type BusinessCategoryCreateNestedOneWithoutAdBoardsInput = {
  connect?: InputMaybe<BusinessCategoryWhereUniqueInput>;
  connectOrCreate?: InputMaybe<BusinessCategoryCreateOrConnectWithoutAdBoardsInput>;
  create?: InputMaybe<BusinessCategoryCreateWithoutAdBoardsInput>;
};

export type BusinessCategoryCreateNestedOneWithoutCampaignsInput = {
  connect?: InputMaybe<BusinessCategoryWhereUniqueInput>;
  connectOrCreate?: InputMaybe<BusinessCategoryCreateOrConnectWithoutCampaignsInput>;
  create?: InputMaybe<BusinessCategoryCreateWithoutCampaignsInput>;
};

export type BusinessCategoryCreateOrConnectWithoutAdBoardsInput = {
  create: BusinessCategoryCreateWithoutAdBoardsInput;
  where: BusinessCategoryWhereUniqueInput;
};

export type BusinessCategoryCreateOrConnectWithoutCampaignsInput = {
  create: BusinessCategoryCreateWithoutCampaignsInput;
  where: BusinessCategoryWhereUniqueInput;
};

export type BusinessCategoryCreateOrConnectWithoutRestrictedByAdBoardsInput = {
  create: BusinessCategoryCreateWithoutRestrictedByAdBoardsInput;
  where: BusinessCategoryWhereUniqueInput;
};

export type BusinessCategoryCreateWithoutAdBoardsInput = {
  campaigns?: InputMaybe<CampaignCreateNestedManyWithoutBusinessCategoryInput>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
  restrictedByAdBoards?: InputMaybe<AdBoardCreateNestedManyWithoutRestrictedBusinesInput>;
};

export type BusinessCategoryCreateWithoutCampaignsInput = {
  adBoards?: InputMaybe<AdBoardCreateNestedManyWithoutCategoryInput>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
  restrictedByAdBoards?: InputMaybe<AdBoardCreateNestedManyWithoutRestrictedBusinesInput>;
};

export type BusinessCategoryCreateWithoutRestrictedByAdBoardsInput = {
  adBoards?: InputMaybe<AdBoardCreateNestedManyWithoutCategoryInput>;
  campaigns?: InputMaybe<CampaignCreateNestedManyWithoutBusinessCategoryInput>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
};

export type BusinessCategoryGroupBy = {
  __typename?: 'BusinessCategoryGroupBy';
  _count?: Maybe<BusinessCategoryCountAggregate>;
  _max?: Maybe<BusinessCategoryMaxAggregate>;
  _min?: Maybe<BusinessCategoryMinAggregate>;
  description?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  name: Scalars['String'];
  restrictedByAdBoardIds?: Maybe<Array<Scalars['String']>>;
};

export type BusinessCategoryListRelationFilter = {
  every?: InputMaybe<BusinessCategoryWhereInput>;
  none?: InputMaybe<BusinessCategoryWhereInput>;
  some?: InputMaybe<BusinessCategoryWhereInput>;
};

export type BusinessCategoryMaxAggregate = {
  __typename?: 'BusinessCategoryMaxAggregate';
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
};

export type BusinessCategoryMaxOrderByAggregateInput = {
  description?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  name?: InputMaybe<SortOrder>;
};

export type BusinessCategoryMinAggregate = {
  __typename?: 'BusinessCategoryMinAggregate';
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
};

export type BusinessCategoryMinOrderByAggregateInput = {
  description?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  name?: InputMaybe<SortOrder>;
};

export type BusinessCategoryNullableRelationFilter = {
  is?: InputMaybe<BusinessCategoryWhereInput>;
  isNot?: InputMaybe<BusinessCategoryWhereInput>;
};

export type BusinessCategoryOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type BusinessCategoryOrderByWithAggregationInput = {
  _count?: InputMaybe<BusinessCategoryCountOrderByAggregateInput>;
  _max?: InputMaybe<BusinessCategoryMaxOrderByAggregateInput>;
  _min?: InputMaybe<BusinessCategoryMinOrderByAggregateInput>;
  description?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  name?: InputMaybe<SortOrder>;
  restrictedByAdBoardIds?: InputMaybe<SortOrder>;
};

export type BusinessCategoryOrderByWithRelationInput = {
  adBoards?: InputMaybe<AdBoardOrderByRelationAggregateInput>;
  campaigns?: InputMaybe<CampaignOrderByRelationAggregateInput>;
  description?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  name?: InputMaybe<SortOrder>;
  restrictedByAdBoardIds?: InputMaybe<SortOrder>;
  restrictedByAdBoards?: InputMaybe<AdBoardOrderByRelationAggregateInput>;
};

export type BusinessCategoryRelationFilter = {
  is?: InputMaybe<BusinessCategoryWhereInput>;
  isNot?: InputMaybe<BusinessCategoryWhereInput>;
};

export enum BusinessCategoryScalarFieldEnum {
  Description = 'description',
  Id = 'id',
  Name = 'name',
  RestrictedByAdBoardIds = 'restrictedByAdBoardIds'
}

export type BusinessCategoryScalarWhereInput = {
  AND?: InputMaybe<Array<BusinessCategoryScalarWhereInput>>;
  NOT?: InputMaybe<Array<BusinessCategoryScalarWhereInput>>;
  OR?: InputMaybe<Array<BusinessCategoryScalarWhereInput>>;
  description?: InputMaybe<StringNullableFilter>;
  id?: InputMaybe<StringFilter>;
  name?: InputMaybe<StringFilter>;
  restrictedByAdBoardIds?: InputMaybe<StringNullableListFilter>;
};

export type BusinessCategoryScalarWhereWithAggregatesInput = {
  AND?: InputMaybe<Array<BusinessCategoryScalarWhereWithAggregatesInput>>;
  NOT?: InputMaybe<Array<BusinessCategoryScalarWhereWithAggregatesInput>>;
  OR?: InputMaybe<Array<BusinessCategoryScalarWhereWithAggregatesInput>>;
  description?: InputMaybe<StringNullableWithAggregatesFilter>;
  id?: InputMaybe<StringWithAggregatesFilter>;
  name?: InputMaybe<StringWithAggregatesFilter>;
  restrictedByAdBoardIds?: InputMaybe<StringNullableListFilter>;
};

export type BusinessCategoryUpdateInput = {
  adBoards?: InputMaybe<AdBoardUpdateManyWithoutCategoryNestedInput>;
  campaigns?: InputMaybe<CampaignUpdateManyWithoutBusinessCategoryNestedInput>;
  description?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  restrictedByAdBoards?: InputMaybe<AdBoardUpdateManyWithoutRestrictedBusinesNestedInput>;
};

export type BusinessCategoryUpdateManyMutationInput = {
  description?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
};

export type BusinessCategoryUpdateManyWithWhereWithoutRestrictedByAdBoardsInput = {
  data: BusinessCategoryUpdateManyMutationInput;
  where: BusinessCategoryScalarWhereInput;
};

export type BusinessCategoryUpdateManyWithoutRestrictedByAdBoardsNestedInput = {
  connect?: InputMaybe<Array<BusinessCategoryWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<BusinessCategoryCreateOrConnectWithoutRestrictedByAdBoardsInput>>;
  create?: InputMaybe<Array<BusinessCategoryCreateWithoutRestrictedByAdBoardsInput>>;
  delete?: InputMaybe<Array<BusinessCategoryWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<BusinessCategoryScalarWhereInput>>;
  disconnect?: InputMaybe<Array<BusinessCategoryWhereUniqueInput>>;
  set?: InputMaybe<Array<BusinessCategoryWhereUniqueInput>>;
  update?: InputMaybe<Array<BusinessCategoryUpdateWithWhereUniqueWithoutRestrictedByAdBoardsInput>>;
  updateMany?: InputMaybe<Array<BusinessCategoryUpdateManyWithWhereWithoutRestrictedByAdBoardsInput>>;
  upsert?: InputMaybe<Array<BusinessCategoryUpsertWithWhereUniqueWithoutRestrictedByAdBoardsInput>>;
};

export type BusinessCategoryUpdateOneRequiredWithoutCampaignsNestedInput = {
  connect?: InputMaybe<BusinessCategoryWhereUniqueInput>;
  connectOrCreate?: InputMaybe<BusinessCategoryCreateOrConnectWithoutCampaignsInput>;
  create?: InputMaybe<BusinessCategoryCreateWithoutCampaignsInput>;
  update?: InputMaybe<BusinessCategoryUpdateToOneWithWhereWithoutCampaignsInput>;
  upsert?: InputMaybe<BusinessCategoryUpsertWithoutCampaignsInput>;
};

export type BusinessCategoryUpdateOneWithoutAdBoardsNestedInput = {
  connect?: InputMaybe<BusinessCategoryWhereUniqueInput>;
  connectOrCreate?: InputMaybe<BusinessCategoryCreateOrConnectWithoutAdBoardsInput>;
  create?: InputMaybe<BusinessCategoryCreateWithoutAdBoardsInput>;
  delete?: InputMaybe<BusinessCategoryWhereInput>;
  disconnect?: InputMaybe<Scalars['Boolean']>;
  update?: InputMaybe<BusinessCategoryUpdateToOneWithWhereWithoutAdBoardsInput>;
  upsert?: InputMaybe<BusinessCategoryUpsertWithoutAdBoardsInput>;
};

export type BusinessCategoryUpdateToOneWithWhereWithoutAdBoardsInput = {
  data: BusinessCategoryUpdateWithoutAdBoardsInput;
  where?: InputMaybe<BusinessCategoryWhereInput>;
};

export type BusinessCategoryUpdateToOneWithWhereWithoutCampaignsInput = {
  data: BusinessCategoryUpdateWithoutCampaignsInput;
  where?: InputMaybe<BusinessCategoryWhereInput>;
};

export type BusinessCategoryUpdateWithWhereUniqueWithoutRestrictedByAdBoardsInput = {
  data: BusinessCategoryUpdateWithoutRestrictedByAdBoardsInput;
  where: BusinessCategoryWhereUniqueInput;
};

export type BusinessCategoryUpdateWithoutAdBoardsInput = {
  campaigns?: InputMaybe<CampaignUpdateManyWithoutBusinessCategoryNestedInput>;
  description?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  restrictedByAdBoards?: InputMaybe<AdBoardUpdateManyWithoutRestrictedBusinesNestedInput>;
};

export type BusinessCategoryUpdateWithoutCampaignsInput = {
  adBoards?: InputMaybe<AdBoardUpdateManyWithoutCategoryNestedInput>;
  description?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  restrictedByAdBoards?: InputMaybe<AdBoardUpdateManyWithoutRestrictedBusinesNestedInput>;
};

export type BusinessCategoryUpdateWithoutRestrictedByAdBoardsInput = {
  adBoards?: InputMaybe<AdBoardUpdateManyWithoutCategoryNestedInput>;
  campaigns?: InputMaybe<CampaignUpdateManyWithoutBusinessCategoryNestedInput>;
  description?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
};

export type BusinessCategoryUpsertWithWhereUniqueWithoutRestrictedByAdBoardsInput = {
  create: BusinessCategoryCreateWithoutRestrictedByAdBoardsInput;
  update: BusinessCategoryUpdateWithoutRestrictedByAdBoardsInput;
  where: BusinessCategoryWhereUniqueInput;
};

export type BusinessCategoryUpsertWithoutAdBoardsInput = {
  create: BusinessCategoryCreateWithoutAdBoardsInput;
  update: BusinessCategoryUpdateWithoutAdBoardsInput;
  where?: InputMaybe<BusinessCategoryWhereInput>;
};

export type BusinessCategoryUpsertWithoutCampaignsInput = {
  create: BusinessCategoryCreateWithoutCampaignsInput;
  update: BusinessCategoryUpdateWithoutCampaignsInput;
  where?: InputMaybe<BusinessCategoryWhereInput>;
};

export type BusinessCategoryWhereInput = {
  AND?: InputMaybe<Array<BusinessCategoryWhereInput>>;
  NOT?: InputMaybe<Array<BusinessCategoryWhereInput>>;
  OR?: InputMaybe<Array<BusinessCategoryWhereInput>>;
  adBoards?: InputMaybe<AdBoardListRelationFilter>;
  campaigns?: InputMaybe<CampaignListRelationFilter>;
  description?: InputMaybe<StringNullableFilter>;
  id?: InputMaybe<StringFilter>;
  name?: InputMaybe<StringFilter>;
  restrictedByAdBoardIds?: InputMaybe<StringNullableListFilter>;
  restrictedByAdBoards?: InputMaybe<AdBoardListRelationFilter>;
};

export type BusinessCategoryWhereUniqueInput = {
  AND?: InputMaybe<Array<BusinessCategoryWhereInput>>;
  NOT?: InputMaybe<Array<BusinessCategoryWhereInput>>;
  OR?: InputMaybe<Array<BusinessCategoryWhereInput>>;
  adBoards?: InputMaybe<AdBoardListRelationFilter>;
  campaigns?: InputMaybe<CampaignListRelationFilter>;
  description?: InputMaybe<StringNullableFilter>;
  id?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  restrictedByAdBoardIds?: InputMaybe<StringNullableListFilter>;
  restrictedByAdBoards?: InputMaybe<AdBoardListRelationFilter>;
};

export type Campaign = {
  __typename?: 'Campaign';
  _count?: Maybe<CampaignCount>;
  assets: Array<File>;
  assetsIDs: Array<Scalars['String']>;
  bookings: Array<Booking>;
  businessCategory: BusinessCategory;
  businessCategoryId: Scalars['String'];
  createdAt: Scalars['DateTime'];
  id: Scalars['String'];
  name: Scalars['String'];
  origin: Scalars['String'];
  payment?: Maybe<BookingPayment>;
  paymentStatus: PaymentStatus;
  selectedDates: OrderSelectedDate;
  updatedAt: Scalars['DateTime'];
  user: User;
  userId: Scalars['String'];
};


export type CampaignAssetsArgs = {
  cursor?: InputMaybe<FileWhereUniqueInput>;
  distinct?: InputMaybe<Array<FileScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<FileOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<FileWhereInput>;
};


export type CampaignBookingsArgs = {
  cursor?: InputMaybe<BookingWhereUniqueInput>;
  distinct?: InputMaybe<Array<BookingScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<BookingOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<BookingWhereInput>;
};

export type CampaignCount = {
  __typename?: 'CampaignCount';
  assets: Scalars['Int'];
  bookings: Scalars['Int'];
};


export type CampaignCountAssetsArgs = {
  where?: InputMaybe<FileWhereInput>;
};


export type CampaignCountBookingsArgs = {
  where?: InputMaybe<BookingWhereInput>;
};

export type CampaignCountAggregate = {
  __typename?: 'CampaignCountAggregate';
  _all: Scalars['Int'];
  assetsIDs: Scalars['Int'];
  businessCategoryId: Scalars['Int'];
  createdAt: Scalars['Int'];
  id: Scalars['Int'];
  name: Scalars['Int'];
  origin: Scalars['Int'];
  paymentStatus: Scalars['Int'];
  updatedAt: Scalars['Int'];
  userId: Scalars['Int'];
};

export type CampaignCountOrderByAggregateInput = {
  assetsIDs?: InputMaybe<SortOrder>;
  businessCategoryId?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  name?: InputMaybe<SortOrder>;
  origin?: InputMaybe<SortOrder>;
  paymentStatus?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
  userId?: InputMaybe<SortOrder>;
};

export type CampaignCreateInput = {
  assets?: InputMaybe<FileCreateNestedManyWithoutCampaignsInput>;
  bookings?: InputMaybe<BookingCreateNestedManyWithoutCampaignInput>;
  businessCategory: BusinessCategoryCreateNestedOneWithoutCampaignsInput;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
  origin: Scalars['String'];
  payment?: InputMaybe<BookingPaymentCreateInput>;
  paymentStatus: PaymentStatus;
  selectedDates: OrderSelectedDateCreateInput;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  user: UserCreateNestedOneWithoutCampaignsInput;
};

export type CampaignCreateManyBusinessCategoryInput = {
  assetsIDs?: InputMaybe<Array<Scalars['String']>>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
  origin: Scalars['String'];
  payment?: InputMaybe<BookingPaymentCreateInput>;
  paymentStatus: PaymentStatus;
  selectedDates: OrderSelectedDateCreateInput;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  userId: Scalars['String'];
};

export type CampaignCreateManyBusinessCategoryInputEnvelope = {
  data: Array<CampaignCreateManyBusinessCategoryInput>;
};

export type CampaignCreateManyInput = {
  assetsIDs?: InputMaybe<Array<Scalars['String']>>;
  businessCategoryId: Scalars['String'];
  createdAt?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
  origin: Scalars['String'];
  payment?: InputMaybe<BookingPaymentCreateInput>;
  paymentStatus: PaymentStatus;
  selectedDates: OrderSelectedDateCreateInput;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  userId: Scalars['String'];
};

export type CampaignCreateManyUserInput = {
  assetsIDs?: InputMaybe<Array<Scalars['String']>>;
  businessCategoryId: Scalars['String'];
  createdAt?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
  origin: Scalars['String'];
  payment?: InputMaybe<BookingPaymentCreateInput>;
  paymentStatus: PaymentStatus;
  selectedDates: OrderSelectedDateCreateInput;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type CampaignCreateManyUserInputEnvelope = {
  data: Array<CampaignCreateManyUserInput>;
};

export type CampaignCreateNestedManyWithoutAssetsInput = {
  connect?: InputMaybe<Array<CampaignWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<CampaignCreateOrConnectWithoutAssetsInput>>;
  create?: InputMaybe<Array<CampaignCreateWithoutAssetsInput>>;
};

export type CampaignCreateNestedManyWithoutBusinessCategoryInput = {
  connect?: InputMaybe<Array<CampaignWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<CampaignCreateOrConnectWithoutBusinessCategoryInput>>;
  create?: InputMaybe<Array<CampaignCreateWithoutBusinessCategoryInput>>;
  createMany?: InputMaybe<CampaignCreateManyBusinessCategoryInputEnvelope>;
};

export type CampaignCreateNestedManyWithoutUserInput = {
  connect?: InputMaybe<Array<CampaignWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<CampaignCreateOrConnectWithoutUserInput>>;
  create?: InputMaybe<Array<CampaignCreateWithoutUserInput>>;
  createMany?: InputMaybe<CampaignCreateManyUserInputEnvelope>;
};

export type CampaignCreateNestedOneWithoutBookingsInput = {
  connect?: InputMaybe<CampaignWhereUniqueInput>;
  connectOrCreate?: InputMaybe<CampaignCreateOrConnectWithoutBookingsInput>;
  create?: InputMaybe<CampaignCreateWithoutBookingsInput>;
};

export type CampaignCreateOrConnectWithoutAssetsInput = {
  create: CampaignCreateWithoutAssetsInput;
  where: CampaignWhereUniqueInput;
};

export type CampaignCreateOrConnectWithoutBookingsInput = {
  create: CampaignCreateWithoutBookingsInput;
  where: CampaignWhereUniqueInput;
};

export type CampaignCreateOrConnectWithoutBusinessCategoryInput = {
  create: CampaignCreateWithoutBusinessCategoryInput;
  where: CampaignWhereUniqueInput;
};

export type CampaignCreateOrConnectWithoutUserInput = {
  create: CampaignCreateWithoutUserInput;
  where: CampaignWhereUniqueInput;
};

export type CampaignCreateWithoutAssetsInput = {
  bookings?: InputMaybe<BookingCreateNestedManyWithoutCampaignInput>;
  businessCategory: BusinessCategoryCreateNestedOneWithoutCampaignsInput;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
  origin: Scalars['String'];
  payment?: InputMaybe<BookingPaymentCreateInput>;
  paymentStatus: PaymentStatus;
  selectedDates: OrderSelectedDateCreateInput;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  user: UserCreateNestedOneWithoutCampaignsInput;
};

export type CampaignCreateWithoutBookingsInput = {
  assets?: InputMaybe<FileCreateNestedManyWithoutCampaignsInput>;
  businessCategory: BusinessCategoryCreateNestedOneWithoutCampaignsInput;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
  origin: Scalars['String'];
  payment?: InputMaybe<BookingPaymentCreateInput>;
  paymentStatus: PaymentStatus;
  selectedDates: OrderSelectedDateCreateInput;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  user: UserCreateNestedOneWithoutCampaignsInput;
};

export type CampaignCreateWithoutBusinessCategoryInput = {
  assets?: InputMaybe<FileCreateNestedManyWithoutCampaignsInput>;
  bookings?: InputMaybe<BookingCreateNestedManyWithoutCampaignInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
  origin: Scalars['String'];
  payment?: InputMaybe<BookingPaymentCreateInput>;
  paymentStatus: PaymentStatus;
  selectedDates: OrderSelectedDateCreateInput;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  user: UserCreateNestedOneWithoutCampaignsInput;
};

export type CampaignCreateWithoutUserInput = {
  assets?: InputMaybe<FileCreateNestedManyWithoutCampaignsInput>;
  bookings?: InputMaybe<BookingCreateNestedManyWithoutCampaignInput>;
  businessCategory: BusinessCategoryCreateNestedOneWithoutCampaignsInput;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
  origin: Scalars['String'];
  payment?: InputMaybe<BookingPaymentCreateInput>;
  paymentStatus: PaymentStatus;
  selectedDates: OrderSelectedDateCreateInput;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type CampaignGroupBy = {
  __typename?: 'CampaignGroupBy';
  _count?: Maybe<CampaignCountAggregate>;
  _max?: Maybe<CampaignMaxAggregate>;
  _min?: Maybe<CampaignMinAggregate>;
  assetsIDs?: Maybe<Array<Scalars['String']>>;
  businessCategoryId: Scalars['String'];
  createdAt: Scalars['DateTime'];
  id: Scalars['String'];
  name: Scalars['String'];
  origin: Scalars['String'];
  paymentStatus: PaymentStatus;
  updatedAt: Scalars['DateTime'];
  userId: Scalars['String'];
};

export type CampaignListRelationFilter = {
  every?: InputMaybe<CampaignWhereInput>;
  none?: InputMaybe<CampaignWhereInput>;
  some?: InputMaybe<CampaignWhereInput>;
};

export type CampaignMaxAggregate = {
  __typename?: 'CampaignMaxAggregate';
  businessCategoryId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  origin?: Maybe<Scalars['String']>;
  paymentStatus?: Maybe<PaymentStatus>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userId?: Maybe<Scalars['String']>;
};

export type CampaignMaxOrderByAggregateInput = {
  businessCategoryId?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  name?: InputMaybe<SortOrder>;
  origin?: InputMaybe<SortOrder>;
  paymentStatus?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
  userId?: InputMaybe<SortOrder>;
};

export type CampaignMinAggregate = {
  __typename?: 'CampaignMinAggregate';
  businessCategoryId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  origin?: Maybe<Scalars['String']>;
  paymentStatus?: Maybe<PaymentStatus>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userId?: Maybe<Scalars['String']>;
};

export type CampaignMinOrderByAggregateInput = {
  businessCategoryId?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  name?: InputMaybe<SortOrder>;
  origin?: InputMaybe<SortOrder>;
  paymentStatus?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
  userId?: InputMaybe<SortOrder>;
};

export type CampaignNullableRelationFilter = {
  is?: InputMaybe<CampaignWhereInput>;
  isNot?: InputMaybe<CampaignWhereInput>;
};

export type CampaignOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type CampaignOrderByWithAggregationInput = {
  _count?: InputMaybe<CampaignCountOrderByAggregateInput>;
  _max?: InputMaybe<CampaignMaxOrderByAggregateInput>;
  _min?: InputMaybe<CampaignMinOrderByAggregateInput>;
  assetsIDs?: InputMaybe<SortOrder>;
  businessCategoryId?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  name?: InputMaybe<SortOrder>;
  origin?: InputMaybe<SortOrder>;
  paymentStatus?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
  userId?: InputMaybe<SortOrder>;
};

export type CampaignOrderByWithRelationInput = {
  assets?: InputMaybe<FileOrderByRelationAggregateInput>;
  assetsIDs?: InputMaybe<SortOrder>;
  bookings?: InputMaybe<BookingOrderByRelationAggregateInput>;
  businessCategory?: InputMaybe<BusinessCategoryOrderByWithRelationInput>;
  businessCategoryId?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  name?: InputMaybe<SortOrder>;
  origin?: InputMaybe<SortOrder>;
  payment?: InputMaybe<BookingPaymentOrderByInput>;
  paymentStatus?: InputMaybe<SortOrder>;
  selectedDates?: InputMaybe<OrderSelectedDateOrderByInput>;
  updatedAt?: InputMaybe<SortOrder>;
  user?: InputMaybe<UserOrderByWithRelationInput>;
  userId?: InputMaybe<SortOrder>;
};

export enum CampaignScalarFieldEnum {
  AssetsIDs = 'assetsIDs',
  BusinessCategoryId = 'businessCategoryId',
  CreatedAt = 'createdAt',
  Id = 'id',
  Name = 'name',
  Origin = 'origin',
  PaymentStatus = 'paymentStatus',
  UpdatedAt = 'updatedAt',
  UserId = 'userId'
}

export type CampaignScalarWhereInput = {
  AND?: InputMaybe<Array<CampaignScalarWhereInput>>;
  NOT?: InputMaybe<Array<CampaignScalarWhereInput>>;
  OR?: InputMaybe<Array<CampaignScalarWhereInput>>;
  assetsIDs?: InputMaybe<StringNullableListFilter>;
  businessCategoryId?: InputMaybe<StringFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  id?: InputMaybe<StringFilter>;
  name?: InputMaybe<StringFilter>;
  origin?: InputMaybe<StringFilter>;
  paymentStatus?: InputMaybe<EnumPaymentStatusFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
  userId?: InputMaybe<StringFilter>;
};

export type CampaignScalarWhereWithAggregatesInput = {
  AND?: InputMaybe<Array<CampaignScalarWhereWithAggregatesInput>>;
  NOT?: InputMaybe<Array<CampaignScalarWhereWithAggregatesInput>>;
  OR?: InputMaybe<Array<CampaignScalarWhereWithAggregatesInput>>;
  assetsIDs?: InputMaybe<StringNullableListFilter>;
  businessCategoryId?: InputMaybe<StringWithAggregatesFilter>;
  createdAt?: InputMaybe<DateTimeWithAggregatesFilter>;
  id?: InputMaybe<StringWithAggregatesFilter>;
  name?: InputMaybe<StringWithAggregatesFilter>;
  origin?: InputMaybe<StringWithAggregatesFilter>;
  paymentStatus?: InputMaybe<EnumPaymentStatusWithAggregatesFilter>;
  updatedAt?: InputMaybe<DateTimeWithAggregatesFilter>;
  userId?: InputMaybe<StringWithAggregatesFilter>;
};

export type CampaignUpdateInput = {
  assets?: InputMaybe<FileUpdateManyWithoutCampaignsNestedInput>;
  bookings?: InputMaybe<BookingUpdateManyWithoutCampaignNestedInput>;
  businessCategory?: InputMaybe<BusinessCategoryUpdateOneRequiredWithoutCampaignsNestedInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  name?: InputMaybe<Scalars['String']>;
  origin?: InputMaybe<Scalars['String']>;
  payment?: InputMaybe<BookingPaymentCreateInput>;
  paymentStatus?: InputMaybe<PaymentStatus>;
  selectedDates?: InputMaybe<OrderSelectedDateCreateInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  user?: InputMaybe<UserUpdateOneRequiredWithoutCampaignsNestedInput>;
};

export type CampaignUpdateManyMutationInput = {
  createdAt?: InputMaybe<Scalars['DateTime']>;
  name?: InputMaybe<Scalars['String']>;
  origin?: InputMaybe<Scalars['String']>;
  payment?: InputMaybe<BookingPaymentCreateInput>;
  paymentStatus?: InputMaybe<PaymentStatus>;
  selectedDates?: InputMaybe<OrderSelectedDateCreateInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type CampaignUpdateManyWithWhereWithoutAssetsInput = {
  data: CampaignUpdateManyMutationInput;
  where: CampaignScalarWhereInput;
};

export type CampaignUpdateManyWithWhereWithoutBusinessCategoryInput = {
  data: CampaignUpdateManyMutationInput;
  where: CampaignScalarWhereInput;
};

export type CampaignUpdateManyWithWhereWithoutUserInput = {
  data: CampaignUpdateManyMutationInput;
  where: CampaignScalarWhereInput;
};

export type CampaignUpdateManyWithoutAssetsNestedInput = {
  connect?: InputMaybe<Array<CampaignWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<CampaignCreateOrConnectWithoutAssetsInput>>;
  create?: InputMaybe<Array<CampaignCreateWithoutAssetsInput>>;
  delete?: InputMaybe<Array<CampaignWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<CampaignScalarWhereInput>>;
  disconnect?: InputMaybe<Array<CampaignWhereUniqueInput>>;
  set?: InputMaybe<Array<CampaignWhereUniqueInput>>;
  update?: InputMaybe<Array<CampaignUpdateWithWhereUniqueWithoutAssetsInput>>;
  updateMany?: InputMaybe<Array<CampaignUpdateManyWithWhereWithoutAssetsInput>>;
  upsert?: InputMaybe<Array<CampaignUpsertWithWhereUniqueWithoutAssetsInput>>;
};

export type CampaignUpdateManyWithoutBusinessCategoryNestedInput = {
  connect?: InputMaybe<Array<CampaignWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<CampaignCreateOrConnectWithoutBusinessCategoryInput>>;
  create?: InputMaybe<Array<CampaignCreateWithoutBusinessCategoryInput>>;
  createMany?: InputMaybe<CampaignCreateManyBusinessCategoryInputEnvelope>;
  delete?: InputMaybe<Array<CampaignWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<CampaignScalarWhereInput>>;
  disconnect?: InputMaybe<Array<CampaignWhereUniqueInput>>;
  set?: InputMaybe<Array<CampaignWhereUniqueInput>>;
  update?: InputMaybe<Array<CampaignUpdateWithWhereUniqueWithoutBusinessCategoryInput>>;
  updateMany?: InputMaybe<Array<CampaignUpdateManyWithWhereWithoutBusinessCategoryInput>>;
  upsert?: InputMaybe<Array<CampaignUpsertWithWhereUniqueWithoutBusinessCategoryInput>>;
};

export type CampaignUpdateManyWithoutUserNestedInput = {
  connect?: InputMaybe<Array<CampaignWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<CampaignCreateOrConnectWithoutUserInput>>;
  create?: InputMaybe<Array<CampaignCreateWithoutUserInput>>;
  createMany?: InputMaybe<CampaignCreateManyUserInputEnvelope>;
  delete?: InputMaybe<Array<CampaignWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<CampaignScalarWhereInput>>;
  disconnect?: InputMaybe<Array<CampaignWhereUniqueInput>>;
  set?: InputMaybe<Array<CampaignWhereUniqueInput>>;
  update?: InputMaybe<Array<CampaignUpdateWithWhereUniqueWithoutUserInput>>;
  updateMany?: InputMaybe<Array<CampaignUpdateManyWithWhereWithoutUserInput>>;
  upsert?: InputMaybe<Array<CampaignUpsertWithWhereUniqueWithoutUserInput>>;
};

export type CampaignUpdateOneWithoutBookingsNestedInput = {
  connect?: InputMaybe<CampaignWhereUniqueInput>;
  connectOrCreate?: InputMaybe<CampaignCreateOrConnectWithoutBookingsInput>;
  create?: InputMaybe<CampaignCreateWithoutBookingsInput>;
  delete?: InputMaybe<CampaignWhereInput>;
  disconnect?: InputMaybe<Scalars['Boolean']>;
  update?: InputMaybe<CampaignUpdateToOneWithWhereWithoutBookingsInput>;
  upsert?: InputMaybe<CampaignUpsertWithoutBookingsInput>;
};

export type CampaignUpdateToOneWithWhereWithoutBookingsInput = {
  data: CampaignUpdateWithoutBookingsInput;
  where?: InputMaybe<CampaignWhereInput>;
};

export type CampaignUpdateWithWhereUniqueWithoutAssetsInput = {
  data: CampaignUpdateWithoutAssetsInput;
  where: CampaignWhereUniqueInput;
};

export type CampaignUpdateWithWhereUniqueWithoutBusinessCategoryInput = {
  data: CampaignUpdateWithoutBusinessCategoryInput;
  where: CampaignWhereUniqueInput;
};

export type CampaignUpdateWithWhereUniqueWithoutUserInput = {
  data: CampaignUpdateWithoutUserInput;
  where: CampaignWhereUniqueInput;
};

export type CampaignUpdateWithoutAssetsInput = {
  bookings?: InputMaybe<BookingUpdateManyWithoutCampaignNestedInput>;
  businessCategory?: InputMaybe<BusinessCategoryUpdateOneRequiredWithoutCampaignsNestedInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  name?: InputMaybe<Scalars['String']>;
  origin?: InputMaybe<Scalars['String']>;
  payment?: InputMaybe<BookingPaymentCreateInput>;
  paymentStatus?: InputMaybe<PaymentStatus>;
  selectedDates?: InputMaybe<OrderSelectedDateCreateInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  user?: InputMaybe<UserUpdateOneRequiredWithoutCampaignsNestedInput>;
};

export type CampaignUpdateWithoutBookingsInput = {
  assets?: InputMaybe<FileUpdateManyWithoutCampaignsNestedInput>;
  businessCategory?: InputMaybe<BusinessCategoryUpdateOneRequiredWithoutCampaignsNestedInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  name?: InputMaybe<Scalars['String']>;
  origin?: InputMaybe<Scalars['String']>;
  payment?: InputMaybe<BookingPaymentCreateInput>;
  paymentStatus?: InputMaybe<PaymentStatus>;
  selectedDates?: InputMaybe<OrderSelectedDateCreateInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  user?: InputMaybe<UserUpdateOneRequiredWithoutCampaignsNestedInput>;
};

export type CampaignUpdateWithoutBusinessCategoryInput = {
  assets?: InputMaybe<FileUpdateManyWithoutCampaignsNestedInput>;
  bookings?: InputMaybe<BookingUpdateManyWithoutCampaignNestedInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  name?: InputMaybe<Scalars['String']>;
  origin?: InputMaybe<Scalars['String']>;
  payment?: InputMaybe<BookingPaymentCreateInput>;
  paymentStatus?: InputMaybe<PaymentStatus>;
  selectedDates?: InputMaybe<OrderSelectedDateCreateInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  user?: InputMaybe<UserUpdateOneRequiredWithoutCampaignsNestedInput>;
};

export type CampaignUpdateWithoutUserInput = {
  assets?: InputMaybe<FileUpdateManyWithoutCampaignsNestedInput>;
  bookings?: InputMaybe<BookingUpdateManyWithoutCampaignNestedInput>;
  businessCategory?: InputMaybe<BusinessCategoryUpdateOneRequiredWithoutCampaignsNestedInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  name?: InputMaybe<Scalars['String']>;
  origin?: InputMaybe<Scalars['String']>;
  payment?: InputMaybe<BookingPaymentCreateInput>;
  paymentStatus?: InputMaybe<PaymentStatus>;
  selectedDates?: InputMaybe<OrderSelectedDateCreateInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type CampaignUpsertWithWhereUniqueWithoutAssetsInput = {
  create: CampaignCreateWithoutAssetsInput;
  update: CampaignUpdateWithoutAssetsInput;
  where: CampaignWhereUniqueInput;
};

export type CampaignUpsertWithWhereUniqueWithoutBusinessCategoryInput = {
  create: CampaignCreateWithoutBusinessCategoryInput;
  update: CampaignUpdateWithoutBusinessCategoryInput;
  where: CampaignWhereUniqueInput;
};

export type CampaignUpsertWithWhereUniqueWithoutUserInput = {
  create: CampaignCreateWithoutUserInput;
  update: CampaignUpdateWithoutUserInput;
  where: CampaignWhereUniqueInput;
};

export type CampaignUpsertWithoutBookingsInput = {
  create: CampaignCreateWithoutBookingsInput;
  update: CampaignUpdateWithoutBookingsInput;
  where?: InputMaybe<CampaignWhereInput>;
};

export type CampaignWhereInput = {
  AND?: InputMaybe<Array<CampaignWhereInput>>;
  NOT?: InputMaybe<Array<CampaignWhereInput>>;
  OR?: InputMaybe<Array<CampaignWhereInput>>;
  assets?: InputMaybe<FileListRelationFilter>;
  assetsIDs?: InputMaybe<StringNullableListFilter>;
  bookings?: InputMaybe<BookingListRelationFilter>;
  businessCategory?: InputMaybe<BusinessCategoryRelationFilter>;
  businessCategoryId?: InputMaybe<StringFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  id?: InputMaybe<StringFilter>;
  name?: InputMaybe<StringFilter>;
  origin?: InputMaybe<StringFilter>;
  payment?: InputMaybe<BookingPaymentNullableCompositeFilter>;
  paymentStatus?: InputMaybe<EnumPaymentStatusFilter>;
  selectedDates?: InputMaybe<OrderSelectedDateCompositeFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
  user?: InputMaybe<UserRelationFilter>;
  userId?: InputMaybe<StringFilter>;
};

export type CampaignWhereUniqueInput = {
  AND?: InputMaybe<Array<CampaignWhereInput>>;
  NOT?: InputMaybe<Array<CampaignWhereInput>>;
  OR?: InputMaybe<Array<CampaignWhereInput>>;
  assets?: InputMaybe<FileListRelationFilter>;
  assetsIDs?: InputMaybe<StringNullableListFilter>;
  bookings?: InputMaybe<BookingListRelationFilter>;
  businessCategory?: InputMaybe<BusinessCategoryRelationFilter>;
  businessCategoryId?: InputMaybe<StringFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  id?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<StringFilter>;
  origin?: InputMaybe<StringFilter>;
  payment?: InputMaybe<BookingPaymentNullableCompositeFilter>;
  paymentStatus?: InputMaybe<EnumPaymentStatusFilter>;
  selectedDates?: InputMaybe<OrderSelectedDateCompositeFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
  user?: InputMaybe<UserRelationFilter>;
  userId?: InputMaybe<StringFilter>;
};

export type Changelog = {
  __typename?: 'Changelog';
  action: Scalars['String'];
  booking?: Maybe<Booking>;
  bookingId?: Maybe<Scalars['String']>;
  createdAt: Scalars['DateTime'];
  id: Scalars['String'];
  message: Scalars['String'];
  updates?: Maybe<Scalars['JSON']>;
  user: User;
  userId: Scalars['String'];
};


export type ChangelogBookingArgs = {
  where?: InputMaybe<BookingWhereInput>;
};

export type ChangelogCountAggregate = {
  __typename?: 'ChangelogCountAggregate';
  _all: Scalars['Int'];
  action: Scalars['Int'];
  bookingId: Scalars['Int'];
  createdAt: Scalars['Int'];
  id: Scalars['Int'];
  message: Scalars['Int'];
  updates: Scalars['Int'];
  userId: Scalars['Int'];
};

export type ChangelogCountOrderByAggregateInput = {
  action?: InputMaybe<SortOrder>;
  bookingId?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  message?: InputMaybe<SortOrder>;
  updates?: InputMaybe<SortOrder>;
  userId?: InputMaybe<SortOrder>;
};

export type ChangelogCreateInput = {
  action: Scalars['String'];
  booking?: InputMaybe<BookingCreateNestedOneWithoutChangelogsInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['String']>;
  message: Scalars['String'];
  updates?: InputMaybe<Scalars['JSON']>;
  user: UserCreateNestedOneWithoutChangelogsInput;
};

export type ChangelogCreateManyBookingInput = {
  action: Scalars['String'];
  createdAt?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['String']>;
  message: Scalars['String'];
  updates?: InputMaybe<Scalars['JSON']>;
  userId: Scalars['String'];
};

export type ChangelogCreateManyBookingInputEnvelope = {
  data: Array<ChangelogCreateManyBookingInput>;
};

export type ChangelogCreateManyInput = {
  action: Scalars['String'];
  bookingId?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['String']>;
  message: Scalars['String'];
  updates?: InputMaybe<Scalars['JSON']>;
  userId: Scalars['String'];
};

export type ChangelogCreateManyUserInput = {
  action: Scalars['String'];
  bookingId?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['String']>;
  message: Scalars['String'];
  updates?: InputMaybe<Scalars['JSON']>;
};

export type ChangelogCreateManyUserInputEnvelope = {
  data: Array<ChangelogCreateManyUserInput>;
};

export type ChangelogCreateNestedManyWithoutBookingInput = {
  connect?: InputMaybe<Array<ChangelogWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<ChangelogCreateOrConnectWithoutBookingInput>>;
  create?: InputMaybe<Array<ChangelogCreateWithoutBookingInput>>;
  createMany?: InputMaybe<ChangelogCreateManyBookingInputEnvelope>;
};

export type ChangelogCreateNestedManyWithoutUserInput = {
  connect?: InputMaybe<Array<ChangelogWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<ChangelogCreateOrConnectWithoutUserInput>>;
  create?: InputMaybe<Array<ChangelogCreateWithoutUserInput>>;
  createMany?: InputMaybe<ChangelogCreateManyUserInputEnvelope>;
};

export type ChangelogCreateOrConnectWithoutBookingInput = {
  create: ChangelogCreateWithoutBookingInput;
  where: ChangelogWhereUniqueInput;
};

export type ChangelogCreateOrConnectWithoutUserInput = {
  create: ChangelogCreateWithoutUserInput;
  where: ChangelogWhereUniqueInput;
};

export type ChangelogCreateWithoutBookingInput = {
  action: Scalars['String'];
  createdAt?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['String']>;
  message: Scalars['String'];
  updates?: InputMaybe<Scalars['JSON']>;
  user: UserCreateNestedOneWithoutChangelogsInput;
};

export type ChangelogCreateWithoutUserInput = {
  action: Scalars['String'];
  booking?: InputMaybe<BookingCreateNestedOneWithoutChangelogsInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['String']>;
  message: Scalars['String'];
  updates?: InputMaybe<Scalars['JSON']>;
};

export type ChangelogGroupBy = {
  __typename?: 'ChangelogGroupBy';
  _count?: Maybe<ChangelogCountAggregate>;
  _max?: Maybe<ChangelogMaxAggregate>;
  _min?: Maybe<ChangelogMinAggregate>;
  action: Scalars['String'];
  bookingId?: Maybe<Scalars['String']>;
  createdAt: Scalars['DateTime'];
  id: Scalars['String'];
  message: Scalars['String'];
  updates?: Maybe<Scalars['JSON']>;
  userId: Scalars['String'];
};

export type ChangelogListRelationFilter = {
  every?: InputMaybe<ChangelogWhereInput>;
  none?: InputMaybe<ChangelogWhereInput>;
  some?: InputMaybe<ChangelogWhereInput>;
};

export type ChangelogMaxAggregate = {
  __typename?: 'ChangelogMaxAggregate';
  action?: Maybe<Scalars['String']>;
  bookingId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  message?: Maybe<Scalars['String']>;
  userId?: Maybe<Scalars['String']>;
};

export type ChangelogMaxOrderByAggregateInput = {
  action?: InputMaybe<SortOrder>;
  bookingId?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  message?: InputMaybe<SortOrder>;
  userId?: InputMaybe<SortOrder>;
};

export type ChangelogMinAggregate = {
  __typename?: 'ChangelogMinAggregate';
  action?: Maybe<Scalars['String']>;
  bookingId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  message?: Maybe<Scalars['String']>;
  userId?: Maybe<Scalars['String']>;
};

export type ChangelogMinOrderByAggregateInput = {
  action?: InputMaybe<SortOrder>;
  bookingId?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  message?: InputMaybe<SortOrder>;
  userId?: InputMaybe<SortOrder>;
};

export type ChangelogOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type ChangelogOrderByWithAggregationInput = {
  _count?: InputMaybe<ChangelogCountOrderByAggregateInput>;
  _max?: InputMaybe<ChangelogMaxOrderByAggregateInput>;
  _min?: InputMaybe<ChangelogMinOrderByAggregateInput>;
  action?: InputMaybe<SortOrder>;
  bookingId?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  message?: InputMaybe<SortOrder>;
  updates?: InputMaybe<SortOrder>;
  userId?: InputMaybe<SortOrder>;
};

export type ChangelogOrderByWithRelationInput = {
  action?: InputMaybe<SortOrder>;
  booking?: InputMaybe<BookingOrderByWithRelationInput>;
  bookingId?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  message?: InputMaybe<SortOrder>;
  updates?: InputMaybe<SortOrder>;
  user?: InputMaybe<UserOrderByWithRelationInput>;
  userId?: InputMaybe<SortOrder>;
};

export enum ChangelogScalarFieldEnum {
  Action = 'action',
  BookingId = 'bookingId',
  CreatedAt = 'createdAt',
  Id = 'id',
  Message = 'message',
  Updates = 'updates',
  UserId = 'userId'
}

export type ChangelogScalarWhereInput = {
  AND?: InputMaybe<Array<ChangelogScalarWhereInput>>;
  NOT?: InputMaybe<Array<ChangelogScalarWhereInput>>;
  OR?: InputMaybe<Array<ChangelogScalarWhereInput>>;
  action?: InputMaybe<StringFilter>;
  bookingId?: InputMaybe<StringNullableFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  id?: InputMaybe<StringFilter>;
  message?: InputMaybe<StringFilter>;
  updates?: InputMaybe<JsonNullableFilter>;
  userId?: InputMaybe<StringFilter>;
};

export type ChangelogScalarWhereWithAggregatesInput = {
  AND?: InputMaybe<Array<ChangelogScalarWhereWithAggregatesInput>>;
  NOT?: InputMaybe<Array<ChangelogScalarWhereWithAggregatesInput>>;
  OR?: InputMaybe<Array<ChangelogScalarWhereWithAggregatesInput>>;
  action?: InputMaybe<StringWithAggregatesFilter>;
  bookingId?: InputMaybe<StringNullableWithAggregatesFilter>;
  createdAt?: InputMaybe<DateTimeWithAggregatesFilter>;
  id?: InputMaybe<StringWithAggregatesFilter>;
  message?: InputMaybe<StringWithAggregatesFilter>;
  updates?: InputMaybe<JsonNullableWithAggregatesFilter>;
  userId?: InputMaybe<StringWithAggregatesFilter>;
};

export type ChangelogUpdateInput = {
  action?: InputMaybe<Scalars['String']>;
  booking?: InputMaybe<BookingUpdateOneWithoutChangelogsNestedInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  message?: InputMaybe<Scalars['String']>;
  updates?: InputMaybe<Scalars['JSON']>;
  user?: InputMaybe<UserUpdateOneRequiredWithoutChangelogsNestedInput>;
};

export type ChangelogUpdateManyMutationInput = {
  action?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  message?: InputMaybe<Scalars['String']>;
  updates?: InputMaybe<Scalars['JSON']>;
};

export type ChangelogUpdateManyWithWhereWithoutBookingInput = {
  data: ChangelogUpdateManyMutationInput;
  where: ChangelogScalarWhereInput;
};

export type ChangelogUpdateManyWithWhereWithoutUserInput = {
  data: ChangelogUpdateManyMutationInput;
  where: ChangelogScalarWhereInput;
};

export type ChangelogUpdateManyWithoutBookingNestedInput = {
  connect?: InputMaybe<Array<ChangelogWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<ChangelogCreateOrConnectWithoutBookingInput>>;
  create?: InputMaybe<Array<ChangelogCreateWithoutBookingInput>>;
  createMany?: InputMaybe<ChangelogCreateManyBookingInputEnvelope>;
  delete?: InputMaybe<Array<ChangelogWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<ChangelogScalarWhereInput>>;
  disconnect?: InputMaybe<Array<ChangelogWhereUniqueInput>>;
  set?: InputMaybe<Array<ChangelogWhereUniqueInput>>;
  update?: InputMaybe<Array<ChangelogUpdateWithWhereUniqueWithoutBookingInput>>;
  updateMany?: InputMaybe<Array<ChangelogUpdateManyWithWhereWithoutBookingInput>>;
  upsert?: InputMaybe<Array<ChangelogUpsertWithWhereUniqueWithoutBookingInput>>;
};

export type ChangelogUpdateManyWithoutUserNestedInput = {
  connect?: InputMaybe<Array<ChangelogWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<ChangelogCreateOrConnectWithoutUserInput>>;
  create?: InputMaybe<Array<ChangelogCreateWithoutUserInput>>;
  createMany?: InputMaybe<ChangelogCreateManyUserInputEnvelope>;
  delete?: InputMaybe<Array<ChangelogWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<ChangelogScalarWhereInput>>;
  disconnect?: InputMaybe<Array<ChangelogWhereUniqueInput>>;
  set?: InputMaybe<Array<ChangelogWhereUniqueInput>>;
  update?: InputMaybe<Array<ChangelogUpdateWithWhereUniqueWithoutUserInput>>;
  updateMany?: InputMaybe<Array<ChangelogUpdateManyWithWhereWithoutUserInput>>;
  upsert?: InputMaybe<Array<ChangelogUpsertWithWhereUniqueWithoutUserInput>>;
};

export type ChangelogUpdateWithWhereUniqueWithoutBookingInput = {
  data: ChangelogUpdateWithoutBookingInput;
  where: ChangelogWhereUniqueInput;
};

export type ChangelogUpdateWithWhereUniqueWithoutUserInput = {
  data: ChangelogUpdateWithoutUserInput;
  where: ChangelogWhereUniqueInput;
};

export type ChangelogUpdateWithoutBookingInput = {
  action?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  message?: InputMaybe<Scalars['String']>;
  updates?: InputMaybe<Scalars['JSON']>;
  user?: InputMaybe<UserUpdateOneRequiredWithoutChangelogsNestedInput>;
};

export type ChangelogUpdateWithoutUserInput = {
  action?: InputMaybe<Scalars['String']>;
  booking?: InputMaybe<BookingUpdateOneWithoutChangelogsNestedInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  message?: InputMaybe<Scalars['String']>;
  updates?: InputMaybe<Scalars['JSON']>;
};

export type ChangelogUpsertWithWhereUniqueWithoutBookingInput = {
  create: ChangelogCreateWithoutBookingInput;
  update: ChangelogUpdateWithoutBookingInput;
  where: ChangelogWhereUniqueInput;
};

export type ChangelogUpsertWithWhereUniqueWithoutUserInput = {
  create: ChangelogCreateWithoutUserInput;
  update: ChangelogUpdateWithoutUserInput;
  where: ChangelogWhereUniqueInput;
};

export type ChangelogWhereInput = {
  AND?: InputMaybe<Array<ChangelogWhereInput>>;
  NOT?: InputMaybe<Array<ChangelogWhereInput>>;
  OR?: InputMaybe<Array<ChangelogWhereInput>>;
  action?: InputMaybe<StringFilter>;
  booking?: InputMaybe<BookingNullableRelationFilter>;
  bookingId?: InputMaybe<StringNullableFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  id?: InputMaybe<StringFilter>;
  message?: InputMaybe<StringFilter>;
  updates?: InputMaybe<JsonNullableFilter>;
  user?: InputMaybe<UserRelationFilter>;
  userId?: InputMaybe<StringFilter>;
};

export type ChangelogWhereUniqueInput = {
  AND?: InputMaybe<Array<ChangelogWhereInput>>;
  NOT?: InputMaybe<Array<ChangelogWhereInput>>;
  OR?: InputMaybe<Array<ChangelogWhereInput>>;
  action?: InputMaybe<StringFilter>;
  booking?: InputMaybe<BookingNullableRelationFilter>;
  bookingId?: InputMaybe<StringNullableFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  id?: InputMaybe<Scalars['String']>;
  message?: InputMaybe<StringFilter>;
  updates?: InputMaybe<JsonNullableFilter>;
  user?: InputMaybe<UserRelationFilter>;
  userId?: InputMaybe<StringFilter>;
};

export type DateTimeFilter = {
  equals?: InputMaybe<Scalars['DateTime']>;
  gt?: InputMaybe<Scalars['DateTime']>;
  gte?: InputMaybe<Scalars['DateTime']>;
  in?: InputMaybe<Array<Scalars['DateTime']>>;
  lt?: InputMaybe<Scalars['DateTime']>;
  lte?: InputMaybe<Scalars['DateTime']>;
  not?: InputMaybe<NestedDateTimeFilter>;
  notIn?: InputMaybe<Array<Scalars['DateTime']>>;
};

export type DateTimeNullableFilter = {
  equals?: InputMaybe<Scalars['DateTime']>;
  gt?: InputMaybe<Scalars['DateTime']>;
  gte?: InputMaybe<Scalars['DateTime']>;
  in?: InputMaybe<Array<Scalars['DateTime']>>;
  isSet?: InputMaybe<Scalars['Boolean']>;
  lt?: InputMaybe<Scalars['DateTime']>;
  lte?: InputMaybe<Scalars['DateTime']>;
  not?: InputMaybe<NestedDateTimeNullableFilter>;
  notIn?: InputMaybe<Array<Scalars['DateTime']>>;
};

export type DateTimeNullableWithAggregatesFilter = {
  _count?: InputMaybe<NestedIntNullableFilter>;
  _max?: InputMaybe<NestedDateTimeNullableFilter>;
  _min?: InputMaybe<NestedDateTimeNullableFilter>;
  equals?: InputMaybe<Scalars['DateTime']>;
  gt?: InputMaybe<Scalars['DateTime']>;
  gte?: InputMaybe<Scalars['DateTime']>;
  in?: InputMaybe<Array<Scalars['DateTime']>>;
  isSet?: InputMaybe<Scalars['Boolean']>;
  lt?: InputMaybe<Scalars['DateTime']>;
  lte?: InputMaybe<Scalars['DateTime']>;
  not?: InputMaybe<NestedDateTimeNullableWithAggregatesFilter>;
  notIn?: InputMaybe<Array<Scalars['DateTime']>>;
};

export type DateTimeWithAggregatesFilter = {
  _count?: InputMaybe<NestedIntFilter>;
  _max?: InputMaybe<NestedDateTimeFilter>;
  _min?: InputMaybe<NestedDateTimeFilter>;
  equals?: InputMaybe<Scalars['DateTime']>;
  gt?: InputMaybe<Scalars['DateTime']>;
  gte?: InputMaybe<Scalars['DateTime']>;
  in?: InputMaybe<Array<Scalars['DateTime']>>;
  lt?: InputMaybe<Scalars['DateTime']>;
  lte?: InputMaybe<Scalars['DateTime']>;
  not?: InputMaybe<NestedDateTimeWithAggregatesFilter>;
  notIn?: InputMaybe<Array<Scalars['DateTime']>>;
};

export type EmailOutput = {
  __typename?: 'EmailOutput';
  success: Scalars['Boolean'];
};

export type Entity = {
  __typename?: 'Entity';
  id: Scalars['String'];
  name?: Maybe<Scalars['String']>;
  type: Scalars['String'];
};

export type EntityCreateInput = {
  id: Scalars['String'];
  name?: InputMaybe<Scalars['String']>;
  type: Scalars['String'];
};

export type EntityNullableCompositeFilter = {
  equals?: InputMaybe<EntityObjectEqualityInput>;
  is?: InputMaybe<EntityWhereInput>;
  isNot?: InputMaybe<EntityWhereInput>;
  isSet?: InputMaybe<Scalars['Boolean']>;
};

export type EntityObjectEqualityInput = {
  id: Scalars['String'];
  name?: InputMaybe<Scalars['String']>;
  type: Scalars['String'];
};

export type EntityOrderByInput = {
  id?: InputMaybe<SortOrder>;
  name?: InputMaybe<SortOrder>;
  type?: InputMaybe<SortOrder>;
};

export type EntityWhereInput = {
  AND?: InputMaybe<Array<EntityWhereInput>>;
  NOT?: InputMaybe<Array<EntityWhereInput>>;
  OR?: InputMaybe<Array<EntityWhereInput>>;
  id?: InputMaybe<StringFilter>;
  name?: InputMaybe<StringNullableFilter>;
  type?: InputMaybe<StringFilter>;
};

export type EnumAdBoardStatusFilter = {
  equals?: InputMaybe<AdBoardStatus>;
  in?: InputMaybe<Array<AdBoardStatus>>;
  not?: InputMaybe<NestedEnumAdBoardStatusFilter>;
  notIn?: InputMaybe<Array<AdBoardStatus>>;
};

export type EnumAdBoardStatusWithAggregatesFilter = {
  _count?: InputMaybe<NestedIntFilter>;
  _max?: InputMaybe<NestedEnumAdBoardStatusFilter>;
  _min?: InputMaybe<NestedEnumAdBoardStatusFilter>;
  equals?: InputMaybe<AdBoardStatus>;
  in?: InputMaybe<Array<AdBoardStatus>>;
  not?: InputMaybe<NestedEnumAdBoardStatusWithAggregatesFilter>;
  notIn?: InputMaybe<Array<AdBoardStatus>>;
};

export type EnumBookingStatusFilter = {
  equals?: InputMaybe<BookingStatus>;
  in?: InputMaybe<Array<BookingStatus>>;
  not?: InputMaybe<NestedEnumBookingStatusFilter>;
  notIn?: InputMaybe<Array<BookingStatus>>;
};

export type EnumBookingStatusWithAggregatesFilter = {
  _count?: InputMaybe<NestedIntFilter>;
  _max?: InputMaybe<NestedEnumBookingStatusFilter>;
  _min?: InputMaybe<NestedEnumBookingStatusFilter>;
  equals?: InputMaybe<BookingStatus>;
  in?: InputMaybe<Array<BookingStatus>>;
  not?: InputMaybe<NestedEnumBookingStatusWithAggregatesFilter>;
  notIn?: InputMaybe<Array<BookingStatus>>;
};

export type EnumFileStatusNullableFilter = {
  equals?: InputMaybe<FileStatus>;
  in?: InputMaybe<Array<FileStatus>>;
  isSet?: InputMaybe<Scalars['Boolean']>;
  not?: InputMaybe<NestedEnumFileStatusNullableFilter>;
  notIn?: InputMaybe<Array<FileStatus>>;
};

export type EnumFileStatusNullableWithAggregatesFilter = {
  _count?: InputMaybe<NestedIntNullableFilter>;
  _max?: InputMaybe<NestedEnumFileStatusNullableFilter>;
  _min?: InputMaybe<NestedEnumFileStatusNullableFilter>;
  equals?: InputMaybe<FileStatus>;
  in?: InputMaybe<Array<FileStatus>>;
  isSet?: InputMaybe<Scalars['Boolean']>;
  not?: InputMaybe<NestedEnumFileStatusNullableWithAggregatesFilter>;
  notIn?: InputMaybe<Array<FileStatus>>;
};

export type EnumMeasurementUnitFilter = {
  equals?: InputMaybe<MeasurementUnit>;
  in?: InputMaybe<Array<MeasurementUnit>>;
  not?: InputMaybe<NestedEnumMeasurementUnitFilter>;
  notIn?: InputMaybe<Array<MeasurementUnit>>;
};

export type EnumPaymentGatewayNameFilter = {
  equals?: InputMaybe<PaymentGatewayName>;
  in?: InputMaybe<Array<PaymentGatewayName>>;
  not?: InputMaybe<NestedEnumPaymentGatewayNameFilter>;
  notIn?: InputMaybe<Array<PaymentGatewayName>>;
};

export type EnumPaymentStatusFilter = {
  equals?: InputMaybe<PaymentStatus>;
  in?: InputMaybe<Array<PaymentStatus>>;
  not?: InputMaybe<NestedEnumPaymentStatusFilter>;
  notIn?: InputMaybe<Array<PaymentStatus>>;
};

export type EnumPaymentStatusWithAggregatesFilter = {
  _count?: InputMaybe<NestedIntFilter>;
  _max?: InputMaybe<NestedEnumPaymentStatusFilter>;
  _min?: InputMaybe<NestedEnumPaymentStatusFilter>;
  equals?: InputMaybe<PaymentStatus>;
  in?: InputMaybe<Array<PaymentStatus>>;
  not?: InputMaybe<NestedEnumPaymentStatusWithAggregatesFilter>;
  notIn?: InputMaybe<Array<PaymentStatus>>;
};

export type EnumPayoutStatusFilter = {
  equals?: InputMaybe<PayoutStatus>;
  in?: InputMaybe<Array<PayoutStatus>>;
  not?: InputMaybe<NestedEnumPayoutStatusFilter>;
  notIn?: InputMaybe<Array<PayoutStatus>>;
};

export type EnumPayoutStatusWithAggregatesFilter = {
  _count?: InputMaybe<NestedIntFilter>;
  _max?: InputMaybe<NestedEnumPayoutStatusFilter>;
  _min?: InputMaybe<NestedEnumPayoutStatusFilter>;
  equals?: InputMaybe<PayoutStatus>;
  in?: InputMaybe<Array<PayoutStatus>>;
  not?: InputMaybe<NestedEnumPayoutStatusWithAggregatesFilter>;
  notIn?: InputMaybe<Array<PayoutStatus>>;
};

export type EnumPermissionNullableListFilter = {
  equals?: InputMaybe<Array<Permission>>;
  has?: InputMaybe<Permission>;
  hasEvery?: InputMaybe<Array<Permission>>;
  hasSome?: InputMaybe<Array<Permission>>;
  isEmpty?: InputMaybe<Scalars['Boolean']>;
};

export type EnumTransactionStatusFilter = {
  equals?: InputMaybe<TransactionStatus>;
  in?: InputMaybe<Array<TransactionStatus>>;
  not?: InputMaybe<NestedEnumTransactionStatusFilter>;
  notIn?: InputMaybe<Array<TransactionStatus>>;
};

export type EnumTransactionStatusWithAggregatesFilter = {
  _count?: InputMaybe<NestedIntFilter>;
  _max?: InputMaybe<NestedEnumTransactionStatusFilter>;
  _min?: InputMaybe<NestedEnumTransactionStatusFilter>;
  equals?: InputMaybe<TransactionStatus>;
  in?: InputMaybe<Array<TransactionStatus>>;
  not?: InputMaybe<NestedEnumTransactionStatusWithAggregatesFilter>;
  notIn?: InputMaybe<Array<TransactionStatus>>;
};

export type File = {
  __typename?: 'File';
  _count?: Maybe<FileCount>;
  bookings: Array<Booking>;
  bookingsIDs: Array<Scalars['String']>;
  campaignIds: Array<Scalars['String']>;
  campaigns: Array<Campaign>;
  contentType: Scalars['String'];
  createdAt: Scalars['DateTime'];
  createdBy: User;
  createdByUserId: Scalars['String'];
  ctime: Scalars['String'];
  filename: Scalars['String'];
  filepath?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  isDirectory: Scalars['Boolean'];
  meta: FileMeta;
  mtime: Scalars['String'];
  name: Scalars['String'];
  proofBooking?: Maybe<Booking>;
  proofBookingId?: Maybe<Scalars['String']>;
  size: Scalars['Int'];
  status?: Maybe<FileStatus>;
  type: Scalars['String'];
  updatedAt: Scalars['DateTime'];
  updatedBy?: Maybe<User>;
  updatedByUserId?: Maybe<Scalars['String']>;
  url: Scalars['String'];
  workspace?: Maybe<Workspace>;
  workspaceId?: Maybe<Scalars['String']>;
};


export type FileBookingsArgs = {
  cursor?: InputMaybe<BookingWhereUniqueInput>;
  distinct?: InputMaybe<Array<BookingScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<BookingOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<BookingWhereInput>;
};


export type FileCampaignsArgs = {
  cursor?: InputMaybe<CampaignWhereUniqueInput>;
  distinct?: InputMaybe<Array<CampaignScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<CampaignOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<CampaignWhereInput>;
};


export type FileProofBookingArgs = {
  where?: InputMaybe<BookingWhereInput>;
};


export type FileUpdatedByArgs = {
  where?: InputMaybe<UserWhereInput>;
};


export type FileWorkspaceArgs = {
  where?: InputMaybe<WorkspaceWhereInput>;
};

export type FileAvgAggregate = {
  __typename?: 'FileAvgAggregate';
  size?: Maybe<Scalars['Float']>;
};

export type FileAvgOrderByAggregateInput = {
  size?: InputMaybe<SortOrder>;
};

export type FileCount = {
  __typename?: 'FileCount';
  bookings: Scalars['Int'];
  campaigns: Scalars['Int'];
};


export type FileCountBookingsArgs = {
  where?: InputMaybe<BookingWhereInput>;
};


export type FileCountCampaignsArgs = {
  where?: InputMaybe<CampaignWhereInput>;
};

export type FileCountAggregate = {
  __typename?: 'FileCountAggregate';
  _all: Scalars['Int'];
  bookingsIDs: Scalars['Int'];
  campaignIds: Scalars['Int'];
  contentType: Scalars['Int'];
  createdAt: Scalars['Int'];
  createdByUserId: Scalars['Int'];
  ctime: Scalars['Int'];
  filename: Scalars['Int'];
  filepath: Scalars['Int'];
  id: Scalars['Int'];
  isDirectory: Scalars['Int'];
  mtime: Scalars['Int'];
  name: Scalars['Int'];
  proofBookingId: Scalars['Int'];
  size: Scalars['Int'];
  status: Scalars['Int'];
  type: Scalars['Int'];
  updatedAt: Scalars['Int'];
  updatedByUserId: Scalars['Int'];
  url: Scalars['Int'];
  workspaceId: Scalars['Int'];
};

export type FileCountOrderByAggregateInput = {
  bookingsIDs?: InputMaybe<SortOrder>;
  campaignIds?: InputMaybe<SortOrder>;
  contentType?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  createdByUserId?: InputMaybe<SortOrder>;
  ctime?: InputMaybe<SortOrder>;
  filename?: InputMaybe<SortOrder>;
  filepath?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  isDirectory?: InputMaybe<SortOrder>;
  mtime?: InputMaybe<SortOrder>;
  name?: InputMaybe<SortOrder>;
  proofBookingId?: InputMaybe<SortOrder>;
  size?: InputMaybe<SortOrder>;
  status?: InputMaybe<SortOrder>;
  type?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
  updatedByUserId?: InputMaybe<SortOrder>;
  url?: InputMaybe<SortOrder>;
  workspaceId?: InputMaybe<SortOrder>;
};

export type FileCreateInput = {
  bookings?: InputMaybe<BookingCreateNestedManyWithoutAssetsInput>;
  campaigns?: InputMaybe<CampaignCreateNestedManyWithoutAssetsInput>;
  contentType: Scalars['String'];
  createdAt?: InputMaybe<Scalars['DateTime']>;
  createdBy: UserCreateNestedOneWithoutCreatedFilesInput;
  ctime: Scalars['String'];
  filename: Scalars['String'];
  filepath?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  isDirectory: Scalars['Boolean'];
  meta: FileMetaCreateInput;
  mtime: Scalars['String'];
  name: Scalars['String'];
  proofBooking?: InputMaybe<BookingCreateNestedOneWithoutProofsInput>;
  size: Scalars['Int'];
  status?: InputMaybe<FileStatus>;
  type: Scalars['String'];
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  updatedBy?: InputMaybe<UserCreateNestedOneWithoutUpdatedFilesInput>;
  url: Scalars['String'];
  workspace?: InputMaybe<WorkspaceCreateNestedOneWithoutFilesInput>;
};

export type FileCreateManyCreatedByInput = {
  bookingsIDs?: InputMaybe<Array<Scalars['String']>>;
  campaignIds?: InputMaybe<Array<Scalars['String']>>;
  contentType: Scalars['String'];
  createdAt?: InputMaybe<Scalars['DateTime']>;
  ctime: Scalars['String'];
  filename: Scalars['String'];
  filepath?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  isDirectory: Scalars['Boolean'];
  meta: FileMetaCreateInput;
  mtime: Scalars['String'];
  name: Scalars['String'];
  proofBookingId?: InputMaybe<Scalars['String']>;
  size: Scalars['Int'];
  status?: InputMaybe<FileStatus>;
  type: Scalars['String'];
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  updatedByUserId?: InputMaybe<Scalars['String']>;
  url: Scalars['String'];
  workspaceId?: InputMaybe<Scalars['String']>;
};

export type FileCreateManyCreatedByInputEnvelope = {
  data: Array<FileCreateManyCreatedByInput>;
};

export type FileCreateManyInput = {
  bookingsIDs?: InputMaybe<Array<Scalars['String']>>;
  campaignIds?: InputMaybe<Array<Scalars['String']>>;
  contentType: Scalars['String'];
  createdAt?: InputMaybe<Scalars['DateTime']>;
  createdByUserId: Scalars['String'];
  ctime: Scalars['String'];
  filename: Scalars['String'];
  filepath?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  isDirectory: Scalars['Boolean'];
  meta: FileMetaCreateInput;
  mtime: Scalars['String'];
  name: Scalars['String'];
  proofBookingId?: InputMaybe<Scalars['String']>;
  size: Scalars['Int'];
  status?: InputMaybe<FileStatus>;
  type: Scalars['String'];
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  updatedByUserId?: InputMaybe<Scalars['String']>;
  url: Scalars['String'];
  workspaceId?: InputMaybe<Scalars['String']>;
};

export type FileCreateManyProofBookingInput = {
  bookingsIDs?: InputMaybe<Array<Scalars['String']>>;
  campaignIds?: InputMaybe<Array<Scalars['String']>>;
  contentType: Scalars['String'];
  createdAt?: InputMaybe<Scalars['DateTime']>;
  createdByUserId: Scalars['String'];
  ctime: Scalars['String'];
  filename: Scalars['String'];
  filepath?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  isDirectory: Scalars['Boolean'];
  meta: FileMetaCreateInput;
  mtime: Scalars['String'];
  name: Scalars['String'];
  size: Scalars['Int'];
  status?: InputMaybe<FileStatus>;
  type: Scalars['String'];
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  updatedByUserId?: InputMaybe<Scalars['String']>;
  url: Scalars['String'];
  workspaceId?: InputMaybe<Scalars['String']>;
};

export type FileCreateManyProofBookingInputEnvelope = {
  data: Array<FileCreateManyProofBookingInput>;
};

export type FileCreateManyUpdatedByInput = {
  bookingsIDs?: InputMaybe<Array<Scalars['String']>>;
  campaignIds?: InputMaybe<Array<Scalars['String']>>;
  contentType: Scalars['String'];
  createdAt?: InputMaybe<Scalars['DateTime']>;
  createdByUserId: Scalars['String'];
  ctime: Scalars['String'];
  filename: Scalars['String'];
  filepath?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  isDirectory: Scalars['Boolean'];
  meta: FileMetaCreateInput;
  mtime: Scalars['String'];
  name: Scalars['String'];
  proofBookingId?: InputMaybe<Scalars['String']>;
  size: Scalars['Int'];
  status?: InputMaybe<FileStatus>;
  type: Scalars['String'];
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  url: Scalars['String'];
  workspaceId?: InputMaybe<Scalars['String']>;
};

export type FileCreateManyUpdatedByInputEnvelope = {
  data: Array<FileCreateManyUpdatedByInput>;
};

export type FileCreateManyWorkspaceInput = {
  bookingsIDs?: InputMaybe<Array<Scalars['String']>>;
  campaignIds?: InputMaybe<Array<Scalars['String']>>;
  contentType: Scalars['String'];
  createdAt?: InputMaybe<Scalars['DateTime']>;
  createdByUserId: Scalars['String'];
  ctime: Scalars['String'];
  filename: Scalars['String'];
  filepath?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  isDirectory: Scalars['Boolean'];
  meta: FileMetaCreateInput;
  mtime: Scalars['String'];
  name: Scalars['String'];
  proofBookingId?: InputMaybe<Scalars['String']>;
  size: Scalars['Int'];
  status?: InputMaybe<FileStatus>;
  type: Scalars['String'];
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  updatedByUserId?: InputMaybe<Scalars['String']>;
  url: Scalars['String'];
};

export type FileCreateManyWorkspaceInputEnvelope = {
  data: Array<FileCreateManyWorkspaceInput>;
};

export type FileCreateNestedManyWithoutBookingsInput = {
  connect?: InputMaybe<Array<FileWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<FileCreateOrConnectWithoutBookingsInput>>;
  create?: InputMaybe<Array<FileCreateWithoutBookingsInput>>;
};

export type FileCreateNestedManyWithoutCampaignsInput = {
  connect?: InputMaybe<Array<FileWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<FileCreateOrConnectWithoutCampaignsInput>>;
  create?: InputMaybe<Array<FileCreateWithoutCampaignsInput>>;
};

export type FileCreateNestedManyWithoutCreatedByInput = {
  connect?: InputMaybe<Array<FileWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<FileCreateOrConnectWithoutCreatedByInput>>;
  create?: InputMaybe<Array<FileCreateWithoutCreatedByInput>>;
  createMany?: InputMaybe<FileCreateManyCreatedByInputEnvelope>;
};

export type FileCreateNestedManyWithoutProofBookingInput = {
  connect?: InputMaybe<Array<FileWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<FileCreateOrConnectWithoutProofBookingInput>>;
  create?: InputMaybe<Array<FileCreateWithoutProofBookingInput>>;
  createMany?: InputMaybe<FileCreateManyProofBookingInputEnvelope>;
};

export type FileCreateNestedManyWithoutUpdatedByInput = {
  connect?: InputMaybe<Array<FileWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<FileCreateOrConnectWithoutUpdatedByInput>>;
  create?: InputMaybe<Array<FileCreateWithoutUpdatedByInput>>;
  createMany?: InputMaybe<FileCreateManyUpdatedByInputEnvelope>;
};

export type FileCreateNestedManyWithoutWorkspaceInput = {
  connect?: InputMaybe<Array<FileWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<FileCreateOrConnectWithoutWorkspaceInput>>;
  create?: InputMaybe<Array<FileCreateWithoutWorkspaceInput>>;
  createMany?: InputMaybe<FileCreateManyWorkspaceInputEnvelope>;
};

export type FileCreateOrConnectWithoutBookingsInput = {
  create: FileCreateWithoutBookingsInput;
  where: FileWhereUniqueInput;
};

export type FileCreateOrConnectWithoutCampaignsInput = {
  create: FileCreateWithoutCampaignsInput;
  where: FileWhereUniqueInput;
};

export type FileCreateOrConnectWithoutCreatedByInput = {
  create: FileCreateWithoutCreatedByInput;
  where: FileWhereUniqueInput;
};

export type FileCreateOrConnectWithoutProofBookingInput = {
  create: FileCreateWithoutProofBookingInput;
  where: FileWhereUniqueInput;
};

export type FileCreateOrConnectWithoutUpdatedByInput = {
  create: FileCreateWithoutUpdatedByInput;
  where: FileWhereUniqueInput;
};

export type FileCreateOrConnectWithoutWorkspaceInput = {
  create: FileCreateWithoutWorkspaceInput;
  where: FileWhereUniqueInput;
};

export type FileCreateWithoutBookingsInput = {
  campaigns?: InputMaybe<CampaignCreateNestedManyWithoutAssetsInput>;
  contentType: Scalars['String'];
  createdAt?: InputMaybe<Scalars['DateTime']>;
  createdBy: UserCreateNestedOneWithoutCreatedFilesInput;
  ctime: Scalars['String'];
  filename: Scalars['String'];
  filepath?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  isDirectory: Scalars['Boolean'];
  meta: FileMetaCreateInput;
  mtime: Scalars['String'];
  name: Scalars['String'];
  proofBooking?: InputMaybe<BookingCreateNestedOneWithoutProofsInput>;
  size: Scalars['Int'];
  status?: InputMaybe<FileStatus>;
  type: Scalars['String'];
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  updatedBy?: InputMaybe<UserCreateNestedOneWithoutUpdatedFilesInput>;
  url: Scalars['String'];
  workspace?: InputMaybe<WorkspaceCreateNestedOneWithoutFilesInput>;
};

export type FileCreateWithoutCampaignsInput = {
  bookings?: InputMaybe<BookingCreateNestedManyWithoutAssetsInput>;
  contentType: Scalars['String'];
  createdAt?: InputMaybe<Scalars['DateTime']>;
  createdBy: UserCreateNestedOneWithoutCreatedFilesInput;
  ctime: Scalars['String'];
  filename: Scalars['String'];
  filepath?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  isDirectory: Scalars['Boolean'];
  meta: FileMetaCreateInput;
  mtime: Scalars['String'];
  name: Scalars['String'];
  proofBooking?: InputMaybe<BookingCreateNestedOneWithoutProofsInput>;
  size: Scalars['Int'];
  status?: InputMaybe<FileStatus>;
  type: Scalars['String'];
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  updatedBy?: InputMaybe<UserCreateNestedOneWithoutUpdatedFilesInput>;
  url: Scalars['String'];
  workspace?: InputMaybe<WorkspaceCreateNestedOneWithoutFilesInput>;
};

export type FileCreateWithoutCreatedByInput = {
  bookings?: InputMaybe<BookingCreateNestedManyWithoutAssetsInput>;
  campaigns?: InputMaybe<CampaignCreateNestedManyWithoutAssetsInput>;
  contentType: Scalars['String'];
  createdAt?: InputMaybe<Scalars['DateTime']>;
  ctime: Scalars['String'];
  filename: Scalars['String'];
  filepath?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  isDirectory: Scalars['Boolean'];
  meta: FileMetaCreateInput;
  mtime: Scalars['String'];
  name: Scalars['String'];
  proofBooking?: InputMaybe<BookingCreateNestedOneWithoutProofsInput>;
  size: Scalars['Int'];
  status?: InputMaybe<FileStatus>;
  type: Scalars['String'];
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  updatedBy?: InputMaybe<UserCreateNestedOneWithoutUpdatedFilesInput>;
  url: Scalars['String'];
  workspace?: InputMaybe<WorkspaceCreateNestedOneWithoutFilesInput>;
};

export type FileCreateWithoutProofBookingInput = {
  bookings?: InputMaybe<BookingCreateNestedManyWithoutAssetsInput>;
  campaigns?: InputMaybe<CampaignCreateNestedManyWithoutAssetsInput>;
  contentType: Scalars['String'];
  createdAt?: InputMaybe<Scalars['DateTime']>;
  createdBy: UserCreateNestedOneWithoutCreatedFilesInput;
  ctime: Scalars['String'];
  filename: Scalars['String'];
  filepath?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  isDirectory: Scalars['Boolean'];
  meta: FileMetaCreateInput;
  mtime: Scalars['String'];
  name: Scalars['String'];
  size: Scalars['Int'];
  status?: InputMaybe<FileStatus>;
  type: Scalars['String'];
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  updatedBy?: InputMaybe<UserCreateNestedOneWithoutUpdatedFilesInput>;
  url: Scalars['String'];
  workspace?: InputMaybe<WorkspaceCreateNestedOneWithoutFilesInput>;
};

export type FileCreateWithoutUpdatedByInput = {
  bookings?: InputMaybe<BookingCreateNestedManyWithoutAssetsInput>;
  campaigns?: InputMaybe<CampaignCreateNestedManyWithoutAssetsInput>;
  contentType: Scalars['String'];
  createdAt?: InputMaybe<Scalars['DateTime']>;
  createdBy: UserCreateNestedOneWithoutCreatedFilesInput;
  ctime: Scalars['String'];
  filename: Scalars['String'];
  filepath?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  isDirectory: Scalars['Boolean'];
  meta: FileMetaCreateInput;
  mtime: Scalars['String'];
  name: Scalars['String'];
  proofBooking?: InputMaybe<BookingCreateNestedOneWithoutProofsInput>;
  size: Scalars['Int'];
  status?: InputMaybe<FileStatus>;
  type: Scalars['String'];
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  url: Scalars['String'];
  workspace?: InputMaybe<WorkspaceCreateNestedOneWithoutFilesInput>;
};

export type FileCreateWithoutWorkspaceInput = {
  bookings?: InputMaybe<BookingCreateNestedManyWithoutAssetsInput>;
  campaigns?: InputMaybe<CampaignCreateNestedManyWithoutAssetsInput>;
  contentType: Scalars['String'];
  createdAt?: InputMaybe<Scalars['DateTime']>;
  createdBy: UserCreateNestedOneWithoutCreatedFilesInput;
  ctime: Scalars['String'];
  filename: Scalars['String'];
  filepath?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  isDirectory: Scalars['Boolean'];
  meta: FileMetaCreateInput;
  mtime: Scalars['String'];
  name: Scalars['String'];
  proofBooking?: InputMaybe<BookingCreateNestedOneWithoutProofsInput>;
  size: Scalars['Int'];
  status?: InputMaybe<FileStatus>;
  type: Scalars['String'];
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  updatedBy?: InputMaybe<UserCreateNestedOneWithoutUpdatedFilesInput>;
  url: Scalars['String'];
};

export type FileGroupBy = {
  __typename?: 'FileGroupBy';
  _avg?: Maybe<FileAvgAggregate>;
  _count?: Maybe<FileCountAggregate>;
  _max?: Maybe<FileMaxAggregate>;
  _min?: Maybe<FileMinAggregate>;
  _sum?: Maybe<FileSumAggregate>;
  bookingsIDs?: Maybe<Array<Scalars['String']>>;
  campaignIds?: Maybe<Array<Scalars['String']>>;
  contentType: Scalars['String'];
  createdAt: Scalars['DateTime'];
  createdByUserId: Scalars['String'];
  ctime: Scalars['String'];
  filename: Scalars['String'];
  filepath?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  isDirectory: Scalars['Boolean'];
  mtime: Scalars['String'];
  name: Scalars['String'];
  proofBookingId?: Maybe<Scalars['String']>;
  size: Scalars['Int'];
  status?: Maybe<FileStatus>;
  type: Scalars['String'];
  updatedAt: Scalars['DateTime'];
  updatedByUserId?: Maybe<Scalars['String']>;
  url: Scalars['String'];
  workspaceId?: Maybe<Scalars['String']>;
};

export type FileListRelationFilter = {
  every?: InputMaybe<FileWhereInput>;
  none?: InputMaybe<FileWhereInput>;
  some?: InputMaybe<FileWhereInput>;
};

export type FileMaxAggregate = {
  __typename?: 'FileMaxAggregate';
  contentType?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  createdByUserId?: Maybe<Scalars['String']>;
  ctime?: Maybe<Scalars['String']>;
  filename?: Maybe<Scalars['String']>;
  filepath?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  isDirectory?: Maybe<Scalars['Boolean']>;
  mtime?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  proofBookingId?: Maybe<Scalars['String']>;
  size?: Maybe<Scalars['Int']>;
  status?: Maybe<FileStatus>;
  type?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  updatedByUserId?: Maybe<Scalars['String']>;
  url?: Maybe<Scalars['String']>;
  workspaceId?: Maybe<Scalars['String']>;
};

export type FileMaxOrderByAggregateInput = {
  contentType?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  createdByUserId?: InputMaybe<SortOrder>;
  ctime?: InputMaybe<SortOrder>;
  filename?: InputMaybe<SortOrder>;
  filepath?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  isDirectory?: InputMaybe<SortOrder>;
  mtime?: InputMaybe<SortOrder>;
  name?: InputMaybe<SortOrder>;
  proofBookingId?: InputMaybe<SortOrder>;
  size?: InputMaybe<SortOrder>;
  status?: InputMaybe<SortOrder>;
  type?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
  updatedByUserId?: InputMaybe<SortOrder>;
  url?: InputMaybe<SortOrder>;
  workspaceId?: InputMaybe<SortOrder>;
};

export type FileMeta = {
  __typename?: 'FileMeta';
  duration: Scalars['Float'];
  height: Scalars['Int'];
  width: Scalars['Int'];
};

export type FileMetaCompositeFilter = {
  equals?: InputMaybe<FileMetaObjectEqualityInput>;
  is?: InputMaybe<FileMetaWhereInput>;
  isNot?: InputMaybe<FileMetaWhereInput>;
};

export type FileMetaCreateInput = {
  duration: Scalars['Float'];
  height: Scalars['Int'];
  width: Scalars['Int'];
};

export type FileMetaObjectEqualityInput = {
  duration: Scalars['Float'];
  height: Scalars['Int'];
  width: Scalars['Int'];
};

export type FileMetaOrderByInput = {
  duration?: InputMaybe<SortOrder>;
  height?: InputMaybe<SortOrder>;
  width?: InputMaybe<SortOrder>;
};

export type FileMetaWhereInput = {
  AND?: InputMaybe<Array<FileMetaWhereInput>>;
  NOT?: InputMaybe<Array<FileMetaWhereInput>>;
  OR?: InputMaybe<Array<FileMetaWhereInput>>;
  duration?: InputMaybe<FloatFilter>;
  height?: InputMaybe<IntFilter>;
  width?: InputMaybe<IntFilter>;
};

export type FileMinAggregate = {
  __typename?: 'FileMinAggregate';
  contentType?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  createdByUserId?: Maybe<Scalars['String']>;
  ctime?: Maybe<Scalars['String']>;
  filename?: Maybe<Scalars['String']>;
  filepath?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  isDirectory?: Maybe<Scalars['Boolean']>;
  mtime?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  proofBookingId?: Maybe<Scalars['String']>;
  size?: Maybe<Scalars['Int']>;
  status?: Maybe<FileStatus>;
  type?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  updatedByUserId?: Maybe<Scalars['String']>;
  url?: Maybe<Scalars['String']>;
  workspaceId?: Maybe<Scalars['String']>;
};

export type FileMinOrderByAggregateInput = {
  contentType?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  createdByUserId?: InputMaybe<SortOrder>;
  ctime?: InputMaybe<SortOrder>;
  filename?: InputMaybe<SortOrder>;
  filepath?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  isDirectory?: InputMaybe<SortOrder>;
  mtime?: InputMaybe<SortOrder>;
  name?: InputMaybe<SortOrder>;
  proofBookingId?: InputMaybe<SortOrder>;
  size?: InputMaybe<SortOrder>;
  status?: InputMaybe<SortOrder>;
  type?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
  updatedByUserId?: InputMaybe<SortOrder>;
  url?: InputMaybe<SortOrder>;
  workspaceId?: InputMaybe<SortOrder>;
};

export type FileOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type FileOrderByWithAggregationInput = {
  _avg?: InputMaybe<FileAvgOrderByAggregateInput>;
  _count?: InputMaybe<FileCountOrderByAggregateInput>;
  _max?: InputMaybe<FileMaxOrderByAggregateInput>;
  _min?: InputMaybe<FileMinOrderByAggregateInput>;
  _sum?: InputMaybe<FileSumOrderByAggregateInput>;
  bookingsIDs?: InputMaybe<SortOrder>;
  campaignIds?: InputMaybe<SortOrder>;
  contentType?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  createdByUserId?: InputMaybe<SortOrder>;
  ctime?: InputMaybe<SortOrder>;
  filename?: InputMaybe<SortOrder>;
  filepath?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  isDirectory?: InputMaybe<SortOrder>;
  mtime?: InputMaybe<SortOrder>;
  name?: InputMaybe<SortOrder>;
  proofBookingId?: InputMaybe<SortOrder>;
  size?: InputMaybe<SortOrder>;
  status?: InputMaybe<SortOrder>;
  type?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
  updatedByUserId?: InputMaybe<SortOrder>;
  url?: InputMaybe<SortOrder>;
  workspaceId?: InputMaybe<SortOrder>;
};

export type FileOrderByWithRelationInput = {
  bookings?: InputMaybe<BookingOrderByRelationAggregateInput>;
  bookingsIDs?: InputMaybe<SortOrder>;
  campaignIds?: InputMaybe<SortOrder>;
  campaigns?: InputMaybe<CampaignOrderByRelationAggregateInput>;
  contentType?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  createdBy?: InputMaybe<UserOrderByWithRelationInput>;
  createdByUserId?: InputMaybe<SortOrder>;
  ctime?: InputMaybe<SortOrder>;
  filename?: InputMaybe<SortOrder>;
  filepath?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  isDirectory?: InputMaybe<SortOrder>;
  meta?: InputMaybe<FileMetaOrderByInput>;
  mtime?: InputMaybe<SortOrder>;
  name?: InputMaybe<SortOrder>;
  proofBooking?: InputMaybe<BookingOrderByWithRelationInput>;
  proofBookingId?: InputMaybe<SortOrder>;
  size?: InputMaybe<SortOrder>;
  status?: InputMaybe<SortOrder>;
  type?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
  updatedBy?: InputMaybe<UserOrderByWithRelationInput>;
  updatedByUserId?: InputMaybe<SortOrder>;
  url?: InputMaybe<SortOrder>;
  workspace?: InputMaybe<WorkspaceOrderByWithRelationInput>;
  workspaceId?: InputMaybe<SortOrder>;
};

export enum FileScalarFieldEnum {
  BookingsIDs = 'bookingsIDs',
  CampaignIds = 'campaignIds',
  ContentType = 'contentType',
  CreatedAt = 'createdAt',
  CreatedByUserId = 'createdByUserId',
  Ctime = 'ctime',
  Filename = 'filename',
  Filepath = 'filepath',
  Id = 'id',
  IsDirectory = 'isDirectory',
  Mtime = 'mtime',
  Name = 'name',
  ProofBookingId = 'proofBookingId',
  Size = 'size',
  Status = 'status',
  Type = 'type',
  UpdatedAt = 'updatedAt',
  UpdatedByUserId = 'updatedByUserId',
  Url = 'url',
  WorkspaceId = 'workspaceId'
}

export type FileScalarWhereInput = {
  AND?: InputMaybe<Array<FileScalarWhereInput>>;
  NOT?: InputMaybe<Array<FileScalarWhereInput>>;
  OR?: InputMaybe<Array<FileScalarWhereInput>>;
  bookingsIDs?: InputMaybe<StringNullableListFilter>;
  campaignIds?: InputMaybe<StringNullableListFilter>;
  contentType?: InputMaybe<StringFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  createdByUserId?: InputMaybe<StringFilter>;
  ctime?: InputMaybe<StringFilter>;
  filename?: InputMaybe<StringFilter>;
  filepath?: InputMaybe<StringNullableFilter>;
  id?: InputMaybe<StringFilter>;
  isDirectory?: InputMaybe<BoolFilter>;
  mtime?: InputMaybe<StringFilter>;
  name?: InputMaybe<StringFilter>;
  proofBookingId?: InputMaybe<StringNullableFilter>;
  size?: InputMaybe<IntFilter>;
  status?: InputMaybe<EnumFileStatusNullableFilter>;
  type?: InputMaybe<StringFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
  updatedByUserId?: InputMaybe<StringNullableFilter>;
  url?: InputMaybe<StringFilter>;
  workspaceId?: InputMaybe<StringNullableFilter>;
};

export type FileScalarWhereWithAggregatesInput = {
  AND?: InputMaybe<Array<FileScalarWhereWithAggregatesInput>>;
  NOT?: InputMaybe<Array<FileScalarWhereWithAggregatesInput>>;
  OR?: InputMaybe<Array<FileScalarWhereWithAggregatesInput>>;
  bookingsIDs?: InputMaybe<StringNullableListFilter>;
  campaignIds?: InputMaybe<StringNullableListFilter>;
  contentType?: InputMaybe<StringWithAggregatesFilter>;
  createdAt?: InputMaybe<DateTimeWithAggregatesFilter>;
  createdByUserId?: InputMaybe<StringWithAggregatesFilter>;
  ctime?: InputMaybe<StringWithAggregatesFilter>;
  filename?: InputMaybe<StringWithAggregatesFilter>;
  filepath?: InputMaybe<StringNullableWithAggregatesFilter>;
  id?: InputMaybe<StringWithAggregatesFilter>;
  isDirectory?: InputMaybe<BoolWithAggregatesFilter>;
  mtime?: InputMaybe<StringWithAggregatesFilter>;
  name?: InputMaybe<StringWithAggregatesFilter>;
  proofBookingId?: InputMaybe<StringNullableWithAggregatesFilter>;
  size?: InputMaybe<IntWithAggregatesFilter>;
  status?: InputMaybe<EnumFileStatusNullableWithAggregatesFilter>;
  type?: InputMaybe<StringWithAggregatesFilter>;
  updatedAt?: InputMaybe<DateTimeWithAggregatesFilter>;
  updatedByUserId?: InputMaybe<StringNullableWithAggregatesFilter>;
  url?: InputMaybe<StringWithAggregatesFilter>;
  workspaceId?: InputMaybe<StringNullableWithAggregatesFilter>;
};

export enum FileStatus {
  Approved = 'APPROVED',
  Rejected = 'REJECTED',
  RequestApproval = 'REQUEST_APPROVAL'
}

export type FileSumAggregate = {
  __typename?: 'FileSumAggregate';
  size?: Maybe<Scalars['Int']>;
};

export type FileSumOrderByAggregateInput = {
  size?: InputMaybe<SortOrder>;
};

export type FileUpdateInput = {
  bookings?: InputMaybe<BookingUpdateManyWithoutAssetsNestedInput>;
  campaigns?: InputMaybe<CampaignUpdateManyWithoutAssetsNestedInput>;
  contentType?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  createdBy?: InputMaybe<UserUpdateOneRequiredWithoutCreatedFilesNestedInput>;
  ctime?: InputMaybe<Scalars['String']>;
  filename?: InputMaybe<Scalars['String']>;
  filepath?: InputMaybe<Scalars['String']>;
  isDirectory?: InputMaybe<Scalars['Boolean']>;
  meta?: InputMaybe<FileMetaCreateInput>;
  mtime?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  proofBooking?: InputMaybe<BookingUpdateOneWithoutProofsNestedInput>;
  size?: InputMaybe<Scalars['Int']>;
  status?: InputMaybe<FileStatus>;
  type?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  updatedBy?: InputMaybe<UserUpdateOneWithoutUpdatedFilesNestedInput>;
  url?: InputMaybe<Scalars['String']>;
  workspace?: InputMaybe<WorkspaceUpdateOneWithoutFilesNestedInput>;
};

export type FileUpdateManyMutationInput = {
  contentType?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  ctime?: InputMaybe<Scalars['String']>;
  filename?: InputMaybe<Scalars['String']>;
  filepath?: InputMaybe<Scalars['String']>;
  isDirectory?: InputMaybe<Scalars['Boolean']>;
  meta?: InputMaybe<FileMetaCreateInput>;
  mtime?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  size?: InputMaybe<Scalars['Int']>;
  status?: InputMaybe<FileStatus>;
  type?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  url?: InputMaybe<Scalars['String']>;
};

export type FileUpdateManyWithWhereWithoutBookingsInput = {
  data: FileUpdateManyMutationInput;
  where: FileScalarWhereInput;
};

export type FileUpdateManyWithWhereWithoutCampaignsInput = {
  data: FileUpdateManyMutationInput;
  where: FileScalarWhereInput;
};

export type FileUpdateManyWithWhereWithoutCreatedByInput = {
  data: FileUpdateManyMutationInput;
  where: FileScalarWhereInput;
};

export type FileUpdateManyWithWhereWithoutProofBookingInput = {
  data: FileUpdateManyMutationInput;
  where: FileScalarWhereInput;
};

export type FileUpdateManyWithWhereWithoutUpdatedByInput = {
  data: FileUpdateManyMutationInput;
  where: FileScalarWhereInput;
};

export type FileUpdateManyWithWhereWithoutWorkspaceInput = {
  data: FileUpdateManyMutationInput;
  where: FileScalarWhereInput;
};

export type FileUpdateManyWithoutBookingsNestedInput = {
  connect?: InputMaybe<Array<FileWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<FileCreateOrConnectWithoutBookingsInput>>;
  create?: InputMaybe<Array<FileCreateWithoutBookingsInput>>;
  delete?: InputMaybe<Array<FileWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<FileScalarWhereInput>>;
  disconnect?: InputMaybe<Array<FileWhereUniqueInput>>;
  set?: InputMaybe<Array<FileWhereUniqueInput>>;
  update?: InputMaybe<Array<FileUpdateWithWhereUniqueWithoutBookingsInput>>;
  updateMany?: InputMaybe<Array<FileUpdateManyWithWhereWithoutBookingsInput>>;
  upsert?: InputMaybe<Array<FileUpsertWithWhereUniqueWithoutBookingsInput>>;
};

export type FileUpdateManyWithoutCampaignsNestedInput = {
  connect?: InputMaybe<Array<FileWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<FileCreateOrConnectWithoutCampaignsInput>>;
  create?: InputMaybe<Array<FileCreateWithoutCampaignsInput>>;
  delete?: InputMaybe<Array<FileWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<FileScalarWhereInput>>;
  disconnect?: InputMaybe<Array<FileWhereUniqueInput>>;
  set?: InputMaybe<Array<FileWhereUniqueInput>>;
  update?: InputMaybe<Array<FileUpdateWithWhereUniqueWithoutCampaignsInput>>;
  updateMany?: InputMaybe<Array<FileUpdateManyWithWhereWithoutCampaignsInput>>;
  upsert?: InputMaybe<Array<FileUpsertWithWhereUniqueWithoutCampaignsInput>>;
};

export type FileUpdateManyWithoutCreatedByNestedInput = {
  connect?: InputMaybe<Array<FileWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<FileCreateOrConnectWithoutCreatedByInput>>;
  create?: InputMaybe<Array<FileCreateWithoutCreatedByInput>>;
  createMany?: InputMaybe<FileCreateManyCreatedByInputEnvelope>;
  delete?: InputMaybe<Array<FileWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<FileScalarWhereInput>>;
  disconnect?: InputMaybe<Array<FileWhereUniqueInput>>;
  set?: InputMaybe<Array<FileWhereUniqueInput>>;
  update?: InputMaybe<Array<FileUpdateWithWhereUniqueWithoutCreatedByInput>>;
  updateMany?: InputMaybe<Array<FileUpdateManyWithWhereWithoutCreatedByInput>>;
  upsert?: InputMaybe<Array<FileUpsertWithWhereUniqueWithoutCreatedByInput>>;
};

export type FileUpdateManyWithoutProofBookingNestedInput = {
  connect?: InputMaybe<Array<FileWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<FileCreateOrConnectWithoutProofBookingInput>>;
  create?: InputMaybe<Array<FileCreateWithoutProofBookingInput>>;
  createMany?: InputMaybe<FileCreateManyProofBookingInputEnvelope>;
  delete?: InputMaybe<Array<FileWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<FileScalarWhereInput>>;
  disconnect?: InputMaybe<Array<FileWhereUniqueInput>>;
  set?: InputMaybe<Array<FileWhereUniqueInput>>;
  update?: InputMaybe<Array<FileUpdateWithWhereUniqueWithoutProofBookingInput>>;
  updateMany?: InputMaybe<Array<FileUpdateManyWithWhereWithoutProofBookingInput>>;
  upsert?: InputMaybe<Array<FileUpsertWithWhereUniqueWithoutProofBookingInput>>;
};

export type FileUpdateManyWithoutUpdatedByNestedInput = {
  connect?: InputMaybe<Array<FileWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<FileCreateOrConnectWithoutUpdatedByInput>>;
  create?: InputMaybe<Array<FileCreateWithoutUpdatedByInput>>;
  createMany?: InputMaybe<FileCreateManyUpdatedByInputEnvelope>;
  delete?: InputMaybe<Array<FileWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<FileScalarWhereInput>>;
  disconnect?: InputMaybe<Array<FileWhereUniqueInput>>;
  set?: InputMaybe<Array<FileWhereUniqueInput>>;
  update?: InputMaybe<Array<FileUpdateWithWhereUniqueWithoutUpdatedByInput>>;
  updateMany?: InputMaybe<Array<FileUpdateManyWithWhereWithoutUpdatedByInput>>;
  upsert?: InputMaybe<Array<FileUpsertWithWhereUniqueWithoutUpdatedByInput>>;
};

export type FileUpdateManyWithoutWorkspaceNestedInput = {
  connect?: InputMaybe<Array<FileWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<FileCreateOrConnectWithoutWorkspaceInput>>;
  create?: InputMaybe<Array<FileCreateWithoutWorkspaceInput>>;
  createMany?: InputMaybe<FileCreateManyWorkspaceInputEnvelope>;
  delete?: InputMaybe<Array<FileWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<FileScalarWhereInput>>;
  disconnect?: InputMaybe<Array<FileWhereUniqueInput>>;
  set?: InputMaybe<Array<FileWhereUniqueInput>>;
  update?: InputMaybe<Array<FileUpdateWithWhereUniqueWithoutWorkspaceInput>>;
  updateMany?: InputMaybe<Array<FileUpdateManyWithWhereWithoutWorkspaceInput>>;
  upsert?: InputMaybe<Array<FileUpsertWithWhereUniqueWithoutWorkspaceInput>>;
};

export type FileUpdateWithWhereUniqueWithoutBookingsInput = {
  data: FileUpdateWithoutBookingsInput;
  where: FileWhereUniqueInput;
};

export type FileUpdateWithWhereUniqueWithoutCampaignsInput = {
  data: FileUpdateWithoutCampaignsInput;
  where: FileWhereUniqueInput;
};

export type FileUpdateWithWhereUniqueWithoutCreatedByInput = {
  data: FileUpdateWithoutCreatedByInput;
  where: FileWhereUniqueInput;
};

export type FileUpdateWithWhereUniqueWithoutProofBookingInput = {
  data: FileUpdateWithoutProofBookingInput;
  where: FileWhereUniqueInput;
};

export type FileUpdateWithWhereUniqueWithoutUpdatedByInput = {
  data: FileUpdateWithoutUpdatedByInput;
  where: FileWhereUniqueInput;
};

export type FileUpdateWithWhereUniqueWithoutWorkspaceInput = {
  data: FileUpdateWithoutWorkspaceInput;
  where: FileWhereUniqueInput;
};

export type FileUpdateWithoutBookingsInput = {
  campaigns?: InputMaybe<CampaignUpdateManyWithoutAssetsNestedInput>;
  contentType?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  createdBy?: InputMaybe<UserUpdateOneRequiredWithoutCreatedFilesNestedInput>;
  ctime?: InputMaybe<Scalars['String']>;
  filename?: InputMaybe<Scalars['String']>;
  filepath?: InputMaybe<Scalars['String']>;
  isDirectory?: InputMaybe<Scalars['Boolean']>;
  meta?: InputMaybe<FileMetaCreateInput>;
  mtime?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  proofBooking?: InputMaybe<BookingUpdateOneWithoutProofsNestedInput>;
  size?: InputMaybe<Scalars['Int']>;
  status?: InputMaybe<FileStatus>;
  type?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  updatedBy?: InputMaybe<UserUpdateOneWithoutUpdatedFilesNestedInput>;
  url?: InputMaybe<Scalars['String']>;
  workspace?: InputMaybe<WorkspaceUpdateOneWithoutFilesNestedInput>;
};

export type FileUpdateWithoutCampaignsInput = {
  bookings?: InputMaybe<BookingUpdateManyWithoutAssetsNestedInput>;
  contentType?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  createdBy?: InputMaybe<UserUpdateOneRequiredWithoutCreatedFilesNestedInput>;
  ctime?: InputMaybe<Scalars['String']>;
  filename?: InputMaybe<Scalars['String']>;
  filepath?: InputMaybe<Scalars['String']>;
  isDirectory?: InputMaybe<Scalars['Boolean']>;
  meta?: InputMaybe<FileMetaCreateInput>;
  mtime?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  proofBooking?: InputMaybe<BookingUpdateOneWithoutProofsNestedInput>;
  size?: InputMaybe<Scalars['Int']>;
  status?: InputMaybe<FileStatus>;
  type?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  updatedBy?: InputMaybe<UserUpdateOneWithoutUpdatedFilesNestedInput>;
  url?: InputMaybe<Scalars['String']>;
  workspace?: InputMaybe<WorkspaceUpdateOneWithoutFilesNestedInput>;
};

export type FileUpdateWithoutCreatedByInput = {
  bookings?: InputMaybe<BookingUpdateManyWithoutAssetsNestedInput>;
  campaigns?: InputMaybe<CampaignUpdateManyWithoutAssetsNestedInput>;
  contentType?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  ctime?: InputMaybe<Scalars['String']>;
  filename?: InputMaybe<Scalars['String']>;
  filepath?: InputMaybe<Scalars['String']>;
  isDirectory?: InputMaybe<Scalars['Boolean']>;
  meta?: InputMaybe<FileMetaCreateInput>;
  mtime?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  proofBooking?: InputMaybe<BookingUpdateOneWithoutProofsNestedInput>;
  size?: InputMaybe<Scalars['Int']>;
  status?: InputMaybe<FileStatus>;
  type?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  updatedBy?: InputMaybe<UserUpdateOneWithoutUpdatedFilesNestedInput>;
  url?: InputMaybe<Scalars['String']>;
  workspace?: InputMaybe<WorkspaceUpdateOneWithoutFilesNestedInput>;
};

export type FileUpdateWithoutProofBookingInput = {
  bookings?: InputMaybe<BookingUpdateManyWithoutAssetsNestedInput>;
  campaigns?: InputMaybe<CampaignUpdateManyWithoutAssetsNestedInput>;
  contentType?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  createdBy?: InputMaybe<UserUpdateOneRequiredWithoutCreatedFilesNestedInput>;
  ctime?: InputMaybe<Scalars['String']>;
  filename?: InputMaybe<Scalars['String']>;
  filepath?: InputMaybe<Scalars['String']>;
  isDirectory?: InputMaybe<Scalars['Boolean']>;
  meta?: InputMaybe<FileMetaCreateInput>;
  mtime?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  size?: InputMaybe<Scalars['Int']>;
  status?: InputMaybe<FileStatus>;
  type?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  updatedBy?: InputMaybe<UserUpdateOneWithoutUpdatedFilesNestedInput>;
  url?: InputMaybe<Scalars['String']>;
  workspace?: InputMaybe<WorkspaceUpdateOneWithoutFilesNestedInput>;
};

export type FileUpdateWithoutUpdatedByInput = {
  bookings?: InputMaybe<BookingUpdateManyWithoutAssetsNestedInput>;
  campaigns?: InputMaybe<CampaignUpdateManyWithoutAssetsNestedInput>;
  contentType?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  createdBy?: InputMaybe<UserUpdateOneRequiredWithoutCreatedFilesNestedInput>;
  ctime?: InputMaybe<Scalars['String']>;
  filename?: InputMaybe<Scalars['String']>;
  filepath?: InputMaybe<Scalars['String']>;
  isDirectory?: InputMaybe<Scalars['Boolean']>;
  meta?: InputMaybe<FileMetaCreateInput>;
  mtime?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  proofBooking?: InputMaybe<BookingUpdateOneWithoutProofsNestedInput>;
  size?: InputMaybe<Scalars['Int']>;
  status?: InputMaybe<FileStatus>;
  type?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  url?: InputMaybe<Scalars['String']>;
  workspace?: InputMaybe<WorkspaceUpdateOneWithoutFilesNestedInput>;
};

export type FileUpdateWithoutWorkspaceInput = {
  bookings?: InputMaybe<BookingUpdateManyWithoutAssetsNestedInput>;
  campaigns?: InputMaybe<CampaignUpdateManyWithoutAssetsNestedInput>;
  contentType?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  createdBy?: InputMaybe<UserUpdateOneRequiredWithoutCreatedFilesNestedInput>;
  ctime?: InputMaybe<Scalars['String']>;
  filename?: InputMaybe<Scalars['String']>;
  filepath?: InputMaybe<Scalars['String']>;
  isDirectory?: InputMaybe<Scalars['Boolean']>;
  meta?: InputMaybe<FileMetaCreateInput>;
  mtime?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  proofBooking?: InputMaybe<BookingUpdateOneWithoutProofsNestedInput>;
  size?: InputMaybe<Scalars['Int']>;
  status?: InputMaybe<FileStatus>;
  type?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  updatedBy?: InputMaybe<UserUpdateOneWithoutUpdatedFilesNestedInput>;
  url?: InputMaybe<Scalars['String']>;
};

export type FileUpsertWithWhereUniqueWithoutBookingsInput = {
  create: FileCreateWithoutBookingsInput;
  update: FileUpdateWithoutBookingsInput;
  where: FileWhereUniqueInput;
};

export type FileUpsertWithWhereUniqueWithoutCampaignsInput = {
  create: FileCreateWithoutCampaignsInput;
  update: FileUpdateWithoutCampaignsInput;
  where: FileWhereUniqueInput;
};

export type FileUpsertWithWhereUniqueWithoutCreatedByInput = {
  create: FileCreateWithoutCreatedByInput;
  update: FileUpdateWithoutCreatedByInput;
  where: FileWhereUniqueInput;
};

export type FileUpsertWithWhereUniqueWithoutProofBookingInput = {
  create: FileCreateWithoutProofBookingInput;
  update: FileUpdateWithoutProofBookingInput;
  where: FileWhereUniqueInput;
};

export type FileUpsertWithWhereUniqueWithoutUpdatedByInput = {
  create: FileCreateWithoutUpdatedByInput;
  update: FileUpdateWithoutUpdatedByInput;
  where: FileWhereUniqueInput;
};

export type FileUpsertWithWhereUniqueWithoutWorkspaceInput = {
  create: FileCreateWithoutWorkspaceInput;
  update: FileUpdateWithoutWorkspaceInput;
  where: FileWhereUniqueInput;
};

export type FileWhereInput = {
  AND?: InputMaybe<Array<FileWhereInput>>;
  NOT?: InputMaybe<Array<FileWhereInput>>;
  OR?: InputMaybe<Array<FileWhereInput>>;
  bookings?: InputMaybe<BookingListRelationFilter>;
  bookingsIDs?: InputMaybe<StringNullableListFilter>;
  campaignIds?: InputMaybe<StringNullableListFilter>;
  campaigns?: InputMaybe<CampaignListRelationFilter>;
  contentType?: InputMaybe<StringFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  createdBy?: InputMaybe<UserRelationFilter>;
  createdByUserId?: InputMaybe<StringFilter>;
  ctime?: InputMaybe<StringFilter>;
  filename?: InputMaybe<StringFilter>;
  filepath?: InputMaybe<StringNullableFilter>;
  id?: InputMaybe<StringFilter>;
  isDirectory?: InputMaybe<BoolFilter>;
  meta?: InputMaybe<FileMetaCompositeFilter>;
  mtime?: InputMaybe<StringFilter>;
  name?: InputMaybe<StringFilter>;
  proofBooking?: InputMaybe<BookingNullableRelationFilter>;
  proofBookingId?: InputMaybe<StringNullableFilter>;
  size?: InputMaybe<IntFilter>;
  status?: InputMaybe<EnumFileStatusNullableFilter>;
  type?: InputMaybe<StringFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
  updatedBy?: InputMaybe<UserNullableRelationFilter>;
  updatedByUserId?: InputMaybe<StringNullableFilter>;
  url?: InputMaybe<StringFilter>;
  workspace?: InputMaybe<WorkspaceNullableRelationFilter>;
  workspaceId?: InputMaybe<StringNullableFilter>;
};

export type FileWhereUniqueInput = {
  AND?: InputMaybe<Array<FileWhereInput>>;
  NOT?: InputMaybe<Array<FileWhereInput>>;
  OR?: InputMaybe<Array<FileWhereInput>>;
  bookings?: InputMaybe<BookingListRelationFilter>;
  bookingsIDs?: InputMaybe<StringNullableListFilter>;
  campaignIds?: InputMaybe<StringNullableListFilter>;
  campaigns?: InputMaybe<CampaignListRelationFilter>;
  contentType?: InputMaybe<StringFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  createdBy?: InputMaybe<UserRelationFilter>;
  createdByUserId?: InputMaybe<StringFilter>;
  ctime?: InputMaybe<StringFilter>;
  filename?: InputMaybe<StringFilter>;
  filepath?: InputMaybe<StringNullableFilter>;
  id?: InputMaybe<Scalars['String']>;
  isDirectory?: InputMaybe<BoolFilter>;
  meta?: InputMaybe<FileMetaCompositeFilter>;
  mtime?: InputMaybe<StringFilter>;
  name?: InputMaybe<StringFilter>;
  proofBooking?: InputMaybe<BookingNullableRelationFilter>;
  proofBookingId?: InputMaybe<StringNullableFilter>;
  size?: InputMaybe<IntFilter>;
  status?: InputMaybe<EnumFileStatusNullableFilter>;
  type?: InputMaybe<StringFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
  updatedBy?: InputMaybe<UserNullableRelationFilter>;
  updatedByUserId?: InputMaybe<StringNullableFilter>;
  url?: InputMaybe<Scalars['String']>;
  workspace?: InputMaybe<WorkspaceNullableRelationFilter>;
  workspaceId?: InputMaybe<StringNullableFilter>;
};

export type FloatFilter = {
  equals?: InputMaybe<Scalars['Float']>;
  gt?: InputMaybe<Scalars['Float']>;
  gte?: InputMaybe<Scalars['Float']>;
  in?: InputMaybe<Array<Scalars['Float']>>;
  lt?: InputMaybe<Scalars['Float']>;
  lte?: InputMaybe<Scalars['Float']>;
  not?: InputMaybe<NestedFloatFilter>;
  notIn?: InputMaybe<Array<Scalars['Float']>>;
};

export type FloatNullableFilter = {
  equals?: InputMaybe<Scalars['Float']>;
  gt?: InputMaybe<Scalars['Float']>;
  gte?: InputMaybe<Scalars['Float']>;
  in?: InputMaybe<Array<Scalars['Float']>>;
  isSet?: InputMaybe<Scalars['Boolean']>;
  lt?: InputMaybe<Scalars['Float']>;
  lte?: InputMaybe<Scalars['Float']>;
  not?: InputMaybe<NestedFloatNullableFilter>;
  notIn?: InputMaybe<Array<Scalars['Float']>>;
};

export type FloatWithAggregatesFilter = {
  _avg?: InputMaybe<NestedFloatFilter>;
  _count?: InputMaybe<NestedIntFilter>;
  _max?: InputMaybe<NestedFloatFilter>;
  _min?: InputMaybe<NestedFloatFilter>;
  _sum?: InputMaybe<NestedFloatFilter>;
  equals?: InputMaybe<Scalars['Float']>;
  gt?: InputMaybe<Scalars['Float']>;
  gte?: InputMaybe<Scalars['Float']>;
  in?: InputMaybe<Array<Scalars['Float']>>;
  lt?: InputMaybe<Scalars['Float']>;
  lte?: InputMaybe<Scalars['Float']>;
  not?: InputMaybe<NestedFloatWithAggregatesFilter>;
  notIn?: InputMaybe<Array<Scalars['Float']>>;
};

export type GenericResponse = {
  __typename?: 'GenericResponse';
  success: Scalars['Boolean'];
};

export type IntFilter = {
  equals?: InputMaybe<Scalars['Int']>;
  gt?: InputMaybe<Scalars['Int']>;
  gte?: InputMaybe<Scalars['Int']>;
  in?: InputMaybe<Array<Scalars['Int']>>;
  lt?: InputMaybe<Scalars['Int']>;
  lte?: InputMaybe<Scalars['Int']>;
  not?: InputMaybe<NestedIntFilter>;
  notIn?: InputMaybe<Array<Scalars['Int']>>;
};

export type IntNullableListFilter = {
  equals?: InputMaybe<Array<Scalars['Int']>>;
  has?: InputMaybe<Scalars['Int']>;
  hasEvery?: InputMaybe<Array<Scalars['Int']>>;
  hasSome?: InputMaybe<Array<Scalars['Int']>>;
  isEmpty?: InputMaybe<Scalars['Boolean']>;
};

export type IntWithAggregatesFilter = {
  _avg?: InputMaybe<NestedFloatFilter>;
  _count?: InputMaybe<NestedIntFilter>;
  _max?: InputMaybe<NestedIntFilter>;
  _min?: InputMaybe<NestedIntFilter>;
  _sum?: InputMaybe<NestedIntFilter>;
  equals?: InputMaybe<Scalars['Int']>;
  gt?: InputMaybe<Scalars['Int']>;
  gte?: InputMaybe<Scalars['Int']>;
  in?: InputMaybe<Array<Scalars['Int']>>;
  lt?: InputMaybe<Scalars['Int']>;
  lte?: InputMaybe<Scalars['Int']>;
  not?: InputMaybe<NestedIntWithAggregatesFilter>;
  notIn?: InputMaybe<Array<Scalars['Int']>>;
};

export type JsonNullableFilter = {
  equals?: InputMaybe<Scalars['JSON']>;
  isSet?: InputMaybe<Scalars['Boolean']>;
  not?: InputMaybe<Scalars['JSON']>;
};

export type JsonNullableWithAggregatesFilter = {
  _count?: InputMaybe<NestedIntNullableFilter>;
  _max?: InputMaybe<NestedJsonNullableFilter>;
  _min?: InputMaybe<NestedJsonNullableFilter>;
  equals?: InputMaybe<Scalars['JSON']>;
  isSet?: InputMaybe<Scalars['Boolean']>;
  not?: InputMaybe<Scalars['JSON']>;
};

export type Map = {
  __typename?: 'Map';
  lat: Scalars['Float'];
  lng: Scalars['Float'];
};

export type MapCompositeFilter = {
  equals?: InputMaybe<MapObjectEqualityInput>;
  is?: InputMaybe<MapWhereInput>;
  isNot?: InputMaybe<MapWhereInput>;
};

export type MapCreateInput = {
  lat: Scalars['Float'];
  lng: Scalars['Float'];
};

export type MapObjectEqualityInput = {
  lat: Scalars['Float'];
  lng: Scalars['Float'];
};

export type MapOrderByInput = {
  lat?: InputMaybe<SortOrder>;
  lng?: InputMaybe<SortOrder>;
};

export type MapWhereInput = {
  AND?: InputMaybe<Array<MapWhereInput>>;
  NOT?: InputMaybe<Array<MapWhereInput>>;
  OR?: InputMaybe<Array<MapWhereInput>>;
  lat?: InputMaybe<FloatFilter>;
  lng?: InputMaybe<FloatFilter>;
};

export enum MeasurementUnit {
  Ft = 'FT',
  Inch = 'INCH'
}

export type Membership = {
  __typename?: 'Membership';
  createdAt: Scalars['DateTime'];
  id: Scalars['String'];
  role: Role;
  roleId: Scalars['String'];
  user: User;
  userId: Scalars['String'];
  workspace: Workspace;
  workspaceId: Scalars['String'];
};

export type MembershipCountAggregate = {
  __typename?: 'MembershipCountAggregate';
  _all: Scalars['Int'];
  createdAt: Scalars['Int'];
  id: Scalars['Int'];
  roleId: Scalars['Int'];
  userId: Scalars['Int'];
  workspaceId: Scalars['Int'];
};

export type MembershipCountOrderByAggregateInput = {
  createdAt?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  roleId?: InputMaybe<SortOrder>;
  userId?: InputMaybe<SortOrder>;
  workspaceId?: InputMaybe<SortOrder>;
};

export type MembershipCreateInput = {
  createdAt?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['String']>;
  role: RoleCreateNestedOneWithoutMembershipsInput;
  user: UserCreateNestedOneWithoutMembershipsInput;
  workspace: WorkspaceCreateNestedOneWithoutMembershipsInput;
};

export type MembershipCreateManyInput = {
  createdAt?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['String']>;
  roleId: Scalars['String'];
  userId: Scalars['String'];
  workspaceId: Scalars['String'];
};

export type MembershipCreateManyRoleInput = {
  createdAt?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['String']>;
  userId: Scalars['String'];
  workspaceId: Scalars['String'];
};

export type MembershipCreateManyRoleInputEnvelope = {
  data: Array<MembershipCreateManyRoleInput>;
};

export type MembershipCreateManyUserInput = {
  createdAt?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['String']>;
  roleId: Scalars['String'];
  workspaceId: Scalars['String'];
};

export type MembershipCreateManyUserInputEnvelope = {
  data: Array<MembershipCreateManyUserInput>;
};

export type MembershipCreateManyWorkspaceInput = {
  createdAt?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['String']>;
  roleId: Scalars['String'];
  userId: Scalars['String'];
};

export type MembershipCreateManyWorkspaceInputEnvelope = {
  data: Array<MembershipCreateManyWorkspaceInput>;
};

export type MembershipCreateNestedManyWithoutRoleInput = {
  connect?: InputMaybe<Array<MembershipWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<MembershipCreateOrConnectWithoutRoleInput>>;
  create?: InputMaybe<Array<MembershipCreateWithoutRoleInput>>;
  createMany?: InputMaybe<MembershipCreateManyRoleInputEnvelope>;
};

export type MembershipCreateNestedManyWithoutUserInput = {
  connect?: InputMaybe<Array<MembershipWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<MembershipCreateOrConnectWithoutUserInput>>;
  create?: InputMaybe<Array<MembershipCreateWithoutUserInput>>;
  createMany?: InputMaybe<MembershipCreateManyUserInputEnvelope>;
};

export type MembershipCreateNestedManyWithoutWorkspaceInput = {
  connect?: InputMaybe<Array<MembershipWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<MembershipCreateOrConnectWithoutWorkspaceInput>>;
  create?: InputMaybe<Array<MembershipCreateWithoutWorkspaceInput>>;
  createMany?: InputMaybe<MembershipCreateManyWorkspaceInputEnvelope>;
};

export type MembershipCreateOrConnectWithoutRoleInput = {
  create: MembershipCreateWithoutRoleInput;
  where: MembershipWhereUniqueInput;
};

export type MembershipCreateOrConnectWithoutUserInput = {
  create: MembershipCreateWithoutUserInput;
  where: MembershipWhereUniqueInput;
};

export type MembershipCreateOrConnectWithoutWorkspaceInput = {
  create: MembershipCreateWithoutWorkspaceInput;
  where: MembershipWhereUniqueInput;
};

export type MembershipCreateWithoutRoleInput = {
  createdAt?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['String']>;
  user: UserCreateNestedOneWithoutMembershipsInput;
  workspace: WorkspaceCreateNestedOneWithoutMembershipsInput;
};

export type MembershipCreateWithoutUserInput = {
  createdAt?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['String']>;
  role: RoleCreateNestedOneWithoutMembershipsInput;
  workspace: WorkspaceCreateNestedOneWithoutMembershipsInput;
};

export type MembershipCreateWithoutWorkspaceInput = {
  createdAt?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['String']>;
  role: RoleCreateNestedOneWithoutMembershipsInput;
  user: UserCreateNestedOneWithoutMembershipsInput;
};

export type MembershipGroupBy = {
  __typename?: 'MembershipGroupBy';
  _count?: Maybe<MembershipCountAggregate>;
  _max?: Maybe<MembershipMaxAggregate>;
  _min?: Maybe<MembershipMinAggregate>;
  createdAt: Scalars['DateTime'];
  id: Scalars['String'];
  roleId: Scalars['String'];
  userId: Scalars['String'];
  workspaceId: Scalars['String'];
};

export type MembershipListRelationFilter = {
  every?: InputMaybe<MembershipWhereInput>;
  none?: InputMaybe<MembershipWhereInput>;
  some?: InputMaybe<MembershipWhereInput>;
};

export type MembershipMaxAggregate = {
  __typename?: 'MembershipMaxAggregate';
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  roleId?: Maybe<Scalars['String']>;
  userId?: Maybe<Scalars['String']>;
  workspaceId?: Maybe<Scalars['String']>;
};

export type MembershipMaxOrderByAggregateInput = {
  createdAt?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  roleId?: InputMaybe<SortOrder>;
  userId?: InputMaybe<SortOrder>;
  workspaceId?: InputMaybe<SortOrder>;
};

export type MembershipMinAggregate = {
  __typename?: 'MembershipMinAggregate';
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  roleId?: Maybe<Scalars['String']>;
  userId?: Maybe<Scalars['String']>;
  workspaceId?: Maybe<Scalars['String']>;
};

export type MembershipMinOrderByAggregateInput = {
  createdAt?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  roleId?: InputMaybe<SortOrder>;
  userId?: InputMaybe<SortOrder>;
  workspaceId?: InputMaybe<SortOrder>;
};

export type MembershipOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type MembershipOrderByWithAggregationInput = {
  _count?: InputMaybe<MembershipCountOrderByAggregateInput>;
  _max?: InputMaybe<MembershipMaxOrderByAggregateInput>;
  _min?: InputMaybe<MembershipMinOrderByAggregateInput>;
  createdAt?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  roleId?: InputMaybe<SortOrder>;
  userId?: InputMaybe<SortOrder>;
  workspaceId?: InputMaybe<SortOrder>;
};

export type MembershipOrderByWithRelationInput = {
  createdAt?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  role?: InputMaybe<RoleOrderByWithRelationInput>;
  roleId?: InputMaybe<SortOrder>;
  user?: InputMaybe<UserOrderByWithRelationInput>;
  userId?: InputMaybe<SortOrder>;
  workspace?: InputMaybe<WorkspaceOrderByWithRelationInput>;
  workspaceId?: InputMaybe<SortOrder>;
};

export enum MembershipScalarFieldEnum {
  CreatedAt = 'createdAt',
  Id = 'id',
  RoleId = 'roleId',
  UserId = 'userId',
  WorkspaceId = 'workspaceId'
}

export type MembershipScalarWhereInput = {
  AND?: InputMaybe<Array<MembershipScalarWhereInput>>;
  NOT?: InputMaybe<Array<MembershipScalarWhereInput>>;
  OR?: InputMaybe<Array<MembershipScalarWhereInput>>;
  createdAt?: InputMaybe<DateTimeFilter>;
  id?: InputMaybe<StringFilter>;
  roleId?: InputMaybe<StringFilter>;
  userId?: InputMaybe<StringFilter>;
  workspaceId?: InputMaybe<StringFilter>;
};

export type MembershipScalarWhereWithAggregatesInput = {
  AND?: InputMaybe<Array<MembershipScalarWhereWithAggregatesInput>>;
  NOT?: InputMaybe<Array<MembershipScalarWhereWithAggregatesInput>>;
  OR?: InputMaybe<Array<MembershipScalarWhereWithAggregatesInput>>;
  createdAt?: InputMaybe<DateTimeWithAggregatesFilter>;
  id?: InputMaybe<StringWithAggregatesFilter>;
  roleId?: InputMaybe<StringWithAggregatesFilter>;
  userId?: InputMaybe<StringWithAggregatesFilter>;
  workspaceId?: InputMaybe<StringWithAggregatesFilter>;
};

export type MembershipUpdateInput = {
  createdAt?: InputMaybe<Scalars['DateTime']>;
  role?: InputMaybe<RoleUpdateOneRequiredWithoutMembershipsNestedInput>;
  user?: InputMaybe<UserUpdateOneRequiredWithoutMembershipsNestedInput>;
  workspace?: InputMaybe<WorkspaceUpdateOneRequiredWithoutMembershipsNestedInput>;
};

export type MembershipUpdateManyMutationInput = {
  createdAt?: InputMaybe<Scalars['DateTime']>;
};

export type MembershipUpdateManyWithWhereWithoutRoleInput = {
  data: MembershipUpdateManyMutationInput;
  where: MembershipScalarWhereInput;
};

export type MembershipUpdateManyWithWhereWithoutUserInput = {
  data: MembershipUpdateManyMutationInput;
  where: MembershipScalarWhereInput;
};

export type MembershipUpdateManyWithWhereWithoutWorkspaceInput = {
  data: MembershipUpdateManyMutationInput;
  where: MembershipScalarWhereInput;
};

export type MembershipUpdateManyWithoutRoleNestedInput = {
  connect?: InputMaybe<Array<MembershipWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<MembershipCreateOrConnectWithoutRoleInput>>;
  create?: InputMaybe<Array<MembershipCreateWithoutRoleInput>>;
  createMany?: InputMaybe<MembershipCreateManyRoleInputEnvelope>;
  delete?: InputMaybe<Array<MembershipWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<MembershipScalarWhereInput>>;
  disconnect?: InputMaybe<Array<MembershipWhereUniqueInput>>;
  set?: InputMaybe<Array<MembershipWhereUniqueInput>>;
  update?: InputMaybe<Array<MembershipUpdateWithWhereUniqueWithoutRoleInput>>;
  updateMany?: InputMaybe<Array<MembershipUpdateManyWithWhereWithoutRoleInput>>;
  upsert?: InputMaybe<Array<MembershipUpsertWithWhereUniqueWithoutRoleInput>>;
};

export type MembershipUpdateManyWithoutUserNestedInput = {
  connect?: InputMaybe<Array<MembershipWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<MembershipCreateOrConnectWithoutUserInput>>;
  create?: InputMaybe<Array<MembershipCreateWithoutUserInput>>;
  createMany?: InputMaybe<MembershipCreateManyUserInputEnvelope>;
  delete?: InputMaybe<Array<MembershipWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<MembershipScalarWhereInput>>;
  disconnect?: InputMaybe<Array<MembershipWhereUniqueInput>>;
  set?: InputMaybe<Array<MembershipWhereUniqueInput>>;
  update?: InputMaybe<Array<MembershipUpdateWithWhereUniqueWithoutUserInput>>;
  updateMany?: InputMaybe<Array<MembershipUpdateManyWithWhereWithoutUserInput>>;
  upsert?: InputMaybe<Array<MembershipUpsertWithWhereUniqueWithoutUserInput>>;
};

export type MembershipUpdateManyWithoutWorkspaceNestedInput = {
  connect?: InputMaybe<Array<MembershipWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<MembershipCreateOrConnectWithoutWorkspaceInput>>;
  create?: InputMaybe<Array<MembershipCreateWithoutWorkspaceInput>>;
  createMany?: InputMaybe<MembershipCreateManyWorkspaceInputEnvelope>;
  delete?: InputMaybe<Array<MembershipWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<MembershipScalarWhereInput>>;
  disconnect?: InputMaybe<Array<MembershipWhereUniqueInput>>;
  set?: InputMaybe<Array<MembershipWhereUniqueInput>>;
  update?: InputMaybe<Array<MembershipUpdateWithWhereUniqueWithoutWorkspaceInput>>;
  updateMany?: InputMaybe<Array<MembershipUpdateManyWithWhereWithoutWorkspaceInput>>;
  upsert?: InputMaybe<Array<MembershipUpsertWithWhereUniqueWithoutWorkspaceInput>>;
};

export type MembershipUpdateWithWhereUniqueWithoutRoleInput = {
  data: MembershipUpdateWithoutRoleInput;
  where: MembershipWhereUniqueInput;
};

export type MembershipUpdateWithWhereUniqueWithoutUserInput = {
  data: MembershipUpdateWithoutUserInput;
  where: MembershipWhereUniqueInput;
};

export type MembershipUpdateWithWhereUniqueWithoutWorkspaceInput = {
  data: MembershipUpdateWithoutWorkspaceInput;
  where: MembershipWhereUniqueInput;
};

export type MembershipUpdateWithoutRoleInput = {
  createdAt?: InputMaybe<Scalars['DateTime']>;
  user?: InputMaybe<UserUpdateOneRequiredWithoutMembershipsNestedInput>;
  workspace?: InputMaybe<WorkspaceUpdateOneRequiredWithoutMembershipsNestedInput>;
};

export type MembershipUpdateWithoutUserInput = {
  createdAt?: InputMaybe<Scalars['DateTime']>;
  role?: InputMaybe<RoleUpdateOneRequiredWithoutMembershipsNestedInput>;
  workspace?: InputMaybe<WorkspaceUpdateOneRequiredWithoutMembershipsNestedInput>;
};

export type MembershipUpdateWithoutWorkspaceInput = {
  createdAt?: InputMaybe<Scalars['DateTime']>;
  role?: InputMaybe<RoleUpdateOneRequiredWithoutMembershipsNestedInput>;
  user?: InputMaybe<UserUpdateOneRequiredWithoutMembershipsNestedInput>;
};

export type MembershipUpsertWithWhereUniqueWithoutRoleInput = {
  create: MembershipCreateWithoutRoleInput;
  update: MembershipUpdateWithoutRoleInput;
  where: MembershipWhereUniqueInput;
};

export type MembershipUpsertWithWhereUniqueWithoutUserInput = {
  create: MembershipCreateWithoutUserInput;
  update: MembershipUpdateWithoutUserInput;
  where: MembershipWhereUniqueInput;
};

export type MembershipUpsertWithWhereUniqueWithoutWorkspaceInput = {
  create: MembershipCreateWithoutWorkspaceInput;
  update: MembershipUpdateWithoutWorkspaceInput;
  where: MembershipWhereUniqueInput;
};

export type MembershipUserIdWorkspaceIdCompoundUniqueInput = {
  userId: Scalars['String'];
  workspaceId: Scalars['String'];
};

export type MembershipWhereInput = {
  AND?: InputMaybe<Array<MembershipWhereInput>>;
  NOT?: InputMaybe<Array<MembershipWhereInput>>;
  OR?: InputMaybe<Array<MembershipWhereInput>>;
  createdAt?: InputMaybe<DateTimeFilter>;
  id?: InputMaybe<StringFilter>;
  role?: InputMaybe<RoleRelationFilter>;
  roleId?: InputMaybe<StringFilter>;
  user?: InputMaybe<UserRelationFilter>;
  userId?: InputMaybe<StringFilter>;
  workspace?: InputMaybe<WorkspaceRelationFilter>;
  workspaceId?: InputMaybe<StringFilter>;
};

export type MembershipWhereUniqueInput = {
  AND?: InputMaybe<Array<MembershipWhereInput>>;
  NOT?: InputMaybe<Array<MembershipWhereInput>>;
  OR?: InputMaybe<Array<MembershipWhereInput>>;
  createdAt?: InputMaybe<DateTimeFilter>;
  id?: InputMaybe<Scalars['String']>;
  role?: InputMaybe<RoleRelationFilter>;
  roleId?: InputMaybe<StringFilter>;
  user?: InputMaybe<UserRelationFilter>;
  userId?: InputMaybe<StringFilter>;
  userId_workspaceId?: InputMaybe<MembershipUserIdWorkspaceIdCompoundUniqueInput>;
  workspace?: InputMaybe<WorkspaceRelationFilter>;
  workspaceId?: InputMaybe<StringFilter>;
};

export type Mutation = {
  __typename?: 'Mutation';
  cancelBooking: Booking;
  createCustomUser?: Maybe<User>;
  createManyAccessLabel: AffectedRowsOutput;
  createManyAdBoard: AffectedRowsOutput;
  createManyAdBoardGroup: AffectedRowsOutput;
  createManyAudit: AffectedRowsOutput;
  createManyBooking: AffectedRowsOutput;
  createManyBusinessCategory: AffectedRowsOutput;
  createManyCampaign: AffectedRowsOutput;
  createManyChangelog: AffectedRowsOutput;
  createManyFile: AffectedRowsOutput;
  createManyMembership: AffectedRowsOutput;
  createManyOrder: AffectedRowsOutput;
  createManyPayout: AffectedRowsOutput;
  createManyPiSignagePlayer: AffectedRowsOutput;
  createManyPlaylist: AffectedRowsOutput;
  createManyRole: AffectedRowsOutput;
  createManySlot: AffectedRowsOutput;
  createManyTransaction: AffectedRowsOutput;
  createManyUser: AffectedRowsOutput;
  createManyWorkspace: AffectedRowsOutput;
  createOneAccessLabel: AccessLabel;
  createOneAdBoard: AdBoard;
  createOneAdBoardGroup: AdBoardGroup;
  createOneAudit: Audit;
  createOneBooking: Booking;
  createOneBusinessCategory: BusinessCategory;
  createOneCampaign: Campaign;
  createOneChangelog: Changelog;
  createOneFile: File;
  createOneMembership: Membership;
  createOneOrder: Order;
  createOnePayout: Payout;
  createOnePiSignagePlayer: PiSignagePlayer;
  createOnePlaylist: Playlist;
  createOneRole: Role;
  createOneSlot: Slot;
  createOneTransaction: Transaction;
  createOneUser: User;
  createOneWorkspace: Workspace;
  deleteManyAccessLabel: AffectedRowsOutput;
  deleteManyAdBoard: AffectedRowsOutput;
  deleteManyAdBoardGroup: AffectedRowsOutput;
  deleteManyAudit: AffectedRowsOutput;
  deleteManyBooking: AffectedRowsOutput;
  deleteManyBusinessCategory: AffectedRowsOutput;
  deleteManyCampaign: AffectedRowsOutput;
  deleteManyChangelog: AffectedRowsOutput;
  deleteManyFile: AffectedRowsOutput;
  deleteManyMembership: AffectedRowsOutput;
  deleteManyOrder: AffectedRowsOutput;
  deleteManyPayout: AffectedRowsOutput;
  deleteManyPiSignagePlayer: AffectedRowsOutput;
  deleteManyPlaylist: AffectedRowsOutput;
  deleteManyRole: AffectedRowsOutput;
  deleteManySlot: AffectedRowsOutput;
  deleteManyTransaction: AffectedRowsOutput;
  deleteManyUser: AffectedRowsOutput;
  deleteManyWorkspace: AffectedRowsOutput;
  deleteOneAccessLabel?: Maybe<AccessLabel>;
  deleteOneAdBoard?: Maybe<AdBoard>;
  deleteOneAdBoardGroup?: Maybe<AdBoardGroup>;
  deleteOneAudit?: Maybe<Audit>;
  deleteOneBooking?: Maybe<Booking>;
  deleteOneBusinessCategory?: Maybe<BusinessCategory>;
  deleteOneCampaign?: Maybe<Campaign>;
  deleteOneChangelog?: Maybe<Changelog>;
  deleteOneFile?: Maybe<File>;
  deleteOneMembership?: Maybe<Membership>;
  deleteOneOrder?: Maybe<Order>;
  deleteOnePayout?: Maybe<Payout>;
  deleteOnePiSignagePlayer?: Maybe<PiSignagePlayer>;
  deleteOnePlaylist?: Maybe<Playlist>;
  deleteOneRole?: Maybe<Role>;
  deleteOneSlot?: Maybe<Slot>;
  deleteOneTransaction?: Maybe<Transaction>;
  deleteOneUser?: Maybe<User>;
  deleteOneWorkspace?: Maybe<Workspace>;
  deleteUserCustom?: Maybe<GenericResponse>;
  prepareBooking: Booking;
  sendMail?: Maybe<EmailOutput>;
  updateBookingAsset: Scalars['Boolean'];
  updateManyAccessLabel: AffectedRowsOutput;
  updateManyAdBoard: AffectedRowsOutput;
  updateManyAdBoardGroup: AffectedRowsOutput;
  updateManyAudit: AffectedRowsOutput;
  updateManyBooking: AffectedRowsOutput;
  updateManyBusinessCategory: AffectedRowsOutput;
  updateManyCampaign: AffectedRowsOutput;
  updateManyChangelog: AffectedRowsOutput;
  updateManyFile: AffectedRowsOutput;
  updateManyMembership: AffectedRowsOutput;
  updateManyOrder: AffectedRowsOutput;
  updateManyPayout: AffectedRowsOutput;
  updateManyPiSignagePlayer: AffectedRowsOutput;
  updateManyPlaylist: AffectedRowsOutput;
  updateManyRole: AffectedRowsOutput;
  updateManySlot: AffectedRowsOutput;
  updateManyTransaction: AffectedRowsOutput;
  updateManyUser: AffectedRowsOutput;
  updateManyWorkspace: AffectedRowsOutput;
  updateOneAccessLabel?: Maybe<AccessLabel>;
  updateOneAdBoard?: Maybe<AdBoard>;
  updateOneAdBoardGroup?: Maybe<AdBoardGroup>;
  updateOneAudit?: Maybe<Audit>;
  updateOneBooking?: Maybe<Booking>;
  updateOneBusinessCategory?: Maybe<BusinessCategory>;
  updateOneCampaign?: Maybe<Campaign>;
  updateOneChangelog?: Maybe<Changelog>;
  updateOneFile?: Maybe<File>;
  updateOneMembership?: Maybe<Membership>;
  updateOneOrder?: Maybe<Order>;
  updateOnePayout?: Maybe<Payout>;
  updateOnePiSignagePlayer?: Maybe<PiSignagePlayer>;
  updateOnePlaylist?: Maybe<Playlist>;
  updateOneRole?: Maybe<Role>;
  updateOneSlot?: Maybe<Slot>;
  updateOneTransaction?: Maybe<Transaction>;
  updateOneUser?: Maybe<User>;
  updateOneWorkspace?: Maybe<Workspace>;
  updateUser?: Maybe<User>;
  upsertOneAccessLabel: AccessLabel;
  upsertOneAdBoard: AdBoard;
  upsertOneAdBoardGroup: AdBoardGroup;
  upsertOneAudit: Audit;
  upsertOneBooking: Booking;
  upsertOneBusinessCategory: BusinessCategory;
  upsertOneCampaign: Campaign;
  upsertOneChangelog: Changelog;
  upsertOneFile: File;
  upsertOneMembership: Membership;
  upsertOneOrder: Order;
  upsertOnePayout: Payout;
  upsertOnePiSignagePlayer: PiSignagePlayer;
  upsertOnePlaylist: Playlist;
  upsertOneRole: Role;
  upsertOneSlot: Slot;
  upsertOneTransaction: Transaction;
  upsertOneUser: User;
  upsertOneWorkspace: Workspace;
};


export type MutationCancelBookingArgs = {
  where: BookingWhereUniqueInput;
};


export type MutationCreateCustomUserArgs = {
  user: UserInput;
};


export type MutationCreateManyAccessLabelArgs = {
  data: Array<AccessLabelCreateManyInput>;
};


export type MutationCreateManyAdBoardArgs = {
  data: Array<AdBoardCreateManyInput>;
};


export type MutationCreateManyAdBoardGroupArgs = {
  data: Array<AdBoardGroupCreateManyInput>;
};


export type MutationCreateManyAuditArgs = {
  data: Array<AuditCreateManyInput>;
};


export type MutationCreateManyBookingArgs = {
  data: Array<BookingCreateManyInput>;
};


export type MutationCreateManyBusinessCategoryArgs = {
  data: Array<BusinessCategoryCreateManyInput>;
};


export type MutationCreateManyCampaignArgs = {
  data: Array<CampaignCreateManyInput>;
};


export type MutationCreateManyChangelogArgs = {
  data: Array<ChangelogCreateManyInput>;
};


export type MutationCreateManyFileArgs = {
  data: Array<FileCreateManyInput>;
};


export type MutationCreateManyMembershipArgs = {
  data: Array<MembershipCreateManyInput>;
};


export type MutationCreateManyOrderArgs = {
  data: Array<OrderCreateManyInput>;
};


export type MutationCreateManyPayoutArgs = {
  data: Array<PayoutCreateManyInput>;
};


export type MutationCreateManyPiSignagePlayerArgs = {
  data: Array<PiSignagePlayerCreateManyInput>;
};


export type MutationCreateManyPlaylistArgs = {
  data: Array<PlaylistCreateManyInput>;
};


export type MutationCreateManyRoleArgs = {
  data: Array<RoleCreateManyInput>;
};


export type MutationCreateManySlotArgs = {
  data: Array<SlotCreateManyInput>;
};


export type MutationCreateManyTransactionArgs = {
  data: Array<TransactionCreateManyInput>;
};


export type MutationCreateManyUserArgs = {
  data: Array<UserCreateManyInput>;
};


export type MutationCreateManyWorkspaceArgs = {
  data: Array<WorkspaceCreateManyInput>;
};


export type MutationCreateOneAccessLabelArgs = {
  data: AccessLabelCreateInput;
};


export type MutationCreateOneAdBoardArgs = {
  data: AdBoardCreateInput;
};


export type MutationCreateOneAdBoardGroupArgs = {
  data: AdBoardGroupCreateInput;
};


export type MutationCreateOneAuditArgs = {
  data: AuditCreateInput;
};


export type MutationCreateOneBookingArgs = {
  data: BookingCreateInput;
};


export type MutationCreateOneBusinessCategoryArgs = {
  data: BusinessCategoryCreateInput;
};


export type MutationCreateOneCampaignArgs = {
  data: CampaignCreateInput;
};


export type MutationCreateOneChangelogArgs = {
  data: ChangelogCreateInput;
};


export type MutationCreateOneFileArgs = {
  data: FileCreateInput;
};


export type MutationCreateOneMembershipArgs = {
  data: MembershipCreateInput;
};


export type MutationCreateOneOrderArgs = {
  data: OrderCreateInput;
};


export type MutationCreateOnePayoutArgs = {
  data: PayoutCreateInput;
};


export type MutationCreateOnePiSignagePlayerArgs = {
  data: PiSignagePlayerCreateInput;
};


export type MutationCreateOnePlaylistArgs = {
  data: PlaylistCreateInput;
};


export type MutationCreateOneRoleArgs = {
  data: RoleCreateInput;
};


export type MutationCreateOneSlotArgs = {
  data: SlotCreateInput;
};


export type MutationCreateOneTransactionArgs = {
  data: TransactionCreateInput;
};


export type MutationCreateOneUserArgs = {
  data: UserCreateInput;
};


export type MutationCreateOneWorkspaceArgs = {
  data: WorkspaceCreateInput;
};


export type MutationDeleteManyAccessLabelArgs = {
  where?: InputMaybe<AccessLabelWhereInput>;
};


export type MutationDeleteManyAdBoardArgs = {
  where?: InputMaybe<AdBoardWhereInput>;
};


export type MutationDeleteManyAdBoardGroupArgs = {
  where?: InputMaybe<AdBoardGroupWhereInput>;
};


export type MutationDeleteManyAuditArgs = {
  where?: InputMaybe<AuditWhereInput>;
};


export type MutationDeleteManyBookingArgs = {
  where?: InputMaybe<BookingWhereInput>;
};


export type MutationDeleteManyBusinessCategoryArgs = {
  where?: InputMaybe<BusinessCategoryWhereInput>;
};


export type MutationDeleteManyCampaignArgs = {
  where?: InputMaybe<CampaignWhereInput>;
};


export type MutationDeleteManyChangelogArgs = {
  where?: InputMaybe<ChangelogWhereInput>;
};


export type MutationDeleteManyFileArgs = {
  where?: InputMaybe<FileWhereInput>;
};


export type MutationDeleteManyMembershipArgs = {
  where?: InputMaybe<MembershipWhereInput>;
};


export type MutationDeleteManyOrderArgs = {
  where?: InputMaybe<OrderWhereInput>;
};


export type MutationDeleteManyPayoutArgs = {
  where?: InputMaybe<PayoutWhereInput>;
};


export type MutationDeleteManyPiSignagePlayerArgs = {
  where?: InputMaybe<PiSignagePlayerWhereInput>;
};


export type MutationDeleteManyPlaylistArgs = {
  where?: InputMaybe<PlaylistWhereInput>;
};


export type MutationDeleteManyRoleArgs = {
  where?: InputMaybe<RoleWhereInput>;
};


export type MutationDeleteManySlotArgs = {
  where?: InputMaybe<SlotWhereInput>;
};


export type MutationDeleteManyTransactionArgs = {
  where?: InputMaybe<TransactionWhereInput>;
};


export type MutationDeleteManyUserArgs = {
  where?: InputMaybe<UserWhereInput>;
};


export type MutationDeleteManyWorkspaceArgs = {
  where?: InputMaybe<WorkspaceWhereInput>;
};


export type MutationDeleteOneAccessLabelArgs = {
  where: AccessLabelWhereUniqueInput;
};


export type MutationDeleteOneAdBoardArgs = {
  where: AdBoardWhereUniqueInput;
};


export type MutationDeleteOneAdBoardGroupArgs = {
  where: AdBoardGroupWhereUniqueInput;
};


export type MutationDeleteOneAuditArgs = {
  where: AuditWhereUniqueInput;
};


export type MutationDeleteOneBookingArgs = {
  where: BookingWhereUniqueInput;
};


export type MutationDeleteOneBusinessCategoryArgs = {
  where: BusinessCategoryWhereUniqueInput;
};


export type MutationDeleteOneCampaignArgs = {
  where: CampaignWhereUniqueInput;
};


export type MutationDeleteOneChangelogArgs = {
  where: ChangelogWhereUniqueInput;
};


export type MutationDeleteOneFileArgs = {
  where: FileWhereUniqueInput;
};


export type MutationDeleteOneMembershipArgs = {
  where: MembershipWhereUniqueInput;
};


export type MutationDeleteOneOrderArgs = {
  where: OrderWhereUniqueInput;
};


export type MutationDeleteOnePayoutArgs = {
  where: PayoutWhereUniqueInput;
};


export type MutationDeleteOnePiSignagePlayerArgs = {
  where: PiSignagePlayerWhereUniqueInput;
};


export type MutationDeleteOnePlaylistArgs = {
  where: PlaylistWhereUniqueInput;
};


export type MutationDeleteOneRoleArgs = {
  where: RoleWhereUniqueInput;
};


export type MutationDeleteOneSlotArgs = {
  where: SlotWhereUniqueInput;
};


export type MutationDeleteOneTransactionArgs = {
  where: TransactionWhereUniqueInput;
};


export type MutationDeleteOneUserArgs = {
  where: UserWhereUniqueInput;
};


export type MutationDeleteOneWorkspaceArgs = {
  where: WorkspaceWhereUniqueInput;
};


export type MutationDeleteUserCustomArgs = {
  email: Scalars['String'];
};


export type MutationPrepareBookingArgs = {
  bookingRequest: BookingRequest;
};


export type MutationSendMailArgs = {
  bookingId: Scalars['String'];
  templateId: TemplateIds;
  to: Array<Scalars['String']>;
};


export type MutationUpdateBookingAssetArgs = {
  assetId: Scalars['String'];
  where: BookingWhereUniqueInput;
};


export type MutationUpdateManyAccessLabelArgs = {
  data: AccessLabelUpdateManyMutationInput;
  where?: InputMaybe<AccessLabelWhereInput>;
};


export type MutationUpdateManyAdBoardArgs = {
  data: AdBoardUpdateManyMutationInput;
  where?: InputMaybe<AdBoardWhereInput>;
};


export type MutationUpdateManyAdBoardGroupArgs = {
  data: AdBoardGroupUpdateManyMutationInput;
  where?: InputMaybe<AdBoardGroupWhereInput>;
};


export type MutationUpdateManyAuditArgs = {
  data: AuditUpdateManyMutationInput;
  where?: InputMaybe<AuditWhereInput>;
};


export type MutationUpdateManyBookingArgs = {
  data: BookingUpdateManyMutationInput;
  where?: InputMaybe<BookingWhereInput>;
};


export type MutationUpdateManyBusinessCategoryArgs = {
  data: BusinessCategoryUpdateManyMutationInput;
  where?: InputMaybe<BusinessCategoryWhereInput>;
};


export type MutationUpdateManyCampaignArgs = {
  data: CampaignUpdateManyMutationInput;
  where?: InputMaybe<CampaignWhereInput>;
};


export type MutationUpdateManyChangelogArgs = {
  data: ChangelogUpdateManyMutationInput;
  where?: InputMaybe<ChangelogWhereInput>;
};


export type MutationUpdateManyFileArgs = {
  data: FileUpdateManyMutationInput;
  where?: InputMaybe<FileWhereInput>;
};


export type MutationUpdateManyMembershipArgs = {
  data: MembershipUpdateManyMutationInput;
  where?: InputMaybe<MembershipWhereInput>;
};


export type MutationUpdateManyOrderArgs = {
  data: OrderUpdateManyMutationInput;
  where?: InputMaybe<OrderWhereInput>;
};


export type MutationUpdateManyPayoutArgs = {
  data: PayoutUpdateManyMutationInput;
  where?: InputMaybe<PayoutWhereInput>;
};


export type MutationUpdateManyPiSignagePlayerArgs = {
  data: PiSignagePlayerUpdateManyMutationInput;
  where?: InputMaybe<PiSignagePlayerWhereInput>;
};


export type MutationUpdateManyPlaylistArgs = {
  data: PlaylistUpdateManyMutationInput;
  where?: InputMaybe<PlaylistWhereInput>;
};


export type MutationUpdateManyRoleArgs = {
  data: RoleUpdateManyMutationInput;
  where?: InputMaybe<RoleWhereInput>;
};


export type MutationUpdateManySlotArgs = {
  data: SlotUpdateManyMutationInput;
  where?: InputMaybe<SlotWhereInput>;
};


export type MutationUpdateManyTransactionArgs = {
  data: TransactionUpdateManyMutationInput;
  where?: InputMaybe<TransactionWhereInput>;
};


export type MutationUpdateManyUserArgs = {
  data: UserUpdateManyMutationInput;
  where?: InputMaybe<UserWhereInput>;
};


export type MutationUpdateManyWorkspaceArgs = {
  data: WorkspaceUpdateManyMutationInput;
  where?: InputMaybe<WorkspaceWhereInput>;
};


export type MutationUpdateOneAccessLabelArgs = {
  data: AccessLabelUpdateInput;
  where: AccessLabelWhereUniqueInput;
};


export type MutationUpdateOneAdBoardArgs = {
  data: AdBoardUpdateInput;
  where: AdBoardWhereUniqueInput;
};


export type MutationUpdateOneAdBoardGroupArgs = {
  data: AdBoardGroupUpdateInput;
  where: AdBoardGroupWhereUniqueInput;
};


export type MutationUpdateOneAuditArgs = {
  data: AuditUpdateInput;
  where: AuditWhereUniqueInput;
};


export type MutationUpdateOneBookingArgs = {
  data: BookingUpdateInput;
  where: BookingWhereUniqueInput;
};


export type MutationUpdateOneBusinessCategoryArgs = {
  data: BusinessCategoryUpdateInput;
  where: BusinessCategoryWhereUniqueInput;
};


export type MutationUpdateOneCampaignArgs = {
  data: CampaignUpdateInput;
  where: CampaignWhereUniqueInput;
};


export type MutationUpdateOneChangelogArgs = {
  data: ChangelogUpdateInput;
  where: ChangelogWhereUniqueInput;
};


export type MutationUpdateOneFileArgs = {
  data: FileUpdateInput;
  where: FileWhereUniqueInput;
};


export type MutationUpdateOneMembershipArgs = {
  data: MembershipUpdateInput;
  where: MembershipWhereUniqueInput;
};


export type MutationUpdateOneOrderArgs = {
  data: OrderUpdateInput;
  where: OrderWhereUniqueInput;
};


export type MutationUpdateOnePayoutArgs = {
  data: PayoutUpdateInput;
  where: PayoutWhereUniqueInput;
};


export type MutationUpdateOnePiSignagePlayerArgs = {
  data: PiSignagePlayerUpdateInput;
  where: PiSignagePlayerWhereUniqueInput;
};


export type MutationUpdateOnePlaylistArgs = {
  data: PlaylistUpdateInput;
  where: PlaylistWhereUniqueInput;
};


export type MutationUpdateOneRoleArgs = {
  data: RoleUpdateInput;
  where: RoleWhereUniqueInput;
};


export type MutationUpdateOneSlotArgs = {
  data: SlotUpdateInput;
  where: SlotWhereUniqueInput;
};


export type MutationUpdateOneTransactionArgs = {
  data: TransactionUpdateInput;
  where: TransactionWhereUniqueInput;
};


export type MutationUpdateOneUserArgs = {
  data: UserUpdateInput;
  where: UserWhereUniqueInput;
};


export type MutationUpdateOneWorkspaceArgs = {
  data: WorkspaceUpdateInput;
  where: WorkspaceWhereUniqueInput;
};


export type MutationUpdateUserArgs = {
  accountDetails: AccountDetails;
};


export type MutationUpsertOneAccessLabelArgs = {
  create: AccessLabelCreateInput;
  update: AccessLabelUpdateInput;
  where: AccessLabelWhereUniqueInput;
};


export type MutationUpsertOneAdBoardArgs = {
  create: AdBoardCreateInput;
  update: AdBoardUpdateInput;
  where: AdBoardWhereUniqueInput;
};


export type MutationUpsertOneAdBoardGroupArgs = {
  create: AdBoardGroupCreateInput;
  update: AdBoardGroupUpdateInput;
  where: AdBoardGroupWhereUniqueInput;
};


export type MutationUpsertOneAuditArgs = {
  create: AuditCreateInput;
  update: AuditUpdateInput;
  where: AuditWhereUniqueInput;
};


export type MutationUpsertOneBookingArgs = {
  create: BookingCreateInput;
  update: BookingUpdateInput;
  where: BookingWhereUniqueInput;
};


export type MutationUpsertOneBusinessCategoryArgs = {
  create: BusinessCategoryCreateInput;
  update: BusinessCategoryUpdateInput;
  where: BusinessCategoryWhereUniqueInput;
};


export type MutationUpsertOneCampaignArgs = {
  create: CampaignCreateInput;
  update: CampaignUpdateInput;
  where: CampaignWhereUniqueInput;
};


export type MutationUpsertOneChangelogArgs = {
  create: ChangelogCreateInput;
  update: ChangelogUpdateInput;
  where: ChangelogWhereUniqueInput;
};


export type MutationUpsertOneFileArgs = {
  create: FileCreateInput;
  update: FileUpdateInput;
  where: FileWhereUniqueInput;
};


export type MutationUpsertOneMembershipArgs = {
  create: MembershipCreateInput;
  update: MembershipUpdateInput;
  where: MembershipWhereUniqueInput;
};


export type MutationUpsertOneOrderArgs = {
  create: OrderCreateInput;
  update: OrderUpdateInput;
  where: OrderWhereUniqueInput;
};


export type MutationUpsertOnePayoutArgs = {
  create: PayoutCreateInput;
  update: PayoutUpdateInput;
  where: PayoutWhereUniqueInput;
};


export type MutationUpsertOnePiSignagePlayerArgs = {
  create: PiSignagePlayerCreateInput;
  update: PiSignagePlayerUpdateInput;
  where: PiSignagePlayerWhereUniqueInput;
};


export type MutationUpsertOnePlaylistArgs = {
  create: PlaylistCreateInput;
  update: PlaylistUpdateInput;
  where: PlaylistWhereUniqueInput;
};


export type MutationUpsertOneRoleArgs = {
  create: RoleCreateInput;
  update: RoleUpdateInput;
  where: RoleWhereUniqueInput;
};


export type MutationUpsertOneSlotArgs = {
  create: SlotCreateInput;
  update: SlotUpdateInput;
  where: SlotWhereUniqueInput;
};


export type MutationUpsertOneTransactionArgs = {
  create: TransactionCreateInput;
  update: TransactionUpdateInput;
  where: TransactionWhereUniqueInput;
};


export type MutationUpsertOneUserArgs = {
  create: UserCreateInput;
  update: UserUpdateInput;
  where: UserWhereUniqueInput;
};


export type MutationUpsertOneWorkspaceArgs = {
  create: WorkspaceCreateInput;
  update: WorkspaceUpdateInput;
  where: WorkspaceWhereUniqueInput;
};

export type NestedBoolFilter = {
  equals?: InputMaybe<Scalars['Boolean']>;
  not?: InputMaybe<NestedBoolFilter>;
};

export type NestedBoolNullableFilter = {
  equals?: InputMaybe<Scalars['Boolean']>;
  isSet?: InputMaybe<Scalars['Boolean']>;
  not?: InputMaybe<NestedBoolNullableFilter>;
};

export type NestedBoolNullableWithAggregatesFilter = {
  _count?: InputMaybe<NestedIntNullableFilter>;
  _max?: InputMaybe<NestedBoolNullableFilter>;
  _min?: InputMaybe<NestedBoolNullableFilter>;
  equals?: InputMaybe<Scalars['Boolean']>;
  isSet?: InputMaybe<Scalars['Boolean']>;
  not?: InputMaybe<NestedBoolNullableWithAggregatesFilter>;
};

export type NestedBoolWithAggregatesFilter = {
  _count?: InputMaybe<NestedIntFilter>;
  _max?: InputMaybe<NestedBoolFilter>;
  _min?: InputMaybe<NestedBoolFilter>;
  equals?: InputMaybe<Scalars['Boolean']>;
  not?: InputMaybe<NestedBoolWithAggregatesFilter>;
};

export type NestedDateTimeFilter = {
  equals?: InputMaybe<Scalars['DateTime']>;
  gt?: InputMaybe<Scalars['DateTime']>;
  gte?: InputMaybe<Scalars['DateTime']>;
  in?: InputMaybe<Array<Scalars['DateTime']>>;
  lt?: InputMaybe<Scalars['DateTime']>;
  lte?: InputMaybe<Scalars['DateTime']>;
  not?: InputMaybe<NestedDateTimeFilter>;
  notIn?: InputMaybe<Array<Scalars['DateTime']>>;
};

export type NestedDateTimeNullableFilter = {
  equals?: InputMaybe<Scalars['DateTime']>;
  gt?: InputMaybe<Scalars['DateTime']>;
  gte?: InputMaybe<Scalars['DateTime']>;
  in?: InputMaybe<Array<Scalars['DateTime']>>;
  isSet?: InputMaybe<Scalars['Boolean']>;
  lt?: InputMaybe<Scalars['DateTime']>;
  lte?: InputMaybe<Scalars['DateTime']>;
  not?: InputMaybe<NestedDateTimeNullableFilter>;
  notIn?: InputMaybe<Array<Scalars['DateTime']>>;
};

export type NestedDateTimeNullableWithAggregatesFilter = {
  _count?: InputMaybe<NestedIntNullableFilter>;
  _max?: InputMaybe<NestedDateTimeNullableFilter>;
  _min?: InputMaybe<NestedDateTimeNullableFilter>;
  equals?: InputMaybe<Scalars['DateTime']>;
  gt?: InputMaybe<Scalars['DateTime']>;
  gte?: InputMaybe<Scalars['DateTime']>;
  in?: InputMaybe<Array<Scalars['DateTime']>>;
  isSet?: InputMaybe<Scalars['Boolean']>;
  lt?: InputMaybe<Scalars['DateTime']>;
  lte?: InputMaybe<Scalars['DateTime']>;
  not?: InputMaybe<NestedDateTimeNullableWithAggregatesFilter>;
  notIn?: InputMaybe<Array<Scalars['DateTime']>>;
};

export type NestedDateTimeWithAggregatesFilter = {
  _count?: InputMaybe<NestedIntFilter>;
  _max?: InputMaybe<NestedDateTimeFilter>;
  _min?: InputMaybe<NestedDateTimeFilter>;
  equals?: InputMaybe<Scalars['DateTime']>;
  gt?: InputMaybe<Scalars['DateTime']>;
  gte?: InputMaybe<Scalars['DateTime']>;
  in?: InputMaybe<Array<Scalars['DateTime']>>;
  lt?: InputMaybe<Scalars['DateTime']>;
  lte?: InputMaybe<Scalars['DateTime']>;
  not?: InputMaybe<NestedDateTimeWithAggregatesFilter>;
  notIn?: InputMaybe<Array<Scalars['DateTime']>>;
};

export type NestedEnumAdBoardStatusFilter = {
  equals?: InputMaybe<AdBoardStatus>;
  in?: InputMaybe<Array<AdBoardStatus>>;
  not?: InputMaybe<NestedEnumAdBoardStatusFilter>;
  notIn?: InputMaybe<Array<AdBoardStatus>>;
};

export type NestedEnumAdBoardStatusWithAggregatesFilter = {
  _count?: InputMaybe<NestedIntFilter>;
  _max?: InputMaybe<NestedEnumAdBoardStatusFilter>;
  _min?: InputMaybe<NestedEnumAdBoardStatusFilter>;
  equals?: InputMaybe<AdBoardStatus>;
  in?: InputMaybe<Array<AdBoardStatus>>;
  not?: InputMaybe<NestedEnumAdBoardStatusWithAggregatesFilter>;
  notIn?: InputMaybe<Array<AdBoardStatus>>;
};

export type NestedEnumBookingStatusFilter = {
  equals?: InputMaybe<BookingStatus>;
  in?: InputMaybe<Array<BookingStatus>>;
  not?: InputMaybe<NestedEnumBookingStatusFilter>;
  notIn?: InputMaybe<Array<BookingStatus>>;
};

export type NestedEnumBookingStatusWithAggregatesFilter = {
  _count?: InputMaybe<NestedIntFilter>;
  _max?: InputMaybe<NestedEnumBookingStatusFilter>;
  _min?: InputMaybe<NestedEnumBookingStatusFilter>;
  equals?: InputMaybe<BookingStatus>;
  in?: InputMaybe<Array<BookingStatus>>;
  not?: InputMaybe<NestedEnumBookingStatusWithAggregatesFilter>;
  notIn?: InputMaybe<Array<BookingStatus>>;
};

export type NestedEnumFileStatusNullableFilter = {
  equals?: InputMaybe<FileStatus>;
  in?: InputMaybe<Array<FileStatus>>;
  isSet?: InputMaybe<Scalars['Boolean']>;
  not?: InputMaybe<NestedEnumFileStatusNullableFilter>;
  notIn?: InputMaybe<Array<FileStatus>>;
};

export type NestedEnumFileStatusNullableWithAggregatesFilter = {
  _count?: InputMaybe<NestedIntNullableFilter>;
  _max?: InputMaybe<NestedEnumFileStatusNullableFilter>;
  _min?: InputMaybe<NestedEnumFileStatusNullableFilter>;
  equals?: InputMaybe<FileStatus>;
  in?: InputMaybe<Array<FileStatus>>;
  isSet?: InputMaybe<Scalars['Boolean']>;
  not?: InputMaybe<NestedEnumFileStatusNullableWithAggregatesFilter>;
  notIn?: InputMaybe<Array<FileStatus>>;
};

export type NestedEnumMeasurementUnitFilter = {
  equals?: InputMaybe<MeasurementUnit>;
  in?: InputMaybe<Array<MeasurementUnit>>;
  not?: InputMaybe<NestedEnumMeasurementUnitFilter>;
  notIn?: InputMaybe<Array<MeasurementUnit>>;
};

export type NestedEnumPaymentGatewayNameFilter = {
  equals?: InputMaybe<PaymentGatewayName>;
  in?: InputMaybe<Array<PaymentGatewayName>>;
  not?: InputMaybe<NestedEnumPaymentGatewayNameFilter>;
  notIn?: InputMaybe<Array<PaymentGatewayName>>;
};

export type NestedEnumPaymentStatusFilter = {
  equals?: InputMaybe<PaymentStatus>;
  in?: InputMaybe<Array<PaymentStatus>>;
  not?: InputMaybe<NestedEnumPaymentStatusFilter>;
  notIn?: InputMaybe<Array<PaymentStatus>>;
};

export type NestedEnumPaymentStatusWithAggregatesFilter = {
  _count?: InputMaybe<NestedIntFilter>;
  _max?: InputMaybe<NestedEnumPaymentStatusFilter>;
  _min?: InputMaybe<NestedEnumPaymentStatusFilter>;
  equals?: InputMaybe<PaymentStatus>;
  in?: InputMaybe<Array<PaymentStatus>>;
  not?: InputMaybe<NestedEnumPaymentStatusWithAggregatesFilter>;
  notIn?: InputMaybe<Array<PaymentStatus>>;
};

export type NestedEnumPayoutStatusFilter = {
  equals?: InputMaybe<PayoutStatus>;
  in?: InputMaybe<Array<PayoutStatus>>;
  not?: InputMaybe<NestedEnumPayoutStatusFilter>;
  notIn?: InputMaybe<Array<PayoutStatus>>;
};

export type NestedEnumPayoutStatusWithAggregatesFilter = {
  _count?: InputMaybe<NestedIntFilter>;
  _max?: InputMaybe<NestedEnumPayoutStatusFilter>;
  _min?: InputMaybe<NestedEnumPayoutStatusFilter>;
  equals?: InputMaybe<PayoutStatus>;
  in?: InputMaybe<Array<PayoutStatus>>;
  not?: InputMaybe<NestedEnumPayoutStatusWithAggregatesFilter>;
  notIn?: InputMaybe<Array<PayoutStatus>>;
};

export type NestedEnumTransactionStatusFilter = {
  equals?: InputMaybe<TransactionStatus>;
  in?: InputMaybe<Array<TransactionStatus>>;
  not?: InputMaybe<NestedEnumTransactionStatusFilter>;
  notIn?: InputMaybe<Array<TransactionStatus>>;
};

export type NestedEnumTransactionStatusWithAggregatesFilter = {
  _count?: InputMaybe<NestedIntFilter>;
  _max?: InputMaybe<NestedEnumTransactionStatusFilter>;
  _min?: InputMaybe<NestedEnumTransactionStatusFilter>;
  equals?: InputMaybe<TransactionStatus>;
  in?: InputMaybe<Array<TransactionStatus>>;
  not?: InputMaybe<NestedEnumTransactionStatusWithAggregatesFilter>;
  notIn?: InputMaybe<Array<TransactionStatus>>;
};

export type NestedFloatFilter = {
  equals?: InputMaybe<Scalars['Float']>;
  gt?: InputMaybe<Scalars['Float']>;
  gte?: InputMaybe<Scalars['Float']>;
  in?: InputMaybe<Array<Scalars['Float']>>;
  lt?: InputMaybe<Scalars['Float']>;
  lte?: InputMaybe<Scalars['Float']>;
  not?: InputMaybe<NestedFloatFilter>;
  notIn?: InputMaybe<Array<Scalars['Float']>>;
};

export type NestedFloatNullableFilter = {
  equals?: InputMaybe<Scalars['Float']>;
  gt?: InputMaybe<Scalars['Float']>;
  gte?: InputMaybe<Scalars['Float']>;
  in?: InputMaybe<Array<Scalars['Float']>>;
  isSet?: InputMaybe<Scalars['Boolean']>;
  lt?: InputMaybe<Scalars['Float']>;
  lte?: InputMaybe<Scalars['Float']>;
  not?: InputMaybe<NestedFloatNullableFilter>;
  notIn?: InputMaybe<Array<Scalars['Float']>>;
};

export type NestedFloatWithAggregatesFilter = {
  _avg?: InputMaybe<NestedFloatFilter>;
  _count?: InputMaybe<NestedIntFilter>;
  _max?: InputMaybe<NestedFloatFilter>;
  _min?: InputMaybe<NestedFloatFilter>;
  _sum?: InputMaybe<NestedFloatFilter>;
  equals?: InputMaybe<Scalars['Float']>;
  gt?: InputMaybe<Scalars['Float']>;
  gte?: InputMaybe<Scalars['Float']>;
  in?: InputMaybe<Array<Scalars['Float']>>;
  lt?: InputMaybe<Scalars['Float']>;
  lte?: InputMaybe<Scalars['Float']>;
  not?: InputMaybe<NestedFloatWithAggregatesFilter>;
  notIn?: InputMaybe<Array<Scalars['Float']>>;
};

export type NestedIntFilter = {
  equals?: InputMaybe<Scalars['Int']>;
  gt?: InputMaybe<Scalars['Int']>;
  gte?: InputMaybe<Scalars['Int']>;
  in?: InputMaybe<Array<Scalars['Int']>>;
  lt?: InputMaybe<Scalars['Int']>;
  lte?: InputMaybe<Scalars['Int']>;
  not?: InputMaybe<NestedIntFilter>;
  notIn?: InputMaybe<Array<Scalars['Int']>>;
};

export type NestedIntNullableFilter = {
  equals?: InputMaybe<Scalars['Int']>;
  gt?: InputMaybe<Scalars['Int']>;
  gte?: InputMaybe<Scalars['Int']>;
  in?: InputMaybe<Array<Scalars['Int']>>;
  isSet?: InputMaybe<Scalars['Boolean']>;
  lt?: InputMaybe<Scalars['Int']>;
  lte?: InputMaybe<Scalars['Int']>;
  not?: InputMaybe<NestedIntNullableFilter>;
  notIn?: InputMaybe<Array<Scalars['Int']>>;
};

export type NestedIntWithAggregatesFilter = {
  _avg?: InputMaybe<NestedFloatFilter>;
  _count?: InputMaybe<NestedIntFilter>;
  _max?: InputMaybe<NestedIntFilter>;
  _min?: InputMaybe<NestedIntFilter>;
  _sum?: InputMaybe<NestedIntFilter>;
  equals?: InputMaybe<Scalars['Int']>;
  gt?: InputMaybe<Scalars['Int']>;
  gte?: InputMaybe<Scalars['Int']>;
  in?: InputMaybe<Array<Scalars['Int']>>;
  lt?: InputMaybe<Scalars['Int']>;
  lte?: InputMaybe<Scalars['Int']>;
  not?: InputMaybe<NestedIntWithAggregatesFilter>;
  notIn?: InputMaybe<Array<Scalars['Int']>>;
};

export type NestedJsonNullableFilter = {
  equals?: InputMaybe<Scalars['JSON']>;
  isSet?: InputMaybe<Scalars['Boolean']>;
  not?: InputMaybe<Scalars['JSON']>;
};

export type NestedStringFilter = {
  contains?: InputMaybe<Scalars['String']>;
  endsWith?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  gt?: InputMaybe<Scalars['String']>;
  gte?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<Scalars['String']>>;
  lt?: InputMaybe<Scalars['String']>;
  lte?: InputMaybe<Scalars['String']>;
  not?: InputMaybe<NestedStringFilter>;
  notIn?: InputMaybe<Array<Scalars['String']>>;
  startsWith?: InputMaybe<Scalars['String']>;
};

export type NestedStringNullableFilter = {
  contains?: InputMaybe<Scalars['String']>;
  endsWith?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  gt?: InputMaybe<Scalars['String']>;
  gte?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<Scalars['String']>>;
  isSet?: InputMaybe<Scalars['Boolean']>;
  lt?: InputMaybe<Scalars['String']>;
  lte?: InputMaybe<Scalars['String']>;
  not?: InputMaybe<NestedStringNullableFilter>;
  notIn?: InputMaybe<Array<Scalars['String']>>;
  startsWith?: InputMaybe<Scalars['String']>;
};

export type NestedStringNullableWithAggregatesFilter = {
  _count?: InputMaybe<NestedIntNullableFilter>;
  _max?: InputMaybe<NestedStringNullableFilter>;
  _min?: InputMaybe<NestedStringNullableFilter>;
  contains?: InputMaybe<Scalars['String']>;
  endsWith?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  gt?: InputMaybe<Scalars['String']>;
  gte?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<Scalars['String']>>;
  isSet?: InputMaybe<Scalars['Boolean']>;
  lt?: InputMaybe<Scalars['String']>;
  lte?: InputMaybe<Scalars['String']>;
  not?: InputMaybe<NestedStringNullableWithAggregatesFilter>;
  notIn?: InputMaybe<Array<Scalars['String']>>;
  startsWith?: InputMaybe<Scalars['String']>;
};

export type NestedStringWithAggregatesFilter = {
  _count?: InputMaybe<NestedIntFilter>;
  _max?: InputMaybe<NestedStringFilter>;
  _min?: InputMaybe<NestedStringFilter>;
  contains?: InputMaybe<Scalars['String']>;
  endsWith?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  gt?: InputMaybe<Scalars['String']>;
  gte?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<Scalars['String']>>;
  lt?: InputMaybe<Scalars['String']>;
  lte?: InputMaybe<Scalars['String']>;
  not?: InputMaybe<NestedStringWithAggregatesFilter>;
  notIn?: InputMaybe<Array<Scalars['String']>>;
  startsWith?: InputMaybe<Scalars['String']>;
};

export type Order = {
  __typename?: 'Order';
  adBoard: AdBoard;
  adBoardId: Scalars['String'];
  createdBy?: Maybe<User>;
  createdByUserId?: Maybe<Scalars['String']>;
  createdDate: Scalars['DateTime'];
  id: Scalars['String'];
  origin: Scalars['String'];
  paymentId?: Maybe<Scalars['String']>;
  priceSummary: OrderPriceSummary;
  selectedDate: OrderSelectedDate;
  selectedSlots: Array<Scalars['Int']>;
};


export type OrderCreatedByArgs = {
  where?: InputMaybe<UserWhereInput>;
};

export type OrderAvgAggregate = {
  __typename?: 'OrderAvgAggregate';
  selectedSlots?: Maybe<Scalars['Float']>;
};

export type OrderAvgOrderByAggregateInput = {
  selectedSlots?: InputMaybe<SortOrder>;
};

export type OrderCountAggregate = {
  __typename?: 'OrderCountAggregate';
  _all: Scalars['Int'];
  adBoardId: Scalars['Int'];
  createdByUserId: Scalars['Int'];
  createdDate: Scalars['Int'];
  id: Scalars['Int'];
  origin: Scalars['Int'];
  paymentId: Scalars['Int'];
  selectedSlots: Scalars['Int'];
};

export type OrderCountOrderByAggregateInput = {
  adBoardId?: InputMaybe<SortOrder>;
  createdByUserId?: InputMaybe<SortOrder>;
  createdDate?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  origin?: InputMaybe<SortOrder>;
  paymentId?: InputMaybe<SortOrder>;
  selectedSlots?: InputMaybe<SortOrder>;
};

export type OrderCreateInput = {
  adBoard: AdBoardCreateNestedOneWithoutOrdersInput;
  createdBy?: InputMaybe<UserCreateNestedOneWithoutOrdersInput>;
  createdDate?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['String']>;
  origin: Scalars['String'];
  paymentId?: InputMaybe<Scalars['String']>;
  priceSummary: OrderPriceSummaryCreateInput;
  selectedDate: OrderSelectedDateCreateInput;
  selectedSlots?: InputMaybe<Array<Scalars['Int']>>;
};

export type OrderCreateManyAdBoardInput = {
  createdByUserId?: InputMaybe<Scalars['String']>;
  createdDate?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['String']>;
  origin: Scalars['String'];
  paymentId?: InputMaybe<Scalars['String']>;
  priceSummary: OrderPriceSummaryCreateInput;
  selectedDate: OrderSelectedDateCreateInput;
  selectedSlots?: InputMaybe<Array<Scalars['Int']>>;
};

export type OrderCreateManyAdBoardInputEnvelope = {
  data: Array<OrderCreateManyAdBoardInput>;
};

export type OrderCreateManyCreatedByInput = {
  adBoardId: Scalars['String'];
  createdDate?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['String']>;
  origin: Scalars['String'];
  paymentId?: InputMaybe<Scalars['String']>;
  priceSummary: OrderPriceSummaryCreateInput;
  selectedDate: OrderSelectedDateCreateInput;
  selectedSlots?: InputMaybe<Array<Scalars['Int']>>;
};

export type OrderCreateManyCreatedByInputEnvelope = {
  data: Array<OrderCreateManyCreatedByInput>;
};

export type OrderCreateManyInput = {
  adBoardId: Scalars['String'];
  createdByUserId?: InputMaybe<Scalars['String']>;
  createdDate?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['String']>;
  origin: Scalars['String'];
  paymentId?: InputMaybe<Scalars['String']>;
  priceSummary: OrderPriceSummaryCreateInput;
  selectedDate: OrderSelectedDateCreateInput;
  selectedSlots?: InputMaybe<Array<Scalars['Int']>>;
};

export type OrderCreateNestedManyWithoutAdBoardInput = {
  connect?: InputMaybe<Array<OrderWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<OrderCreateOrConnectWithoutAdBoardInput>>;
  create?: InputMaybe<Array<OrderCreateWithoutAdBoardInput>>;
  createMany?: InputMaybe<OrderCreateManyAdBoardInputEnvelope>;
};

export type OrderCreateNestedManyWithoutCreatedByInput = {
  connect?: InputMaybe<Array<OrderWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<OrderCreateOrConnectWithoutCreatedByInput>>;
  create?: InputMaybe<Array<OrderCreateWithoutCreatedByInput>>;
  createMany?: InputMaybe<OrderCreateManyCreatedByInputEnvelope>;
};

export type OrderCreateOrConnectWithoutAdBoardInput = {
  create: OrderCreateWithoutAdBoardInput;
  where: OrderWhereUniqueInput;
};

export type OrderCreateOrConnectWithoutCreatedByInput = {
  create: OrderCreateWithoutCreatedByInput;
  where: OrderWhereUniqueInput;
};

export type OrderCreateWithoutAdBoardInput = {
  createdBy?: InputMaybe<UserCreateNestedOneWithoutOrdersInput>;
  createdDate?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['String']>;
  origin: Scalars['String'];
  paymentId?: InputMaybe<Scalars['String']>;
  priceSummary: OrderPriceSummaryCreateInput;
  selectedDate: OrderSelectedDateCreateInput;
  selectedSlots?: InputMaybe<Array<Scalars['Int']>>;
};

export type OrderCreateWithoutCreatedByInput = {
  adBoard: AdBoardCreateNestedOneWithoutOrdersInput;
  createdDate?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['String']>;
  origin: Scalars['String'];
  paymentId?: InputMaybe<Scalars['String']>;
  priceSummary: OrderPriceSummaryCreateInput;
  selectedDate: OrderSelectedDateCreateInput;
  selectedSlots?: InputMaybe<Array<Scalars['Int']>>;
};

export type OrderGroupBy = {
  __typename?: 'OrderGroupBy';
  _avg?: Maybe<OrderAvgAggregate>;
  _count?: Maybe<OrderCountAggregate>;
  _max?: Maybe<OrderMaxAggregate>;
  _min?: Maybe<OrderMinAggregate>;
  _sum?: Maybe<OrderSumAggregate>;
  adBoardId: Scalars['String'];
  createdByUserId?: Maybe<Scalars['String']>;
  createdDate: Scalars['DateTime'];
  id: Scalars['String'];
  origin: Scalars['String'];
  paymentId?: Maybe<Scalars['String']>;
  selectedSlots?: Maybe<Array<Scalars['Int']>>;
};

export type OrderListRelationFilter = {
  every?: InputMaybe<OrderWhereInput>;
  none?: InputMaybe<OrderWhereInput>;
  some?: InputMaybe<OrderWhereInput>;
};

export type OrderMaxAggregate = {
  __typename?: 'OrderMaxAggregate';
  adBoardId?: Maybe<Scalars['String']>;
  createdByUserId?: Maybe<Scalars['String']>;
  createdDate?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  origin?: Maybe<Scalars['String']>;
  paymentId?: Maybe<Scalars['String']>;
};

export type OrderMaxOrderByAggregateInput = {
  adBoardId?: InputMaybe<SortOrder>;
  createdByUserId?: InputMaybe<SortOrder>;
  createdDate?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  origin?: InputMaybe<SortOrder>;
  paymentId?: InputMaybe<SortOrder>;
};

export type OrderMinAggregate = {
  __typename?: 'OrderMinAggregate';
  adBoardId?: Maybe<Scalars['String']>;
  createdByUserId?: Maybe<Scalars['String']>;
  createdDate?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  origin?: Maybe<Scalars['String']>;
  paymentId?: Maybe<Scalars['String']>;
};

export type OrderMinOrderByAggregateInput = {
  adBoardId?: InputMaybe<SortOrder>;
  createdByUserId?: InputMaybe<SortOrder>;
  createdDate?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  origin?: InputMaybe<SortOrder>;
  paymentId?: InputMaybe<SortOrder>;
};

export type OrderOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type OrderOrderByWithAggregationInput = {
  _avg?: InputMaybe<OrderAvgOrderByAggregateInput>;
  _count?: InputMaybe<OrderCountOrderByAggregateInput>;
  _max?: InputMaybe<OrderMaxOrderByAggregateInput>;
  _min?: InputMaybe<OrderMinOrderByAggregateInput>;
  _sum?: InputMaybe<OrderSumOrderByAggregateInput>;
  adBoardId?: InputMaybe<SortOrder>;
  createdByUserId?: InputMaybe<SortOrder>;
  createdDate?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  origin?: InputMaybe<SortOrder>;
  paymentId?: InputMaybe<SortOrder>;
  selectedSlots?: InputMaybe<SortOrder>;
};

export type OrderOrderByWithRelationInput = {
  adBoard?: InputMaybe<AdBoardOrderByWithRelationInput>;
  adBoardId?: InputMaybe<SortOrder>;
  createdBy?: InputMaybe<UserOrderByWithRelationInput>;
  createdByUserId?: InputMaybe<SortOrder>;
  createdDate?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  origin?: InputMaybe<SortOrder>;
  paymentId?: InputMaybe<SortOrder>;
  priceSummary?: InputMaybe<OrderPriceSummaryOrderByInput>;
  selectedDate?: InputMaybe<OrderSelectedDateOrderByInput>;
  selectedSlots?: InputMaybe<SortOrder>;
};

export type OrderPriceSummary = {
  __typename?: 'OrderPriceSummary';
  days: Scalars['Int'];
  discount?: Maybe<Scalars['Float']>;
  payableRent: Scalars['Float'];
  rentPerDay: Scalars['Int'];
  serviceCharge: Scalars['Float'];
  totalRent: Scalars['Int'];
};

export type OrderPriceSummaryCompositeFilter = {
  equals?: InputMaybe<OrderPriceSummaryObjectEqualityInput>;
  is?: InputMaybe<OrderPriceSummaryWhereInput>;
  isNot?: InputMaybe<OrderPriceSummaryWhereInput>;
};

export type OrderPriceSummaryCreateInput = {
  days: Scalars['Int'];
  discount?: InputMaybe<Scalars['Float']>;
  payableRent: Scalars['Float'];
  rentPerDay: Scalars['Int'];
  serviceCharge: Scalars['Float'];
  totalRent: Scalars['Int'];
};

export type OrderPriceSummaryNullableCompositeFilter = {
  equals?: InputMaybe<OrderPriceSummaryObjectEqualityInput>;
  is?: InputMaybe<OrderPriceSummaryWhereInput>;
  isNot?: InputMaybe<OrderPriceSummaryWhereInput>;
  isSet?: InputMaybe<Scalars['Boolean']>;
};

export type OrderPriceSummaryObjectEqualityInput = {
  days: Scalars['Int'];
  discount?: InputMaybe<Scalars['Float']>;
  payableRent: Scalars['Float'];
  rentPerDay: Scalars['Int'];
  serviceCharge: Scalars['Float'];
  totalRent: Scalars['Int'];
};

export type OrderPriceSummaryOrderByInput = {
  days?: InputMaybe<SortOrder>;
  discount?: InputMaybe<SortOrder>;
  payableRent?: InputMaybe<SortOrder>;
  rentPerDay?: InputMaybe<SortOrder>;
  serviceCharge?: InputMaybe<SortOrder>;
  totalRent?: InputMaybe<SortOrder>;
};

export type OrderPriceSummaryWhereInput = {
  AND?: InputMaybe<Array<OrderPriceSummaryWhereInput>>;
  NOT?: InputMaybe<Array<OrderPriceSummaryWhereInput>>;
  OR?: InputMaybe<Array<OrderPriceSummaryWhereInput>>;
  days?: InputMaybe<IntFilter>;
  discount?: InputMaybe<FloatNullableFilter>;
  payableRent?: InputMaybe<FloatFilter>;
  rentPerDay?: InputMaybe<IntFilter>;
  serviceCharge?: InputMaybe<FloatFilter>;
  totalRent?: InputMaybe<IntFilter>;
};

export enum OrderScalarFieldEnum {
  AdBoardId = 'adBoardId',
  CreatedByUserId = 'createdByUserId',
  CreatedDate = 'createdDate',
  Id = 'id',
  Origin = 'origin',
  PaymentId = 'paymentId',
  SelectedSlots = 'selectedSlots'
}

export type OrderScalarWhereInput = {
  AND?: InputMaybe<Array<OrderScalarWhereInput>>;
  NOT?: InputMaybe<Array<OrderScalarWhereInput>>;
  OR?: InputMaybe<Array<OrderScalarWhereInput>>;
  adBoardId?: InputMaybe<StringFilter>;
  createdByUserId?: InputMaybe<StringNullableFilter>;
  createdDate?: InputMaybe<DateTimeFilter>;
  id?: InputMaybe<StringFilter>;
  origin?: InputMaybe<StringFilter>;
  paymentId?: InputMaybe<StringNullableFilter>;
  selectedSlots?: InputMaybe<IntNullableListFilter>;
};

export type OrderScalarWhereWithAggregatesInput = {
  AND?: InputMaybe<Array<OrderScalarWhereWithAggregatesInput>>;
  NOT?: InputMaybe<Array<OrderScalarWhereWithAggregatesInput>>;
  OR?: InputMaybe<Array<OrderScalarWhereWithAggregatesInput>>;
  adBoardId?: InputMaybe<StringWithAggregatesFilter>;
  createdByUserId?: InputMaybe<StringNullableWithAggregatesFilter>;
  createdDate?: InputMaybe<DateTimeWithAggregatesFilter>;
  id?: InputMaybe<StringWithAggregatesFilter>;
  origin?: InputMaybe<StringWithAggregatesFilter>;
  paymentId?: InputMaybe<StringNullableWithAggregatesFilter>;
  selectedSlots?: InputMaybe<IntNullableListFilter>;
};

export type OrderSelectedDate = {
  __typename?: 'OrderSelectedDate';
  endDate: Scalars['DateTime'];
  startDate: Scalars['DateTime'];
};

export type OrderSelectedDateCompositeFilter = {
  equals?: InputMaybe<OrderSelectedDateObjectEqualityInput>;
  is?: InputMaybe<OrderSelectedDateWhereInput>;
  isNot?: InputMaybe<OrderSelectedDateWhereInput>;
};

export type OrderSelectedDateCreateInput = {
  endDate: Scalars['DateTime'];
  startDate: Scalars['DateTime'];
};

export type OrderSelectedDateObjectEqualityInput = {
  endDate: Scalars['DateTime'];
  startDate: Scalars['DateTime'];
};

export type OrderSelectedDateOrderByInput = {
  endDate?: InputMaybe<SortOrder>;
  startDate?: InputMaybe<SortOrder>;
};

export type OrderSelectedDateWhereInput = {
  AND?: InputMaybe<Array<OrderSelectedDateWhereInput>>;
  NOT?: InputMaybe<Array<OrderSelectedDateWhereInput>>;
  OR?: InputMaybe<Array<OrderSelectedDateWhereInput>>;
  endDate?: InputMaybe<DateTimeFilter>;
  startDate?: InputMaybe<DateTimeFilter>;
};

export type OrderSumAggregate = {
  __typename?: 'OrderSumAggregate';
  selectedSlots?: Maybe<Array<Scalars['Int']>>;
};

export type OrderSumOrderByAggregateInput = {
  selectedSlots?: InputMaybe<SortOrder>;
};

export type OrderUpdateInput = {
  adBoard?: InputMaybe<AdBoardUpdateOneRequiredWithoutOrdersNestedInput>;
  createdBy?: InputMaybe<UserUpdateOneWithoutOrdersNestedInput>;
  createdDate?: InputMaybe<Scalars['DateTime']>;
  origin?: InputMaybe<Scalars['String']>;
  paymentId?: InputMaybe<Scalars['String']>;
  priceSummary?: InputMaybe<OrderPriceSummaryCreateInput>;
  selectedDate?: InputMaybe<OrderSelectedDateCreateInput>;
  selectedSlots?: InputMaybe<Array<Scalars['Int']>>;
};

export type OrderUpdateManyMutationInput = {
  createdDate?: InputMaybe<Scalars['DateTime']>;
  origin?: InputMaybe<Scalars['String']>;
  paymentId?: InputMaybe<Scalars['String']>;
  priceSummary?: InputMaybe<OrderPriceSummaryCreateInput>;
  selectedDate?: InputMaybe<OrderSelectedDateCreateInput>;
  selectedSlots?: InputMaybe<Array<Scalars['Int']>>;
};

export type OrderUpdateManyWithWhereWithoutAdBoardInput = {
  data: OrderUpdateManyMutationInput;
  where: OrderScalarWhereInput;
};

export type OrderUpdateManyWithWhereWithoutCreatedByInput = {
  data: OrderUpdateManyMutationInput;
  where: OrderScalarWhereInput;
};

export type OrderUpdateManyWithoutAdBoardNestedInput = {
  connect?: InputMaybe<Array<OrderWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<OrderCreateOrConnectWithoutAdBoardInput>>;
  create?: InputMaybe<Array<OrderCreateWithoutAdBoardInput>>;
  createMany?: InputMaybe<OrderCreateManyAdBoardInputEnvelope>;
  delete?: InputMaybe<Array<OrderWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<OrderScalarWhereInput>>;
  disconnect?: InputMaybe<Array<OrderWhereUniqueInput>>;
  set?: InputMaybe<Array<OrderWhereUniqueInput>>;
  update?: InputMaybe<Array<OrderUpdateWithWhereUniqueWithoutAdBoardInput>>;
  updateMany?: InputMaybe<Array<OrderUpdateManyWithWhereWithoutAdBoardInput>>;
  upsert?: InputMaybe<Array<OrderUpsertWithWhereUniqueWithoutAdBoardInput>>;
};

export type OrderUpdateManyWithoutCreatedByNestedInput = {
  connect?: InputMaybe<Array<OrderWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<OrderCreateOrConnectWithoutCreatedByInput>>;
  create?: InputMaybe<Array<OrderCreateWithoutCreatedByInput>>;
  createMany?: InputMaybe<OrderCreateManyCreatedByInputEnvelope>;
  delete?: InputMaybe<Array<OrderWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<OrderScalarWhereInput>>;
  disconnect?: InputMaybe<Array<OrderWhereUniqueInput>>;
  set?: InputMaybe<Array<OrderWhereUniqueInput>>;
  update?: InputMaybe<Array<OrderUpdateWithWhereUniqueWithoutCreatedByInput>>;
  updateMany?: InputMaybe<Array<OrderUpdateManyWithWhereWithoutCreatedByInput>>;
  upsert?: InputMaybe<Array<OrderUpsertWithWhereUniqueWithoutCreatedByInput>>;
};

export type OrderUpdateWithWhereUniqueWithoutAdBoardInput = {
  data: OrderUpdateWithoutAdBoardInput;
  where: OrderWhereUniqueInput;
};

export type OrderUpdateWithWhereUniqueWithoutCreatedByInput = {
  data: OrderUpdateWithoutCreatedByInput;
  where: OrderWhereUniqueInput;
};

export type OrderUpdateWithoutAdBoardInput = {
  createdBy?: InputMaybe<UserUpdateOneWithoutOrdersNestedInput>;
  createdDate?: InputMaybe<Scalars['DateTime']>;
  origin?: InputMaybe<Scalars['String']>;
  paymentId?: InputMaybe<Scalars['String']>;
  priceSummary?: InputMaybe<OrderPriceSummaryCreateInput>;
  selectedDate?: InputMaybe<OrderSelectedDateCreateInput>;
  selectedSlots?: InputMaybe<Array<Scalars['Int']>>;
};

export type OrderUpdateWithoutCreatedByInput = {
  adBoard?: InputMaybe<AdBoardUpdateOneRequiredWithoutOrdersNestedInput>;
  createdDate?: InputMaybe<Scalars['DateTime']>;
  origin?: InputMaybe<Scalars['String']>;
  paymentId?: InputMaybe<Scalars['String']>;
  priceSummary?: InputMaybe<OrderPriceSummaryCreateInput>;
  selectedDate?: InputMaybe<OrderSelectedDateCreateInput>;
  selectedSlots?: InputMaybe<Array<Scalars['Int']>>;
};

export type OrderUpsertWithWhereUniqueWithoutAdBoardInput = {
  create: OrderCreateWithoutAdBoardInput;
  update: OrderUpdateWithoutAdBoardInput;
  where: OrderWhereUniqueInput;
};

export type OrderUpsertWithWhereUniqueWithoutCreatedByInput = {
  create: OrderCreateWithoutCreatedByInput;
  update: OrderUpdateWithoutCreatedByInput;
  where: OrderWhereUniqueInput;
};

export type OrderWhereInput = {
  AND?: InputMaybe<Array<OrderWhereInput>>;
  NOT?: InputMaybe<Array<OrderWhereInput>>;
  OR?: InputMaybe<Array<OrderWhereInput>>;
  adBoard?: InputMaybe<AdBoardRelationFilter>;
  adBoardId?: InputMaybe<StringFilter>;
  createdBy?: InputMaybe<UserNullableRelationFilter>;
  createdByUserId?: InputMaybe<StringNullableFilter>;
  createdDate?: InputMaybe<DateTimeFilter>;
  id?: InputMaybe<StringFilter>;
  origin?: InputMaybe<StringFilter>;
  paymentId?: InputMaybe<StringNullableFilter>;
  priceSummary?: InputMaybe<OrderPriceSummaryCompositeFilter>;
  selectedDate?: InputMaybe<OrderSelectedDateCompositeFilter>;
  selectedSlots?: InputMaybe<IntNullableListFilter>;
};

export type OrderWhereUniqueInput = {
  AND?: InputMaybe<Array<OrderWhereInput>>;
  NOT?: InputMaybe<Array<OrderWhereInput>>;
  OR?: InputMaybe<Array<OrderWhereInput>>;
  adBoard?: InputMaybe<AdBoardRelationFilter>;
  adBoardId?: InputMaybe<StringFilter>;
  createdBy?: InputMaybe<UserNullableRelationFilter>;
  createdByUserId?: InputMaybe<StringNullableFilter>;
  createdDate?: InputMaybe<DateTimeFilter>;
  id?: InputMaybe<Scalars['String']>;
  origin?: InputMaybe<StringFilter>;
  paymentId?: InputMaybe<StringNullableFilter>;
  priceSummary?: InputMaybe<OrderPriceSummaryCompositeFilter>;
  selectedDate?: InputMaybe<OrderSelectedDateCompositeFilter>;
  selectedSlots?: InputMaybe<IntNullableListFilter>;
};

export type PaymentCustomerDetails = {
  __typename?: 'PaymentCustomerDetails';
  email: Scalars['String'];
  name: Scalars['String'];
  phone?: Maybe<Scalars['String']>;
};

export type PaymentCustomerDetailsCreateInput = {
  email: Scalars['String'];
  name: Scalars['String'];
  phone?: InputMaybe<Scalars['String']>;
};

export type PaymentCustomerDetailsNullableCompositeFilter = {
  equals?: InputMaybe<PaymentCustomerDetailsObjectEqualityInput>;
  is?: InputMaybe<PaymentCustomerDetailsWhereInput>;
  isNot?: InputMaybe<PaymentCustomerDetailsWhereInput>;
  isSet?: InputMaybe<Scalars['Boolean']>;
};

export type PaymentCustomerDetailsObjectEqualityInput = {
  email: Scalars['String'];
  name: Scalars['String'];
  phone?: InputMaybe<Scalars['String']>;
};

export type PaymentCustomerDetailsOrderByInput = {
  email?: InputMaybe<SortOrder>;
  name?: InputMaybe<SortOrder>;
  phone?: InputMaybe<SortOrder>;
};

export type PaymentCustomerDetailsWhereInput = {
  AND?: InputMaybe<Array<PaymentCustomerDetailsWhereInput>>;
  NOT?: InputMaybe<Array<PaymentCustomerDetailsWhereInput>>;
  OR?: InputMaybe<Array<PaymentCustomerDetailsWhereInput>>;
  email?: InputMaybe<StringFilter>;
  name?: InputMaybe<StringFilter>;
  phone?: InputMaybe<StringNullableFilter>;
};

export enum PaymentGatewayName {
  Instamojo = 'INSTAMOJO',
  Razorpay = 'RAZORPAY',
  Stripe = 'STRIPE'
}

export enum PaymentStatus {
  Failed = 'FAILED',
  FullyRefunded = 'FULLY_REFUNDED',
  PartiallyRefunded = 'PARTIALLY_REFUNDED',
  Pending = 'PENDING',
  Success = 'SUCCESS'
}

export type PaymentTotalDetails = {
  __typename?: 'PaymentTotalDetails';
  discount: Scalars['Float'];
  shipping: Scalars['Float'];
  subtotal: Scalars['Float'];
  tax: Scalars['Float'];
  total: Scalars['Float'];
};

export type PaymentTotalDetailsCreateInput = {
  discount: Scalars['Float'];
  shipping: Scalars['Float'];
  subtotal: Scalars['Float'];
  tax: Scalars['Float'];
  total: Scalars['Float'];
};

export type PaymentTotalDetailsNullableCompositeFilter = {
  equals?: InputMaybe<PaymentTotalDetailsObjectEqualityInput>;
  is?: InputMaybe<PaymentTotalDetailsWhereInput>;
  isNot?: InputMaybe<PaymentTotalDetailsWhereInput>;
  isSet?: InputMaybe<Scalars['Boolean']>;
};

export type PaymentTotalDetailsObjectEqualityInput = {
  discount: Scalars['Float'];
  shipping: Scalars['Float'];
  subtotal: Scalars['Float'];
  tax: Scalars['Float'];
  total: Scalars['Float'];
};

export type PaymentTotalDetailsOrderByInput = {
  discount?: InputMaybe<SortOrder>;
  shipping?: InputMaybe<SortOrder>;
  subtotal?: InputMaybe<SortOrder>;
  tax?: InputMaybe<SortOrder>;
  total?: InputMaybe<SortOrder>;
};

export type PaymentTotalDetailsWhereInput = {
  AND?: InputMaybe<Array<PaymentTotalDetailsWhereInput>>;
  NOT?: InputMaybe<Array<PaymentTotalDetailsWhereInput>>;
  OR?: InputMaybe<Array<PaymentTotalDetailsWhereInput>>;
  discount?: InputMaybe<FloatFilter>;
  shipping?: InputMaybe<FloatFilter>;
  subtotal?: InputMaybe<FloatFilter>;
  tax?: InputMaybe<FloatFilter>;
  total?: InputMaybe<FloatFilter>;
};

export type Payout = {
  __typename?: 'Payout';
  booking: Booking;
  bookingId: Scalars['String'];
  commissionAmount: Scalars['Float'];
  commissionRate: Scalars['Float'];
  createdAt: Scalars['DateTime'];
  id: Scalars['String'];
  netAmount: Scalars['Float'];
  status: PayoutStatus;
  totalAmount: Scalars['Float'];
  transaction?: Maybe<Transaction>;
  transactionId?: Maybe<Scalars['String']>;
};


export type PayoutTransactionArgs = {
  where?: InputMaybe<TransactionWhereInput>;
};

export type PayoutAvgAggregate = {
  __typename?: 'PayoutAvgAggregate';
  commissionAmount?: Maybe<Scalars['Float']>;
  commissionRate?: Maybe<Scalars['Float']>;
  netAmount?: Maybe<Scalars['Float']>;
  totalAmount?: Maybe<Scalars['Float']>;
};

export type PayoutAvgOrderByAggregateInput = {
  commissionAmount?: InputMaybe<SortOrder>;
  commissionRate?: InputMaybe<SortOrder>;
  netAmount?: InputMaybe<SortOrder>;
  totalAmount?: InputMaybe<SortOrder>;
};

export type PayoutCountAggregate = {
  __typename?: 'PayoutCountAggregate';
  _all: Scalars['Int'];
  bookingId: Scalars['Int'];
  commissionAmount: Scalars['Int'];
  commissionRate: Scalars['Int'];
  createdAt: Scalars['Int'];
  id: Scalars['Int'];
  netAmount: Scalars['Int'];
  status: Scalars['Int'];
  totalAmount: Scalars['Int'];
  transactionId: Scalars['Int'];
};

export type PayoutCountOrderByAggregateInput = {
  bookingId?: InputMaybe<SortOrder>;
  commissionAmount?: InputMaybe<SortOrder>;
  commissionRate?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  netAmount?: InputMaybe<SortOrder>;
  status?: InputMaybe<SortOrder>;
  totalAmount?: InputMaybe<SortOrder>;
  transactionId?: InputMaybe<SortOrder>;
};

export type PayoutCreateInput = {
  booking: BookingCreateNestedOneWithoutPayoutsInput;
  commissionAmount: Scalars['Float'];
  commissionRate: Scalars['Float'];
  createdAt?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['String']>;
  netAmount: Scalars['Float'];
  status: PayoutStatus;
  totalAmount: Scalars['Float'];
  transaction?: InputMaybe<TransactionCreateNestedOneWithoutPayoutsInput>;
};

export type PayoutCreateManyBookingInput = {
  commissionAmount: Scalars['Float'];
  commissionRate: Scalars['Float'];
  createdAt?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['String']>;
  netAmount: Scalars['Float'];
  status: PayoutStatus;
  totalAmount: Scalars['Float'];
  transactionId?: InputMaybe<Scalars['String']>;
};

export type PayoutCreateManyBookingInputEnvelope = {
  data: Array<PayoutCreateManyBookingInput>;
};

export type PayoutCreateManyInput = {
  bookingId: Scalars['String'];
  commissionAmount: Scalars['Float'];
  commissionRate: Scalars['Float'];
  createdAt?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['String']>;
  netAmount: Scalars['Float'];
  status: PayoutStatus;
  totalAmount: Scalars['Float'];
  transactionId?: InputMaybe<Scalars['String']>;
};

export type PayoutCreateManyTransactionInput = {
  bookingId: Scalars['String'];
  commissionAmount: Scalars['Float'];
  commissionRate: Scalars['Float'];
  createdAt?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['String']>;
  netAmount: Scalars['Float'];
  status: PayoutStatus;
  totalAmount: Scalars['Float'];
};

export type PayoutCreateManyTransactionInputEnvelope = {
  data: Array<PayoutCreateManyTransactionInput>;
};

export type PayoutCreateNestedManyWithoutBookingInput = {
  connect?: InputMaybe<Array<PayoutWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<PayoutCreateOrConnectWithoutBookingInput>>;
  create?: InputMaybe<Array<PayoutCreateWithoutBookingInput>>;
  createMany?: InputMaybe<PayoutCreateManyBookingInputEnvelope>;
};

export type PayoutCreateNestedManyWithoutTransactionInput = {
  connect?: InputMaybe<Array<PayoutWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<PayoutCreateOrConnectWithoutTransactionInput>>;
  create?: InputMaybe<Array<PayoutCreateWithoutTransactionInput>>;
  createMany?: InputMaybe<PayoutCreateManyTransactionInputEnvelope>;
};

export type PayoutCreateOrConnectWithoutBookingInput = {
  create: PayoutCreateWithoutBookingInput;
  where: PayoutWhereUniqueInput;
};

export type PayoutCreateOrConnectWithoutTransactionInput = {
  create: PayoutCreateWithoutTransactionInput;
  where: PayoutWhereUniqueInput;
};

export type PayoutCreateWithoutBookingInput = {
  commissionAmount: Scalars['Float'];
  commissionRate: Scalars['Float'];
  createdAt?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['String']>;
  netAmount: Scalars['Float'];
  status: PayoutStatus;
  totalAmount: Scalars['Float'];
  transaction?: InputMaybe<TransactionCreateNestedOneWithoutPayoutsInput>;
};

export type PayoutCreateWithoutTransactionInput = {
  booking: BookingCreateNestedOneWithoutPayoutsInput;
  commissionAmount: Scalars['Float'];
  commissionRate: Scalars['Float'];
  createdAt?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['String']>;
  netAmount: Scalars['Float'];
  status: PayoutStatus;
  totalAmount: Scalars['Float'];
};

export type PayoutGroupBy = {
  __typename?: 'PayoutGroupBy';
  _avg?: Maybe<PayoutAvgAggregate>;
  _count?: Maybe<PayoutCountAggregate>;
  _max?: Maybe<PayoutMaxAggregate>;
  _min?: Maybe<PayoutMinAggregate>;
  _sum?: Maybe<PayoutSumAggregate>;
  bookingId: Scalars['String'];
  commissionAmount: Scalars['Float'];
  commissionRate: Scalars['Float'];
  createdAt: Scalars['DateTime'];
  id: Scalars['String'];
  netAmount: Scalars['Float'];
  status: PayoutStatus;
  totalAmount: Scalars['Float'];
  transactionId?: Maybe<Scalars['String']>;
};

export type PayoutListRelationFilter = {
  every?: InputMaybe<PayoutWhereInput>;
  none?: InputMaybe<PayoutWhereInput>;
  some?: InputMaybe<PayoutWhereInput>;
};

export type PayoutMaxAggregate = {
  __typename?: 'PayoutMaxAggregate';
  bookingId?: Maybe<Scalars['String']>;
  commissionAmount?: Maybe<Scalars['Float']>;
  commissionRate?: Maybe<Scalars['Float']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  netAmount?: Maybe<Scalars['Float']>;
  status?: Maybe<PayoutStatus>;
  totalAmount?: Maybe<Scalars['Float']>;
  transactionId?: Maybe<Scalars['String']>;
};

export type PayoutMaxOrderByAggregateInput = {
  bookingId?: InputMaybe<SortOrder>;
  commissionAmount?: InputMaybe<SortOrder>;
  commissionRate?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  netAmount?: InputMaybe<SortOrder>;
  status?: InputMaybe<SortOrder>;
  totalAmount?: InputMaybe<SortOrder>;
  transactionId?: InputMaybe<SortOrder>;
};

export type PayoutMinAggregate = {
  __typename?: 'PayoutMinAggregate';
  bookingId?: Maybe<Scalars['String']>;
  commissionAmount?: Maybe<Scalars['Float']>;
  commissionRate?: Maybe<Scalars['Float']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  netAmount?: Maybe<Scalars['Float']>;
  status?: Maybe<PayoutStatus>;
  totalAmount?: Maybe<Scalars['Float']>;
  transactionId?: Maybe<Scalars['String']>;
};

export type PayoutMinOrderByAggregateInput = {
  bookingId?: InputMaybe<SortOrder>;
  commissionAmount?: InputMaybe<SortOrder>;
  commissionRate?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  netAmount?: InputMaybe<SortOrder>;
  status?: InputMaybe<SortOrder>;
  totalAmount?: InputMaybe<SortOrder>;
  transactionId?: InputMaybe<SortOrder>;
};

export type PayoutOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type PayoutOrderByWithAggregationInput = {
  _avg?: InputMaybe<PayoutAvgOrderByAggregateInput>;
  _count?: InputMaybe<PayoutCountOrderByAggregateInput>;
  _max?: InputMaybe<PayoutMaxOrderByAggregateInput>;
  _min?: InputMaybe<PayoutMinOrderByAggregateInput>;
  _sum?: InputMaybe<PayoutSumOrderByAggregateInput>;
  bookingId?: InputMaybe<SortOrder>;
  commissionAmount?: InputMaybe<SortOrder>;
  commissionRate?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  netAmount?: InputMaybe<SortOrder>;
  status?: InputMaybe<SortOrder>;
  totalAmount?: InputMaybe<SortOrder>;
  transactionId?: InputMaybe<SortOrder>;
};

export type PayoutOrderByWithRelationInput = {
  booking?: InputMaybe<BookingOrderByWithRelationInput>;
  bookingId?: InputMaybe<SortOrder>;
  commissionAmount?: InputMaybe<SortOrder>;
  commissionRate?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  netAmount?: InputMaybe<SortOrder>;
  status?: InputMaybe<SortOrder>;
  totalAmount?: InputMaybe<SortOrder>;
  transaction?: InputMaybe<TransactionOrderByWithRelationInput>;
  transactionId?: InputMaybe<SortOrder>;
};

export enum PayoutScalarFieldEnum {
  BookingId = 'bookingId',
  CommissionAmount = 'commissionAmount',
  CommissionRate = 'commissionRate',
  CreatedAt = 'createdAt',
  Id = 'id',
  NetAmount = 'netAmount',
  Status = 'status',
  TotalAmount = 'totalAmount',
  TransactionId = 'transactionId'
}

export type PayoutScalarWhereInput = {
  AND?: InputMaybe<Array<PayoutScalarWhereInput>>;
  NOT?: InputMaybe<Array<PayoutScalarWhereInput>>;
  OR?: InputMaybe<Array<PayoutScalarWhereInput>>;
  bookingId?: InputMaybe<StringFilter>;
  commissionAmount?: InputMaybe<FloatFilter>;
  commissionRate?: InputMaybe<FloatFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  id?: InputMaybe<StringFilter>;
  netAmount?: InputMaybe<FloatFilter>;
  status?: InputMaybe<EnumPayoutStatusFilter>;
  totalAmount?: InputMaybe<FloatFilter>;
  transactionId?: InputMaybe<StringNullableFilter>;
};

export type PayoutScalarWhereWithAggregatesInput = {
  AND?: InputMaybe<Array<PayoutScalarWhereWithAggregatesInput>>;
  NOT?: InputMaybe<Array<PayoutScalarWhereWithAggregatesInput>>;
  OR?: InputMaybe<Array<PayoutScalarWhereWithAggregatesInput>>;
  bookingId?: InputMaybe<StringWithAggregatesFilter>;
  commissionAmount?: InputMaybe<FloatWithAggregatesFilter>;
  commissionRate?: InputMaybe<FloatWithAggregatesFilter>;
  createdAt?: InputMaybe<DateTimeWithAggregatesFilter>;
  id?: InputMaybe<StringWithAggregatesFilter>;
  netAmount?: InputMaybe<FloatWithAggregatesFilter>;
  status?: InputMaybe<EnumPayoutStatusWithAggregatesFilter>;
  totalAmount?: InputMaybe<FloatWithAggregatesFilter>;
  transactionId?: InputMaybe<StringNullableWithAggregatesFilter>;
};

export enum PayoutStatus {
  Pending = 'PENDING',
  Processed = 'PROCESSED',
  Scheduled = 'SCHEDULED'
}

export type PayoutSumAggregate = {
  __typename?: 'PayoutSumAggregate';
  commissionAmount?: Maybe<Scalars['Float']>;
  commissionRate?: Maybe<Scalars['Float']>;
  netAmount?: Maybe<Scalars['Float']>;
  totalAmount?: Maybe<Scalars['Float']>;
};

export type PayoutSumOrderByAggregateInput = {
  commissionAmount?: InputMaybe<SortOrder>;
  commissionRate?: InputMaybe<SortOrder>;
  netAmount?: InputMaybe<SortOrder>;
  totalAmount?: InputMaybe<SortOrder>;
};

export type PayoutUpdateInput = {
  booking?: InputMaybe<BookingUpdateOneRequiredWithoutPayoutsNestedInput>;
  commissionAmount?: InputMaybe<Scalars['Float']>;
  commissionRate?: InputMaybe<Scalars['Float']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  netAmount?: InputMaybe<Scalars['Float']>;
  status?: InputMaybe<PayoutStatus>;
  totalAmount?: InputMaybe<Scalars['Float']>;
  transaction?: InputMaybe<TransactionUpdateOneWithoutPayoutsNestedInput>;
};

export type PayoutUpdateManyMutationInput = {
  commissionAmount?: InputMaybe<Scalars['Float']>;
  commissionRate?: InputMaybe<Scalars['Float']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  netAmount?: InputMaybe<Scalars['Float']>;
  status?: InputMaybe<PayoutStatus>;
  totalAmount?: InputMaybe<Scalars['Float']>;
};

export type PayoutUpdateManyWithWhereWithoutBookingInput = {
  data: PayoutUpdateManyMutationInput;
  where: PayoutScalarWhereInput;
};

export type PayoutUpdateManyWithWhereWithoutTransactionInput = {
  data: PayoutUpdateManyMutationInput;
  where: PayoutScalarWhereInput;
};

export type PayoutUpdateManyWithoutBookingNestedInput = {
  connect?: InputMaybe<Array<PayoutWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<PayoutCreateOrConnectWithoutBookingInput>>;
  create?: InputMaybe<Array<PayoutCreateWithoutBookingInput>>;
  createMany?: InputMaybe<PayoutCreateManyBookingInputEnvelope>;
  delete?: InputMaybe<Array<PayoutWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<PayoutScalarWhereInput>>;
  disconnect?: InputMaybe<Array<PayoutWhereUniqueInput>>;
  set?: InputMaybe<Array<PayoutWhereUniqueInput>>;
  update?: InputMaybe<Array<PayoutUpdateWithWhereUniqueWithoutBookingInput>>;
  updateMany?: InputMaybe<Array<PayoutUpdateManyWithWhereWithoutBookingInput>>;
  upsert?: InputMaybe<Array<PayoutUpsertWithWhereUniqueWithoutBookingInput>>;
};

export type PayoutUpdateManyWithoutTransactionNestedInput = {
  connect?: InputMaybe<Array<PayoutWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<PayoutCreateOrConnectWithoutTransactionInput>>;
  create?: InputMaybe<Array<PayoutCreateWithoutTransactionInput>>;
  createMany?: InputMaybe<PayoutCreateManyTransactionInputEnvelope>;
  delete?: InputMaybe<Array<PayoutWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<PayoutScalarWhereInput>>;
  disconnect?: InputMaybe<Array<PayoutWhereUniqueInput>>;
  set?: InputMaybe<Array<PayoutWhereUniqueInput>>;
  update?: InputMaybe<Array<PayoutUpdateWithWhereUniqueWithoutTransactionInput>>;
  updateMany?: InputMaybe<Array<PayoutUpdateManyWithWhereWithoutTransactionInput>>;
  upsert?: InputMaybe<Array<PayoutUpsertWithWhereUniqueWithoutTransactionInput>>;
};

export type PayoutUpdateWithWhereUniqueWithoutBookingInput = {
  data: PayoutUpdateWithoutBookingInput;
  where: PayoutWhereUniqueInput;
};

export type PayoutUpdateWithWhereUniqueWithoutTransactionInput = {
  data: PayoutUpdateWithoutTransactionInput;
  where: PayoutWhereUniqueInput;
};

export type PayoutUpdateWithoutBookingInput = {
  commissionAmount?: InputMaybe<Scalars['Float']>;
  commissionRate?: InputMaybe<Scalars['Float']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  netAmount?: InputMaybe<Scalars['Float']>;
  status?: InputMaybe<PayoutStatus>;
  totalAmount?: InputMaybe<Scalars['Float']>;
  transaction?: InputMaybe<TransactionUpdateOneWithoutPayoutsNestedInput>;
};

export type PayoutUpdateWithoutTransactionInput = {
  booking?: InputMaybe<BookingUpdateOneRequiredWithoutPayoutsNestedInput>;
  commissionAmount?: InputMaybe<Scalars['Float']>;
  commissionRate?: InputMaybe<Scalars['Float']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  netAmount?: InputMaybe<Scalars['Float']>;
  status?: InputMaybe<PayoutStatus>;
  totalAmount?: InputMaybe<Scalars['Float']>;
};

export type PayoutUpsertWithWhereUniqueWithoutBookingInput = {
  create: PayoutCreateWithoutBookingInput;
  update: PayoutUpdateWithoutBookingInput;
  where: PayoutWhereUniqueInput;
};

export type PayoutUpsertWithWhereUniqueWithoutTransactionInput = {
  create: PayoutCreateWithoutTransactionInput;
  update: PayoutUpdateWithoutTransactionInput;
  where: PayoutWhereUniqueInput;
};

export type PayoutWhereInput = {
  AND?: InputMaybe<Array<PayoutWhereInput>>;
  NOT?: InputMaybe<Array<PayoutWhereInput>>;
  OR?: InputMaybe<Array<PayoutWhereInput>>;
  booking?: InputMaybe<BookingRelationFilter>;
  bookingId?: InputMaybe<StringFilter>;
  commissionAmount?: InputMaybe<FloatFilter>;
  commissionRate?: InputMaybe<FloatFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  id?: InputMaybe<StringFilter>;
  netAmount?: InputMaybe<FloatFilter>;
  status?: InputMaybe<EnumPayoutStatusFilter>;
  totalAmount?: InputMaybe<FloatFilter>;
  transaction?: InputMaybe<TransactionNullableRelationFilter>;
  transactionId?: InputMaybe<StringNullableFilter>;
};

export type PayoutWhereUniqueInput = {
  AND?: InputMaybe<Array<PayoutWhereInput>>;
  NOT?: InputMaybe<Array<PayoutWhereInput>>;
  OR?: InputMaybe<Array<PayoutWhereInput>>;
  booking?: InputMaybe<BookingRelationFilter>;
  bookingId?: InputMaybe<StringFilter>;
  commissionAmount?: InputMaybe<FloatFilter>;
  commissionRate?: InputMaybe<FloatFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  id?: InputMaybe<Scalars['String']>;
  netAmount?: InputMaybe<FloatFilter>;
  status?: InputMaybe<EnumPayoutStatusFilter>;
  totalAmount?: InputMaybe<FloatFilter>;
  transaction?: InputMaybe<TransactionNullableRelationFilter>;
  transactionId?: InputMaybe<StringNullableFilter>;
};

export enum Permission {
  ManageAccessLabels = 'MANAGE_ACCESS_LABELS',
  ManageAdboards = 'MANAGE_ADBOARDS',
  ManageAdboardGroups = 'MANAGE_ADBOARD_GROUPS',
  ManageAds = 'MANAGE_ADS',
  ManageBookings = 'MANAGE_BOOKINGS',
  ManageBusinessCategories = 'MANAGE_BUSINESS_CATEGORIES',
  ManageFiles = 'MANAGE_FILES',
  ManagePlayers = 'MANAGE_PLAYERS',
  ManagePlaylists = 'MANAGE_PLAYLISTS',
  ManageRoles = 'MANAGE_ROLES',
  ManageUsers = 'MANAGE_USERS',
  ManageWorkspaces = 'MANAGE_WORKSPACES',
  ViewAccessLabels = 'VIEW_ACCESS_LABELS',
  ViewAdboards = 'VIEW_ADBOARDS',
  ViewAdboardGroups = 'VIEW_ADBOARD_GROUPS',
  ViewBookings = 'VIEW_BOOKINGS',
  ViewBusinessCategories = 'VIEW_BUSINESS_CATEGORIES',
  ViewFiles = 'VIEW_FILES',
  ViewPlayers = 'VIEW_PLAYERS',
  ViewPlaylists = 'VIEW_PLAYLISTS',
  ViewRoles = 'VIEW_ROLES',
  ViewUsers = 'VIEW_USERS',
  ViewWorkspaces = 'VIEW_WORKSPACES'
}

export type PiSignagePlayer = {
  __typename?: 'PiSignagePlayer';
  adBoardGroup?: Maybe<AdBoardGroup>;
  adBoardGroupId?: Maybe<Scalars['String']>;
  configLocation?: Maybe<Scalars['String']>;
  cpuSerialNumber: Scalars['String'];
  displayName?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  name: Scalars['String'];
  workpaceId?: Maybe<Scalars['String']>;
  workspace?: Maybe<Workspace>;
};


export type PiSignagePlayerAdBoardGroupArgs = {
  where?: InputMaybe<AdBoardGroupWhereInput>;
};


export type PiSignagePlayerWorkspaceArgs = {
  where?: InputMaybe<WorkspaceWhereInput>;
};

export type PiSignagePlayerCountAggregate = {
  __typename?: 'PiSignagePlayerCountAggregate';
  _all: Scalars['Int'];
  adBoardGroupId: Scalars['Int'];
  configLocation: Scalars['Int'];
  cpuSerialNumber: Scalars['Int'];
  displayName: Scalars['Int'];
  id: Scalars['Int'];
  name: Scalars['Int'];
  workpaceId: Scalars['Int'];
};

export type PiSignagePlayerCountOrderByAggregateInput = {
  adBoardGroupId?: InputMaybe<SortOrder>;
  configLocation?: InputMaybe<SortOrder>;
  cpuSerialNumber?: InputMaybe<SortOrder>;
  displayName?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  name?: InputMaybe<SortOrder>;
  workpaceId?: InputMaybe<SortOrder>;
};

export type PiSignagePlayerCreateInput = {
  adBoardGroup?: InputMaybe<AdBoardGroupCreateNestedOneWithoutPisignagePlayersInput>;
  configLocation?: InputMaybe<Scalars['String']>;
  cpuSerialNumber: Scalars['String'];
  displayName?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
  workspace?: InputMaybe<WorkspaceCreateNestedOneWithoutPiSignagePlayersInput>;
};

export type PiSignagePlayerCreateManyAdBoardGroupInput = {
  configLocation?: InputMaybe<Scalars['String']>;
  cpuSerialNumber: Scalars['String'];
  displayName?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
  workpaceId?: InputMaybe<Scalars['String']>;
};

export type PiSignagePlayerCreateManyAdBoardGroupInputEnvelope = {
  data: Array<PiSignagePlayerCreateManyAdBoardGroupInput>;
};

export type PiSignagePlayerCreateManyInput = {
  adBoardGroupId?: InputMaybe<Scalars['String']>;
  configLocation?: InputMaybe<Scalars['String']>;
  cpuSerialNumber: Scalars['String'];
  displayName?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
  workpaceId?: InputMaybe<Scalars['String']>;
};

export type PiSignagePlayerCreateManyWorkspaceInput = {
  adBoardGroupId?: InputMaybe<Scalars['String']>;
  configLocation?: InputMaybe<Scalars['String']>;
  cpuSerialNumber: Scalars['String'];
  displayName?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
};

export type PiSignagePlayerCreateManyWorkspaceInputEnvelope = {
  data: Array<PiSignagePlayerCreateManyWorkspaceInput>;
};

export type PiSignagePlayerCreateNestedManyWithoutAdBoardGroupInput = {
  connect?: InputMaybe<Array<PiSignagePlayerWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<PiSignagePlayerCreateOrConnectWithoutAdBoardGroupInput>>;
  create?: InputMaybe<Array<PiSignagePlayerCreateWithoutAdBoardGroupInput>>;
  createMany?: InputMaybe<PiSignagePlayerCreateManyAdBoardGroupInputEnvelope>;
};

export type PiSignagePlayerCreateNestedManyWithoutWorkspaceInput = {
  connect?: InputMaybe<Array<PiSignagePlayerWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<PiSignagePlayerCreateOrConnectWithoutWorkspaceInput>>;
  create?: InputMaybe<Array<PiSignagePlayerCreateWithoutWorkspaceInput>>;
  createMany?: InputMaybe<PiSignagePlayerCreateManyWorkspaceInputEnvelope>;
};

export type PiSignagePlayerCreateOrConnectWithoutAdBoardGroupInput = {
  create: PiSignagePlayerCreateWithoutAdBoardGroupInput;
  where: PiSignagePlayerWhereUniqueInput;
};

export type PiSignagePlayerCreateOrConnectWithoutWorkspaceInput = {
  create: PiSignagePlayerCreateWithoutWorkspaceInput;
  where: PiSignagePlayerWhereUniqueInput;
};

export type PiSignagePlayerCreateWithoutAdBoardGroupInput = {
  configLocation?: InputMaybe<Scalars['String']>;
  cpuSerialNumber: Scalars['String'];
  displayName?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
  workspace?: InputMaybe<WorkspaceCreateNestedOneWithoutPiSignagePlayersInput>;
};

export type PiSignagePlayerCreateWithoutWorkspaceInput = {
  adBoardGroup?: InputMaybe<AdBoardGroupCreateNestedOneWithoutPisignagePlayersInput>;
  configLocation?: InputMaybe<Scalars['String']>;
  cpuSerialNumber: Scalars['String'];
  displayName?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
};

export type PiSignagePlayerGroupBy = {
  __typename?: 'PiSignagePlayerGroupBy';
  _count?: Maybe<PiSignagePlayerCountAggregate>;
  _max?: Maybe<PiSignagePlayerMaxAggregate>;
  _min?: Maybe<PiSignagePlayerMinAggregate>;
  adBoardGroupId?: Maybe<Scalars['String']>;
  configLocation?: Maybe<Scalars['String']>;
  cpuSerialNumber: Scalars['String'];
  displayName?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  name: Scalars['String'];
  workpaceId?: Maybe<Scalars['String']>;
};

export type PiSignagePlayerListRelationFilter = {
  every?: InputMaybe<PiSignagePlayerWhereInput>;
  none?: InputMaybe<PiSignagePlayerWhereInput>;
  some?: InputMaybe<PiSignagePlayerWhereInput>;
};

export type PiSignagePlayerMaxAggregate = {
  __typename?: 'PiSignagePlayerMaxAggregate';
  adBoardGroupId?: Maybe<Scalars['String']>;
  configLocation?: Maybe<Scalars['String']>;
  cpuSerialNumber?: Maybe<Scalars['String']>;
  displayName?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  workpaceId?: Maybe<Scalars['String']>;
};

export type PiSignagePlayerMaxOrderByAggregateInput = {
  adBoardGroupId?: InputMaybe<SortOrder>;
  configLocation?: InputMaybe<SortOrder>;
  cpuSerialNumber?: InputMaybe<SortOrder>;
  displayName?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  name?: InputMaybe<SortOrder>;
  workpaceId?: InputMaybe<SortOrder>;
};

export type PiSignagePlayerMinAggregate = {
  __typename?: 'PiSignagePlayerMinAggregate';
  adBoardGroupId?: Maybe<Scalars['String']>;
  configLocation?: Maybe<Scalars['String']>;
  cpuSerialNumber?: Maybe<Scalars['String']>;
  displayName?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  workpaceId?: Maybe<Scalars['String']>;
};

export type PiSignagePlayerMinOrderByAggregateInput = {
  adBoardGroupId?: InputMaybe<SortOrder>;
  configLocation?: InputMaybe<SortOrder>;
  cpuSerialNumber?: InputMaybe<SortOrder>;
  displayName?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  name?: InputMaybe<SortOrder>;
  workpaceId?: InputMaybe<SortOrder>;
};

export type PiSignagePlayerOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type PiSignagePlayerOrderByWithAggregationInput = {
  _count?: InputMaybe<PiSignagePlayerCountOrderByAggregateInput>;
  _max?: InputMaybe<PiSignagePlayerMaxOrderByAggregateInput>;
  _min?: InputMaybe<PiSignagePlayerMinOrderByAggregateInput>;
  adBoardGroupId?: InputMaybe<SortOrder>;
  configLocation?: InputMaybe<SortOrder>;
  cpuSerialNumber?: InputMaybe<SortOrder>;
  displayName?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  name?: InputMaybe<SortOrder>;
  workpaceId?: InputMaybe<SortOrder>;
};

export type PiSignagePlayerOrderByWithRelationInput = {
  adBoardGroup?: InputMaybe<AdBoardGroupOrderByWithRelationInput>;
  adBoardGroupId?: InputMaybe<SortOrder>;
  configLocation?: InputMaybe<SortOrder>;
  cpuSerialNumber?: InputMaybe<SortOrder>;
  displayName?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  name?: InputMaybe<SortOrder>;
  workpaceId?: InputMaybe<SortOrder>;
  workspace?: InputMaybe<WorkspaceOrderByWithRelationInput>;
};

export enum PiSignagePlayerScalarFieldEnum {
  AdBoardGroupId = 'adBoardGroupId',
  ConfigLocation = 'configLocation',
  CpuSerialNumber = 'cpuSerialNumber',
  DisplayName = 'displayName',
  Id = 'id',
  Name = 'name',
  WorkpaceId = 'workpaceId'
}

export type PiSignagePlayerScalarWhereInput = {
  AND?: InputMaybe<Array<PiSignagePlayerScalarWhereInput>>;
  NOT?: InputMaybe<Array<PiSignagePlayerScalarWhereInput>>;
  OR?: InputMaybe<Array<PiSignagePlayerScalarWhereInput>>;
  adBoardGroupId?: InputMaybe<StringNullableFilter>;
  configLocation?: InputMaybe<StringNullableFilter>;
  cpuSerialNumber?: InputMaybe<StringFilter>;
  displayName?: InputMaybe<StringNullableFilter>;
  id?: InputMaybe<StringFilter>;
  name?: InputMaybe<StringFilter>;
  workpaceId?: InputMaybe<StringNullableFilter>;
};

export type PiSignagePlayerScalarWhereWithAggregatesInput = {
  AND?: InputMaybe<Array<PiSignagePlayerScalarWhereWithAggregatesInput>>;
  NOT?: InputMaybe<Array<PiSignagePlayerScalarWhereWithAggregatesInput>>;
  OR?: InputMaybe<Array<PiSignagePlayerScalarWhereWithAggregatesInput>>;
  adBoardGroupId?: InputMaybe<StringNullableWithAggregatesFilter>;
  configLocation?: InputMaybe<StringNullableWithAggregatesFilter>;
  cpuSerialNumber?: InputMaybe<StringWithAggregatesFilter>;
  displayName?: InputMaybe<StringNullableWithAggregatesFilter>;
  id?: InputMaybe<StringWithAggregatesFilter>;
  name?: InputMaybe<StringWithAggregatesFilter>;
  workpaceId?: InputMaybe<StringNullableWithAggregatesFilter>;
};

export type PiSignagePlayerUpdateInput = {
  adBoardGroup?: InputMaybe<AdBoardGroupUpdateOneWithoutPisignagePlayersNestedInput>;
  configLocation?: InputMaybe<Scalars['String']>;
  cpuSerialNumber?: InputMaybe<Scalars['String']>;
  displayName?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  workspace?: InputMaybe<WorkspaceUpdateOneWithoutPiSignagePlayersNestedInput>;
};

export type PiSignagePlayerUpdateManyMutationInput = {
  configLocation?: InputMaybe<Scalars['String']>;
  cpuSerialNumber?: InputMaybe<Scalars['String']>;
  displayName?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
};

export type PiSignagePlayerUpdateManyWithWhereWithoutAdBoardGroupInput = {
  data: PiSignagePlayerUpdateManyMutationInput;
  where: PiSignagePlayerScalarWhereInput;
};

export type PiSignagePlayerUpdateManyWithWhereWithoutWorkspaceInput = {
  data: PiSignagePlayerUpdateManyMutationInput;
  where: PiSignagePlayerScalarWhereInput;
};

export type PiSignagePlayerUpdateManyWithoutAdBoardGroupNestedInput = {
  connect?: InputMaybe<Array<PiSignagePlayerWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<PiSignagePlayerCreateOrConnectWithoutAdBoardGroupInput>>;
  create?: InputMaybe<Array<PiSignagePlayerCreateWithoutAdBoardGroupInput>>;
  createMany?: InputMaybe<PiSignagePlayerCreateManyAdBoardGroupInputEnvelope>;
  delete?: InputMaybe<Array<PiSignagePlayerWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<PiSignagePlayerScalarWhereInput>>;
  disconnect?: InputMaybe<Array<PiSignagePlayerWhereUniqueInput>>;
  set?: InputMaybe<Array<PiSignagePlayerWhereUniqueInput>>;
  update?: InputMaybe<Array<PiSignagePlayerUpdateWithWhereUniqueWithoutAdBoardGroupInput>>;
  updateMany?: InputMaybe<Array<PiSignagePlayerUpdateManyWithWhereWithoutAdBoardGroupInput>>;
  upsert?: InputMaybe<Array<PiSignagePlayerUpsertWithWhereUniqueWithoutAdBoardGroupInput>>;
};

export type PiSignagePlayerUpdateManyWithoutWorkspaceNestedInput = {
  connect?: InputMaybe<Array<PiSignagePlayerWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<PiSignagePlayerCreateOrConnectWithoutWorkspaceInput>>;
  create?: InputMaybe<Array<PiSignagePlayerCreateWithoutWorkspaceInput>>;
  createMany?: InputMaybe<PiSignagePlayerCreateManyWorkspaceInputEnvelope>;
  delete?: InputMaybe<Array<PiSignagePlayerWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<PiSignagePlayerScalarWhereInput>>;
  disconnect?: InputMaybe<Array<PiSignagePlayerWhereUniqueInput>>;
  set?: InputMaybe<Array<PiSignagePlayerWhereUniqueInput>>;
  update?: InputMaybe<Array<PiSignagePlayerUpdateWithWhereUniqueWithoutWorkspaceInput>>;
  updateMany?: InputMaybe<Array<PiSignagePlayerUpdateManyWithWhereWithoutWorkspaceInput>>;
  upsert?: InputMaybe<Array<PiSignagePlayerUpsertWithWhereUniqueWithoutWorkspaceInput>>;
};

export type PiSignagePlayerUpdateWithWhereUniqueWithoutAdBoardGroupInput = {
  data: PiSignagePlayerUpdateWithoutAdBoardGroupInput;
  where: PiSignagePlayerWhereUniqueInput;
};

export type PiSignagePlayerUpdateWithWhereUniqueWithoutWorkspaceInput = {
  data: PiSignagePlayerUpdateWithoutWorkspaceInput;
  where: PiSignagePlayerWhereUniqueInput;
};

export type PiSignagePlayerUpdateWithoutAdBoardGroupInput = {
  configLocation?: InputMaybe<Scalars['String']>;
  cpuSerialNumber?: InputMaybe<Scalars['String']>;
  displayName?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  workspace?: InputMaybe<WorkspaceUpdateOneWithoutPiSignagePlayersNestedInput>;
};

export type PiSignagePlayerUpdateWithoutWorkspaceInput = {
  adBoardGroup?: InputMaybe<AdBoardGroupUpdateOneWithoutPisignagePlayersNestedInput>;
  configLocation?: InputMaybe<Scalars['String']>;
  cpuSerialNumber?: InputMaybe<Scalars['String']>;
  displayName?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
};

export type PiSignagePlayerUpsertWithWhereUniqueWithoutAdBoardGroupInput = {
  create: PiSignagePlayerCreateWithoutAdBoardGroupInput;
  update: PiSignagePlayerUpdateWithoutAdBoardGroupInput;
  where: PiSignagePlayerWhereUniqueInput;
};

export type PiSignagePlayerUpsertWithWhereUniqueWithoutWorkspaceInput = {
  create: PiSignagePlayerCreateWithoutWorkspaceInput;
  update: PiSignagePlayerUpdateWithoutWorkspaceInput;
  where: PiSignagePlayerWhereUniqueInput;
};

export type PiSignagePlayerWhereInput = {
  AND?: InputMaybe<Array<PiSignagePlayerWhereInput>>;
  NOT?: InputMaybe<Array<PiSignagePlayerWhereInput>>;
  OR?: InputMaybe<Array<PiSignagePlayerWhereInput>>;
  adBoardGroup?: InputMaybe<AdBoardGroupNullableRelationFilter>;
  adBoardGroupId?: InputMaybe<StringNullableFilter>;
  configLocation?: InputMaybe<StringNullableFilter>;
  cpuSerialNumber?: InputMaybe<StringFilter>;
  displayName?: InputMaybe<StringNullableFilter>;
  id?: InputMaybe<StringFilter>;
  name?: InputMaybe<StringFilter>;
  workpaceId?: InputMaybe<StringNullableFilter>;
  workspace?: InputMaybe<WorkspaceNullableRelationFilter>;
};

export type PiSignagePlayerWhereUniqueInput = {
  AND?: InputMaybe<Array<PiSignagePlayerWhereInput>>;
  NOT?: InputMaybe<Array<PiSignagePlayerWhereInput>>;
  OR?: InputMaybe<Array<PiSignagePlayerWhereInput>>;
  adBoardGroup?: InputMaybe<AdBoardGroupNullableRelationFilter>;
  adBoardGroupId?: InputMaybe<StringNullableFilter>;
  configLocation?: InputMaybe<StringNullableFilter>;
  cpuSerialNumber?: InputMaybe<Scalars['String']>;
  displayName?: InputMaybe<StringNullableFilter>;
  id?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<StringFilter>;
  workpaceId?: InputMaybe<StringNullableFilter>;
  workspace?: InputMaybe<WorkspaceNullableRelationFilter>;
};

export type PisignageFile = {
  __typename?: 'PisignageFile';
  duration?: Maybe<Scalars['Int']>;
  muteAudio?: Maybe<Scalars['Boolean']>;
  name: Scalars['String'];
};

export type PisignageFileCreateInput = {
  duration?: InputMaybe<Scalars['Int']>;
  muteAudio?: InputMaybe<Scalars['Boolean']>;
  name: Scalars['String'];
};

export type PisignageFileObjectEqualityInput = {
  duration?: InputMaybe<Scalars['Int']>;
  muteAudio?: InputMaybe<Scalars['Boolean']>;
  name: Scalars['String'];
};

export type PisignageFileOrderByCompositeAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type PlaybackTime = {
  __typename?: 'PlaybackTime';
  endTime: Scalars['String'];
  name: Scalars['String'];
  startTime: Scalars['String'];
};

export type PlaybackTimeCreateInput = {
  endTime: Scalars['String'];
  name: Scalars['String'];
  startTime: Scalars['String'];
};

export type PlaybackTimeObjectEqualityInput = {
  endTime: Scalars['String'];
  name: Scalars['String'];
  startTime: Scalars['String'];
};

export type PlaybackTimeOrderByCompositeAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type Playlist = {
  __typename?: 'Playlist';
  _count?: Maybe<PlaylistCount>;
  accessLabelIDs: Array<Scalars['String']>;
  accessLabels: Array<AccessLabel>;
  adBoardGroupIds: Array<Scalars['String']>;
  adBoardGroups: Array<AdBoardGroup>;
  assets: Array<PisignageFile>;
  displayName?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  isAdsPlaylist?: Maybe<Scalars['Boolean']>;
  layout?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  workspace: Workspace;
  workspaceId: Scalars['String'];
};


export type PlaylistAccessLabelsArgs = {
  cursor?: InputMaybe<AccessLabelWhereUniqueInput>;
  distinct?: InputMaybe<Array<AccessLabelScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<AccessLabelOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<AccessLabelWhereInput>;
};


export type PlaylistAdBoardGroupsArgs = {
  cursor?: InputMaybe<AdBoardGroupWhereUniqueInput>;
  distinct?: InputMaybe<Array<AdBoardGroupScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<AdBoardGroupOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<AdBoardGroupWhereInput>;
};

export type PlaylistCount = {
  __typename?: 'PlaylistCount';
  accessLabels: Scalars['Int'];
  adBoardGroups: Scalars['Int'];
};


export type PlaylistCountAccessLabelsArgs = {
  where?: InputMaybe<AccessLabelWhereInput>;
};


export type PlaylistCountAdBoardGroupsArgs = {
  where?: InputMaybe<AdBoardGroupWhereInput>;
};

export type PlaylistCountAggregate = {
  __typename?: 'PlaylistCountAggregate';
  _all: Scalars['Int'];
  accessLabelIDs: Scalars['Int'];
  adBoardGroupIds: Scalars['Int'];
  displayName: Scalars['Int'];
  id: Scalars['Int'];
  isAdsPlaylist: Scalars['Int'];
  layout: Scalars['Int'];
  name: Scalars['Int'];
  workspaceId: Scalars['Int'];
};

export type PlaylistCountOrderByAggregateInput = {
  accessLabelIDs?: InputMaybe<SortOrder>;
  adBoardGroupIds?: InputMaybe<SortOrder>;
  displayName?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  isAdsPlaylist?: InputMaybe<SortOrder>;
  layout?: InputMaybe<SortOrder>;
  name?: InputMaybe<SortOrder>;
  workspaceId?: InputMaybe<SortOrder>;
};

export type PlaylistCreateInput = {
  accessLabels?: InputMaybe<AccessLabelCreateNestedManyWithoutPlaylistsInput>;
  adBoardGroups?: InputMaybe<AdBoardGroupCreateNestedManyWithoutPlaylistsInput>;
  assets?: InputMaybe<Array<PisignageFileCreateInput>>;
  displayName?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  isAdsPlaylist?: InputMaybe<Scalars['Boolean']>;
  layout?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
  workspace: WorkspaceCreateNestedOneWithoutPlaylistsInput;
};

export type PlaylistCreateManyInput = {
  accessLabelIDs?: InputMaybe<Array<Scalars['String']>>;
  adBoardGroupIds?: InputMaybe<Array<Scalars['String']>>;
  assets?: InputMaybe<Array<PisignageFileCreateInput>>;
  displayName?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  isAdsPlaylist?: InputMaybe<Scalars['Boolean']>;
  layout?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
  workspaceId: Scalars['String'];
};

export type PlaylistCreateManyWorkspaceInput = {
  accessLabelIDs?: InputMaybe<Array<Scalars['String']>>;
  adBoardGroupIds?: InputMaybe<Array<Scalars['String']>>;
  assets?: InputMaybe<Array<PisignageFileCreateInput>>;
  displayName?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  isAdsPlaylist?: InputMaybe<Scalars['Boolean']>;
  layout?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
};

export type PlaylistCreateManyWorkspaceInputEnvelope = {
  data: Array<PlaylistCreateManyWorkspaceInput>;
};

export type PlaylistCreateNestedManyWithoutAccessLabelsInput = {
  connect?: InputMaybe<Array<PlaylistWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<PlaylistCreateOrConnectWithoutAccessLabelsInput>>;
  create?: InputMaybe<Array<PlaylistCreateWithoutAccessLabelsInput>>;
};

export type PlaylistCreateNestedManyWithoutAdBoardGroupsInput = {
  connect?: InputMaybe<Array<PlaylistWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<PlaylistCreateOrConnectWithoutAdBoardGroupsInput>>;
  create?: InputMaybe<Array<PlaylistCreateWithoutAdBoardGroupsInput>>;
};

export type PlaylistCreateNestedManyWithoutWorkspaceInput = {
  connect?: InputMaybe<Array<PlaylistWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<PlaylistCreateOrConnectWithoutWorkspaceInput>>;
  create?: InputMaybe<Array<PlaylistCreateWithoutWorkspaceInput>>;
  createMany?: InputMaybe<PlaylistCreateManyWorkspaceInputEnvelope>;
};

export type PlaylistCreateOrConnectWithoutAccessLabelsInput = {
  create: PlaylistCreateWithoutAccessLabelsInput;
  where: PlaylistWhereUniqueInput;
};

export type PlaylistCreateOrConnectWithoutAdBoardGroupsInput = {
  create: PlaylistCreateWithoutAdBoardGroupsInput;
  where: PlaylistWhereUniqueInput;
};

export type PlaylistCreateOrConnectWithoutWorkspaceInput = {
  create: PlaylistCreateWithoutWorkspaceInput;
  where: PlaylistWhereUniqueInput;
};

export type PlaylistCreateWithoutAccessLabelsInput = {
  adBoardGroups?: InputMaybe<AdBoardGroupCreateNestedManyWithoutPlaylistsInput>;
  assets?: InputMaybe<Array<PisignageFileCreateInput>>;
  displayName?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  isAdsPlaylist?: InputMaybe<Scalars['Boolean']>;
  layout?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
  workspace: WorkspaceCreateNestedOneWithoutPlaylistsInput;
};

export type PlaylistCreateWithoutAdBoardGroupsInput = {
  accessLabels?: InputMaybe<AccessLabelCreateNestedManyWithoutPlaylistsInput>;
  assets?: InputMaybe<Array<PisignageFileCreateInput>>;
  displayName?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  isAdsPlaylist?: InputMaybe<Scalars['Boolean']>;
  layout?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
  workspace: WorkspaceCreateNestedOneWithoutPlaylistsInput;
};

export type PlaylistCreateWithoutWorkspaceInput = {
  accessLabels?: InputMaybe<AccessLabelCreateNestedManyWithoutPlaylistsInput>;
  adBoardGroups?: InputMaybe<AdBoardGroupCreateNestedManyWithoutPlaylistsInput>;
  assets?: InputMaybe<Array<PisignageFileCreateInput>>;
  displayName?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  isAdsPlaylist?: InputMaybe<Scalars['Boolean']>;
  layout?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
};

export type PlaylistGroupBy = {
  __typename?: 'PlaylistGroupBy';
  _count?: Maybe<PlaylistCountAggregate>;
  _max?: Maybe<PlaylistMaxAggregate>;
  _min?: Maybe<PlaylistMinAggregate>;
  accessLabelIDs?: Maybe<Array<Scalars['String']>>;
  adBoardGroupIds?: Maybe<Array<Scalars['String']>>;
  displayName?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  isAdsPlaylist?: Maybe<Scalars['Boolean']>;
  layout?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  workspaceId: Scalars['String'];
};

export type PlaylistListRelationFilter = {
  every?: InputMaybe<PlaylistWhereInput>;
  none?: InputMaybe<PlaylistWhereInput>;
  some?: InputMaybe<PlaylistWhereInput>;
};

export type PlaylistMaxAggregate = {
  __typename?: 'PlaylistMaxAggregate';
  displayName?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  isAdsPlaylist?: Maybe<Scalars['Boolean']>;
  layout?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  workspaceId?: Maybe<Scalars['String']>;
};

export type PlaylistMaxOrderByAggregateInput = {
  displayName?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  isAdsPlaylist?: InputMaybe<SortOrder>;
  layout?: InputMaybe<SortOrder>;
  name?: InputMaybe<SortOrder>;
  workspaceId?: InputMaybe<SortOrder>;
};

export type PlaylistMinAggregate = {
  __typename?: 'PlaylistMinAggregate';
  displayName?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  isAdsPlaylist?: Maybe<Scalars['Boolean']>;
  layout?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  workspaceId?: Maybe<Scalars['String']>;
};

export type PlaylistMinOrderByAggregateInput = {
  displayName?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  isAdsPlaylist?: InputMaybe<SortOrder>;
  layout?: InputMaybe<SortOrder>;
  name?: InputMaybe<SortOrder>;
  workspaceId?: InputMaybe<SortOrder>;
};

export type PlaylistOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type PlaylistOrderByWithAggregationInput = {
  _count?: InputMaybe<PlaylistCountOrderByAggregateInput>;
  _max?: InputMaybe<PlaylistMaxOrderByAggregateInput>;
  _min?: InputMaybe<PlaylistMinOrderByAggregateInput>;
  accessLabelIDs?: InputMaybe<SortOrder>;
  adBoardGroupIds?: InputMaybe<SortOrder>;
  displayName?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  isAdsPlaylist?: InputMaybe<SortOrder>;
  layout?: InputMaybe<SortOrder>;
  name?: InputMaybe<SortOrder>;
  workspaceId?: InputMaybe<SortOrder>;
};

export type PlaylistOrderByWithRelationInput = {
  accessLabelIDs?: InputMaybe<SortOrder>;
  accessLabels?: InputMaybe<AccessLabelOrderByRelationAggregateInput>;
  adBoardGroupIds?: InputMaybe<SortOrder>;
  adBoardGroups?: InputMaybe<AdBoardGroupOrderByRelationAggregateInput>;
  assets?: InputMaybe<PisignageFileOrderByCompositeAggregateInput>;
  displayName?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  isAdsPlaylist?: InputMaybe<SortOrder>;
  layout?: InputMaybe<SortOrder>;
  name?: InputMaybe<SortOrder>;
  workspace?: InputMaybe<WorkspaceOrderByWithRelationInput>;
  workspaceId?: InputMaybe<SortOrder>;
};

export enum PlaylistScalarFieldEnum {
  AccessLabelIDs = 'accessLabelIDs',
  AdBoardGroupIds = 'adBoardGroupIds',
  DisplayName = 'displayName',
  Id = 'id',
  IsAdsPlaylist = 'isAdsPlaylist',
  Layout = 'layout',
  Name = 'name',
  WorkspaceId = 'workspaceId'
}

export type PlaylistScalarWhereInput = {
  AND?: InputMaybe<Array<PlaylistScalarWhereInput>>;
  NOT?: InputMaybe<Array<PlaylistScalarWhereInput>>;
  OR?: InputMaybe<Array<PlaylistScalarWhereInput>>;
  accessLabelIDs?: InputMaybe<StringNullableListFilter>;
  adBoardGroupIds?: InputMaybe<StringNullableListFilter>;
  displayName?: InputMaybe<StringNullableFilter>;
  id?: InputMaybe<StringFilter>;
  isAdsPlaylist?: InputMaybe<BoolNullableFilter>;
  layout?: InputMaybe<StringNullableFilter>;
  name?: InputMaybe<StringFilter>;
  workspaceId?: InputMaybe<StringFilter>;
};

export type PlaylistScalarWhereWithAggregatesInput = {
  AND?: InputMaybe<Array<PlaylistScalarWhereWithAggregatesInput>>;
  NOT?: InputMaybe<Array<PlaylistScalarWhereWithAggregatesInput>>;
  OR?: InputMaybe<Array<PlaylistScalarWhereWithAggregatesInput>>;
  accessLabelIDs?: InputMaybe<StringNullableListFilter>;
  adBoardGroupIds?: InputMaybe<StringNullableListFilter>;
  displayName?: InputMaybe<StringNullableWithAggregatesFilter>;
  id?: InputMaybe<StringWithAggregatesFilter>;
  isAdsPlaylist?: InputMaybe<BoolNullableWithAggregatesFilter>;
  layout?: InputMaybe<StringNullableWithAggregatesFilter>;
  name?: InputMaybe<StringWithAggregatesFilter>;
  workspaceId?: InputMaybe<StringWithAggregatesFilter>;
};

export type PlaylistUpdateInput = {
  accessLabels?: InputMaybe<AccessLabelUpdateManyWithoutPlaylistsNestedInput>;
  adBoardGroups?: InputMaybe<AdBoardGroupUpdateManyWithoutPlaylistsNestedInput>;
  assets?: InputMaybe<Array<PisignageFileCreateInput>>;
  displayName?: InputMaybe<Scalars['String']>;
  isAdsPlaylist?: InputMaybe<Scalars['Boolean']>;
  layout?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  workspace?: InputMaybe<WorkspaceUpdateOneRequiredWithoutPlaylistsNestedInput>;
};

export type PlaylistUpdateManyMutationInput = {
  assets?: InputMaybe<Array<PisignageFileCreateInput>>;
  displayName?: InputMaybe<Scalars['String']>;
  isAdsPlaylist?: InputMaybe<Scalars['Boolean']>;
  layout?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
};

export type PlaylistUpdateManyWithWhereWithoutAccessLabelsInput = {
  data: PlaylistUpdateManyMutationInput;
  where: PlaylistScalarWhereInput;
};

export type PlaylistUpdateManyWithWhereWithoutAdBoardGroupsInput = {
  data: PlaylistUpdateManyMutationInput;
  where: PlaylistScalarWhereInput;
};

export type PlaylistUpdateManyWithWhereWithoutWorkspaceInput = {
  data: PlaylistUpdateManyMutationInput;
  where: PlaylistScalarWhereInput;
};

export type PlaylistUpdateManyWithoutAccessLabelsNestedInput = {
  connect?: InputMaybe<Array<PlaylistWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<PlaylistCreateOrConnectWithoutAccessLabelsInput>>;
  create?: InputMaybe<Array<PlaylistCreateWithoutAccessLabelsInput>>;
  delete?: InputMaybe<Array<PlaylistWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<PlaylistScalarWhereInput>>;
  disconnect?: InputMaybe<Array<PlaylistWhereUniqueInput>>;
  set?: InputMaybe<Array<PlaylistWhereUniqueInput>>;
  update?: InputMaybe<Array<PlaylistUpdateWithWhereUniqueWithoutAccessLabelsInput>>;
  updateMany?: InputMaybe<Array<PlaylistUpdateManyWithWhereWithoutAccessLabelsInput>>;
  upsert?: InputMaybe<Array<PlaylistUpsertWithWhereUniqueWithoutAccessLabelsInput>>;
};

export type PlaylistUpdateManyWithoutAdBoardGroupsNestedInput = {
  connect?: InputMaybe<Array<PlaylistWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<PlaylistCreateOrConnectWithoutAdBoardGroupsInput>>;
  create?: InputMaybe<Array<PlaylistCreateWithoutAdBoardGroupsInput>>;
  delete?: InputMaybe<Array<PlaylistWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<PlaylistScalarWhereInput>>;
  disconnect?: InputMaybe<Array<PlaylistWhereUniqueInput>>;
  set?: InputMaybe<Array<PlaylistWhereUniqueInput>>;
  update?: InputMaybe<Array<PlaylistUpdateWithWhereUniqueWithoutAdBoardGroupsInput>>;
  updateMany?: InputMaybe<Array<PlaylistUpdateManyWithWhereWithoutAdBoardGroupsInput>>;
  upsert?: InputMaybe<Array<PlaylistUpsertWithWhereUniqueWithoutAdBoardGroupsInput>>;
};

export type PlaylistUpdateManyWithoutWorkspaceNestedInput = {
  connect?: InputMaybe<Array<PlaylistWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<PlaylistCreateOrConnectWithoutWorkspaceInput>>;
  create?: InputMaybe<Array<PlaylistCreateWithoutWorkspaceInput>>;
  createMany?: InputMaybe<PlaylistCreateManyWorkspaceInputEnvelope>;
  delete?: InputMaybe<Array<PlaylistWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<PlaylistScalarWhereInput>>;
  disconnect?: InputMaybe<Array<PlaylistWhereUniqueInput>>;
  set?: InputMaybe<Array<PlaylistWhereUniqueInput>>;
  update?: InputMaybe<Array<PlaylistUpdateWithWhereUniqueWithoutWorkspaceInput>>;
  updateMany?: InputMaybe<Array<PlaylistUpdateManyWithWhereWithoutWorkspaceInput>>;
  upsert?: InputMaybe<Array<PlaylistUpsertWithWhereUniqueWithoutWorkspaceInput>>;
};

export type PlaylistUpdateWithWhereUniqueWithoutAccessLabelsInput = {
  data: PlaylistUpdateWithoutAccessLabelsInput;
  where: PlaylistWhereUniqueInput;
};

export type PlaylistUpdateWithWhereUniqueWithoutAdBoardGroupsInput = {
  data: PlaylistUpdateWithoutAdBoardGroupsInput;
  where: PlaylistWhereUniqueInput;
};

export type PlaylistUpdateWithWhereUniqueWithoutWorkspaceInput = {
  data: PlaylistUpdateWithoutWorkspaceInput;
  where: PlaylistWhereUniqueInput;
};

export type PlaylistUpdateWithoutAccessLabelsInput = {
  adBoardGroups?: InputMaybe<AdBoardGroupUpdateManyWithoutPlaylistsNestedInput>;
  assets?: InputMaybe<Array<PisignageFileCreateInput>>;
  displayName?: InputMaybe<Scalars['String']>;
  isAdsPlaylist?: InputMaybe<Scalars['Boolean']>;
  layout?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  workspace?: InputMaybe<WorkspaceUpdateOneRequiredWithoutPlaylistsNestedInput>;
};

export type PlaylistUpdateWithoutAdBoardGroupsInput = {
  accessLabels?: InputMaybe<AccessLabelUpdateManyWithoutPlaylistsNestedInput>;
  assets?: InputMaybe<Array<PisignageFileCreateInput>>;
  displayName?: InputMaybe<Scalars['String']>;
  isAdsPlaylist?: InputMaybe<Scalars['Boolean']>;
  layout?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  workspace?: InputMaybe<WorkspaceUpdateOneRequiredWithoutPlaylistsNestedInput>;
};

export type PlaylistUpdateWithoutWorkspaceInput = {
  accessLabels?: InputMaybe<AccessLabelUpdateManyWithoutPlaylistsNestedInput>;
  adBoardGroups?: InputMaybe<AdBoardGroupUpdateManyWithoutPlaylistsNestedInput>;
  assets?: InputMaybe<Array<PisignageFileCreateInput>>;
  displayName?: InputMaybe<Scalars['String']>;
  isAdsPlaylist?: InputMaybe<Scalars['Boolean']>;
  layout?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
};

export type PlaylistUpsertWithWhereUniqueWithoutAccessLabelsInput = {
  create: PlaylistCreateWithoutAccessLabelsInput;
  update: PlaylistUpdateWithoutAccessLabelsInput;
  where: PlaylistWhereUniqueInput;
};

export type PlaylistUpsertWithWhereUniqueWithoutAdBoardGroupsInput = {
  create: PlaylistCreateWithoutAdBoardGroupsInput;
  update: PlaylistUpdateWithoutAdBoardGroupsInput;
  where: PlaylistWhereUniqueInput;
};

export type PlaylistUpsertWithWhereUniqueWithoutWorkspaceInput = {
  create: PlaylistCreateWithoutWorkspaceInput;
  update: PlaylistUpdateWithoutWorkspaceInput;
  where: PlaylistWhereUniqueInput;
};

export type PlaylistWhereInput = {
  AND?: InputMaybe<Array<PlaylistWhereInput>>;
  NOT?: InputMaybe<Array<PlaylistWhereInput>>;
  OR?: InputMaybe<Array<PlaylistWhereInput>>;
  accessLabelIDs?: InputMaybe<StringNullableListFilter>;
  accessLabels?: InputMaybe<AccessLabelListRelationFilter>;
  adBoardGroupIds?: InputMaybe<StringNullableListFilter>;
  adBoardGroups?: InputMaybe<AdBoardGroupListRelationFilter>;
  assets?: InputMaybe<Array<PisignageFileObjectEqualityInput>>;
  displayName?: InputMaybe<StringNullableFilter>;
  id?: InputMaybe<StringFilter>;
  isAdsPlaylist?: InputMaybe<BoolNullableFilter>;
  layout?: InputMaybe<StringNullableFilter>;
  name?: InputMaybe<StringFilter>;
  workspace?: InputMaybe<WorkspaceRelationFilter>;
  workspaceId?: InputMaybe<StringFilter>;
};

export type PlaylistWhereUniqueInput = {
  AND?: InputMaybe<Array<PlaylistWhereInput>>;
  NOT?: InputMaybe<Array<PlaylistWhereInput>>;
  OR?: InputMaybe<Array<PlaylistWhereInput>>;
  accessLabelIDs?: InputMaybe<StringNullableListFilter>;
  accessLabels?: InputMaybe<AccessLabelListRelationFilter>;
  adBoardGroupIds?: InputMaybe<StringNullableListFilter>;
  adBoardGroups?: InputMaybe<AdBoardGroupListRelationFilter>;
  assets?: InputMaybe<Array<PisignageFileObjectEqualityInput>>;
  displayName?: InputMaybe<StringNullableFilter>;
  id?: InputMaybe<Scalars['String']>;
  isAdsPlaylist?: InputMaybe<BoolNullableFilter>;
  layout?: InputMaybe<StringNullableFilter>;
  name?: InputMaybe<Scalars['String']>;
  workspace?: InputMaybe<WorkspaceRelationFilter>;
  workspaceId?: InputMaybe<StringFilter>;
};

export type Query = {
  __typename?: 'Query';
  accessLabel?: Maybe<AccessLabel>;
  accessLabels: Array<AccessLabel>;
  adBoard?: Maybe<AdBoard>;
  adBoardGroup?: Maybe<AdBoardGroup>;
  adBoardGroups: Array<AdBoardGroup>;
  adBoards: Array<AdBoard>;
  aggregateAccessLabel: AggregateAccessLabel;
  aggregateAdBoard: AggregateAdBoard;
  aggregateAdBoardGroup: AggregateAdBoardGroup;
  aggregateAudit: AggregateAudit;
  aggregateBooking: AggregateBooking;
  aggregateBusinessCategory: AggregateBusinessCategory;
  aggregateCampaign: AggregateCampaign;
  aggregateChangelog: AggregateChangelog;
  aggregateFile: AggregateFile;
  aggregateMembership: AggregateMembership;
  aggregateOrder: AggregateOrder;
  aggregatePayout: AggregatePayout;
  aggregatePiSignagePlayer: AggregatePiSignagePlayer;
  aggregatePlaylist: AggregatePlaylist;
  aggregateRole: AggregateRole;
  aggregateSlot: AggregateSlot;
  aggregateTransaction: AggregateTransaction;
  aggregateUser: AggregateUser;
  aggregateWorkspace: AggregateWorkspace;
  audit?: Maybe<Audit>;
  audits: Array<Audit>;
  booking?: Maybe<Booking>;
  bookings: Array<Booking>;
  businessCategories: Array<BusinessCategory>;
  businessCategory?: Maybe<BusinessCategory>;
  campaign?: Maybe<Campaign>;
  campaigns: Array<Campaign>;
  changelog?: Maybe<Changelog>;
  changelogs: Array<Changelog>;
  file?: Maybe<File>;
  files: Array<File>;
  findFirstAccessLabel?: Maybe<AccessLabel>;
  findFirstAccessLabelOrThrow?: Maybe<AccessLabel>;
  findFirstAdBoard?: Maybe<AdBoard>;
  findFirstAdBoardGroup?: Maybe<AdBoardGroup>;
  findFirstAdBoardGroupOrThrow?: Maybe<AdBoardGroup>;
  findFirstAdBoardOrThrow?: Maybe<AdBoard>;
  findFirstAudit?: Maybe<Audit>;
  findFirstAuditOrThrow?: Maybe<Audit>;
  findFirstBooking?: Maybe<Booking>;
  findFirstBookingOrThrow?: Maybe<Booking>;
  findFirstBusinessCategory?: Maybe<BusinessCategory>;
  findFirstBusinessCategoryOrThrow?: Maybe<BusinessCategory>;
  findFirstCampaign?: Maybe<Campaign>;
  findFirstCampaignOrThrow?: Maybe<Campaign>;
  findFirstChangelog?: Maybe<Changelog>;
  findFirstChangelogOrThrow?: Maybe<Changelog>;
  findFirstFile?: Maybe<File>;
  findFirstFileOrThrow?: Maybe<File>;
  findFirstMembership?: Maybe<Membership>;
  findFirstMembershipOrThrow?: Maybe<Membership>;
  findFirstOrder?: Maybe<Order>;
  findFirstOrderOrThrow?: Maybe<Order>;
  findFirstPayout?: Maybe<Payout>;
  findFirstPayoutOrThrow?: Maybe<Payout>;
  findFirstPiSignagePlayer?: Maybe<PiSignagePlayer>;
  findFirstPiSignagePlayerOrThrow?: Maybe<PiSignagePlayer>;
  findFirstPlaylist?: Maybe<Playlist>;
  findFirstPlaylistOrThrow?: Maybe<Playlist>;
  findFirstRole?: Maybe<Role>;
  findFirstRoleOrThrow?: Maybe<Role>;
  findFirstSlot?: Maybe<Slot>;
  findFirstSlotOrThrow?: Maybe<Slot>;
  findFirstTransaction?: Maybe<Transaction>;
  findFirstTransactionOrThrow?: Maybe<Transaction>;
  findFirstUser?: Maybe<User>;
  findFirstUserOrThrow?: Maybe<User>;
  findFirstWorkspace?: Maybe<Workspace>;
  findFirstWorkspaceOrThrow?: Maybe<Workspace>;
  getAccessLabel?: Maybe<AccessLabel>;
  getAdBoard?: Maybe<AdBoard>;
  getAdBoardGroup?: Maybe<AdBoardGroup>;
  getAudit?: Maybe<Audit>;
  getBooking?: Maybe<Booking>;
  getBusinessCategory?: Maybe<BusinessCategory>;
  getCampaign?: Maybe<Campaign>;
  getChangelog?: Maybe<Changelog>;
  getFile?: Maybe<File>;
  getMembership?: Maybe<Membership>;
  getOrder?: Maybe<Order>;
  getPayout?: Maybe<Payout>;
  getPiSignagePlayer?: Maybe<PiSignagePlayer>;
  getPlaylist?: Maybe<Playlist>;
  getRole?: Maybe<Role>;
  getSlot?: Maybe<Slot>;
  getSlots?: Maybe<BookingSlot>;
  getTransaction?: Maybe<Transaction>;
  getUser?: Maybe<User>;
  getWorkspace?: Maybe<Workspace>;
  groupByAccessLabel: Array<AccessLabelGroupBy>;
  groupByAdBoard: Array<AdBoardGroupBy>;
  groupByAdBoardGroup: Array<AdBoardGroupGroupBy>;
  groupByAudit: Array<AuditGroupBy>;
  groupByBooking: Array<BookingGroupBy>;
  groupByBusinessCategory: Array<BusinessCategoryGroupBy>;
  groupByCampaign: Array<CampaignGroupBy>;
  groupByChangelog: Array<ChangelogGroupBy>;
  groupByFile: Array<FileGroupBy>;
  groupByMembership: Array<MembershipGroupBy>;
  groupByOrder: Array<OrderGroupBy>;
  groupByPayout: Array<PayoutGroupBy>;
  groupByPiSignagePlayer: Array<PiSignagePlayerGroupBy>;
  groupByPlaylist: Array<PlaylistGroupBy>;
  groupByRole: Array<RoleGroupBy>;
  groupBySlot: Array<SlotGroupBy>;
  groupByTransaction: Array<TransactionGroupBy>;
  groupByUser: Array<UserGroupBy>;
  groupByWorkspace: Array<WorkspaceGroupBy>;
  membership?: Maybe<Membership>;
  memberships: Array<Membership>;
  order?: Maybe<Order>;
  orders: Array<Order>;
  payout?: Maybe<Payout>;
  payouts: Array<Payout>;
  piSignagePlayer?: Maybe<PiSignagePlayer>;
  piSignagePlayers: Array<PiSignagePlayer>;
  playlist?: Maybe<Playlist>;
  playlists: Array<Playlist>;
  role?: Maybe<Role>;
  roles: Array<Role>;
  slot?: Maybe<Slot>;
  slots: Array<Slot>;
  transaction?: Maybe<Transaction>;
  transactions: Array<Transaction>;
  user?: Maybe<User>;
  users: Array<User>;
  workspace?: Maybe<Workspace>;
  workspaces: Array<Workspace>;
};


export type QueryAccessLabelArgs = {
  where: AccessLabelWhereUniqueInput;
};


export type QueryAccessLabelsArgs = {
  cursor?: InputMaybe<AccessLabelWhereUniqueInput>;
  distinct?: InputMaybe<Array<AccessLabelScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<AccessLabelOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<AccessLabelWhereInput>;
};


export type QueryAdBoardArgs = {
  where: AdBoardWhereUniqueInput;
};


export type QueryAdBoardGroupArgs = {
  where: AdBoardGroupWhereUniqueInput;
};


export type QueryAdBoardGroupsArgs = {
  cursor?: InputMaybe<AdBoardGroupWhereUniqueInput>;
  distinct?: InputMaybe<Array<AdBoardGroupScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<AdBoardGroupOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<AdBoardGroupWhereInput>;
};


export type QueryAdBoardsArgs = {
  cursor?: InputMaybe<AdBoardWhereUniqueInput>;
  distinct?: InputMaybe<Array<AdBoardScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<AdBoardOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<AdBoardWhereInput>;
};


export type QueryAggregateAccessLabelArgs = {
  cursor?: InputMaybe<AccessLabelWhereUniqueInput>;
  orderBy?: InputMaybe<Array<AccessLabelOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<AccessLabelWhereInput>;
};


export type QueryAggregateAdBoardArgs = {
  cursor?: InputMaybe<AdBoardWhereUniqueInput>;
  orderBy?: InputMaybe<Array<AdBoardOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<AdBoardWhereInput>;
};


export type QueryAggregateAdBoardGroupArgs = {
  cursor?: InputMaybe<AdBoardGroupWhereUniqueInput>;
  orderBy?: InputMaybe<Array<AdBoardGroupOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<AdBoardGroupWhereInput>;
};


export type QueryAggregateAuditArgs = {
  cursor?: InputMaybe<AuditWhereUniqueInput>;
  orderBy?: InputMaybe<Array<AuditOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<AuditWhereInput>;
};


export type QueryAggregateBookingArgs = {
  cursor?: InputMaybe<BookingWhereUniqueInput>;
  orderBy?: InputMaybe<Array<BookingOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<BookingWhereInput>;
};


export type QueryAggregateBusinessCategoryArgs = {
  cursor?: InputMaybe<BusinessCategoryWhereUniqueInput>;
  orderBy?: InputMaybe<Array<BusinessCategoryOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<BusinessCategoryWhereInput>;
};


export type QueryAggregateCampaignArgs = {
  cursor?: InputMaybe<CampaignWhereUniqueInput>;
  orderBy?: InputMaybe<Array<CampaignOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<CampaignWhereInput>;
};


export type QueryAggregateChangelogArgs = {
  cursor?: InputMaybe<ChangelogWhereUniqueInput>;
  orderBy?: InputMaybe<Array<ChangelogOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<ChangelogWhereInput>;
};


export type QueryAggregateFileArgs = {
  cursor?: InputMaybe<FileWhereUniqueInput>;
  orderBy?: InputMaybe<Array<FileOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<FileWhereInput>;
};


export type QueryAggregateMembershipArgs = {
  cursor?: InputMaybe<MembershipWhereUniqueInput>;
  orderBy?: InputMaybe<Array<MembershipOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<MembershipWhereInput>;
};


export type QueryAggregateOrderArgs = {
  cursor?: InputMaybe<OrderWhereUniqueInput>;
  orderBy?: InputMaybe<Array<OrderOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<OrderWhereInput>;
};


export type QueryAggregatePayoutArgs = {
  cursor?: InputMaybe<PayoutWhereUniqueInput>;
  orderBy?: InputMaybe<Array<PayoutOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<PayoutWhereInput>;
};


export type QueryAggregatePiSignagePlayerArgs = {
  cursor?: InputMaybe<PiSignagePlayerWhereUniqueInput>;
  orderBy?: InputMaybe<Array<PiSignagePlayerOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<PiSignagePlayerWhereInput>;
};


export type QueryAggregatePlaylistArgs = {
  cursor?: InputMaybe<PlaylistWhereUniqueInput>;
  orderBy?: InputMaybe<Array<PlaylistOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<PlaylistWhereInput>;
};


export type QueryAggregateRoleArgs = {
  cursor?: InputMaybe<RoleWhereUniqueInput>;
  orderBy?: InputMaybe<Array<RoleOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<RoleWhereInput>;
};


export type QueryAggregateSlotArgs = {
  cursor?: InputMaybe<SlotWhereUniqueInput>;
  orderBy?: InputMaybe<Array<SlotOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<SlotWhereInput>;
};


export type QueryAggregateTransactionArgs = {
  cursor?: InputMaybe<TransactionWhereUniqueInput>;
  orderBy?: InputMaybe<Array<TransactionOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<TransactionWhereInput>;
};


export type QueryAggregateUserArgs = {
  cursor?: InputMaybe<UserWhereUniqueInput>;
  orderBy?: InputMaybe<Array<UserOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<UserWhereInput>;
};


export type QueryAggregateWorkspaceArgs = {
  cursor?: InputMaybe<WorkspaceWhereUniqueInput>;
  orderBy?: InputMaybe<Array<WorkspaceOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<WorkspaceWhereInput>;
};


export type QueryAuditArgs = {
  where: AuditWhereUniqueInput;
};


export type QueryAuditsArgs = {
  cursor?: InputMaybe<AuditWhereUniqueInput>;
  distinct?: InputMaybe<Array<AuditScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<AuditOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<AuditWhereInput>;
};


export type QueryBookingArgs = {
  where: BookingWhereUniqueInput;
};


export type QueryBookingsArgs = {
  cursor?: InputMaybe<BookingWhereUniqueInput>;
  distinct?: InputMaybe<Array<BookingScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<BookingOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<BookingWhereInput>;
};


export type QueryBusinessCategoriesArgs = {
  cursor?: InputMaybe<BusinessCategoryWhereUniqueInput>;
  distinct?: InputMaybe<Array<BusinessCategoryScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<BusinessCategoryOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<BusinessCategoryWhereInput>;
};


export type QueryBusinessCategoryArgs = {
  where: BusinessCategoryWhereUniqueInput;
};


export type QueryCampaignArgs = {
  where: CampaignWhereUniqueInput;
};


export type QueryCampaignsArgs = {
  cursor?: InputMaybe<CampaignWhereUniqueInput>;
  distinct?: InputMaybe<Array<CampaignScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<CampaignOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<CampaignWhereInput>;
};


export type QueryChangelogArgs = {
  where: ChangelogWhereUniqueInput;
};


export type QueryChangelogsArgs = {
  cursor?: InputMaybe<ChangelogWhereUniqueInput>;
  distinct?: InputMaybe<Array<ChangelogScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<ChangelogOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<ChangelogWhereInput>;
};


export type QueryFileArgs = {
  where: FileWhereUniqueInput;
};


export type QueryFilesArgs = {
  cursor?: InputMaybe<FileWhereUniqueInput>;
  distinct?: InputMaybe<Array<FileScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<FileOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<FileWhereInput>;
};


export type QueryFindFirstAccessLabelArgs = {
  cursor?: InputMaybe<AccessLabelWhereUniqueInput>;
  distinct?: InputMaybe<Array<AccessLabelScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<AccessLabelOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<AccessLabelWhereInput>;
};


export type QueryFindFirstAccessLabelOrThrowArgs = {
  cursor?: InputMaybe<AccessLabelWhereUniqueInput>;
  distinct?: InputMaybe<Array<AccessLabelScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<AccessLabelOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<AccessLabelWhereInput>;
};


export type QueryFindFirstAdBoardArgs = {
  cursor?: InputMaybe<AdBoardWhereUniqueInput>;
  distinct?: InputMaybe<Array<AdBoardScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<AdBoardOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<AdBoardWhereInput>;
};


export type QueryFindFirstAdBoardGroupArgs = {
  cursor?: InputMaybe<AdBoardGroupWhereUniqueInput>;
  distinct?: InputMaybe<Array<AdBoardGroupScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<AdBoardGroupOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<AdBoardGroupWhereInput>;
};


export type QueryFindFirstAdBoardGroupOrThrowArgs = {
  cursor?: InputMaybe<AdBoardGroupWhereUniqueInput>;
  distinct?: InputMaybe<Array<AdBoardGroupScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<AdBoardGroupOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<AdBoardGroupWhereInput>;
};


export type QueryFindFirstAdBoardOrThrowArgs = {
  cursor?: InputMaybe<AdBoardWhereUniqueInput>;
  distinct?: InputMaybe<Array<AdBoardScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<AdBoardOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<AdBoardWhereInput>;
};


export type QueryFindFirstAuditArgs = {
  cursor?: InputMaybe<AuditWhereUniqueInput>;
  distinct?: InputMaybe<Array<AuditScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<AuditOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<AuditWhereInput>;
};


export type QueryFindFirstAuditOrThrowArgs = {
  cursor?: InputMaybe<AuditWhereUniqueInput>;
  distinct?: InputMaybe<Array<AuditScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<AuditOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<AuditWhereInput>;
};


export type QueryFindFirstBookingArgs = {
  cursor?: InputMaybe<BookingWhereUniqueInput>;
  distinct?: InputMaybe<Array<BookingScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<BookingOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<BookingWhereInput>;
};


export type QueryFindFirstBookingOrThrowArgs = {
  cursor?: InputMaybe<BookingWhereUniqueInput>;
  distinct?: InputMaybe<Array<BookingScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<BookingOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<BookingWhereInput>;
};


export type QueryFindFirstBusinessCategoryArgs = {
  cursor?: InputMaybe<BusinessCategoryWhereUniqueInput>;
  distinct?: InputMaybe<Array<BusinessCategoryScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<BusinessCategoryOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<BusinessCategoryWhereInput>;
};


export type QueryFindFirstBusinessCategoryOrThrowArgs = {
  cursor?: InputMaybe<BusinessCategoryWhereUniqueInput>;
  distinct?: InputMaybe<Array<BusinessCategoryScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<BusinessCategoryOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<BusinessCategoryWhereInput>;
};


export type QueryFindFirstCampaignArgs = {
  cursor?: InputMaybe<CampaignWhereUniqueInput>;
  distinct?: InputMaybe<Array<CampaignScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<CampaignOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<CampaignWhereInput>;
};


export type QueryFindFirstCampaignOrThrowArgs = {
  cursor?: InputMaybe<CampaignWhereUniqueInput>;
  distinct?: InputMaybe<Array<CampaignScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<CampaignOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<CampaignWhereInput>;
};


export type QueryFindFirstChangelogArgs = {
  cursor?: InputMaybe<ChangelogWhereUniqueInput>;
  distinct?: InputMaybe<Array<ChangelogScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<ChangelogOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<ChangelogWhereInput>;
};


export type QueryFindFirstChangelogOrThrowArgs = {
  cursor?: InputMaybe<ChangelogWhereUniqueInput>;
  distinct?: InputMaybe<Array<ChangelogScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<ChangelogOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<ChangelogWhereInput>;
};


export type QueryFindFirstFileArgs = {
  cursor?: InputMaybe<FileWhereUniqueInput>;
  distinct?: InputMaybe<Array<FileScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<FileOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<FileWhereInput>;
};


export type QueryFindFirstFileOrThrowArgs = {
  cursor?: InputMaybe<FileWhereUniqueInput>;
  distinct?: InputMaybe<Array<FileScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<FileOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<FileWhereInput>;
};


export type QueryFindFirstMembershipArgs = {
  cursor?: InputMaybe<MembershipWhereUniqueInput>;
  distinct?: InputMaybe<Array<MembershipScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<MembershipOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<MembershipWhereInput>;
};


export type QueryFindFirstMembershipOrThrowArgs = {
  cursor?: InputMaybe<MembershipWhereUniqueInput>;
  distinct?: InputMaybe<Array<MembershipScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<MembershipOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<MembershipWhereInput>;
};


export type QueryFindFirstOrderArgs = {
  cursor?: InputMaybe<OrderWhereUniqueInput>;
  distinct?: InputMaybe<Array<OrderScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<OrderOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<OrderWhereInput>;
};


export type QueryFindFirstOrderOrThrowArgs = {
  cursor?: InputMaybe<OrderWhereUniqueInput>;
  distinct?: InputMaybe<Array<OrderScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<OrderOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<OrderWhereInput>;
};


export type QueryFindFirstPayoutArgs = {
  cursor?: InputMaybe<PayoutWhereUniqueInput>;
  distinct?: InputMaybe<Array<PayoutScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<PayoutOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<PayoutWhereInput>;
};


export type QueryFindFirstPayoutOrThrowArgs = {
  cursor?: InputMaybe<PayoutWhereUniqueInput>;
  distinct?: InputMaybe<Array<PayoutScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<PayoutOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<PayoutWhereInput>;
};


export type QueryFindFirstPiSignagePlayerArgs = {
  cursor?: InputMaybe<PiSignagePlayerWhereUniqueInput>;
  distinct?: InputMaybe<Array<PiSignagePlayerScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<PiSignagePlayerOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<PiSignagePlayerWhereInput>;
};


export type QueryFindFirstPiSignagePlayerOrThrowArgs = {
  cursor?: InputMaybe<PiSignagePlayerWhereUniqueInput>;
  distinct?: InputMaybe<Array<PiSignagePlayerScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<PiSignagePlayerOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<PiSignagePlayerWhereInput>;
};


export type QueryFindFirstPlaylistArgs = {
  cursor?: InputMaybe<PlaylistWhereUniqueInput>;
  distinct?: InputMaybe<Array<PlaylistScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<PlaylistOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<PlaylistWhereInput>;
};


export type QueryFindFirstPlaylistOrThrowArgs = {
  cursor?: InputMaybe<PlaylistWhereUniqueInput>;
  distinct?: InputMaybe<Array<PlaylistScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<PlaylistOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<PlaylistWhereInput>;
};


export type QueryFindFirstRoleArgs = {
  cursor?: InputMaybe<RoleWhereUniqueInput>;
  distinct?: InputMaybe<Array<RoleScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<RoleOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<RoleWhereInput>;
};


export type QueryFindFirstRoleOrThrowArgs = {
  cursor?: InputMaybe<RoleWhereUniqueInput>;
  distinct?: InputMaybe<Array<RoleScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<RoleOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<RoleWhereInput>;
};


export type QueryFindFirstSlotArgs = {
  cursor?: InputMaybe<SlotWhereUniqueInput>;
  distinct?: InputMaybe<Array<SlotScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<SlotOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<SlotWhereInput>;
};


export type QueryFindFirstSlotOrThrowArgs = {
  cursor?: InputMaybe<SlotWhereUniqueInput>;
  distinct?: InputMaybe<Array<SlotScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<SlotOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<SlotWhereInput>;
};


export type QueryFindFirstTransactionArgs = {
  cursor?: InputMaybe<TransactionWhereUniqueInput>;
  distinct?: InputMaybe<Array<TransactionScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<TransactionOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<TransactionWhereInput>;
};


export type QueryFindFirstTransactionOrThrowArgs = {
  cursor?: InputMaybe<TransactionWhereUniqueInput>;
  distinct?: InputMaybe<Array<TransactionScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<TransactionOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<TransactionWhereInput>;
};


export type QueryFindFirstUserArgs = {
  cursor?: InputMaybe<UserWhereUniqueInput>;
  distinct?: InputMaybe<Array<UserScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<UserOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<UserWhereInput>;
};


export type QueryFindFirstUserOrThrowArgs = {
  cursor?: InputMaybe<UserWhereUniqueInput>;
  distinct?: InputMaybe<Array<UserScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<UserOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<UserWhereInput>;
};


export type QueryFindFirstWorkspaceArgs = {
  cursor?: InputMaybe<WorkspaceWhereUniqueInput>;
  distinct?: InputMaybe<Array<WorkspaceScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<WorkspaceOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<WorkspaceWhereInput>;
};


export type QueryFindFirstWorkspaceOrThrowArgs = {
  cursor?: InputMaybe<WorkspaceWhereUniqueInput>;
  distinct?: InputMaybe<Array<WorkspaceScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<WorkspaceOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<WorkspaceWhereInput>;
};


export type QueryGetAccessLabelArgs = {
  where: AccessLabelWhereUniqueInput;
};


export type QueryGetAdBoardArgs = {
  where: AdBoardWhereUniqueInput;
};


export type QueryGetAdBoardGroupArgs = {
  where: AdBoardGroupWhereUniqueInput;
};


export type QueryGetAuditArgs = {
  where: AuditWhereUniqueInput;
};


export type QueryGetBookingArgs = {
  where: BookingWhereUniqueInput;
};


export type QueryGetBusinessCategoryArgs = {
  where: BusinessCategoryWhereUniqueInput;
};


export type QueryGetCampaignArgs = {
  where: CampaignWhereUniqueInput;
};


export type QueryGetChangelogArgs = {
  where: ChangelogWhereUniqueInput;
};


export type QueryGetFileArgs = {
  where: FileWhereUniqueInput;
};


export type QueryGetMembershipArgs = {
  where: MembershipWhereUniqueInput;
};


export type QueryGetOrderArgs = {
  where: OrderWhereUniqueInput;
};


export type QueryGetPayoutArgs = {
  where: PayoutWhereUniqueInput;
};


export type QueryGetPiSignagePlayerArgs = {
  where: PiSignagePlayerWhereUniqueInput;
};


export type QueryGetPlaylistArgs = {
  where: PlaylistWhereUniqueInput;
};


export type QueryGetRoleArgs = {
  where: RoleWhereUniqueInput;
};


export type QueryGetSlotArgs = {
  where: SlotWhereUniqueInput;
};


export type QueryGetSlotsArgs = {
  adBoardId: Scalars['String'];
  endDate: Scalars['DateTime'];
  startDate: Scalars['DateTime'];
};


export type QueryGetTransactionArgs = {
  where: TransactionWhereUniqueInput;
};


export type QueryGetUserArgs = {
  where: UserWhereUniqueInput;
};


export type QueryGetWorkspaceArgs = {
  where: WorkspaceWhereUniqueInput;
};


export type QueryGroupByAccessLabelArgs = {
  by: Array<AccessLabelScalarFieldEnum>;
  having?: InputMaybe<AccessLabelScalarWhereWithAggregatesInput>;
  orderBy?: InputMaybe<Array<AccessLabelOrderByWithAggregationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<AccessLabelWhereInput>;
};


export type QueryGroupByAdBoardArgs = {
  by: Array<AdBoardScalarFieldEnum>;
  having?: InputMaybe<AdBoardScalarWhereWithAggregatesInput>;
  orderBy?: InputMaybe<Array<AdBoardOrderByWithAggregationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<AdBoardWhereInput>;
};


export type QueryGroupByAdBoardGroupArgs = {
  by: Array<AdBoardGroupScalarFieldEnum>;
  having?: InputMaybe<AdBoardGroupScalarWhereWithAggregatesInput>;
  orderBy?: InputMaybe<Array<AdBoardGroupOrderByWithAggregationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<AdBoardGroupWhereInput>;
};


export type QueryGroupByAuditArgs = {
  by: Array<AuditScalarFieldEnum>;
  having?: InputMaybe<AuditScalarWhereWithAggregatesInput>;
  orderBy?: InputMaybe<Array<AuditOrderByWithAggregationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<AuditWhereInput>;
};


export type QueryGroupByBookingArgs = {
  by: Array<BookingScalarFieldEnum>;
  having?: InputMaybe<BookingScalarWhereWithAggregatesInput>;
  orderBy?: InputMaybe<Array<BookingOrderByWithAggregationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<BookingWhereInput>;
};


export type QueryGroupByBusinessCategoryArgs = {
  by: Array<BusinessCategoryScalarFieldEnum>;
  having?: InputMaybe<BusinessCategoryScalarWhereWithAggregatesInput>;
  orderBy?: InputMaybe<Array<BusinessCategoryOrderByWithAggregationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<BusinessCategoryWhereInput>;
};


export type QueryGroupByCampaignArgs = {
  by: Array<CampaignScalarFieldEnum>;
  having?: InputMaybe<CampaignScalarWhereWithAggregatesInput>;
  orderBy?: InputMaybe<Array<CampaignOrderByWithAggregationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<CampaignWhereInput>;
};


export type QueryGroupByChangelogArgs = {
  by: Array<ChangelogScalarFieldEnum>;
  having?: InputMaybe<ChangelogScalarWhereWithAggregatesInput>;
  orderBy?: InputMaybe<Array<ChangelogOrderByWithAggregationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<ChangelogWhereInput>;
};


export type QueryGroupByFileArgs = {
  by: Array<FileScalarFieldEnum>;
  having?: InputMaybe<FileScalarWhereWithAggregatesInput>;
  orderBy?: InputMaybe<Array<FileOrderByWithAggregationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<FileWhereInput>;
};


export type QueryGroupByMembershipArgs = {
  by: Array<MembershipScalarFieldEnum>;
  having?: InputMaybe<MembershipScalarWhereWithAggregatesInput>;
  orderBy?: InputMaybe<Array<MembershipOrderByWithAggregationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<MembershipWhereInput>;
};


export type QueryGroupByOrderArgs = {
  by: Array<OrderScalarFieldEnum>;
  having?: InputMaybe<OrderScalarWhereWithAggregatesInput>;
  orderBy?: InputMaybe<Array<OrderOrderByWithAggregationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<OrderWhereInput>;
};


export type QueryGroupByPayoutArgs = {
  by: Array<PayoutScalarFieldEnum>;
  having?: InputMaybe<PayoutScalarWhereWithAggregatesInput>;
  orderBy?: InputMaybe<Array<PayoutOrderByWithAggregationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<PayoutWhereInput>;
};


export type QueryGroupByPiSignagePlayerArgs = {
  by: Array<PiSignagePlayerScalarFieldEnum>;
  having?: InputMaybe<PiSignagePlayerScalarWhereWithAggregatesInput>;
  orderBy?: InputMaybe<Array<PiSignagePlayerOrderByWithAggregationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<PiSignagePlayerWhereInput>;
};


export type QueryGroupByPlaylistArgs = {
  by: Array<PlaylistScalarFieldEnum>;
  having?: InputMaybe<PlaylistScalarWhereWithAggregatesInput>;
  orderBy?: InputMaybe<Array<PlaylistOrderByWithAggregationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<PlaylistWhereInput>;
};


export type QueryGroupByRoleArgs = {
  by: Array<RoleScalarFieldEnum>;
  having?: InputMaybe<RoleScalarWhereWithAggregatesInput>;
  orderBy?: InputMaybe<Array<RoleOrderByWithAggregationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<RoleWhereInput>;
};


export type QueryGroupBySlotArgs = {
  by: Array<SlotScalarFieldEnum>;
  having?: InputMaybe<SlotScalarWhereWithAggregatesInput>;
  orderBy?: InputMaybe<Array<SlotOrderByWithAggregationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<SlotWhereInput>;
};


export type QueryGroupByTransactionArgs = {
  by: Array<TransactionScalarFieldEnum>;
  having?: InputMaybe<TransactionScalarWhereWithAggregatesInput>;
  orderBy?: InputMaybe<Array<TransactionOrderByWithAggregationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<TransactionWhereInput>;
};


export type QueryGroupByUserArgs = {
  by: Array<UserScalarFieldEnum>;
  having?: InputMaybe<UserScalarWhereWithAggregatesInput>;
  orderBy?: InputMaybe<Array<UserOrderByWithAggregationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<UserWhereInput>;
};


export type QueryGroupByWorkspaceArgs = {
  by: Array<WorkspaceScalarFieldEnum>;
  having?: InputMaybe<WorkspaceScalarWhereWithAggregatesInput>;
  orderBy?: InputMaybe<Array<WorkspaceOrderByWithAggregationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<WorkspaceWhereInput>;
};


export type QueryMembershipArgs = {
  where: MembershipWhereUniqueInput;
};


export type QueryMembershipsArgs = {
  cursor?: InputMaybe<MembershipWhereUniqueInput>;
  distinct?: InputMaybe<Array<MembershipScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<MembershipOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<MembershipWhereInput>;
};


export type QueryOrderArgs = {
  where: OrderWhereUniqueInput;
};


export type QueryOrdersArgs = {
  cursor?: InputMaybe<OrderWhereUniqueInput>;
  distinct?: InputMaybe<Array<OrderScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<OrderOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<OrderWhereInput>;
};


export type QueryPayoutArgs = {
  where: PayoutWhereUniqueInput;
};


export type QueryPayoutsArgs = {
  cursor?: InputMaybe<PayoutWhereUniqueInput>;
  distinct?: InputMaybe<Array<PayoutScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<PayoutOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<PayoutWhereInput>;
};


export type QueryPiSignagePlayerArgs = {
  where: PiSignagePlayerWhereUniqueInput;
};


export type QueryPiSignagePlayersArgs = {
  cursor?: InputMaybe<PiSignagePlayerWhereUniqueInput>;
  distinct?: InputMaybe<Array<PiSignagePlayerScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<PiSignagePlayerOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<PiSignagePlayerWhereInput>;
};


export type QueryPlaylistArgs = {
  where: PlaylistWhereUniqueInput;
};


export type QueryPlaylistsArgs = {
  cursor?: InputMaybe<PlaylistWhereUniqueInput>;
  distinct?: InputMaybe<Array<PlaylistScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<PlaylistOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<PlaylistWhereInput>;
};


export type QueryRoleArgs = {
  where: RoleWhereUniqueInput;
};


export type QueryRolesArgs = {
  cursor?: InputMaybe<RoleWhereUniqueInput>;
  distinct?: InputMaybe<Array<RoleScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<RoleOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<RoleWhereInput>;
};


export type QuerySlotArgs = {
  where: SlotWhereUniqueInput;
};


export type QuerySlotsArgs = {
  cursor?: InputMaybe<SlotWhereUniqueInput>;
  distinct?: InputMaybe<Array<SlotScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<SlotOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<SlotWhereInput>;
};


export type QueryTransactionArgs = {
  where: TransactionWhereUniqueInput;
};


export type QueryTransactionsArgs = {
  cursor?: InputMaybe<TransactionWhereUniqueInput>;
  distinct?: InputMaybe<Array<TransactionScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<TransactionOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<TransactionWhereInput>;
};


export type QueryUserArgs = {
  where: UserWhereUniqueInput;
};


export type QueryUsersArgs = {
  cursor?: InputMaybe<UserWhereUniqueInput>;
  distinct?: InputMaybe<Array<UserScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<UserOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<UserWhereInput>;
};


export type QueryWorkspaceArgs = {
  where: WorkspaceWhereUniqueInput;
};


export type QueryWorkspacesArgs = {
  cursor?: InputMaybe<WorkspaceWhereUniqueInput>;
  distinct?: InputMaybe<Array<WorkspaceScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<WorkspaceOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<WorkspaceWhereInput>;
};

export enum QueryMode {
  Default = 'default',
  Insensitive = 'insensitive'
}

export type Resolution = {
  __typename?: 'Resolution';
  height: Scalars['Int'];
  width: Scalars['Int'];
};

export type ResolutionCreateInput = {
  height: Scalars['Int'];
  width: Scalars['Int'];
};

export type ResolutionNullableCompositeFilter = {
  equals?: InputMaybe<ResolutionObjectEqualityInput>;
  is?: InputMaybe<ResolutionWhereInput>;
  isNot?: InputMaybe<ResolutionWhereInput>;
  isSet?: InputMaybe<Scalars['Boolean']>;
};

export type ResolutionObjectEqualityInput = {
  height: Scalars['Int'];
  width: Scalars['Int'];
};

export type ResolutionOrderByInput = {
  height?: InputMaybe<SortOrder>;
  width?: InputMaybe<SortOrder>;
};

export type ResolutionWhereInput = {
  AND?: InputMaybe<Array<ResolutionWhereInput>>;
  NOT?: InputMaybe<Array<ResolutionWhereInput>>;
  OR?: InputMaybe<Array<ResolutionWhereInput>>;
  height?: InputMaybe<IntFilter>;
  width?: InputMaybe<IntFilter>;
};

export type Role = {
  __typename?: 'Role';
  _count?: Maybe<RoleCount>;
  id: Scalars['String'];
  memberships: Array<Membership>;
  name: Scalars['String'];
  permissions: Array<Permission>;
  userIDs: Array<Scalars['String']>;
  users: Array<User>;
};


export type RoleMembershipsArgs = {
  cursor?: InputMaybe<MembershipWhereUniqueInput>;
  distinct?: InputMaybe<Array<MembershipScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<MembershipOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<MembershipWhereInput>;
};


export type RoleUsersArgs = {
  cursor?: InputMaybe<UserWhereUniqueInput>;
  distinct?: InputMaybe<Array<UserScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<UserOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<UserWhereInput>;
};

export type RoleCount = {
  __typename?: 'RoleCount';
  memberships: Scalars['Int'];
  users: Scalars['Int'];
};


export type RoleCountMembershipsArgs = {
  where?: InputMaybe<MembershipWhereInput>;
};


export type RoleCountUsersArgs = {
  where?: InputMaybe<UserWhereInput>;
};

export type RoleCountAggregate = {
  __typename?: 'RoleCountAggregate';
  _all: Scalars['Int'];
  id: Scalars['Int'];
  name: Scalars['Int'];
  permissions: Scalars['Int'];
  userIDs: Scalars['Int'];
};

export type RoleCountOrderByAggregateInput = {
  id?: InputMaybe<SortOrder>;
  name?: InputMaybe<SortOrder>;
  permissions?: InputMaybe<SortOrder>;
  userIDs?: InputMaybe<SortOrder>;
};

export type RoleCreateInput = {
  id?: InputMaybe<Scalars['String']>;
  memberships?: InputMaybe<MembershipCreateNestedManyWithoutRoleInput>;
  name: Scalars['String'];
  permissions?: InputMaybe<Array<Permission>>;
  users?: InputMaybe<UserCreateNestedManyWithoutRolesInput>;
};

export type RoleCreateManyInput = {
  id?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
  permissions?: InputMaybe<Array<Permission>>;
  userIDs?: InputMaybe<Array<Scalars['String']>>;
};

export type RoleCreateNestedManyWithoutUsersInput = {
  connect?: InputMaybe<Array<RoleWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<RoleCreateOrConnectWithoutUsersInput>>;
  create?: InputMaybe<Array<RoleCreateWithoutUsersInput>>;
};

export type RoleCreateNestedOneWithoutMembershipsInput = {
  connect?: InputMaybe<RoleWhereUniqueInput>;
  connectOrCreate?: InputMaybe<RoleCreateOrConnectWithoutMembershipsInput>;
  create?: InputMaybe<RoleCreateWithoutMembershipsInput>;
};

export type RoleCreateOrConnectWithoutMembershipsInput = {
  create: RoleCreateWithoutMembershipsInput;
  where: RoleWhereUniqueInput;
};

export type RoleCreateOrConnectWithoutUsersInput = {
  create: RoleCreateWithoutUsersInput;
  where: RoleWhereUniqueInput;
};

export type RoleCreateWithoutMembershipsInput = {
  id?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
  permissions?: InputMaybe<Array<Permission>>;
  users?: InputMaybe<UserCreateNestedManyWithoutRolesInput>;
};

export type RoleCreateWithoutUsersInput = {
  id?: InputMaybe<Scalars['String']>;
  memberships?: InputMaybe<MembershipCreateNestedManyWithoutRoleInput>;
  name: Scalars['String'];
  permissions?: InputMaybe<Array<Permission>>;
};

export type RoleGroupBy = {
  __typename?: 'RoleGroupBy';
  _count?: Maybe<RoleCountAggregate>;
  _max?: Maybe<RoleMaxAggregate>;
  _min?: Maybe<RoleMinAggregate>;
  id: Scalars['String'];
  name: Scalars['String'];
  permissions?: Maybe<Array<Permission>>;
  userIDs?: Maybe<Array<Scalars['String']>>;
};

export type RoleListRelationFilter = {
  every?: InputMaybe<RoleWhereInput>;
  none?: InputMaybe<RoleWhereInput>;
  some?: InputMaybe<RoleWhereInput>;
};

export type RoleMaxAggregate = {
  __typename?: 'RoleMaxAggregate';
  id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
};

export type RoleMaxOrderByAggregateInput = {
  id?: InputMaybe<SortOrder>;
  name?: InputMaybe<SortOrder>;
};

export type RoleMinAggregate = {
  __typename?: 'RoleMinAggregate';
  id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
};

export type RoleMinOrderByAggregateInput = {
  id?: InputMaybe<SortOrder>;
  name?: InputMaybe<SortOrder>;
};

export type RoleOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type RoleOrderByWithAggregationInput = {
  _count?: InputMaybe<RoleCountOrderByAggregateInput>;
  _max?: InputMaybe<RoleMaxOrderByAggregateInput>;
  _min?: InputMaybe<RoleMinOrderByAggregateInput>;
  id?: InputMaybe<SortOrder>;
  name?: InputMaybe<SortOrder>;
  permissions?: InputMaybe<SortOrder>;
  userIDs?: InputMaybe<SortOrder>;
};

export type RoleOrderByWithRelationInput = {
  id?: InputMaybe<SortOrder>;
  memberships?: InputMaybe<MembershipOrderByRelationAggregateInput>;
  name?: InputMaybe<SortOrder>;
  permissions?: InputMaybe<SortOrder>;
  userIDs?: InputMaybe<SortOrder>;
  users?: InputMaybe<UserOrderByRelationAggregateInput>;
};

export type RoleRelationFilter = {
  is?: InputMaybe<RoleWhereInput>;
  isNot?: InputMaybe<RoleWhereInput>;
};

export enum RoleScalarFieldEnum {
  Id = 'id',
  Name = 'name',
  Permissions = 'permissions',
  UserIDs = 'userIDs'
}

export type RoleScalarWhereInput = {
  AND?: InputMaybe<Array<RoleScalarWhereInput>>;
  NOT?: InputMaybe<Array<RoleScalarWhereInput>>;
  OR?: InputMaybe<Array<RoleScalarWhereInput>>;
  id?: InputMaybe<StringFilter>;
  name?: InputMaybe<StringFilter>;
  permissions?: InputMaybe<EnumPermissionNullableListFilter>;
  userIDs?: InputMaybe<StringNullableListFilter>;
};

export type RoleScalarWhereWithAggregatesInput = {
  AND?: InputMaybe<Array<RoleScalarWhereWithAggregatesInput>>;
  NOT?: InputMaybe<Array<RoleScalarWhereWithAggregatesInput>>;
  OR?: InputMaybe<Array<RoleScalarWhereWithAggregatesInput>>;
  id?: InputMaybe<StringWithAggregatesFilter>;
  name?: InputMaybe<StringWithAggregatesFilter>;
  permissions?: InputMaybe<EnumPermissionNullableListFilter>;
  userIDs?: InputMaybe<StringNullableListFilter>;
};

export type RoleUpdateInput = {
  memberships?: InputMaybe<MembershipUpdateManyWithoutRoleNestedInput>;
  name?: InputMaybe<Scalars['String']>;
  permissions?: InputMaybe<Array<Permission>>;
  users?: InputMaybe<UserUpdateManyWithoutRolesNestedInput>;
};

export type RoleUpdateManyMutationInput = {
  name?: InputMaybe<Scalars['String']>;
  permissions?: InputMaybe<Array<Permission>>;
};

export type RoleUpdateManyWithWhereWithoutUsersInput = {
  data: RoleUpdateManyMutationInput;
  where: RoleScalarWhereInput;
};

export type RoleUpdateManyWithoutUsersNestedInput = {
  connect?: InputMaybe<Array<RoleWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<RoleCreateOrConnectWithoutUsersInput>>;
  create?: InputMaybe<Array<RoleCreateWithoutUsersInput>>;
  delete?: InputMaybe<Array<RoleWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<RoleScalarWhereInput>>;
  disconnect?: InputMaybe<Array<RoleWhereUniqueInput>>;
  set?: InputMaybe<Array<RoleWhereUniqueInput>>;
  update?: InputMaybe<Array<RoleUpdateWithWhereUniqueWithoutUsersInput>>;
  updateMany?: InputMaybe<Array<RoleUpdateManyWithWhereWithoutUsersInput>>;
  upsert?: InputMaybe<Array<RoleUpsertWithWhereUniqueWithoutUsersInput>>;
};

export type RoleUpdateOneRequiredWithoutMembershipsNestedInput = {
  connect?: InputMaybe<RoleWhereUniqueInput>;
  connectOrCreate?: InputMaybe<RoleCreateOrConnectWithoutMembershipsInput>;
  create?: InputMaybe<RoleCreateWithoutMembershipsInput>;
  update?: InputMaybe<RoleUpdateToOneWithWhereWithoutMembershipsInput>;
  upsert?: InputMaybe<RoleUpsertWithoutMembershipsInput>;
};

export type RoleUpdateToOneWithWhereWithoutMembershipsInput = {
  data: RoleUpdateWithoutMembershipsInput;
  where?: InputMaybe<RoleWhereInput>;
};

export type RoleUpdateWithWhereUniqueWithoutUsersInput = {
  data: RoleUpdateWithoutUsersInput;
  where: RoleWhereUniqueInput;
};

export type RoleUpdateWithoutMembershipsInput = {
  name?: InputMaybe<Scalars['String']>;
  permissions?: InputMaybe<Array<Permission>>;
  users?: InputMaybe<UserUpdateManyWithoutRolesNestedInput>;
};

export type RoleUpdateWithoutUsersInput = {
  memberships?: InputMaybe<MembershipUpdateManyWithoutRoleNestedInput>;
  name?: InputMaybe<Scalars['String']>;
  permissions?: InputMaybe<Array<Permission>>;
};

export type RoleUpsertWithWhereUniqueWithoutUsersInput = {
  create: RoleCreateWithoutUsersInput;
  update: RoleUpdateWithoutUsersInput;
  where: RoleWhereUniqueInput;
};

export type RoleUpsertWithoutMembershipsInput = {
  create: RoleCreateWithoutMembershipsInput;
  update: RoleUpdateWithoutMembershipsInput;
  where?: InputMaybe<RoleWhereInput>;
};

export type RoleWhereInput = {
  AND?: InputMaybe<Array<RoleWhereInput>>;
  NOT?: InputMaybe<Array<RoleWhereInput>>;
  OR?: InputMaybe<Array<RoleWhereInput>>;
  id?: InputMaybe<StringFilter>;
  memberships?: InputMaybe<MembershipListRelationFilter>;
  name?: InputMaybe<StringFilter>;
  permissions?: InputMaybe<EnumPermissionNullableListFilter>;
  userIDs?: InputMaybe<StringNullableListFilter>;
  users?: InputMaybe<UserListRelationFilter>;
};

export type RoleWhereUniqueInput = {
  AND?: InputMaybe<Array<RoleWhereInput>>;
  NOT?: InputMaybe<Array<RoleWhereInput>>;
  OR?: InputMaybe<Array<RoleWhereInput>>;
  id?: InputMaybe<Scalars['String']>;
  memberships?: InputMaybe<MembershipListRelationFilter>;
  name?: InputMaybe<Scalars['String']>;
  permissions?: InputMaybe<EnumPermissionNullableListFilter>;
  userIDs?: InputMaybe<StringNullableListFilter>;
  users?: InputMaybe<UserListRelationFilter>;
};

export type Schedule = {
  __typename?: 'Schedule';
  endTime?: Maybe<Scalars['String']>;
  playlistId?: Maybe<Scalars['String']>;
  playlistType?: Maybe<Scalars['String']>;
  skipForSchedule?: Maybe<Scalars['Boolean']>;
  startTime?: Maybe<Scalars['String']>;
};

export type ScheduleCreateInput = {
  endTime?: InputMaybe<Scalars['String']>;
  playlistId?: InputMaybe<Scalars['String']>;
  playlistType?: InputMaybe<Scalars['String']>;
  skipForSchedule?: InputMaybe<Scalars['Boolean']>;
  startTime?: InputMaybe<Scalars['String']>;
};

export type ScheduleObjectEqualityInput = {
  endTime?: InputMaybe<Scalars['String']>;
  playlistId?: InputMaybe<Scalars['String']>;
  playlistType?: InputMaybe<Scalars['String']>;
  skipForSchedule?: InputMaybe<Scalars['Boolean']>;
  startTime?: InputMaybe<Scalars['String']>;
};

export type ScheduleOrderByCompositeAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type ScreenSize = {
  __typename?: 'ScreenSize';
  height: Scalars['Int'];
  unit: MeasurementUnit;
  width: Scalars['Int'];
};

export type ScreenSizeCreateInput = {
  height: Scalars['Int'];
  unit: MeasurementUnit;
  width: Scalars['Int'];
};

export type ScreenSizeNullableCompositeFilter = {
  equals?: InputMaybe<ScreenSizeObjectEqualityInput>;
  is?: InputMaybe<ScreenSizeWhereInput>;
  isNot?: InputMaybe<ScreenSizeWhereInput>;
  isSet?: InputMaybe<Scalars['Boolean']>;
};

export type ScreenSizeObjectEqualityInput = {
  height: Scalars['Int'];
  unit: MeasurementUnit;
  width: Scalars['Int'];
};

export type ScreenSizeOrderByInput = {
  height?: InputMaybe<SortOrder>;
  unit?: InputMaybe<SortOrder>;
  width?: InputMaybe<SortOrder>;
};

export type ScreenSizeWhereInput = {
  AND?: InputMaybe<Array<ScreenSizeWhereInput>>;
  NOT?: InputMaybe<Array<ScreenSizeWhereInput>>;
  OR?: InputMaybe<Array<ScreenSizeWhereInput>>;
  height?: InputMaybe<IntFilter>;
  unit?: InputMaybe<EnumMeasurementUnitFilter>;
  width?: InputMaybe<IntFilter>;
};

export type ScreenType = {
  __typename?: 'ScreenType';
  name: Scalars['String'];
};

export type ScreenTypeCreateInput = {
  name: Scalars['String'];
};

export type ScreenTypeNullableCompositeFilter = {
  equals?: InputMaybe<ScreenTypeObjectEqualityInput>;
  is?: InputMaybe<ScreenTypeWhereInput>;
  isNot?: InputMaybe<ScreenTypeWhereInput>;
  isSet?: InputMaybe<Scalars['Boolean']>;
};

export type ScreenTypeObjectEqualityInput = {
  name: Scalars['String'];
};

export type ScreenTypeOrderByInput = {
  name?: InputMaybe<SortOrder>;
};

export type ScreenTypeWhereInput = {
  AND?: InputMaybe<Array<ScreenTypeWhereInput>>;
  NOT?: InputMaybe<Array<ScreenTypeWhereInput>>;
  OR?: InputMaybe<Array<ScreenTypeWhereInput>>;
  name?: InputMaybe<StringFilter>;
};

export type Slot = {
  __typename?: 'Slot';
  adBoard: AdBoard;
  adBoardId: Scalars['String'];
  booking?: Maybe<Booking>;
  bookingId?: Maybe<Scalars['String']>;
  createdAt: Scalars['DateTime'];
  date: Scalars['DateTime'];
  id: Scalars['String'];
  time: Scalars['Int'];
};


export type SlotBookingArgs = {
  where?: InputMaybe<BookingWhereInput>;
};

export type SlotAvgAggregate = {
  __typename?: 'SlotAvgAggregate';
  time?: Maybe<Scalars['Float']>;
};

export type SlotAvgOrderByAggregateInput = {
  time?: InputMaybe<SortOrder>;
};

export type SlotCountAggregate = {
  __typename?: 'SlotCountAggregate';
  _all: Scalars['Int'];
  adBoardId: Scalars['Int'];
  bookingId: Scalars['Int'];
  createdAt: Scalars['Int'];
  date: Scalars['Int'];
  id: Scalars['Int'];
  time: Scalars['Int'];
};

export type SlotCountOrderByAggregateInput = {
  adBoardId?: InputMaybe<SortOrder>;
  bookingId?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  date?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  time?: InputMaybe<SortOrder>;
};

export type SlotCreateInput = {
  adBoard: AdBoardCreateNestedOneWithoutBookedSlotsInput;
  booking?: InputMaybe<BookingCreateNestedOneWithoutBookedSlotsInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  date: Scalars['DateTime'];
  id?: InputMaybe<Scalars['String']>;
  time: Scalars['Int'];
};

export type SlotCreateManyAdBoardInput = {
  bookingId?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  date: Scalars['DateTime'];
  id?: InputMaybe<Scalars['String']>;
  time: Scalars['Int'];
};

export type SlotCreateManyAdBoardInputEnvelope = {
  data: Array<SlotCreateManyAdBoardInput>;
};

export type SlotCreateManyBookingInput = {
  adBoardId: Scalars['String'];
  createdAt?: InputMaybe<Scalars['DateTime']>;
  date: Scalars['DateTime'];
  id?: InputMaybe<Scalars['String']>;
  time: Scalars['Int'];
};

export type SlotCreateManyBookingInputEnvelope = {
  data: Array<SlotCreateManyBookingInput>;
};

export type SlotCreateManyInput = {
  adBoardId: Scalars['String'];
  bookingId?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  date: Scalars['DateTime'];
  id?: InputMaybe<Scalars['String']>;
  time: Scalars['Int'];
};

export type SlotCreateNestedManyWithoutAdBoardInput = {
  connect?: InputMaybe<Array<SlotWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<SlotCreateOrConnectWithoutAdBoardInput>>;
  create?: InputMaybe<Array<SlotCreateWithoutAdBoardInput>>;
  createMany?: InputMaybe<SlotCreateManyAdBoardInputEnvelope>;
};

export type SlotCreateNestedManyWithoutBookingInput = {
  connect?: InputMaybe<Array<SlotWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<SlotCreateOrConnectWithoutBookingInput>>;
  create?: InputMaybe<Array<SlotCreateWithoutBookingInput>>;
  createMany?: InputMaybe<SlotCreateManyBookingInputEnvelope>;
};

export type SlotCreateOrConnectWithoutAdBoardInput = {
  create: SlotCreateWithoutAdBoardInput;
  where: SlotWhereUniqueInput;
};

export type SlotCreateOrConnectWithoutBookingInput = {
  create: SlotCreateWithoutBookingInput;
  where: SlotWhereUniqueInput;
};

export type SlotCreateWithoutAdBoardInput = {
  booking?: InputMaybe<BookingCreateNestedOneWithoutBookedSlotsInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  date: Scalars['DateTime'];
  id?: InputMaybe<Scalars['String']>;
  time: Scalars['Int'];
};

export type SlotCreateWithoutBookingInput = {
  adBoard: AdBoardCreateNestedOneWithoutBookedSlotsInput;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  date: Scalars['DateTime'];
  id?: InputMaybe<Scalars['String']>;
  time: Scalars['Int'];
};

export type SlotDateTimeAdBoardIdCompoundUniqueInput = {
  adBoardId: Scalars['String'];
  date: Scalars['DateTime'];
  time: Scalars['Int'];
};

export type SlotGroupBy = {
  __typename?: 'SlotGroupBy';
  _avg?: Maybe<SlotAvgAggregate>;
  _count?: Maybe<SlotCountAggregate>;
  _max?: Maybe<SlotMaxAggregate>;
  _min?: Maybe<SlotMinAggregate>;
  _sum?: Maybe<SlotSumAggregate>;
  adBoardId: Scalars['String'];
  bookingId?: Maybe<Scalars['String']>;
  createdAt: Scalars['DateTime'];
  date: Scalars['DateTime'];
  id: Scalars['String'];
  time: Scalars['Int'];
};

export type SlotListRelationFilter = {
  every?: InputMaybe<SlotWhereInput>;
  none?: InputMaybe<SlotWhereInput>;
  some?: InputMaybe<SlotWhereInput>;
};

export type SlotMaxAggregate = {
  __typename?: 'SlotMaxAggregate';
  adBoardId?: Maybe<Scalars['String']>;
  bookingId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  date?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  time?: Maybe<Scalars['Int']>;
};

export type SlotMaxOrderByAggregateInput = {
  adBoardId?: InputMaybe<SortOrder>;
  bookingId?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  date?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  time?: InputMaybe<SortOrder>;
};

export type SlotMinAggregate = {
  __typename?: 'SlotMinAggregate';
  adBoardId?: Maybe<Scalars['String']>;
  bookingId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  date?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  time?: Maybe<Scalars['Int']>;
};

export type SlotMinOrderByAggregateInput = {
  adBoardId?: InputMaybe<SortOrder>;
  bookingId?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  date?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  time?: InputMaybe<SortOrder>;
};

export type SlotOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type SlotOrderByWithAggregationInput = {
  _avg?: InputMaybe<SlotAvgOrderByAggregateInput>;
  _count?: InputMaybe<SlotCountOrderByAggregateInput>;
  _max?: InputMaybe<SlotMaxOrderByAggregateInput>;
  _min?: InputMaybe<SlotMinOrderByAggregateInput>;
  _sum?: InputMaybe<SlotSumOrderByAggregateInput>;
  adBoardId?: InputMaybe<SortOrder>;
  bookingId?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  date?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  time?: InputMaybe<SortOrder>;
};

export type SlotOrderByWithRelationInput = {
  adBoard?: InputMaybe<AdBoardOrderByWithRelationInput>;
  adBoardId?: InputMaybe<SortOrder>;
  booking?: InputMaybe<BookingOrderByWithRelationInput>;
  bookingId?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  date?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  time?: InputMaybe<SortOrder>;
};

export enum SlotScalarFieldEnum {
  AdBoardId = 'adBoardId',
  BookingId = 'bookingId',
  CreatedAt = 'createdAt',
  Date = 'date',
  Id = 'id',
  Time = 'time'
}

export type SlotScalarWhereInput = {
  AND?: InputMaybe<Array<SlotScalarWhereInput>>;
  NOT?: InputMaybe<Array<SlotScalarWhereInput>>;
  OR?: InputMaybe<Array<SlotScalarWhereInput>>;
  adBoardId?: InputMaybe<StringFilter>;
  bookingId?: InputMaybe<StringNullableFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  date?: InputMaybe<DateTimeFilter>;
  id?: InputMaybe<StringFilter>;
  time?: InputMaybe<IntFilter>;
};

export type SlotScalarWhereWithAggregatesInput = {
  AND?: InputMaybe<Array<SlotScalarWhereWithAggregatesInput>>;
  NOT?: InputMaybe<Array<SlotScalarWhereWithAggregatesInput>>;
  OR?: InputMaybe<Array<SlotScalarWhereWithAggregatesInput>>;
  adBoardId?: InputMaybe<StringWithAggregatesFilter>;
  bookingId?: InputMaybe<StringNullableWithAggregatesFilter>;
  createdAt?: InputMaybe<DateTimeWithAggregatesFilter>;
  date?: InputMaybe<DateTimeWithAggregatesFilter>;
  id?: InputMaybe<StringWithAggregatesFilter>;
  time?: InputMaybe<IntWithAggregatesFilter>;
};

export type SlotSumAggregate = {
  __typename?: 'SlotSumAggregate';
  time?: Maybe<Scalars['Int']>;
};

export type SlotSumOrderByAggregateInput = {
  time?: InputMaybe<SortOrder>;
};

export type SlotUpdateInput = {
  adBoard?: InputMaybe<AdBoardUpdateOneRequiredWithoutBookedSlotsNestedInput>;
  booking?: InputMaybe<BookingUpdateOneWithoutBookedSlotsNestedInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  date?: InputMaybe<Scalars['DateTime']>;
  time?: InputMaybe<Scalars['Int']>;
};

export type SlotUpdateManyMutationInput = {
  createdAt?: InputMaybe<Scalars['DateTime']>;
  date?: InputMaybe<Scalars['DateTime']>;
  time?: InputMaybe<Scalars['Int']>;
};

export type SlotUpdateManyWithWhereWithoutAdBoardInput = {
  data: SlotUpdateManyMutationInput;
  where: SlotScalarWhereInput;
};

export type SlotUpdateManyWithWhereWithoutBookingInput = {
  data: SlotUpdateManyMutationInput;
  where: SlotScalarWhereInput;
};

export type SlotUpdateManyWithoutAdBoardNestedInput = {
  connect?: InputMaybe<Array<SlotWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<SlotCreateOrConnectWithoutAdBoardInput>>;
  create?: InputMaybe<Array<SlotCreateWithoutAdBoardInput>>;
  createMany?: InputMaybe<SlotCreateManyAdBoardInputEnvelope>;
  delete?: InputMaybe<Array<SlotWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<SlotScalarWhereInput>>;
  disconnect?: InputMaybe<Array<SlotWhereUniqueInput>>;
  set?: InputMaybe<Array<SlotWhereUniqueInput>>;
  update?: InputMaybe<Array<SlotUpdateWithWhereUniqueWithoutAdBoardInput>>;
  updateMany?: InputMaybe<Array<SlotUpdateManyWithWhereWithoutAdBoardInput>>;
  upsert?: InputMaybe<Array<SlotUpsertWithWhereUniqueWithoutAdBoardInput>>;
};

export type SlotUpdateManyWithoutBookingNestedInput = {
  connect?: InputMaybe<Array<SlotWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<SlotCreateOrConnectWithoutBookingInput>>;
  create?: InputMaybe<Array<SlotCreateWithoutBookingInput>>;
  createMany?: InputMaybe<SlotCreateManyBookingInputEnvelope>;
  delete?: InputMaybe<Array<SlotWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<SlotScalarWhereInput>>;
  disconnect?: InputMaybe<Array<SlotWhereUniqueInput>>;
  set?: InputMaybe<Array<SlotWhereUniqueInput>>;
  update?: InputMaybe<Array<SlotUpdateWithWhereUniqueWithoutBookingInput>>;
  updateMany?: InputMaybe<Array<SlotUpdateManyWithWhereWithoutBookingInput>>;
  upsert?: InputMaybe<Array<SlotUpsertWithWhereUniqueWithoutBookingInput>>;
};

export type SlotUpdateWithWhereUniqueWithoutAdBoardInput = {
  data: SlotUpdateWithoutAdBoardInput;
  where: SlotWhereUniqueInput;
};

export type SlotUpdateWithWhereUniqueWithoutBookingInput = {
  data: SlotUpdateWithoutBookingInput;
  where: SlotWhereUniqueInput;
};

export type SlotUpdateWithoutAdBoardInput = {
  booking?: InputMaybe<BookingUpdateOneWithoutBookedSlotsNestedInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  date?: InputMaybe<Scalars['DateTime']>;
  time?: InputMaybe<Scalars['Int']>;
};

export type SlotUpdateWithoutBookingInput = {
  adBoard?: InputMaybe<AdBoardUpdateOneRequiredWithoutBookedSlotsNestedInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  date?: InputMaybe<Scalars['DateTime']>;
  time?: InputMaybe<Scalars['Int']>;
};

export type SlotUpsertWithWhereUniqueWithoutAdBoardInput = {
  create: SlotCreateWithoutAdBoardInput;
  update: SlotUpdateWithoutAdBoardInput;
  where: SlotWhereUniqueInput;
};

export type SlotUpsertWithWhereUniqueWithoutBookingInput = {
  create: SlotCreateWithoutBookingInput;
  update: SlotUpdateWithoutBookingInput;
  where: SlotWhereUniqueInput;
};

export type SlotWhereInput = {
  AND?: InputMaybe<Array<SlotWhereInput>>;
  NOT?: InputMaybe<Array<SlotWhereInput>>;
  OR?: InputMaybe<Array<SlotWhereInput>>;
  adBoard?: InputMaybe<AdBoardRelationFilter>;
  adBoardId?: InputMaybe<StringFilter>;
  booking?: InputMaybe<BookingNullableRelationFilter>;
  bookingId?: InputMaybe<StringNullableFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  date?: InputMaybe<DateTimeFilter>;
  id?: InputMaybe<StringFilter>;
  time?: InputMaybe<IntFilter>;
};

export type SlotWhereUniqueInput = {
  AND?: InputMaybe<Array<SlotWhereInput>>;
  NOT?: InputMaybe<Array<SlotWhereInput>>;
  OR?: InputMaybe<Array<SlotWhereInput>>;
  adBoard?: InputMaybe<AdBoardRelationFilter>;
  adBoardId?: InputMaybe<StringFilter>;
  booking?: InputMaybe<BookingNullableRelationFilter>;
  bookingId?: InputMaybe<StringNullableFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  date?: InputMaybe<DateTimeFilter>;
  date_time_adBoardId?: InputMaybe<SlotDateTimeAdBoardIdCompoundUniqueInput>;
  id?: InputMaybe<Scalars['String']>;
  time?: InputMaybe<IntFilter>;
};

export enum SortOrder {
  Asc = 'asc',
  Desc = 'desc'
}

export type Specification = {
  __typename?: 'Specification';
  name: Scalars['String'];
  value?: Maybe<Scalars['String']>;
};

export type SpecificationCreateInput = {
  name: Scalars['String'];
  value?: InputMaybe<Scalars['String']>;
};

export type SpecificationObjectEqualityInput = {
  name: Scalars['String'];
  value?: InputMaybe<Scalars['String']>;
};

export type SpecificationOrderByCompositeAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type StringFilter = {
  contains?: InputMaybe<Scalars['String']>;
  endsWith?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  gt?: InputMaybe<Scalars['String']>;
  gte?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<Scalars['String']>>;
  lt?: InputMaybe<Scalars['String']>;
  lte?: InputMaybe<Scalars['String']>;
  mode?: InputMaybe<QueryMode>;
  not?: InputMaybe<NestedStringFilter>;
  notIn?: InputMaybe<Array<Scalars['String']>>;
  startsWith?: InputMaybe<Scalars['String']>;
};

export type StringNullableFilter = {
  contains?: InputMaybe<Scalars['String']>;
  endsWith?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  gt?: InputMaybe<Scalars['String']>;
  gte?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<Scalars['String']>>;
  isSet?: InputMaybe<Scalars['Boolean']>;
  lt?: InputMaybe<Scalars['String']>;
  lte?: InputMaybe<Scalars['String']>;
  mode?: InputMaybe<QueryMode>;
  not?: InputMaybe<NestedStringNullableFilter>;
  notIn?: InputMaybe<Array<Scalars['String']>>;
  startsWith?: InputMaybe<Scalars['String']>;
};

export type StringNullableListFilter = {
  equals?: InputMaybe<Array<Scalars['String']>>;
  has?: InputMaybe<Scalars['String']>;
  hasEvery?: InputMaybe<Array<Scalars['String']>>;
  hasSome?: InputMaybe<Array<Scalars['String']>>;
  isEmpty?: InputMaybe<Scalars['Boolean']>;
};

export type StringNullableWithAggregatesFilter = {
  _count?: InputMaybe<NestedIntNullableFilter>;
  _max?: InputMaybe<NestedStringNullableFilter>;
  _min?: InputMaybe<NestedStringNullableFilter>;
  contains?: InputMaybe<Scalars['String']>;
  endsWith?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  gt?: InputMaybe<Scalars['String']>;
  gte?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<Scalars['String']>>;
  isSet?: InputMaybe<Scalars['Boolean']>;
  lt?: InputMaybe<Scalars['String']>;
  lte?: InputMaybe<Scalars['String']>;
  mode?: InputMaybe<QueryMode>;
  not?: InputMaybe<NestedStringNullableWithAggregatesFilter>;
  notIn?: InputMaybe<Array<Scalars['String']>>;
  startsWith?: InputMaybe<Scalars['String']>;
};

export type StringWithAggregatesFilter = {
  _count?: InputMaybe<NestedIntFilter>;
  _max?: InputMaybe<NestedStringFilter>;
  _min?: InputMaybe<NestedStringFilter>;
  contains?: InputMaybe<Scalars['String']>;
  endsWith?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  gt?: InputMaybe<Scalars['String']>;
  gte?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<Scalars['String']>>;
  lt?: InputMaybe<Scalars['String']>;
  lte?: InputMaybe<Scalars['String']>;
  mode?: InputMaybe<QueryMode>;
  not?: InputMaybe<NestedStringWithAggregatesFilter>;
  notIn?: InputMaybe<Array<Scalars['String']>>;
  startsWith?: InputMaybe<Scalars['String']>;
};

export enum TemplateIds {
  AssetUpdated = 'ASSET_UPDATED',
  BookingConfirmed = 'BOOKING_CONFIRMED',
  OrderCancelled = 'ORDER_CANCELLED',
  OrderConfirmation = 'ORDER_CONFIRMATION',
  StatusUpdate = 'STATUS_UPDATE'
}

export type Transaction = {
  __typename?: 'Transaction';
  _count?: Maybe<TransactionCount>;
  amount: Scalars['Float'];
  createAt: Scalars['DateTime'];
  details?: Maybe<Scalars['JSON']>;
  id: Scalars['String'];
  payouts: Array<Payout>;
  processedAt?: Maybe<Scalars['DateTime']>;
  relatedEntityId: Scalars['String'];
  transactionStatus: TransactionStatus;
  workspace?: Maybe<Workspace>;
  workspaceId?: Maybe<Scalars['String']>;
};


export type TransactionPayoutsArgs = {
  cursor?: InputMaybe<PayoutWhereUniqueInput>;
  distinct?: InputMaybe<Array<PayoutScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<PayoutOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<PayoutWhereInput>;
};


export type TransactionWorkspaceArgs = {
  where?: InputMaybe<WorkspaceWhereInput>;
};

export type TransactionAvgAggregate = {
  __typename?: 'TransactionAvgAggregate';
  amount?: Maybe<Scalars['Float']>;
};

export type TransactionAvgOrderByAggregateInput = {
  amount?: InputMaybe<SortOrder>;
};

export type TransactionCount = {
  __typename?: 'TransactionCount';
  payouts: Scalars['Int'];
};


export type TransactionCountPayoutsArgs = {
  where?: InputMaybe<PayoutWhereInput>;
};

export type TransactionCountAggregate = {
  __typename?: 'TransactionCountAggregate';
  _all: Scalars['Int'];
  amount: Scalars['Int'];
  createAt: Scalars['Int'];
  details: Scalars['Int'];
  id: Scalars['Int'];
  processedAt: Scalars['Int'];
  relatedEntityId: Scalars['Int'];
  transactionStatus: Scalars['Int'];
  workspaceId: Scalars['Int'];
};

export type TransactionCountOrderByAggregateInput = {
  amount?: InputMaybe<SortOrder>;
  createAt?: InputMaybe<SortOrder>;
  details?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  processedAt?: InputMaybe<SortOrder>;
  relatedEntityId?: InputMaybe<SortOrder>;
  transactionStatus?: InputMaybe<SortOrder>;
  workspaceId?: InputMaybe<SortOrder>;
};

export type TransactionCreateInput = {
  amount: Scalars['Float'];
  createAt?: InputMaybe<Scalars['DateTime']>;
  details?: InputMaybe<Scalars['JSON']>;
  id?: InputMaybe<Scalars['String']>;
  payouts?: InputMaybe<PayoutCreateNestedManyWithoutTransactionInput>;
  processedAt?: InputMaybe<Scalars['DateTime']>;
  relatedEntityId: Scalars['String'];
  transactionStatus: TransactionStatus;
  workspace?: InputMaybe<WorkspaceCreateNestedOneWithoutTransactionsInput>;
};

export type TransactionCreateManyInput = {
  amount: Scalars['Float'];
  createAt?: InputMaybe<Scalars['DateTime']>;
  details?: InputMaybe<Scalars['JSON']>;
  id?: InputMaybe<Scalars['String']>;
  processedAt?: InputMaybe<Scalars['DateTime']>;
  relatedEntityId: Scalars['String'];
  transactionStatus: TransactionStatus;
  workspaceId?: InputMaybe<Scalars['String']>;
};

export type TransactionCreateManyWorkspaceInput = {
  amount: Scalars['Float'];
  createAt?: InputMaybe<Scalars['DateTime']>;
  details?: InputMaybe<Scalars['JSON']>;
  id?: InputMaybe<Scalars['String']>;
  processedAt?: InputMaybe<Scalars['DateTime']>;
  relatedEntityId: Scalars['String'];
  transactionStatus: TransactionStatus;
};

export type TransactionCreateManyWorkspaceInputEnvelope = {
  data: Array<TransactionCreateManyWorkspaceInput>;
};

export type TransactionCreateNestedManyWithoutWorkspaceInput = {
  connect?: InputMaybe<Array<TransactionWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<TransactionCreateOrConnectWithoutWorkspaceInput>>;
  create?: InputMaybe<Array<TransactionCreateWithoutWorkspaceInput>>;
  createMany?: InputMaybe<TransactionCreateManyWorkspaceInputEnvelope>;
};

export type TransactionCreateNestedOneWithoutPayoutsInput = {
  connect?: InputMaybe<TransactionWhereUniqueInput>;
  connectOrCreate?: InputMaybe<TransactionCreateOrConnectWithoutPayoutsInput>;
  create?: InputMaybe<TransactionCreateWithoutPayoutsInput>;
};

export type TransactionCreateOrConnectWithoutPayoutsInput = {
  create: TransactionCreateWithoutPayoutsInput;
  where: TransactionWhereUniqueInput;
};

export type TransactionCreateOrConnectWithoutWorkspaceInput = {
  create: TransactionCreateWithoutWorkspaceInput;
  where: TransactionWhereUniqueInput;
};

export type TransactionCreateWithoutPayoutsInput = {
  amount: Scalars['Float'];
  createAt?: InputMaybe<Scalars['DateTime']>;
  details?: InputMaybe<Scalars['JSON']>;
  id?: InputMaybe<Scalars['String']>;
  processedAt?: InputMaybe<Scalars['DateTime']>;
  relatedEntityId: Scalars['String'];
  transactionStatus: TransactionStatus;
  workspace?: InputMaybe<WorkspaceCreateNestedOneWithoutTransactionsInput>;
};

export type TransactionCreateWithoutWorkspaceInput = {
  amount: Scalars['Float'];
  createAt?: InputMaybe<Scalars['DateTime']>;
  details?: InputMaybe<Scalars['JSON']>;
  id?: InputMaybe<Scalars['String']>;
  payouts?: InputMaybe<PayoutCreateNestedManyWithoutTransactionInput>;
  processedAt?: InputMaybe<Scalars['DateTime']>;
  relatedEntityId: Scalars['String'];
  transactionStatus: TransactionStatus;
};

export type TransactionGroupBy = {
  __typename?: 'TransactionGroupBy';
  _avg?: Maybe<TransactionAvgAggregate>;
  _count?: Maybe<TransactionCountAggregate>;
  _max?: Maybe<TransactionMaxAggregate>;
  _min?: Maybe<TransactionMinAggregate>;
  _sum?: Maybe<TransactionSumAggregate>;
  amount: Scalars['Float'];
  createAt: Scalars['DateTime'];
  details?: Maybe<Scalars['JSON']>;
  id: Scalars['String'];
  processedAt?: Maybe<Scalars['DateTime']>;
  relatedEntityId: Scalars['String'];
  transactionStatus: TransactionStatus;
  workspaceId?: Maybe<Scalars['String']>;
};

export type TransactionListRelationFilter = {
  every?: InputMaybe<TransactionWhereInput>;
  none?: InputMaybe<TransactionWhereInput>;
  some?: InputMaybe<TransactionWhereInput>;
};

export type TransactionMaxAggregate = {
  __typename?: 'TransactionMaxAggregate';
  amount?: Maybe<Scalars['Float']>;
  createAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  processedAt?: Maybe<Scalars['DateTime']>;
  relatedEntityId?: Maybe<Scalars['String']>;
  transactionStatus?: Maybe<TransactionStatus>;
  workspaceId?: Maybe<Scalars['String']>;
};

export type TransactionMaxOrderByAggregateInput = {
  amount?: InputMaybe<SortOrder>;
  createAt?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  processedAt?: InputMaybe<SortOrder>;
  relatedEntityId?: InputMaybe<SortOrder>;
  transactionStatus?: InputMaybe<SortOrder>;
  workspaceId?: InputMaybe<SortOrder>;
};

export type TransactionMinAggregate = {
  __typename?: 'TransactionMinAggregate';
  amount?: Maybe<Scalars['Float']>;
  createAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  processedAt?: Maybe<Scalars['DateTime']>;
  relatedEntityId?: Maybe<Scalars['String']>;
  transactionStatus?: Maybe<TransactionStatus>;
  workspaceId?: Maybe<Scalars['String']>;
};

export type TransactionMinOrderByAggregateInput = {
  amount?: InputMaybe<SortOrder>;
  createAt?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  processedAt?: InputMaybe<SortOrder>;
  relatedEntityId?: InputMaybe<SortOrder>;
  transactionStatus?: InputMaybe<SortOrder>;
  workspaceId?: InputMaybe<SortOrder>;
};

export type TransactionNullableRelationFilter = {
  is?: InputMaybe<TransactionWhereInput>;
  isNot?: InputMaybe<TransactionWhereInput>;
};

export type TransactionOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type TransactionOrderByWithAggregationInput = {
  _avg?: InputMaybe<TransactionAvgOrderByAggregateInput>;
  _count?: InputMaybe<TransactionCountOrderByAggregateInput>;
  _max?: InputMaybe<TransactionMaxOrderByAggregateInput>;
  _min?: InputMaybe<TransactionMinOrderByAggregateInput>;
  _sum?: InputMaybe<TransactionSumOrderByAggregateInput>;
  amount?: InputMaybe<SortOrder>;
  createAt?: InputMaybe<SortOrder>;
  details?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  processedAt?: InputMaybe<SortOrder>;
  relatedEntityId?: InputMaybe<SortOrder>;
  transactionStatus?: InputMaybe<SortOrder>;
  workspaceId?: InputMaybe<SortOrder>;
};

export type TransactionOrderByWithRelationInput = {
  amount?: InputMaybe<SortOrder>;
  createAt?: InputMaybe<SortOrder>;
  details?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  payouts?: InputMaybe<PayoutOrderByRelationAggregateInput>;
  processedAt?: InputMaybe<SortOrder>;
  relatedEntityId?: InputMaybe<SortOrder>;
  transactionStatus?: InputMaybe<SortOrder>;
  workspace?: InputMaybe<WorkspaceOrderByWithRelationInput>;
  workspaceId?: InputMaybe<SortOrder>;
};

export enum TransactionScalarFieldEnum {
  Amount = 'amount',
  CreateAt = 'createAt',
  Details = 'details',
  Id = 'id',
  ProcessedAt = 'processedAt',
  RelatedEntityId = 'relatedEntityId',
  TransactionStatus = 'transactionStatus',
  WorkspaceId = 'workspaceId'
}

export type TransactionScalarWhereInput = {
  AND?: InputMaybe<Array<TransactionScalarWhereInput>>;
  NOT?: InputMaybe<Array<TransactionScalarWhereInput>>;
  OR?: InputMaybe<Array<TransactionScalarWhereInput>>;
  amount?: InputMaybe<FloatFilter>;
  createAt?: InputMaybe<DateTimeFilter>;
  details?: InputMaybe<JsonNullableFilter>;
  id?: InputMaybe<StringFilter>;
  processedAt?: InputMaybe<DateTimeNullableFilter>;
  relatedEntityId?: InputMaybe<StringFilter>;
  transactionStatus?: InputMaybe<EnumTransactionStatusFilter>;
  workspaceId?: InputMaybe<StringNullableFilter>;
};

export type TransactionScalarWhereWithAggregatesInput = {
  AND?: InputMaybe<Array<TransactionScalarWhereWithAggregatesInput>>;
  NOT?: InputMaybe<Array<TransactionScalarWhereWithAggregatesInput>>;
  OR?: InputMaybe<Array<TransactionScalarWhereWithAggregatesInput>>;
  amount?: InputMaybe<FloatWithAggregatesFilter>;
  createAt?: InputMaybe<DateTimeWithAggregatesFilter>;
  details?: InputMaybe<JsonNullableWithAggregatesFilter>;
  id?: InputMaybe<StringWithAggregatesFilter>;
  processedAt?: InputMaybe<DateTimeNullableWithAggregatesFilter>;
  relatedEntityId?: InputMaybe<StringWithAggregatesFilter>;
  transactionStatus?: InputMaybe<EnumTransactionStatusWithAggregatesFilter>;
  workspaceId?: InputMaybe<StringNullableWithAggregatesFilter>;
};

export enum TransactionStatus {
  Failed = 'FAILED',
  Pending = 'PENDING',
  Processed = 'PROCESSED'
}

export type TransactionSumAggregate = {
  __typename?: 'TransactionSumAggregate';
  amount?: Maybe<Scalars['Float']>;
};

export type TransactionSumOrderByAggregateInput = {
  amount?: InputMaybe<SortOrder>;
};

export type TransactionUpdateInput = {
  amount?: InputMaybe<Scalars['Float']>;
  createAt?: InputMaybe<Scalars['DateTime']>;
  details?: InputMaybe<Scalars['JSON']>;
  payouts?: InputMaybe<PayoutUpdateManyWithoutTransactionNestedInput>;
  processedAt?: InputMaybe<Scalars['DateTime']>;
  relatedEntityId?: InputMaybe<Scalars['String']>;
  transactionStatus?: InputMaybe<TransactionStatus>;
  workspace?: InputMaybe<WorkspaceUpdateOneWithoutTransactionsNestedInput>;
};

export type TransactionUpdateManyMutationInput = {
  amount?: InputMaybe<Scalars['Float']>;
  createAt?: InputMaybe<Scalars['DateTime']>;
  details?: InputMaybe<Scalars['JSON']>;
  processedAt?: InputMaybe<Scalars['DateTime']>;
  relatedEntityId?: InputMaybe<Scalars['String']>;
  transactionStatus?: InputMaybe<TransactionStatus>;
};

export type TransactionUpdateManyWithWhereWithoutWorkspaceInput = {
  data: TransactionUpdateManyMutationInput;
  where: TransactionScalarWhereInput;
};

export type TransactionUpdateManyWithoutWorkspaceNestedInput = {
  connect?: InputMaybe<Array<TransactionWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<TransactionCreateOrConnectWithoutWorkspaceInput>>;
  create?: InputMaybe<Array<TransactionCreateWithoutWorkspaceInput>>;
  createMany?: InputMaybe<TransactionCreateManyWorkspaceInputEnvelope>;
  delete?: InputMaybe<Array<TransactionWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<TransactionScalarWhereInput>>;
  disconnect?: InputMaybe<Array<TransactionWhereUniqueInput>>;
  set?: InputMaybe<Array<TransactionWhereUniqueInput>>;
  update?: InputMaybe<Array<TransactionUpdateWithWhereUniqueWithoutWorkspaceInput>>;
  updateMany?: InputMaybe<Array<TransactionUpdateManyWithWhereWithoutWorkspaceInput>>;
  upsert?: InputMaybe<Array<TransactionUpsertWithWhereUniqueWithoutWorkspaceInput>>;
};

export type TransactionUpdateOneWithoutPayoutsNestedInput = {
  connect?: InputMaybe<TransactionWhereUniqueInput>;
  connectOrCreate?: InputMaybe<TransactionCreateOrConnectWithoutPayoutsInput>;
  create?: InputMaybe<TransactionCreateWithoutPayoutsInput>;
  delete?: InputMaybe<TransactionWhereInput>;
  disconnect?: InputMaybe<Scalars['Boolean']>;
  update?: InputMaybe<TransactionUpdateToOneWithWhereWithoutPayoutsInput>;
  upsert?: InputMaybe<TransactionUpsertWithoutPayoutsInput>;
};

export type TransactionUpdateToOneWithWhereWithoutPayoutsInput = {
  data: TransactionUpdateWithoutPayoutsInput;
  where?: InputMaybe<TransactionWhereInput>;
};

export type TransactionUpdateWithWhereUniqueWithoutWorkspaceInput = {
  data: TransactionUpdateWithoutWorkspaceInput;
  where: TransactionWhereUniqueInput;
};

export type TransactionUpdateWithoutPayoutsInput = {
  amount?: InputMaybe<Scalars['Float']>;
  createAt?: InputMaybe<Scalars['DateTime']>;
  details?: InputMaybe<Scalars['JSON']>;
  processedAt?: InputMaybe<Scalars['DateTime']>;
  relatedEntityId?: InputMaybe<Scalars['String']>;
  transactionStatus?: InputMaybe<TransactionStatus>;
  workspace?: InputMaybe<WorkspaceUpdateOneWithoutTransactionsNestedInput>;
};

export type TransactionUpdateWithoutWorkspaceInput = {
  amount?: InputMaybe<Scalars['Float']>;
  createAt?: InputMaybe<Scalars['DateTime']>;
  details?: InputMaybe<Scalars['JSON']>;
  payouts?: InputMaybe<PayoutUpdateManyWithoutTransactionNestedInput>;
  processedAt?: InputMaybe<Scalars['DateTime']>;
  relatedEntityId?: InputMaybe<Scalars['String']>;
  transactionStatus?: InputMaybe<TransactionStatus>;
};

export type TransactionUpsertWithWhereUniqueWithoutWorkspaceInput = {
  create: TransactionCreateWithoutWorkspaceInput;
  update: TransactionUpdateWithoutWorkspaceInput;
  where: TransactionWhereUniqueInput;
};

export type TransactionUpsertWithoutPayoutsInput = {
  create: TransactionCreateWithoutPayoutsInput;
  update: TransactionUpdateWithoutPayoutsInput;
  where?: InputMaybe<TransactionWhereInput>;
};

export type TransactionWhereInput = {
  AND?: InputMaybe<Array<TransactionWhereInput>>;
  NOT?: InputMaybe<Array<TransactionWhereInput>>;
  OR?: InputMaybe<Array<TransactionWhereInput>>;
  amount?: InputMaybe<FloatFilter>;
  createAt?: InputMaybe<DateTimeFilter>;
  details?: InputMaybe<JsonNullableFilter>;
  id?: InputMaybe<StringFilter>;
  payouts?: InputMaybe<PayoutListRelationFilter>;
  processedAt?: InputMaybe<DateTimeNullableFilter>;
  relatedEntityId?: InputMaybe<StringFilter>;
  transactionStatus?: InputMaybe<EnumTransactionStatusFilter>;
  workspace?: InputMaybe<WorkspaceNullableRelationFilter>;
  workspaceId?: InputMaybe<StringNullableFilter>;
};

export type TransactionWhereUniqueInput = {
  AND?: InputMaybe<Array<TransactionWhereInput>>;
  NOT?: InputMaybe<Array<TransactionWhereInput>>;
  OR?: InputMaybe<Array<TransactionWhereInput>>;
  amount?: InputMaybe<FloatFilter>;
  createAt?: InputMaybe<DateTimeFilter>;
  details?: InputMaybe<JsonNullableFilter>;
  id?: InputMaybe<Scalars['String']>;
  payouts?: InputMaybe<PayoutListRelationFilter>;
  processedAt?: InputMaybe<DateTimeNullableFilter>;
  relatedEntityId?: InputMaybe<StringFilter>;
  transactionStatus?: InputMaybe<EnumTransactionStatusFilter>;
  workspace?: InputMaybe<WorkspaceNullableRelationFilter>;
  workspaceId?: InputMaybe<StringNullableFilter>;
};

export type User = {
  __typename?: 'User';
  _count?: Maybe<UserCount>;
  accessLabels: Array<AccessLabel>;
  accessLabelsIDs: Array<Scalars['String']>;
  adBoards: Array<AdBoard>;
  adminWorkspaces: Array<Workspace>;
  audits: Array<Audit>;
  bookings: Array<Booking>;
  campaigns: Array<Campaign>;
  changelogs: Array<Changelog>;
  createdFiles: Array<File>;
  displayName?: Maybe<Scalars['String']>;
  email: Scalars['String'];
  id: Scalars['String'];
  image?: Maybe<Scalars['String']>;
  memberships: Array<Membership>;
  orders: Array<Order>;
  otherDetails?: Maybe<Scalars['JSON']>;
  permissions: Array<Permission>;
  phoneNumber?: Maybe<Scalars['String']>;
  refunds: Array<BookingRefund>;
  roleIDs: Array<Scalars['String']>;
  roles: Array<Role>;
  sharedBookingIds: Array<Scalars['String']>;
  sharedBookings: Array<Booking>;
  stripe?: Maybe<UserStripe>;
  uid: Scalars['String'];
  updatedFiles: Array<File>;
  workspaces: Array<Workspace>;
  workspacesIDs: Array<Scalars['String']>;
};


export type UserAccessLabelsArgs = {
  cursor?: InputMaybe<AccessLabelWhereUniqueInput>;
  distinct?: InputMaybe<Array<AccessLabelScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<AccessLabelOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<AccessLabelWhereInput>;
};


export type UserAdBoardsArgs = {
  cursor?: InputMaybe<AdBoardWhereUniqueInput>;
  distinct?: InputMaybe<Array<AdBoardScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<AdBoardOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<AdBoardWhereInput>;
};


export type UserAdminWorkspacesArgs = {
  cursor?: InputMaybe<WorkspaceWhereUniqueInput>;
  distinct?: InputMaybe<Array<WorkspaceScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<WorkspaceOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<WorkspaceWhereInput>;
};


export type UserAuditsArgs = {
  cursor?: InputMaybe<AuditWhereUniqueInput>;
  distinct?: InputMaybe<Array<AuditScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<AuditOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<AuditWhereInput>;
};


export type UserBookingsArgs = {
  cursor?: InputMaybe<BookingWhereUniqueInput>;
  distinct?: InputMaybe<Array<BookingScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<BookingOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<BookingWhereInput>;
};


export type UserCampaignsArgs = {
  cursor?: InputMaybe<CampaignWhereUniqueInput>;
  distinct?: InputMaybe<Array<CampaignScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<CampaignOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<CampaignWhereInput>;
};


export type UserChangelogsArgs = {
  cursor?: InputMaybe<ChangelogWhereUniqueInput>;
  distinct?: InputMaybe<Array<ChangelogScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<ChangelogOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<ChangelogWhereInput>;
};


export type UserCreatedFilesArgs = {
  cursor?: InputMaybe<FileWhereUniqueInput>;
  distinct?: InputMaybe<Array<FileScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<FileOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<FileWhereInput>;
};


export type UserMembershipsArgs = {
  cursor?: InputMaybe<MembershipWhereUniqueInput>;
  distinct?: InputMaybe<Array<MembershipScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<MembershipOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<MembershipWhereInput>;
};


export type UserOrdersArgs = {
  cursor?: InputMaybe<OrderWhereUniqueInput>;
  distinct?: InputMaybe<Array<OrderScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<OrderOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<OrderWhereInput>;
};


export type UserRolesArgs = {
  cursor?: InputMaybe<RoleWhereUniqueInput>;
  distinct?: InputMaybe<Array<RoleScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<RoleOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<RoleWhereInput>;
};


export type UserSharedBookingsArgs = {
  cursor?: InputMaybe<BookingWhereUniqueInput>;
  distinct?: InputMaybe<Array<BookingScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<BookingOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<BookingWhereInput>;
};


export type UserUpdatedFilesArgs = {
  cursor?: InputMaybe<FileWhereUniqueInput>;
  distinct?: InputMaybe<Array<FileScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<FileOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<FileWhereInput>;
};


export type UserWorkspacesArgs = {
  cursor?: InputMaybe<WorkspaceWhereUniqueInput>;
  distinct?: InputMaybe<Array<WorkspaceScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<WorkspaceOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<WorkspaceWhereInput>;
};

export type UserCount = {
  __typename?: 'UserCount';
  accessLabels: Scalars['Int'];
  adBoards: Scalars['Int'];
  adminWorkspaces: Scalars['Int'];
  audits: Scalars['Int'];
  bookings: Scalars['Int'];
  campaigns: Scalars['Int'];
  changelogs: Scalars['Int'];
  createdFiles: Scalars['Int'];
  memberships: Scalars['Int'];
  orders: Scalars['Int'];
  roles: Scalars['Int'];
  sharedBookings: Scalars['Int'];
  updatedFiles: Scalars['Int'];
  workspaces: Scalars['Int'];
};


export type UserCountAccessLabelsArgs = {
  where?: InputMaybe<AccessLabelWhereInput>;
};


export type UserCountAdBoardsArgs = {
  where?: InputMaybe<AdBoardWhereInput>;
};


export type UserCountAdminWorkspacesArgs = {
  where?: InputMaybe<WorkspaceWhereInput>;
};


export type UserCountAuditsArgs = {
  where?: InputMaybe<AuditWhereInput>;
};


export type UserCountBookingsArgs = {
  where?: InputMaybe<BookingWhereInput>;
};


export type UserCountCampaignsArgs = {
  where?: InputMaybe<CampaignWhereInput>;
};


export type UserCountChangelogsArgs = {
  where?: InputMaybe<ChangelogWhereInput>;
};


export type UserCountCreatedFilesArgs = {
  where?: InputMaybe<FileWhereInput>;
};


export type UserCountMembershipsArgs = {
  where?: InputMaybe<MembershipWhereInput>;
};


export type UserCountOrdersArgs = {
  where?: InputMaybe<OrderWhereInput>;
};


export type UserCountRolesArgs = {
  where?: InputMaybe<RoleWhereInput>;
};


export type UserCountSharedBookingsArgs = {
  where?: InputMaybe<BookingWhereInput>;
};


export type UserCountUpdatedFilesArgs = {
  where?: InputMaybe<FileWhereInput>;
};


export type UserCountWorkspacesArgs = {
  where?: InputMaybe<WorkspaceWhereInput>;
};

export type UserCountAggregate = {
  __typename?: 'UserCountAggregate';
  _all: Scalars['Int'];
  accessLabelsIDs: Scalars['Int'];
  displayName: Scalars['Int'];
  email: Scalars['Int'];
  id: Scalars['Int'];
  image: Scalars['Int'];
  otherDetails: Scalars['Int'];
  permissions: Scalars['Int'];
  phoneNumber: Scalars['Int'];
  roleIDs: Scalars['Int'];
  sharedBookingIds: Scalars['Int'];
  uid: Scalars['Int'];
  workspacesIDs: Scalars['Int'];
};

export type UserCountOrderByAggregateInput = {
  accessLabelsIDs?: InputMaybe<SortOrder>;
  displayName?: InputMaybe<SortOrder>;
  email?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  image?: InputMaybe<SortOrder>;
  otherDetails?: InputMaybe<SortOrder>;
  permissions?: InputMaybe<SortOrder>;
  phoneNumber?: InputMaybe<SortOrder>;
  roleIDs?: InputMaybe<SortOrder>;
  sharedBookingIds?: InputMaybe<SortOrder>;
  uid?: InputMaybe<SortOrder>;
  workspacesIDs?: InputMaybe<SortOrder>;
};

export type UserCreateInput = {
  accessLabels?: InputMaybe<AccessLabelCreateNestedManyWithoutUserInput>;
  adBoards?: InputMaybe<AdBoardCreateNestedManyWithoutCreatedByInput>;
  adminWorkspaces?: InputMaybe<WorkspaceCreateNestedManyWithoutAdminInput>;
  audits?: InputMaybe<AuditCreateNestedManyWithoutUserInput>;
  bookings?: InputMaybe<BookingCreateNestedManyWithoutUserInput>;
  campaigns?: InputMaybe<CampaignCreateNestedManyWithoutUserInput>;
  changelogs?: InputMaybe<ChangelogCreateNestedManyWithoutUserInput>;
  createdFiles?: InputMaybe<FileCreateNestedManyWithoutCreatedByInput>;
  displayName?: InputMaybe<Scalars['String']>;
  email: Scalars['String'];
  id?: InputMaybe<Scalars['String']>;
  image?: InputMaybe<Scalars['String']>;
  memberships?: InputMaybe<MembershipCreateNestedManyWithoutUserInput>;
  orders?: InputMaybe<OrderCreateNestedManyWithoutCreatedByInput>;
  otherDetails?: InputMaybe<Scalars['JSON']>;
  permissions?: InputMaybe<Array<Permission>>;
  phoneNumber?: InputMaybe<Scalars['String']>;
  refunds?: InputMaybe<Array<BookingRefundCreateInput>>;
  roles?: InputMaybe<RoleCreateNestedManyWithoutUsersInput>;
  sharedBookings?: InputMaybe<BookingCreateNestedManyWithoutSharedUsersInput>;
  stripe?: InputMaybe<UserStripeCreateInput>;
  uid: Scalars['String'];
  updatedFiles?: InputMaybe<FileCreateNestedManyWithoutUpdatedByInput>;
  workspaces?: InputMaybe<WorkspaceCreateNestedManyWithoutUsersInput>;
};

export type UserCreateManyInput = {
  accessLabelsIDs?: InputMaybe<Array<Scalars['String']>>;
  displayName?: InputMaybe<Scalars['String']>;
  email: Scalars['String'];
  id?: InputMaybe<Scalars['String']>;
  image?: InputMaybe<Scalars['String']>;
  otherDetails?: InputMaybe<Scalars['JSON']>;
  permissions?: InputMaybe<Array<Permission>>;
  phoneNumber?: InputMaybe<Scalars['String']>;
  refunds?: InputMaybe<Array<BookingRefundCreateInput>>;
  roleIDs?: InputMaybe<Array<Scalars['String']>>;
  sharedBookingIds?: InputMaybe<Array<Scalars['String']>>;
  stripe?: InputMaybe<UserStripeCreateInput>;
  uid: Scalars['String'];
  workspacesIDs?: InputMaybe<Array<Scalars['String']>>;
};

export type UserCreateNestedManyWithoutAccessLabelsInput = {
  connect?: InputMaybe<Array<UserWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<UserCreateOrConnectWithoutAccessLabelsInput>>;
  create?: InputMaybe<Array<UserCreateWithoutAccessLabelsInput>>;
};

export type UserCreateNestedManyWithoutRolesInput = {
  connect?: InputMaybe<Array<UserWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<UserCreateOrConnectWithoutRolesInput>>;
  create?: InputMaybe<Array<UserCreateWithoutRolesInput>>;
};

export type UserCreateNestedManyWithoutSharedBookingsInput = {
  connect?: InputMaybe<Array<UserWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<UserCreateOrConnectWithoutSharedBookingsInput>>;
  create?: InputMaybe<Array<UserCreateWithoutSharedBookingsInput>>;
};

export type UserCreateNestedManyWithoutWorkspacesInput = {
  connect?: InputMaybe<Array<UserWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<UserCreateOrConnectWithoutWorkspacesInput>>;
  create?: InputMaybe<Array<UserCreateWithoutWorkspacesInput>>;
};

export type UserCreateNestedOneWithoutAdBoardsInput = {
  connect?: InputMaybe<UserWhereUniqueInput>;
  connectOrCreate?: InputMaybe<UserCreateOrConnectWithoutAdBoardsInput>;
  create?: InputMaybe<UserCreateWithoutAdBoardsInput>;
};

export type UserCreateNestedOneWithoutAdminWorkspacesInput = {
  connect?: InputMaybe<UserWhereUniqueInput>;
  connectOrCreate?: InputMaybe<UserCreateOrConnectWithoutAdminWorkspacesInput>;
  create?: InputMaybe<UserCreateWithoutAdminWorkspacesInput>;
};

export type UserCreateNestedOneWithoutAuditsInput = {
  connect?: InputMaybe<UserWhereUniqueInput>;
  connectOrCreate?: InputMaybe<UserCreateOrConnectWithoutAuditsInput>;
  create?: InputMaybe<UserCreateWithoutAuditsInput>;
};

export type UserCreateNestedOneWithoutBookingsInput = {
  connect?: InputMaybe<UserWhereUniqueInput>;
  connectOrCreate?: InputMaybe<UserCreateOrConnectWithoutBookingsInput>;
  create?: InputMaybe<UserCreateWithoutBookingsInput>;
};

export type UserCreateNestedOneWithoutCampaignsInput = {
  connect?: InputMaybe<UserWhereUniqueInput>;
  connectOrCreate?: InputMaybe<UserCreateOrConnectWithoutCampaignsInput>;
  create?: InputMaybe<UserCreateWithoutCampaignsInput>;
};

export type UserCreateNestedOneWithoutChangelogsInput = {
  connect?: InputMaybe<UserWhereUniqueInput>;
  connectOrCreate?: InputMaybe<UserCreateOrConnectWithoutChangelogsInput>;
  create?: InputMaybe<UserCreateWithoutChangelogsInput>;
};

export type UserCreateNestedOneWithoutCreatedFilesInput = {
  connect?: InputMaybe<UserWhereUniqueInput>;
  connectOrCreate?: InputMaybe<UserCreateOrConnectWithoutCreatedFilesInput>;
  create?: InputMaybe<UserCreateWithoutCreatedFilesInput>;
};

export type UserCreateNestedOneWithoutMembershipsInput = {
  connect?: InputMaybe<UserWhereUniqueInput>;
  connectOrCreate?: InputMaybe<UserCreateOrConnectWithoutMembershipsInput>;
  create?: InputMaybe<UserCreateWithoutMembershipsInput>;
};

export type UserCreateNestedOneWithoutOrdersInput = {
  connect?: InputMaybe<UserWhereUniqueInput>;
  connectOrCreate?: InputMaybe<UserCreateOrConnectWithoutOrdersInput>;
  create?: InputMaybe<UserCreateWithoutOrdersInput>;
};

export type UserCreateNestedOneWithoutUpdatedFilesInput = {
  connect?: InputMaybe<UserWhereUniqueInput>;
  connectOrCreate?: InputMaybe<UserCreateOrConnectWithoutUpdatedFilesInput>;
  create?: InputMaybe<UserCreateWithoutUpdatedFilesInput>;
};

export type UserCreateOrConnectWithoutAccessLabelsInput = {
  create: UserCreateWithoutAccessLabelsInput;
  where: UserWhereUniqueInput;
};

export type UserCreateOrConnectWithoutAdBoardsInput = {
  create: UserCreateWithoutAdBoardsInput;
  where: UserWhereUniqueInput;
};

export type UserCreateOrConnectWithoutAdminWorkspacesInput = {
  create: UserCreateWithoutAdminWorkspacesInput;
  where: UserWhereUniqueInput;
};

export type UserCreateOrConnectWithoutAuditsInput = {
  create: UserCreateWithoutAuditsInput;
  where: UserWhereUniqueInput;
};

export type UserCreateOrConnectWithoutBookingsInput = {
  create: UserCreateWithoutBookingsInput;
  where: UserWhereUniqueInput;
};

export type UserCreateOrConnectWithoutCampaignsInput = {
  create: UserCreateWithoutCampaignsInput;
  where: UserWhereUniqueInput;
};

export type UserCreateOrConnectWithoutChangelogsInput = {
  create: UserCreateWithoutChangelogsInput;
  where: UserWhereUniqueInput;
};

export type UserCreateOrConnectWithoutCreatedFilesInput = {
  create: UserCreateWithoutCreatedFilesInput;
  where: UserWhereUniqueInput;
};

export type UserCreateOrConnectWithoutMembershipsInput = {
  create: UserCreateWithoutMembershipsInput;
  where: UserWhereUniqueInput;
};

export type UserCreateOrConnectWithoutOrdersInput = {
  create: UserCreateWithoutOrdersInput;
  where: UserWhereUniqueInput;
};

export type UserCreateOrConnectWithoutRolesInput = {
  create: UserCreateWithoutRolesInput;
  where: UserWhereUniqueInput;
};

export type UserCreateOrConnectWithoutSharedBookingsInput = {
  create: UserCreateWithoutSharedBookingsInput;
  where: UserWhereUniqueInput;
};

export type UserCreateOrConnectWithoutUpdatedFilesInput = {
  create: UserCreateWithoutUpdatedFilesInput;
  where: UserWhereUniqueInput;
};

export type UserCreateOrConnectWithoutWorkspacesInput = {
  create: UserCreateWithoutWorkspacesInput;
  where: UserWhereUniqueInput;
};

export type UserCreateWithoutAccessLabelsInput = {
  adBoards?: InputMaybe<AdBoardCreateNestedManyWithoutCreatedByInput>;
  adminWorkspaces?: InputMaybe<WorkspaceCreateNestedManyWithoutAdminInput>;
  audits?: InputMaybe<AuditCreateNestedManyWithoutUserInput>;
  bookings?: InputMaybe<BookingCreateNestedManyWithoutUserInput>;
  campaigns?: InputMaybe<CampaignCreateNestedManyWithoutUserInput>;
  changelogs?: InputMaybe<ChangelogCreateNestedManyWithoutUserInput>;
  createdFiles?: InputMaybe<FileCreateNestedManyWithoutCreatedByInput>;
  displayName?: InputMaybe<Scalars['String']>;
  email: Scalars['String'];
  id?: InputMaybe<Scalars['String']>;
  image?: InputMaybe<Scalars['String']>;
  memberships?: InputMaybe<MembershipCreateNestedManyWithoutUserInput>;
  orders?: InputMaybe<OrderCreateNestedManyWithoutCreatedByInput>;
  otherDetails?: InputMaybe<Scalars['JSON']>;
  permissions?: InputMaybe<Array<Permission>>;
  phoneNumber?: InputMaybe<Scalars['String']>;
  refunds?: InputMaybe<Array<BookingRefundCreateInput>>;
  roles?: InputMaybe<RoleCreateNestedManyWithoutUsersInput>;
  sharedBookings?: InputMaybe<BookingCreateNestedManyWithoutSharedUsersInput>;
  stripe?: InputMaybe<UserStripeCreateInput>;
  uid: Scalars['String'];
  updatedFiles?: InputMaybe<FileCreateNestedManyWithoutUpdatedByInput>;
  workspaces?: InputMaybe<WorkspaceCreateNestedManyWithoutUsersInput>;
};

export type UserCreateWithoutAdBoardsInput = {
  accessLabels?: InputMaybe<AccessLabelCreateNestedManyWithoutUserInput>;
  adminWorkspaces?: InputMaybe<WorkspaceCreateNestedManyWithoutAdminInput>;
  audits?: InputMaybe<AuditCreateNestedManyWithoutUserInput>;
  bookings?: InputMaybe<BookingCreateNestedManyWithoutUserInput>;
  campaigns?: InputMaybe<CampaignCreateNestedManyWithoutUserInput>;
  changelogs?: InputMaybe<ChangelogCreateNestedManyWithoutUserInput>;
  createdFiles?: InputMaybe<FileCreateNestedManyWithoutCreatedByInput>;
  displayName?: InputMaybe<Scalars['String']>;
  email: Scalars['String'];
  id?: InputMaybe<Scalars['String']>;
  image?: InputMaybe<Scalars['String']>;
  memberships?: InputMaybe<MembershipCreateNestedManyWithoutUserInput>;
  orders?: InputMaybe<OrderCreateNestedManyWithoutCreatedByInput>;
  otherDetails?: InputMaybe<Scalars['JSON']>;
  permissions?: InputMaybe<Array<Permission>>;
  phoneNumber?: InputMaybe<Scalars['String']>;
  refunds?: InputMaybe<Array<BookingRefundCreateInput>>;
  roles?: InputMaybe<RoleCreateNestedManyWithoutUsersInput>;
  sharedBookings?: InputMaybe<BookingCreateNestedManyWithoutSharedUsersInput>;
  stripe?: InputMaybe<UserStripeCreateInput>;
  uid: Scalars['String'];
  updatedFiles?: InputMaybe<FileCreateNestedManyWithoutUpdatedByInput>;
  workspaces?: InputMaybe<WorkspaceCreateNestedManyWithoutUsersInput>;
};

export type UserCreateWithoutAdminWorkspacesInput = {
  accessLabels?: InputMaybe<AccessLabelCreateNestedManyWithoutUserInput>;
  adBoards?: InputMaybe<AdBoardCreateNestedManyWithoutCreatedByInput>;
  audits?: InputMaybe<AuditCreateNestedManyWithoutUserInput>;
  bookings?: InputMaybe<BookingCreateNestedManyWithoutUserInput>;
  campaigns?: InputMaybe<CampaignCreateNestedManyWithoutUserInput>;
  changelogs?: InputMaybe<ChangelogCreateNestedManyWithoutUserInput>;
  createdFiles?: InputMaybe<FileCreateNestedManyWithoutCreatedByInput>;
  displayName?: InputMaybe<Scalars['String']>;
  email: Scalars['String'];
  id?: InputMaybe<Scalars['String']>;
  image?: InputMaybe<Scalars['String']>;
  memberships?: InputMaybe<MembershipCreateNestedManyWithoutUserInput>;
  orders?: InputMaybe<OrderCreateNestedManyWithoutCreatedByInput>;
  otherDetails?: InputMaybe<Scalars['JSON']>;
  permissions?: InputMaybe<Array<Permission>>;
  phoneNumber?: InputMaybe<Scalars['String']>;
  refunds?: InputMaybe<Array<BookingRefundCreateInput>>;
  roles?: InputMaybe<RoleCreateNestedManyWithoutUsersInput>;
  sharedBookings?: InputMaybe<BookingCreateNestedManyWithoutSharedUsersInput>;
  stripe?: InputMaybe<UserStripeCreateInput>;
  uid: Scalars['String'];
  updatedFiles?: InputMaybe<FileCreateNestedManyWithoutUpdatedByInput>;
  workspaces?: InputMaybe<WorkspaceCreateNestedManyWithoutUsersInput>;
};

export type UserCreateWithoutAuditsInput = {
  accessLabels?: InputMaybe<AccessLabelCreateNestedManyWithoutUserInput>;
  adBoards?: InputMaybe<AdBoardCreateNestedManyWithoutCreatedByInput>;
  adminWorkspaces?: InputMaybe<WorkspaceCreateNestedManyWithoutAdminInput>;
  bookings?: InputMaybe<BookingCreateNestedManyWithoutUserInput>;
  campaigns?: InputMaybe<CampaignCreateNestedManyWithoutUserInput>;
  changelogs?: InputMaybe<ChangelogCreateNestedManyWithoutUserInput>;
  createdFiles?: InputMaybe<FileCreateNestedManyWithoutCreatedByInput>;
  displayName?: InputMaybe<Scalars['String']>;
  email: Scalars['String'];
  id?: InputMaybe<Scalars['String']>;
  image?: InputMaybe<Scalars['String']>;
  memberships?: InputMaybe<MembershipCreateNestedManyWithoutUserInput>;
  orders?: InputMaybe<OrderCreateNestedManyWithoutCreatedByInput>;
  otherDetails?: InputMaybe<Scalars['JSON']>;
  permissions?: InputMaybe<Array<Permission>>;
  phoneNumber?: InputMaybe<Scalars['String']>;
  refunds?: InputMaybe<Array<BookingRefundCreateInput>>;
  roles?: InputMaybe<RoleCreateNestedManyWithoutUsersInput>;
  sharedBookings?: InputMaybe<BookingCreateNestedManyWithoutSharedUsersInput>;
  stripe?: InputMaybe<UserStripeCreateInput>;
  uid: Scalars['String'];
  updatedFiles?: InputMaybe<FileCreateNestedManyWithoutUpdatedByInput>;
  workspaces?: InputMaybe<WorkspaceCreateNestedManyWithoutUsersInput>;
};

export type UserCreateWithoutBookingsInput = {
  accessLabels?: InputMaybe<AccessLabelCreateNestedManyWithoutUserInput>;
  adBoards?: InputMaybe<AdBoardCreateNestedManyWithoutCreatedByInput>;
  adminWorkspaces?: InputMaybe<WorkspaceCreateNestedManyWithoutAdminInput>;
  audits?: InputMaybe<AuditCreateNestedManyWithoutUserInput>;
  campaigns?: InputMaybe<CampaignCreateNestedManyWithoutUserInput>;
  changelogs?: InputMaybe<ChangelogCreateNestedManyWithoutUserInput>;
  createdFiles?: InputMaybe<FileCreateNestedManyWithoutCreatedByInput>;
  displayName?: InputMaybe<Scalars['String']>;
  email: Scalars['String'];
  id?: InputMaybe<Scalars['String']>;
  image?: InputMaybe<Scalars['String']>;
  memberships?: InputMaybe<MembershipCreateNestedManyWithoutUserInput>;
  orders?: InputMaybe<OrderCreateNestedManyWithoutCreatedByInput>;
  otherDetails?: InputMaybe<Scalars['JSON']>;
  permissions?: InputMaybe<Array<Permission>>;
  phoneNumber?: InputMaybe<Scalars['String']>;
  refunds?: InputMaybe<Array<BookingRefundCreateInput>>;
  roles?: InputMaybe<RoleCreateNestedManyWithoutUsersInput>;
  sharedBookings?: InputMaybe<BookingCreateNestedManyWithoutSharedUsersInput>;
  stripe?: InputMaybe<UserStripeCreateInput>;
  uid: Scalars['String'];
  updatedFiles?: InputMaybe<FileCreateNestedManyWithoutUpdatedByInput>;
  workspaces?: InputMaybe<WorkspaceCreateNestedManyWithoutUsersInput>;
};

export type UserCreateWithoutCampaignsInput = {
  accessLabels?: InputMaybe<AccessLabelCreateNestedManyWithoutUserInput>;
  adBoards?: InputMaybe<AdBoardCreateNestedManyWithoutCreatedByInput>;
  adminWorkspaces?: InputMaybe<WorkspaceCreateNestedManyWithoutAdminInput>;
  audits?: InputMaybe<AuditCreateNestedManyWithoutUserInput>;
  bookings?: InputMaybe<BookingCreateNestedManyWithoutUserInput>;
  changelogs?: InputMaybe<ChangelogCreateNestedManyWithoutUserInput>;
  createdFiles?: InputMaybe<FileCreateNestedManyWithoutCreatedByInput>;
  displayName?: InputMaybe<Scalars['String']>;
  email: Scalars['String'];
  id?: InputMaybe<Scalars['String']>;
  image?: InputMaybe<Scalars['String']>;
  memberships?: InputMaybe<MembershipCreateNestedManyWithoutUserInput>;
  orders?: InputMaybe<OrderCreateNestedManyWithoutCreatedByInput>;
  otherDetails?: InputMaybe<Scalars['JSON']>;
  permissions?: InputMaybe<Array<Permission>>;
  phoneNumber?: InputMaybe<Scalars['String']>;
  refunds?: InputMaybe<Array<BookingRefundCreateInput>>;
  roles?: InputMaybe<RoleCreateNestedManyWithoutUsersInput>;
  sharedBookings?: InputMaybe<BookingCreateNestedManyWithoutSharedUsersInput>;
  stripe?: InputMaybe<UserStripeCreateInput>;
  uid: Scalars['String'];
  updatedFiles?: InputMaybe<FileCreateNestedManyWithoutUpdatedByInput>;
  workspaces?: InputMaybe<WorkspaceCreateNestedManyWithoutUsersInput>;
};

export type UserCreateWithoutChangelogsInput = {
  accessLabels?: InputMaybe<AccessLabelCreateNestedManyWithoutUserInput>;
  adBoards?: InputMaybe<AdBoardCreateNestedManyWithoutCreatedByInput>;
  adminWorkspaces?: InputMaybe<WorkspaceCreateNestedManyWithoutAdminInput>;
  audits?: InputMaybe<AuditCreateNestedManyWithoutUserInput>;
  bookings?: InputMaybe<BookingCreateNestedManyWithoutUserInput>;
  campaigns?: InputMaybe<CampaignCreateNestedManyWithoutUserInput>;
  createdFiles?: InputMaybe<FileCreateNestedManyWithoutCreatedByInput>;
  displayName?: InputMaybe<Scalars['String']>;
  email: Scalars['String'];
  id?: InputMaybe<Scalars['String']>;
  image?: InputMaybe<Scalars['String']>;
  memberships?: InputMaybe<MembershipCreateNestedManyWithoutUserInput>;
  orders?: InputMaybe<OrderCreateNestedManyWithoutCreatedByInput>;
  otherDetails?: InputMaybe<Scalars['JSON']>;
  permissions?: InputMaybe<Array<Permission>>;
  phoneNumber?: InputMaybe<Scalars['String']>;
  refunds?: InputMaybe<Array<BookingRefundCreateInput>>;
  roles?: InputMaybe<RoleCreateNestedManyWithoutUsersInput>;
  sharedBookings?: InputMaybe<BookingCreateNestedManyWithoutSharedUsersInput>;
  stripe?: InputMaybe<UserStripeCreateInput>;
  uid: Scalars['String'];
  updatedFiles?: InputMaybe<FileCreateNestedManyWithoutUpdatedByInput>;
  workspaces?: InputMaybe<WorkspaceCreateNestedManyWithoutUsersInput>;
};

export type UserCreateWithoutCreatedFilesInput = {
  accessLabels?: InputMaybe<AccessLabelCreateNestedManyWithoutUserInput>;
  adBoards?: InputMaybe<AdBoardCreateNestedManyWithoutCreatedByInput>;
  adminWorkspaces?: InputMaybe<WorkspaceCreateNestedManyWithoutAdminInput>;
  audits?: InputMaybe<AuditCreateNestedManyWithoutUserInput>;
  bookings?: InputMaybe<BookingCreateNestedManyWithoutUserInput>;
  campaigns?: InputMaybe<CampaignCreateNestedManyWithoutUserInput>;
  changelogs?: InputMaybe<ChangelogCreateNestedManyWithoutUserInput>;
  displayName?: InputMaybe<Scalars['String']>;
  email: Scalars['String'];
  id?: InputMaybe<Scalars['String']>;
  image?: InputMaybe<Scalars['String']>;
  memberships?: InputMaybe<MembershipCreateNestedManyWithoutUserInput>;
  orders?: InputMaybe<OrderCreateNestedManyWithoutCreatedByInput>;
  otherDetails?: InputMaybe<Scalars['JSON']>;
  permissions?: InputMaybe<Array<Permission>>;
  phoneNumber?: InputMaybe<Scalars['String']>;
  refunds?: InputMaybe<Array<BookingRefundCreateInput>>;
  roles?: InputMaybe<RoleCreateNestedManyWithoutUsersInput>;
  sharedBookings?: InputMaybe<BookingCreateNestedManyWithoutSharedUsersInput>;
  stripe?: InputMaybe<UserStripeCreateInput>;
  uid: Scalars['String'];
  updatedFiles?: InputMaybe<FileCreateNestedManyWithoutUpdatedByInput>;
  workspaces?: InputMaybe<WorkspaceCreateNestedManyWithoutUsersInput>;
};

export type UserCreateWithoutMembershipsInput = {
  accessLabels?: InputMaybe<AccessLabelCreateNestedManyWithoutUserInput>;
  adBoards?: InputMaybe<AdBoardCreateNestedManyWithoutCreatedByInput>;
  adminWorkspaces?: InputMaybe<WorkspaceCreateNestedManyWithoutAdminInput>;
  audits?: InputMaybe<AuditCreateNestedManyWithoutUserInput>;
  bookings?: InputMaybe<BookingCreateNestedManyWithoutUserInput>;
  campaigns?: InputMaybe<CampaignCreateNestedManyWithoutUserInput>;
  changelogs?: InputMaybe<ChangelogCreateNestedManyWithoutUserInput>;
  createdFiles?: InputMaybe<FileCreateNestedManyWithoutCreatedByInput>;
  displayName?: InputMaybe<Scalars['String']>;
  email: Scalars['String'];
  id?: InputMaybe<Scalars['String']>;
  image?: InputMaybe<Scalars['String']>;
  orders?: InputMaybe<OrderCreateNestedManyWithoutCreatedByInput>;
  otherDetails?: InputMaybe<Scalars['JSON']>;
  permissions?: InputMaybe<Array<Permission>>;
  phoneNumber?: InputMaybe<Scalars['String']>;
  refunds?: InputMaybe<Array<BookingRefundCreateInput>>;
  roles?: InputMaybe<RoleCreateNestedManyWithoutUsersInput>;
  sharedBookings?: InputMaybe<BookingCreateNestedManyWithoutSharedUsersInput>;
  stripe?: InputMaybe<UserStripeCreateInput>;
  uid: Scalars['String'];
  updatedFiles?: InputMaybe<FileCreateNestedManyWithoutUpdatedByInput>;
  workspaces?: InputMaybe<WorkspaceCreateNestedManyWithoutUsersInput>;
};

export type UserCreateWithoutOrdersInput = {
  accessLabels?: InputMaybe<AccessLabelCreateNestedManyWithoutUserInput>;
  adBoards?: InputMaybe<AdBoardCreateNestedManyWithoutCreatedByInput>;
  adminWorkspaces?: InputMaybe<WorkspaceCreateNestedManyWithoutAdminInput>;
  audits?: InputMaybe<AuditCreateNestedManyWithoutUserInput>;
  bookings?: InputMaybe<BookingCreateNestedManyWithoutUserInput>;
  campaigns?: InputMaybe<CampaignCreateNestedManyWithoutUserInput>;
  changelogs?: InputMaybe<ChangelogCreateNestedManyWithoutUserInput>;
  createdFiles?: InputMaybe<FileCreateNestedManyWithoutCreatedByInput>;
  displayName?: InputMaybe<Scalars['String']>;
  email: Scalars['String'];
  id?: InputMaybe<Scalars['String']>;
  image?: InputMaybe<Scalars['String']>;
  memberships?: InputMaybe<MembershipCreateNestedManyWithoutUserInput>;
  otherDetails?: InputMaybe<Scalars['JSON']>;
  permissions?: InputMaybe<Array<Permission>>;
  phoneNumber?: InputMaybe<Scalars['String']>;
  refunds?: InputMaybe<Array<BookingRefundCreateInput>>;
  roles?: InputMaybe<RoleCreateNestedManyWithoutUsersInput>;
  sharedBookings?: InputMaybe<BookingCreateNestedManyWithoutSharedUsersInput>;
  stripe?: InputMaybe<UserStripeCreateInput>;
  uid: Scalars['String'];
  updatedFiles?: InputMaybe<FileCreateNestedManyWithoutUpdatedByInput>;
  workspaces?: InputMaybe<WorkspaceCreateNestedManyWithoutUsersInput>;
};

export type UserCreateWithoutRolesInput = {
  accessLabels?: InputMaybe<AccessLabelCreateNestedManyWithoutUserInput>;
  adBoards?: InputMaybe<AdBoardCreateNestedManyWithoutCreatedByInput>;
  adminWorkspaces?: InputMaybe<WorkspaceCreateNestedManyWithoutAdminInput>;
  audits?: InputMaybe<AuditCreateNestedManyWithoutUserInput>;
  bookings?: InputMaybe<BookingCreateNestedManyWithoutUserInput>;
  campaigns?: InputMaybe<CampaignCreateNestedManyWithoutUserInput>;
  changelogs?: InputMaybe<ChangelogCreateNestedManyWithoutUserInput>;
  createdFiles?: InputMaybe<FileCreateNestedManyWithoutCreatedByInput>;
  displayName?: InputMaybe<Scalars['String']>;
  email: Scalars['String'];
  id?: InputMaybe<Scalars['String']>;
  image?: InputMaybe<Scalars['String']>;
  memberships?: InputMaybe<MembershipCreateNestedManyWithoutUserInput>;
  orders?: InputMaybe<OrderCreateNestedManyWithoutCreatedByInput>;
  otherDetails?: InputMaybe<Scalars['JSON']>;
  permissions?: InputMaybe<Array<Permission>>;
  phoneNumber?: InputMaybe<Scalars['String']>;
  refunds?: InputMaybe<Array<BookingRefundCreateInput>>;
  sharedBookings?: InputMaybe<BookingCreateNestedManyWithoutSharedUsersInput>;
  stripe?: InputMaybe<UserStripeCreateInput>;
  uid: Scalars['String'];
  updatedFiles?: InputMaybe<FileCreateNestedManyWithoutUpdatedByInput>;
  workspaces?: InputMaybe<WorkspaceCreateNestedManyWithoutUsersInput>;
};

export type UserCreateWithoutSharedBookingsInput = {
  accessLabels?: InputMaybe<AccessLabelCreateNestedManyWithoutUserInput>;
  adBoards?: InputMaybe<AdBoardCreateNestedManyWithoutCreatedByInput>;
  adminWorkspaces?: InputMaybe<WorkspaceCreateNestedManyWithoutAdminInput>;
  audits?: InputMaybe<AuditCreateNestedManyWithoutUserInput>;
  bookings?: InputMaybe<BookingCreateNestedManyWithoutUserInput>;
  campaigns?: InputMaybe<CampaignCreateNestedManyWithoutUserInput>;
  changelogs?: InputMaybe<ChangelogCreateNestedManyWithoutUserInput>;
  createdFiles?: InputMaybe<FileCreateNestedManyWithoutCreatedByInput>;
  displayName?: InputMaybe<Scalars['String']>;
  email: Scalars['String'];
  id?: InputMaybe<Scalars['String']>;
  image?: InputMaybe<Scalars['String']>;
  memberships?: InputMaybe<MembershipCreateNestedManyWithoutUserInput>;
  orders?: InputMaybe<OrderCreateNestedManyWithoutCreatedByInput>;
  otherDetails?: InputMaybe<Scalars['JSON']>;
  permissions?: InputMaybe<Array<Permission>>;
  phoneNumber?: InputMaybe<Scalars['String']>;
  refunds?: InputMaybe<Array<BookingRefundCreateInput>>;
  roles?: InputMaybe<RoleCreateNestedManyWithoutUsersInput>;
  stripe?: InputMaybe<UserStripeCreateInput>;
  uid: Scalars['String'];
  updatedFiles?: InputMaybe<FileCreateNestedManyWithoutUpdatedByInput>;
  workspaces?: InputMaybe<WorkspaceCreateNestedManyWithoutUsersInput>;
};

export type UserCreateWithoutUpdatedFilesInput = {
  accessLabels?: InputMaybe<AccessLabelCreateNestedManyWithoutUserInput>;
  adBoards?: InputMaybe<AdBoardCreateNestedManyWithoutCreatedByInput>;
  adminWorkspaces?: InputMaybe<WorkspaceCreateNestedManyWithoutAdminInput>;
  audits?: InputMaybe<AuditCreateNestedManyWithoutUserInput>;
  bookings?: InputMaybe<BookingCreateNestedManyWithoutUserInput>;
  campaigns?: InputMaybe<CampaignCreateNestedManyWithoutUserInput>;
  changelogs?: InputMaybe<ChangelogCreateNestedManyWithoutUserInput>;
  createdFiles?: InputMaybe<FileCreateNestedManyWithoutCreatedByInput>;
  displayName?: InputMaybe<Scalars['String']>;
  email: Scalars['String'];
  id?: InputMaybe<Scalars['String']>;
  image?: InputMaybe<Scalars['String']>;
  memberships?: InputMaybe<MembershipCreateNestedManyWithoutUserInput>;
  orders?: InputMaybe<OrderCreateNestedManyWithoutCreatedByInput>;
  otherDetails?: InputMaybe<Scalars['JSON']>;
  permissions?: InputMaybe<Array<Permission>>;
  phoneNumber?: InputMaybe<Scalars['String']>;
  refunds?: InputMaybe<Array<BookingRefundCreateInput>>;
  roles?: InputMaybe<RoleCreateNestedManyWithoutUsersInput>;
  sharedBookings?: InputMaybe<BookingCreateNestedManyWithoutSharedUsersInput>;
  stripe?: InputMaybe<UserStripeCreateInput>;
  uid: Scalars['String'];
  workspaces?: InputMaybe<WorkspaceCreateNestedManyWithoutUsersInput>;
};

export type UserCreateWithoutWorkspacesInput = {
  accessLabels?: InputMaybe<AccessLabelCreateNestedManyWithoutUserInput>;
  adBoards?: InputMaybe<AdBoardCreateNestedManyWithoutCreatedByInput>;
  adminWorkspaces?: InputMaybe<WorkspaceCreateNestedManyWithoutAdminInput>;
  audits?: InputMaybe<AuditCreateNestedManyWithoutUserInput>;
  bookings?: InputMaybe<BookingCreateNestedManyWithoutUserInput>;
  campaigns?: InputMaybe<CampaignCreateNestedManyWithoutUserInput>;
  changelogs?: InputMaybe<ChangelogCreateNestedManyWithoutUserInput>;
  createdFiles?: InputMaybe<FileCreateNestedManyWithoutCreatedByInput>;
  displayName?: InputMaybe<Scalars['String']>;
  email: Scalars['String'];
  id?: InputMaybe<Scalars['String']>;
  image?: InputMaybe<Scalars['String']>;
  memberships?: InputMaybe<MembershipCreateNestedManyWithoutUserInput>;
  orders?: InputMaybe<OrderCreateNestedManyWithoutCreatedByInput>;
  otherDetails?: InputMaybe<Scalars['JSON']>;
  permissions?: InputMaybe<Array<Permission>>;
  phoneNumber?: InputMaybe<Scalars['String']>;
  refunds?: InputMaybe<Array<BookingRefundCreateInput>>;
  roles?: InputMaybe<RoleCreateNestedManyWithoutUsersInput>;
  sharedBookings?: InputMaybe<BookingCreateNestedManyWithoutSharedUsersInput>;
  stripe?: InputMaybe<UserStripeCreateInput>;
  uid: Scalars['String'];
  updatedFiles?: InputMaybe<FileCreateNestedManyWithoutUpdatedByInput>;
};

export type UserGroupBy = {
  __typename?: 'UserGroupBy';
  _count?: Maybe<UserCountAggregate>;
  _max?: Maybe<UserMaxAggregate>;
  _min?: Maybe<UserMinAggregate>;
  accessLabelsIDs?: Maybe<Array<Scalars['String']>>;
  displayName?: Maybe<Scalars['String']>;
  email: Scalars['String'];
  id: Scalars['String'];
  image?: Maybe<Scalars['String']>;
  otherDetails?: Maybe<Scalars['JSON']>;
  permissions?: Maybe<Array<Permission>>;
  phoneNumber?: Maybe<Scalars['String']>;
  roleIDs?: Maybe<Array<Scalars['String']>>;
  sharedBookingIds?: Maybe<Array<Scalars['String']>>;
  uid: Scalars['String'];
  workspacesIDs?: Maybe<Array<Scalars['String']>>;
};

export type UserInput = {
  displayName: Scalars['String'];
  email: Scalars['String'];
  password: Scalars['String'];
  phoneNumber: Scalars['String'];
};

export type UserListRelationFilter = {
  every?: InputMaybe<UserWhereInput>;
  none?: InputMaybe<UserWhereInput>;
  some?: InputMaybe<UserWhereInput>;
};

export type UserMaxAggregate = {
  __typename?: 'UserMaxAggregate';
  displayName?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  image?: Maybe<Scalars['String']>;
  phoneNumber?: Maybe<Scalars['String']>;
  uid?: Maybe<Scalars['String']>;
};

export type UserMaxOrderByAggregateInput = {
  displayName?: InputMaybe<SortOrder>;
  email?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  image?: InputMaybe<SortOrder>;
  phoneNumber?: InputMaybe<SortOrder>;
  uid?: InputMaybe<SortOrder>;
};

export type UserMinAggregate = {
  __typename?: 'UserMinAggregate';
  displayName?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  image?: Maybe<Scalars['String']>;
  phoneNumber?: Maybe<Scalars['String']>;
  uid?: Maybe<Scalars['String']>;
};

export type UserMinOrderByAggregateInput = {
  displayName?: InputMaybe<SortOrder>;
  email?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  image?: InputMaybe<SortOrder>;
  phoneNumber?: InputMaybe<SortOrder>;
  uid?: InputMaybe<SortOrder>;
};

export type UserNullableRelationFilter = {
  is?: InputMaybe<UserWhereInput>;
  isNot?: InputMaybe<UserWhereInput>;
};

export type UserOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type UserOrderByWithAggregationInput = {
  _count?: InputMaybe<UserCountOrderByAggregateInput>;
  _max?: InputMaybe<UserMaxOrderByAggregateInput>;
  _min?: InputMaybe<UserMinOrderByAggregateInput>;
  accessLabelsIDs?: InputMaybe<SortOrder>;
  displayName?: InputMaybe<SortOrder>;
  email?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  image?: InputMaybe<SortOrder>;
  otherDetails?: InputMaybe<SortOrder>;
  permissions?: InputMaybe<SortOrder>;
  phoneNumber?: InputMaybe<SortOrder>;
  roleIDs?: InputMaybe<SortOrder>;
  sharedBookingIds?: InputMaybe<SortOrder>;
  uid?: InputMaybe<SortOrder>;
  workspacesIDs?: InputMaybe<SortOrder>;
};

export type UserOrderByWithRelationInput = {
  accessLabels?: InputMaybe<AccessLabelOrderByRelationAggregateInput>;
  accessLabelsIDs?: InputMaybe<SortOrder>;
  adBoards?: InputMaybe<AdBoardOrderByRelationAggregateInput>;
  adminWorkspaces?: InputMaybe<WorkspaceOrderByRelationAggregateInput>;
  audits?: InputMaybe<AuditOrderByRelationAggregateInput>;
  bookings?: InputMaybe<BookingOrderByRelationAggregateInput>;
  campaigns?: InputMaybe<CampaignOrderByRelationAggregateInput>;
  changelogs?: InputMaybe<ChangelogOrderByRelationAggregateInput>;
  createdFiles?: InputMaybe<FileOrderByRelationAggregateInput>;
  displayName?: InputMaybe<SortOrder>;
  email?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  image?: InputMaybe<SortOrder>;
  memberships?: InputMaybe<MembershipOrderByRelationAggregateInput>;
  orders?: InputMaybe<OrderOrderByRelationAggregateInput>;
  otherDetails?: InputMaybe<SortOrder>;
  permissions?: InputMaybe<SortOrder>;
  phoneNumber?: InputMaybe<SortOrder>;
  refunds?: InputMaybe<BookingRefundOrderByCompositeAggregateInput>;
  roleIDs?: InputMaybe<SortOrder>;
  roles?: InputMaybe<RoleOrderByRelationAggregateInput>;
  sharedBookingIds?: InputMaybe<SortOrder>;
  sharedBookings?: InputMaybe<BookingOrderByRelationAggregateInput>;
  stripe?: InputMaybe<UserStripeOrderByInput>;
  uid?: InputMaybe<SortOrder>;
  updatedFiles?: InputMaybe<FileOrderByRelationAggregateInput>;
  workspaces?: InputMaybe<WorkspaceOrderByRelationAggregateInput>;
  workspacesIDs?: InputMaybe<SortOrder>;
};

export type UserRelationFilter = {
  is?: InputMaybe<UserWhereInput>;
  isNot?: InputMaybe<UserWhereInput>;
};

export enum UserScalarFieldEnum {
  AccessLabelsIDs = 'accessLabelsIDs',
  DisplayName = 'displayName',
  Email = 'email',
  Id = 'id',
  Image = 'image',
  OtherDetails = 'otherDetails',
  Permissions = 'permissions',
  PhoneNumber = 'phoneNumber',
  RoleIDs = 'roleIDs',
  SharedBookingIds = 'sharedBookingIds',
  Uid = 'uid',
  WorkspacesIDs = 'workspacesIDs'
}

export type UserScalarWhereInput = {
  AND?: InputMaybe<Array<UserScalarWhereInput>>;
  NOT?: InputMaybe<Array<UserScalarWhereInput>>;
  OR?: InputMaybe<Array<UserScalarWhereInput>>;
  accessLabelsIDs?: InputMaybe<StringNullableListFilter>;
  displayName?: InputMaybe<StringNullableFilter>;
  email?: InputMaybe<StringFilter>;
  id?: InputMaybe<StringFilter>;
  image?: InputMaybe<StringNullableFilter>;
  otherDetails?: InputMaybe<JsonNullableFilter>;
  permissions?: InputMaybe<EnumPermissionNullableListFilter>;
  phoneNumber?: InputMaybe<StringNullableFilter>;
  roleIDs?: InputMaybe<StringNullableListFilter>;
  sharedBookingIds?: InputMaybe<StringNullableListFilter>;
  uid?: InputMaybe<StringFilter>;
  workspacesIDs?: InputMaybe<StringNullableListFilter>;
};

export type UserScalarWhereWithAggregatesInput = {
  AND?: InputMaybe<Array<UserScalarWhereWithAggregatesInput>>;
  NOT?: InputMaybe<Array<UserScalarWhereWithAggregatesInput>>;
  OR?: InputMaybe<Array<UserScalarWhereWithAggregatesInput>>;
  accessLabelsIDs?: InputMaybe<StringNullableListFilter>;
  displayName?: InputMaybe<StringNullableWithAggregatesFilter>;
  email?: InputMaybe<StringWithAggregatesFilter>;
  id?: InputMaybe<StringWithAggregatesFilter>;
  image?: InputMaybe<StringNullableWithAggregatesFilter>;
  otherDetails?: InputMaybe<JsonNullableWithAggregatesFilter>;
  permissions?: InputMaybe<EnumPermissionNullableListFilter>;
  phoneNumber?: InputMaybe<StringNullableWithAggregatesFilter>;
  roleIDs?: InputMaybe<StringNullableListFilter>;
  sharedBookingIds?: InputMaybe<StringNullableListFilter>;
  uid?: InputMaybe<StringWithAggregatesFilter>;
  workspacesIDs?: InputMaybe<StringNullableListFilter>;
};

export type UserStripe = {
  __typename?: 'UserStripe';
  customerId: Scalars['String'];
};

export type UserStripeCreateInput = {
  customerId: Scalars['String'];
};

export type UserStripeNullableCompositeFilter = {
  equals?: InputMaybe<UserStripeObjectEqualityInput>;
  is?: InputMaybe<UserStripeWhereInput>;
  isNot?: InputMaybe<UserStripeWhereInput>;
  isSet?: InputMaybe<Scalars['Boolean']>;
};

export type UserStripeObjectEqualityInput = {
  customerId: Scalars['String'];
};

export type UserStripeOrderByInput = {
  customerId?: InputMaybe<SortOrder>;
};

export type UserStripeWhereInput = {
  AND?: InputMaybe<Array<UserStripeWhereInput>>;
  NOT?: InputMaybe<Array<UserStripeWhereInput>>;
  OR?: InputMaybe<Array<UserStripeWhereInput>>;
  customerId?: InputMaybe<StringFilter>;
};

export type UserUpdateInput = {
  accessLabels?: InputMaybe<AccessLabelUpdateManyWithoutUserNestedInput>;
  adBoards?: InputMaybe<AdBoardUpdateManyWithoutCreatedByNestedInput>;
  adminWorkspaces?: InputMaybe<WorkspaceUpdateManyWithoutAdminNestedInput>;
  audits?: InputMaybe<AuditUpdateManyWithoutUserNestedInput>;
  bookings?: InputMaybe<BookingUpdateManyWithoutUserNestedInput>;
  campaigns?: InputMaybe<CampaignUpdateManyWithoutUserNestedInput>;
  changelogs?: InputMaybe<ChangelogUpdateManyWithoutUserNestedInput>;
  createdFiles?: InputMaybe<FileUpdateManyWithoutCreatedByNestedInput>;
  displayName?: InputMaybe<Scalars['String']>;
  email?: InputMaybe<Scalars['String']>;
  image?: InputMaybe<Scalars['String']>;
  memberships?: InputMaybe<MembershipUpdateManyWithoutUserNestedInput>;
  orders?: InputMaybe<OrderUpdateManyWithoutCreatedByNestedInput>;
  otherDetails?: InputMaybe<Scalars['JSON']>;
  permissions?: InputMaybe<Array<Permission>>;
  phoneNumber?: InputMaybe<Scalars['String']>;
  refunds?: InputMaybe<Array<BookingRefundCreateInput>>;
  roles?: InputMaybe<RoleUpdateManyWithoutUsersNestedInput>;
  sharedBookings?: InputMaybe<BookingUpdateManyWithoutSharedUsersNestedInput>;
  stripe?: InputMaybe<UserStripeCreateInput>;
  uid?: InputMaybe<Scalars['String']>;
  updatedFiles?: InputMaybe<FileUpdateManyWithoutUpdatedByNestedInput>;
  workspaces?: InputMaybe<WorkspaceUpdateManyWithoutUsersNestedInput>;
};

export type UserUpdateManyMutationInput = {
  displayName?: InputMaybe<Scalars['String']>;
  email?: InputMaybe<Scalars['String']>;
  image?: InputMaybe<Scalars['String']>;
  otherDetails?: InputMaybe<Scalars['JSON']>;
  permissions?: InputMaybe<Array<Permission>>;
  phoneNumber?: InputMaybe<Scalars['String']>;
  refunds?: InputMaybe<Array<BookingRefundCreateInput>>;
  stripe?: InputMaybe<UserStripeCreateInput>;
  uid?: InputMaybe<Scalars['String']>;
};

export type UserUpdateManyWithWhereWithoutAccessLabelsInput = {
  data: UserUpdateManyMutationInput;
  where: UserScalarWhereInput;
};

export type UserUpdateManyWithWhereWithoutRolesInput = {
  data: UserUpdateManyMutationInput;
  where: UserScalarWhereInput;
};

export type UserUpdateManyWithWhereWithoutSharedBookingsInput = {
  data: UserUpdateManyMutationInput;
  where: UserScalarWhereInput;
};

export type UserUpdateManyWithWhereWithoutWorkspacesInput = {
  data: UserUpdateManyMutationInput;
  where: UserScalarWhereInput;
};

export type UserUpdateManyWithoutAccessLabelsNestedInput = {
  connect?: InputMaybe<Array<UserWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<UserCreateOrConnectWithoutAccessLabelsInput>>;
  create?: InputMaybe<Array<UserCreateWithoutAccessLabelsInput>>;
  delete?: InputMaybe<Array<UserWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<UserScalarWhereInput>>;
  disconnect?: InputMaybe<Array<UserWhereUniqueInput>>;
  set?: InputMaybe<Array<UserWhereUniqueInput>>;
  update?: InputMaybe<Array<UserUpdateWithWhereUniqueWithoutAccessLabelsInput>>;
  updateMany?: InputMaybe<Array<UserUpdateManyWithWhereWithoutAccessLabelsInput>>;
  upsert?: InputMaybe<Array<UserUpsertWithWhereUniqueWithoutAccessLabelsInput>>;
};

export type UserUpdateManyWithoutRolesNestedInput = {
  connect?: InputMaybe<Array<UserWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<UserCreateOrConnectWithoutRolesInput>>;
  create?: InputMaybe<Array<UserCreateWithoutRolesInput>>;
  delete?: InputMaybe<Array<UserWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<UserScalarWhereInput>>;
  disconnect?: InputMaybe<Array<UserWhereUniqueInput>>;
  set?: InputMaybe<Array<UserWhereUniqueInput>>;
  update?: InputMaybe<Array<UserUpdateWithWhereUniqueWithoutRolesInput>>;
  updateMany?: InputMaybe<Array<UserUpdateManyWithWhereWithoutRolesInput>>;
  upsert?: InputMaybe<Array<UserUpsertWithWhereUniqueWithoutRolesInput>>;
};

export type UserUpdateManyWithoutSharedBookingsNestedInput = {
  connect?: InputMaybe<Array<UserWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<UserCreateOrConnectWithoutSharedBookingsInput>>;
  create?: InputMaybe<Array<UserCreateWithoutSharedBookingsInput>>;
  delete?: InputMaybe<Array<UserWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<UserScalarWhereInput>>;
  disconnect?: InputMaybe<Array<UserWhereUniqueInput>>;
  set?: InputMaybe<Array<UserWhereUniqueInput>>;
  update?: InputMaybe<Array<UserUpdateWithWhereUniqueWithoutSharedBookingsInput>>;
  updateMany?: InputMaybe<Array<UserUpdateManyWithWhereWithoutSharedBookingsInput>>;
  upsert?: InputMaybe<Array<UserUpsertWithWhereUniqueWithoutSharedBookingsInput>>;
};

export type UserUpdateManyWithoutWorkspacesNestedInput = {
  connect?: InputMaybe<Array<UserWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<UserCreateOrConnectWithoutWorkspacesInput>>;
  create?: InputMaybe<Array<UserCreateWithoutWorkspacesInput>>;
  delete?: InputMaybe<Array<UserWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<UserScalarWhereInput>>;
  disconnect?: InputMaybe<Array<UserWhereUniqueInput>>;
  set?: InputMaybe<Array<UserWhereUniqueInput>>;
  update?: InputMaybe<Array<UserUpdateWithWhereUniqueWithoutWorkspacesInput>>;
  updateMany?: InputMaybe<Array<UserUpdateManyWithWhereWithoutWorkspacesInput>>;
  upsert?: InputMaybe<Array<UserUpsertWithWhereUniqueWithoutWorkspacesInput>>;
};

export type UserUpdateOneRequiredWithoutAdminWorkspacesNestedInput = {
  connect?: InputMaybe<UserWhereUniqueInput>;
  connectOrCreate?: InputMaybe<UserCreateOrConnectWithoutAdminWorkspacesInput>;
  create?: InputMaybe<UserCreateWithoutAdminWorkspacesInput>;
  update?: InputMaybe<UserUpdateToOneWithWhereWithoutAdminWorkspacesInput>;
  upsert?: InputMaybe<UserUpsertWithoutAdminWorkspacesInput>;
};

export type UserUpdateOneRequiredWithoutAuditsNestedInput = {
  connect?: InputMaybe<UserWhereUniqueInput>;
  connectOrCreate?: InputMaybe<UserCreateOrConnectWithoutAuditsInput>;
  create?: InputMaybe<UserCreateWithoutAuditsInput>;
  update?: InputMaybe<UserUpdateToOneWithWhereWithoutAuditsInput>;
  upsert?: InputMaybe<UserUpsertWithoutAuditsInput>;
};

export type UserUpdateOneRequiredWithoutBookingsNestedInput = {
  connect?: InputMaybe<UserWhereUniqueInput>;
  connectOrCreate?: InputMaybe<UserCreateOrConnectWithoutBookingsInput>;
  create?: InputMaybe<UserCreateWithoutBookingsInput>;
  update?: InputMaybe<UserUpdateToOneWithWhereWithoutBookingsInput>;
  upsert?: InputMaybe<UserUpsertWithoutBookingsInput>;
};

export type UserUpdateOneRequiredWithoutCampaignsNestedInput = {
  connect?: InputMaybe<UserWhereUniqueInput>;
  connectOrCreate?: InputMaybe<UserCreateOrConnectWithoutCampaignsInput>;
  create?: InputMaybe<UserCreateWithoutCampaignsInput>;
  update?: InputMaybe<UserUpdateToOneWithWhereWithoutCampaignsInput>;
  upsert?: InputMaybe<UserUpsertWithoutCampaignsInput>;
};

export type UserUpdateOneRequiredWithoutChangelogsNestedInput = {
  connect?: InputMaybe<UserWhereUniqueInput>;
  connectOrCreate?: InputMaybe<UserCreateOrConnectWithoutChangelogsInput>;
  create?: InputMaybe<UserCreateWithoutChangelogsInput>;
  update?: InputMaybe<UserUpdateToOneWithWhereWithoutChangelogsInput>;
  upsert?: InputMaybe<UserUpsertWithoutChangelogsInput>;
};

export type UserUpdateOneRequiredWithoutCreatedFilesNestedInput = {
  connect?: InputMaybe<UserWhereUniqueInput>;
  connectOrCreate?: InputMaybe<UserCreateOrConnectWithoutCreatedFilesInput>;
  create?: InputMaybe<UserCreateWithoutCreatedFilesInput>;
  update?: InputMaybe<UserUpdateToOneWithWhereWithoutCreatedFilesInput>;
  upsert?: InputMaybe<UserUpsertWithoutCreatedFilesInput>;
};

export type UserUpdateOneRequiredWithoutMembershipsNestedInput = {
  connect?: InputMaybe<UserWhereUniqueInput>;
  connectOrCreate?: InputMaybe<UserCreateOrConnectWithoutMembershipsInput>;
  create?: InputMaybe<UserCreateWithoutMembershipsInput>;
  update?: InputMaybe<UserUpdateToOneWithWhereWithoutMembershipsInput>;
  upsert?: InputMaybe<UserUpsertWithoutMembershipsInput>;
};

export type UserUpdateOneWithoutAdBoardsNestedInput = {
  connect?: InputMaybe<UserWhereUniqueInput>;
  connectOrCreate?: InputMaybe<UserCreateOrConnectWithoutAdBoardsInput>;
  create?: InputMaybe<UserCreateWithoutAdBoardsInput>;
  delete?: InputMaybe<UserWhereInput>;
  disconnect?: InputMaybe<Scalars['Boolean']>;
  update?: InputMaybe<UserUpdateToOneWithWhereWithoutAdBoardsInput>;
  upsert?: InputMaybe<UserUpsertWithoutAdBoardsInput>;
};

export type UserUpdateOneWithoutOrdersNestedInput = {
  connect?: InputMaybe<UserWhereUniqueInput>;
  connectOrCreate?: InputMaybe<UserCreateOrConnectWithoutOrdersInput>;
  create?: InputMaybe<UserCreateWithoutOrdersInput>;
  delete?: InputMaybe<UserWhereInput>;
  disconnect?: InputMaybe<Scalars['Boolean']>;
  update?: InputMaybe<UserUpdateToOneWithWhereWithoutOrdersInput>;
  upsert?: InputMaybe<UserUpsertWithoutOrdersInput>;
};

export type UserUpdateOneWithoutUpdatedFilesNestedInput = {
  connect?: InputMaybe<UserWhereUniqueInput>;
  connectOrCreate?: InputMaybe<UserCreateOrConnectWithoutUpdatedFilesInput>;
  create?: InputMaybe<UserCreateWithoutUpdatedFilesInput>;
  delete?: InputMaybe<UserWhereInput>;
  disconnect?: InputMaybe<Scalars['Boolean']>;
  update?: InputMaybe<UserUpdateToOneWithWhereWithoutUpdatedFilesInput>;
  upsert?: InputMaybe<UserUpsertWithoutUpdatedFilesInput>;
};

export type UserUpdateToOneWithWhereWithoutAdBoardsInput = {
  data: UserUpdateWithoutAdBoardsInput;
  where?: InputMaybe<UserWhereInput>;
};

export type UserUpdateToOneWithWhereWithoutAdminWorkspacesInput = {
  data: UserUpdateWithoutAdminWorkspacesInput;
  where?: InputMaybe<UserWhereInput>;
};

export type UserUpdateToOneWithWhereWithoutAuditsInput = {
  data: UserUpdateWithoutAuditsInput;
  where?: InputMaybe<UserWhereInput>;
};

export type UserUpdateToOneWithWhereWithoutBookingsInput = {
  data: UserUpdateWithoutBookingsInput;
  where?: InputMaybe<UserWhereInput>;
};

export type UserUpdateToOneWithWhereWithoutCampaignsInput = {
  data: UserUpdateWithoutCampaignsInput;
  where?: InputMaybe<UserWhereInput>;
};

export type UserUpdateToOneWithWhereWithoutChangelogsInput = {
  data: UserUpdateWithoutChangelogsInput;
  where?: InputMaybe<UserWhereInput>;
};

export type UserUpdateToOneWithWhereWithoutCreatedFilesInput = {
  data: UserUpdateWithoutCreatedFilesInput;
  where?: InputMaybe<UserWhereInput>;
};

export type UserUpdateToOneWithWhereWithoutMembershipsInput = {
  data: UserUpdateWithoutMembershipsInput;
  where?: InputMaybe<UserWhereInput>;
};

export type UserUpdateToOneWithWhereWithoutOrdersInput = {
  data: UserUpdateWithoutOrdersInput;
  where?: InputMaybe<UserWhereInput>;
};

export type UserUpdateToOneWithWhereWithoutUpdatedFilesInput = {
  data: UserUpdateWithoutUpdatedFilesInput;
  where?: InputMaybe<UserWhereInput>;
};

export type UserUpdateWithWhereUniqueWithoutAccessLabelsInput = {
  data: UserUpdateWithoutAccessLabelsInput;
  where: UserWhereUniqueInput;
};

export type UserUpdateWithWhereUniqueWithoutRolesInput = {
  data: UserUpdateWithoutRolesInput;
  where: UserWhereUniqueInput;
};

export type UserUpdateWithWhereUniqueWithoutSharedBookingsInput = {
  data: UserUpdateWithoutSharedBookingsInput;
  where: UserWhereUniqueInput;
};

export type UserUpdateWithWhereUniqueWithoutWorkspacesInput = {
  data: UserUpdateWithoutWorkspacesInput;
  where: UserWhereUniqueInput;
};

export type UserUpdateWithoutAccessLabelsInput = {
  adBoards?: InputMaybe<AdBoardUpdateManyWithoutCreatedByNestedInput>;
  adminWorkspaces?: InputMaybe<WorkspaceUpdateManyWithoutAdminNestedInput>;
  audits?: InputMaybe<AuditUpdateManyWithoutUserNestedInput>;
  bookings?: InputMaybe<BookingUpdateManyWithoutUserNestedInput>;
  campaigns?: InputMaybe<CampaignUpdateManyWithoutUserNestedInput>;
  changelogs?: InputMaybe<ChangelogUpdateManyWithoutUserNestedInput>;
  createdFiles?: InputMaybe<FileUpdateManyWithoutCreatedByNestedInput>;
  displayName?: InputMaybe<Scalars['String']>;
  email?: InputMaybe<Scalars['String']>;
  image?: InputMaybe<Scalars['String']>;
  memberships?: InputMaybe<MembershipUpdateManyWithoutUserNestedInput>;
  orders?: InputMaybe<OrderUpdateManyWithoutCreatedByNestedInput>;
  otherDetails?: InputMaybe<Scalars['JSON']>;
  permissions?: InputMaybe<Array<Permission>>;
  phoneNumber?: InputMaybe<Scalars['String']>;
  refunds?: InputMaybe<Array<BookingRefundCreateInput>>;
  roles?: InputMaybe<RoleUpdateManyWithoutUsersNestedInput>;
  sharedBookings?: InputMaybe<BookingUpdateManyWithoutSharedUsersNestedInput>;
  stripe?: InputMaybe<UserStripeCreateInput>;
  uid?: InputMaybe<Scalars['String']>;
  updatedFiles?: InputMaybe<FileUpdateManyWithoutUpdatedByNestedInput>;
  workspaces?: InputMaybe<WorkspaceUpdateManyWithoutUsersNestedInput>;
};

export type UserUpdateWithoutAdBoardsInput = {
  accessLabels?: InputMaybe<AccessLabelUpdateManyWithoutUserNestedInput>;
  adminWorkspaces?: InputMaybe<WorkspaceUpdateManyWithoutAdminNestedInput>;
  audits?: InputMaybe<AuditUpdateManyWithoutUserNestedInput>;
  bookings?: InputMaybe<BookingUpdateManyWithoutUserNestedInput>;
  campaigns?: InputMaybe<CampaignUpdateManyWithoutUserNestedInput>;
  changelogs?: InputMaybe<ChangelogUpdateManyWithoutUserNestedInput>;
  createdFiles?: InputMaybe<FileUpdateManyWithoutCreatedByNestedInput>;
  displayName?: InputMaybe<Scalars['String']>;
  email?: InputMaybe<Scalars['String']>;
  image?: InputMaybe<Scalars['String']>;
  memberships?: InputMaybe<MembershipUpdateManyWithoutUserNestedInput>;
  orders?: InputMaybe<OrderUpdateManyWithoutCreatedByNestedInput>;
  otherDetails?: InputMaybe<Scalars['JSON']>;
  permissions?: InputMaybe<Array<Permission>>;
  phoneNumber?: InputMaybe<Scalars['String']>;
  refunds?: InputMaybe<Array<BookingRefundCreateInput>>;
  roles?: InputMaybe<RoleUpdateManyWithoutUsersNestedInput>;
  sharedBookings?: InputMaybe<BookingUpdateManyWithoutSharedUsersNestedInput>;
  stripe?: InputMaybe<UserStripeCreateInput>;
  uid?: InputMaybe<Scalars['String']>;
  updatedFiles?: InputMaybe<FileUpdateManyWithoutUpdatedByNestedInput>;
  workspaces?: InputMaybe<WorkspaceUpdateManyWithoutUsersNestedInput>;
};

export type UserUpdateWithoutAdminWorkspacesInput = {
  accessLabels?: InputMaybe<AccessLabelUpdateManyWithoutUserNestedInput>;
  adBoards?: InputMaybe<AdBoardUpdateManyWithoutCreatedByNestedInput>;
  audits?: InputMaybe<AuditUpdateManyWithoutUserNestedInput>;
  bookings?: InputMaybe<BookingUpdateManyWithoutUserNestedInput>;
  campaigns?: InputMaybe<CampaignUpdateManyWithoutUserNestedInput>;
  changelogs?: InputMaybe<ChangelogUpdateManyWithoutUserNestedInput>;
  createdFiles?: InputMaybe<FileUpdateManyWithoutCreatedByNestedInput>;
  displayName?: InputMaybe<Scalars['String']>;
  email?: InputMaybe<Scalars['String']>;
  image?: InputMaybe<Scalars['String']>;
  memberships?: InputMaybe<MembershipUpdateManyWithoutUserNestedInput>;
  orders?: InputMaybe<OrderUpdateManyWithoutCreatedByNestedInput>;
  otherDetails?: InputMaybe<Scalars['JSON']>;
  permissions?: InputMaybe<Array<Permission>>;
  phoneNumber?: InputMaybe<Scalars['String']>;
  refunds?: InputMaybe<Array<BookingRefundCreateInput>>;
  roles?: InputMaybe<RoleUpdateManyWithoutUsersNestedInput>;
  sharedBookings?: InputMaybe<BookingUpdateManyWithoutSharedUsersNestedInput>;
  stripe?: InputMaybe<UserStripeCreateInput>;
  uid?: InputMaybe<Scalars['String']>;
  updatedFiles?: InputMaybe<FileUpdateManyWithoutUpdatedByNestedInput>;
  workspaces?: InputMaybe<WorkspaceUpdateManyWithoutUsersNestedInput>;
};

export type UserUpdateWithoutAuditsInput = {
  accessLabels?: InputMaybe<AccessLabelUpdateManyWithoutUserNestedInput>;
  adBoards?: InputMaybe<AdBoardUpdateManyWithoutCreatedByNestedInput>;
  adminWorkspaces?: InputMaybe<WorkspaceUpdateManyWithoutAdminNestedInput>;
  bookings?: InputMaybe<BookingUpdateManyWithoutUserNestedInput>;
  campaigns?: InputMaybe<CampaignUpdateManyWithoutUserNestedInput>;
  changelogs?: InputMaybe<ChangelogUpdateManyWithoutUserNestedInput>;
  createdFiles?: InputMaybe<FileUpdateManyWithoutCreatedByNestedInput>;
  displayName?: InputMaybe<Scalars['String']>;
  email?: InputMaybe<Scalars['String']>;
  image?: InputMaybe<Scalars['String']>;
  memberships?: InputMaybe<MembershipUpdateManyWithoutUserNestedInput>;
  orders?: InputMaybe<OrderUpdateManyWithoutCreatedByNestedInput>;
  otherDetails?: InputMaybe<Scalars['JSON']>;
  permissions?: InputMaybe<Array<Permission>>;
  phoneNumber?: InputMaybe<Scalars['String']>;
  refunds?: InputMaybe<Array<BookingRefundCreateInput>>;
  roles?: InputMaybe<RoleUpdateManyWithoutUsersNestedInput>;
  sharedBookings?: InputMaybe<BookingUpdateManyWithoutSharedUsersNestedInput>;
  stripe?: InputMaybe<UserStripeCreateInput>;
  uid?: InputMaybe<Scalars['String']>;
  updatedFiles?: InputMaybe<FileUpdateManyWithoutUpdatedByNestedInput>;
  workspaces?: InputMaybe<WorkspaceUpdateManyWithoutUsersNestedInput>;
};

export type UserUpdateWithoutBookingsInput = {
  accessLabels?: InputMaybe<AccessLabelUpdateManyWithoutUserNestedInput>;
  adBoards?: InputMaybe<AdBoardUpdateManyWithoutCreatedByNestedInput>;
  adminWorkspaces?: InputMaybe<WorkspaceUpdateManyWithoutAdminNestedInput>;
  audits?: InputMaybe<AuditUpdateManyWithoutUserNestedInput>;
  campaigns?: InputMaybe<CampaignUpdateManyWithoutUserNestedInput>;
  changelogs?: InputMaybe<ChangelogUpdateManyWithoutUserNestedInput>;
  createdFiles?: InputMaybe<FileUpdateManyWithoutCreatedByNestedInput>;
  displayName?: InputMaybe<Scalars['String']>;
  email?: InputMaybe<Scalars['String']>;
  image?: InputMaybe<Scalars['String']>;
  memberships?: InputMaybe<MembershipUpdateManyWithoutUserNestedInput>;
  orders?: InputMaybe<OrderUpdateManyWithoutCreatedByNestedInput>;
  otherDetails?: InputMaybe<Scalars['JSON']>;
  permissions?: InputMaybe<Array<Permission>>;
  phoneNumber?: InputMaybe<Scalars['String']>;
  refunds?: InputMaybe<Array<BookingRefundCreateInput>>;
  roles?: InputMaybe<RoleUpdateManyWithoutUsersNestedInput>;
  sharedBookings?: InputMaybe<BookingUpdateManyWithoutSharedUsersNestedInput>;
  stripe?: InputMaybe<UserStripeCreateInput>;
  uid?: InputMaybe<Scalars['String']>;
  updatedFiles?: InputMaybe<FileUpdateManyWithoutUpdatedByNestedInput>;
  workspaces?: InputMaybe<WorkspaceUpdateManyWithoutUsersNestedInput>;
};

export type UserUpdateWithoutCampaignsInput = {
  accessLabels?: InputMaybe<AccessLabelUpdateManyWithoutUserNestedInput>;
  adBoards?: InputMaybe<AdBoardUpdateManyWithoutCreatedByNestedInput>;
  adminWorkspaces?: InputMaybe<WorkspaceUpdateManyWithoutAdminNestedInput>;
  audits?: InputMaybe<AuditUpdateManyWithoutUserNestedInput>;
  bookings?: InputMaybe<BookingUpdateManyWithoutUserNestedInput>;
  changelogs?: InputMaybe<ChangelogUpdateManyWithoutUserNestedInput>;
  createdFiles?: InputMaybe<FileUpdateManyWithoutCreatedByNestedInput>;
  displayName?: InputMaybe<Scalars['String']>;
  email?: InputMaybe<Scalars['String']>;
  image?: InputMaybe<Scalars['String']>;
  memberships?: InputMaybe<MembershipUpdateManyWithoutUserNestedInput>;
  orders?: InputMaybe<OrderUpdateManyWithoutCreatedByNestedInput>;
  otherDetails?: InputMaybe<Scalars['JSON']>;
  permissions?: InputMaybe<Array<Permission>>;
  phoneNumber?: InputMaybe<Scalars['String']>;
  refunds?: InputMaybe<Array<BookingRefundCreateInput>>;
  roles?: InputMaybe<RoleUpdateManyWithoutUsersNestedInput>;
  sharedBookings?: InputMaybe<BookingUpdateManyWithoutSharedUsersNestedInput>;
  stripe?: InputMaybe<UserStripeCreateInput>;
  uid?: InputMaybe<Scalars['String']>;
  updatedFiles?: InputMaybe<FileUpdateManyWithoutUpdatedByNestedInput>;
  workspaces?: InputMaybe<WorkspaceUpdateManyWithoutUsersNestedInput>;
};

export type UserUpdateWithoutChangelogsInput = {
  accessLabels?: InputMaybe<AccessLabelUpdateManyWithoutUserNestedInput>;
  adBoards?: InputMaybe<AdBoardUpdateManyWithoutCreatedByNestedInput>;
  adminWorkspaces?: InputMaybe<WorkspaceUpdateManyWithoutAdminNestedInput>;
  audits?: InputMaybe<AuditUpdateManyWithoutUserNestedInput>;
  bookings?: InputMaybe<BookingUpdateManyWithoutUserNestedInput>;
  campaigns?: InputMaybe<CampaignUpdateManyWithoutUserNestedInput>;
  createdFiles?: InputMaybe<FileUpdateManyWithoutCreatedByNestedInput>;
  displayName?: InputMaybe<Scalars['String']>;
  email?: InputMaybe<Scalars['String']>;
  image?: InputMaybe<Scalars['String']>;
  memberships?: InputMaybe<MembershipUpdateManyWithoutUserNestedInput>;
  orders?: InputMaybe<OrderUpdateManyWithoutCreatedByNestedInput>;
  otherDetails?: InputMaybe<Scalars['JSON']>;
  permissions?: InputMaybe<Array<Permission>>;
  phoneNumber?: InputMaybe<Scalars['String']>;
  refunds?: InputMaybe<Array<BookingRefundCreateInput>>;
  roles?: InputMaybe<RoleUpdateManyWithoutUsersNestedInput>;
  sharedBookings?: InputMaybe<BookingUpdateManyWithoutSharedUsersNestedInput>;
  stripe?: InputMaybe<UserStripeCreateInput>;
  uid?: InputMaybe<Scalars['String']>;
  updatedFiles?: InputMaybe<FileUpdateManyWithoutUpdatedByNestedInput>;
  workspaces?: InputMaybe<WorkspaceUpdateManyWithoutUsersNestedInput>;
};

export type UserUpdateWithoutCreatedFilesInput = {
  accessLabels?: InputMaybe<AccessLabelUpdateManyWithoutUserNestedInput>;
  adBoards?: InputMaybe<AdBoardUpdateManyWithoutCreatedByNestedInput>;
  adminWorkspaces?: InputMaybe<WorkspaceUpdateManyWithoutAdminNestedInput>;
  audits?: InputMaybe<AuditUpdateManyWithoutUserNestedInput>;
  bookings?: InputMaybe<BookingUpdateManyWithoutUserNestedInput>;
  campaigns?: InputMaybe<CampaignUpdateManyWithoutUserNestedInput>;
  changelogs?: InputMaybe<ChangelogUpdateManyWithoutUserNestedInput>;
  displayName?: InputMaybe<Scalars['String']>;
  email?: InputMaybe<Scalars['String']>;
  image?: InputMaybe<Scalars['String']>;
  memberships?: InputMaybe<MembershipUpdateManyWithoutUserNestedInput>;
  orders?: InputMaybe<OrderUpdateManyWithoutCreatedByNestedInput>;
  otherDetails?: InputMaybe<Scalars['JSON']>;
  permissions?: InputMaybe<Array<Permission>>;
  phoneNumber?: InputMaybe<Scalars['String']>;
  refunds?: InputMaybe<Array<BookingRefundCreateInput>>;
  roles?: InputMaybe<RoleUpdateManyWithoutUsersNestedInput>;
  sharedBookings?: InputMaybe<BookingUpdateManyWithoutSharedUsersNestedInput>;
  stripe?: InputMaybe<UserStripeCreateInput>;
  uid?: InputMaybe<Scalars['String']>;
  updatedFiles?: InputMaybe<FileUpdateManyWithoutUpdatedByNestedInput>;
  workspaces?: InputMaybe<WorkspaceUpdateManyWithoutUsersNestedInput>;
};

export type UserUpdateWithoutMembershipsInput = {
  accessLabels?: InputMaybe<AccessLabelUpdateManyWithoutUserNestedInput>;
  adBoards?: InputMaybe<AdBoardUpdateManyWithoutCreatedByNestedInput>;
  adminWorkspaces?: InputMaybe<WorkspaceUpdateManyWithoutAdminNestedInput>;
  audits?: InputMaybe<AuditUpdateManyWithoutUserNestedInput>;
  bookings?: InputMaybe<BookingUpdateManyWithoutUserNestedInput>;
  campaigns?: InputMaybe<CampaignUpdateManyWithoutUserNestedInput>;
  changelogs?: InputMaybe<ChangelogUpdateManyWithoutUserNestedInput>;
  createdFiles?: InputMaybe<FileUpdateManyWithoutCreatedByNestedInput>;
  displayName?: InputMaybe<Scalars['String']>;
  email?: InputMaybe<Scalars['String']>;
  image?: InputMaybe<Scalars['String']>;
  orders?: InputMaybe<OrderUpdateManyWithoutCreatedByNestedInput>;
  otherDetails?: InputMaybe<Scalars['JSON']>;
  permissions?: InputMaybe<Array<Permission>>;
  phoneNumber?: InputMaybe<Scalars['String']>;
  refunds?: InputMaybe<Array<BookingRefundCreateInput>>;
  roles?: InputMaybe<RoleUpdateManyWithoutUsersNestedInput>;
  sharedBookings?: InputMaybe<BookingUpdateManyWithoutSharedUsersNestedInput>;
  stripe?: InputMaybe<UserStripeCreateInput>;
  uid?: InputMaybe<Scalars['String']>;
  updatedFiles?: InputMaybe<FileUpdateManyWithoutUpdatedByNestedInput>;
  workspaces?: InputMaybe<WorkspaceUpdateManyWithoutUsersNestedInput>;
};

export type UserUpdateWithoutOrdersInput = {
  accessLabels?: InputMaybe<AccessLabelUpdateManyWithoutUserNestedInput>;
  adBoards?: InputMaybe<AdBoardUpdateManyWithoutCreatedByNestedInput>;
  adminWorkspaces?: InputMaybe<WorkspaceUpdateManyWithoutAdminNestedInput>;
  audits?: InputMaybe<AuditUpdateManyWithoutUserNestedInput>;
  bookings?: InputMaybe<BookingUpdateManyWithoutUserNestedInput>;
  campaigns?: InputMaybe<CampaignUpdateManyWithoutUserNestedInput>;
  changelogs?: InputMaybe<ChangelogUpdateManyWithoutUserNestedInput>;
  createdFiles?: InputMaybe<FileUpdateManyWithoutCreatedByNestedInput>;
  displayName?: InputMaybe<Scalars['String']>;
  email?: InputMaybe<Scalars['String']>;
  image?: InputMaybe<Scalars['String']>;
  memberships?: InputMaybe<MembershipUpdateManyWithoutUserNestedInput>;
  otherDetails?: InputMaybe<Scalars['JSON']>;
  permissions?: InputMaybe<Array<Permission>>;
  phoneNumber?: InputMaybe<Scalars['String']>;
  refunds?: InputMaybe<Array<BookingRefundCreateInput>>;
  roles?: InputMaybe<RoleUpdateManyWithoutUsersNestedInput>;
  sharedBookings?: InputMaybe<BookingUpdateManyWithoutSharedUsersNestedInput>;
  stripe?: InputMaybe<UserStripeCreateInput>;
  uid?: InputMaybe<Scalars['String']>;
  updatedFiles?: InputMaybe<FileUpdateManyWithoutUpdatedByNestedInput>;
  workspaces?: InputMaybe<WorkspaceUpdateManyWithoutUsersNestedInput>;
};

export type UserUpdateWithoutRolesInput = {
  accessLabels?: InputMaybe<AccessLabelUpdateManyWithoutUserNestedInput>;
  adBoards?: InputMaybe<AdBoardUpdateManyWithoutCreatedByNestedInput>;
  adminWorkspaces?: InputMaybe<WorkspaceUpdateManyWithoutAdminNestedInput>;
  audits?: InputMaybe<AuditUpdateManyWithoutUserNestedInput>;
  bookings?: InputMaybe<BookingUpdateManyWithoutUserNestedInput>;
  campaigns?: InputMaybe<CampaignUpdateManyWithoutUserNestedInput>;
  changelogs?: InputMaybe<ChangelogUpdateManyWithoutUserNestedInput>;
  createdFiles?: InputMaybe<FileUpdateManyWithoutCreatedByNestedInput>;
  displayName?: InputMaybe<Scalars['String']>;
  email?: InputMaybe<Scalars['String']>;
  image?: InputMaybe<Scalars['String']>;
  memberships?: InputMaybe<MembershipUpdateManyWithoutUserNestedInput>;
  orders?: InputMaybe<OrderUpdateManyWithoutCreatedByNestedInput>;
  otherDetails?: InputMaybe<Scalars['JSON']>;
  permissions?: InputMaybe<Array<Permission>>;
  phoneNumber?: InputMaybe<Scalars['String']>;
  refunds?: InputMaybe<Array<BookingRefundCreateInput>>;
  sharedBookings?: InputMaybe<BookingUpdateManyWithoutSharedUsersNestedInput>;
  stripe?: InputMaybe<UserStripeCreateInput>;
  uid?: InputMaybe<Scalars['String']>;
  updatedFiles?: InputMaybe<FileUpdateManyWithoutUpdatedByNestedInput>;
  workspaces?: InputMaybe<WorkspaceUpdateManyWithoutUsersNestedInput>;
};

export type UserUpdateWithoutSharedBookingsInput = {
  accessLabels?: InputMaybe<AccessLabelUpdateManyWithoutUserNestedInput>;
  adBoards?: InputMaybe<AdBoardUpdateManyWithoutCreatedByNestedInput>;
  adminWorkspaces?: InputMaybe<WorkspaceUpdateManyWithoutAdminNestedInput>;
  audits?: InputMaybe<AuditUpdateManyWithoutUserNestedInput>;
  bookings?: InputMaybe<BookingUpdateManyWithoutUserNestedInput>;
  campaigns?: InputMaybe<CampaignUpdateManyWithoutUserNestedInput>;
  changelogs?: InputMaybe<ChangelogUpdateManyWithoutUserNestedInput>;
  createdFiles?: InputMaybe<FileUpdateManyWithoutCreatedByNestedInput>;
  displayName?: InputMaybe<Scalars['String']>;
  email?: InputMaybe<Scalars['String']>;
  image?: InputMaybe<Scalars['String']>;
  memberships?: InputMaybe<MembershipUpdateManyWithoutUserNestedInput>;
  orders?: InputMaybe<OrderUpdateManyWithoutCreatedByNestedInput>;
  otherDetails?: InputMaybe<Scalars['JSON']>;
  permissions?: InputMaybe<Array<Permission>>;
  phoneNumber?: InputMaybe<Scalars['String']>;
  refunds?: InputMaybe<Array<BookingRefundCreateInput>>;
  roles?: InputMaybe<RoleUpdateManyWithoutUsersNestedInput>;
  stripe?: InputMaybe<UserStripeCreateInput>;
  uid?: InputMaybe<Scalars['String']>;
  updatedFiles?: InputMaybe<FileUpdateManyWithoutUpdatedByNestedInput>;
  workspaces?: InputMaybe<WorkspaceUpdateManyWithoutUsersNestedInput>;
};

export type UserUpdateWithoutUpdatedFilesInput = {
  accessLabels?: InputMaybe<AccessLabelUpdateManyWithoutUserNestedInput>;
  adBoards?: InputMaybe<AdBoardUpdateManyWithoutCreatedByNestedInput>;
  adminWorkspaces?: InputMaybe<WorkspaceUpdateManyWithoutAdminNestedInput>;
  audits?: InputMaybe<AuditUpdateManyWithoutUserNestedInput>;
  bookings?: InputMaybe<BookingUpdateManyWithoutUserNestedInput>;
  campaigns?: InputMaybe<CampaignUpdateManyWithoutUserNestedInput>;
  changelogs?: InputMaybe<ChangelogUpdateManyWithoutUserNestedInput>;
  createdFiles?: InputMaybe<FileUpdateManyWithoutCreatedByNestedInput>;
  displayName?: InputMaybe<Scalars['String']>;
  email?: InputMaybe<Scalars['String']>;
  image?: InputMaybe<Scalars['String']>;
  memberships?: InputMaybe<MembershipUpdateManyWithoutUserNestedInput>;
  orders?: InputMaybe<OrderUpdateManyWithoutCreatedByNestedInput>;
  otherDetails?: InputMaybe<Scalars['JSON']>;
  permissions?: InputMaybe<Array<Permission>>;
  phoneNumber?: InputMaybe<Scalars['String']>;
  refunds?: InputMaybe<Array<BookingRefundCreateInput>>;
  roles?: InputMaybe<RoleUpdateManyWithoutUsersNestedInput>;
  sharedBookings?: InputMaybe<BookingUpdateManyWithoutSharedUsersNestedInput>;
  stripe?: InputMaybe<UserStripeCreateInput>;
  uid?: InputMaybe<Scalars['String']>;
  workspaces?: InputMaybe<WorkspaceUpdateManyWithoutUsersNestedInput>;
};

export type UserUpdateWithoutWorkspacesInput = {
  accessLabels?: InputMaybe<AccessLabelUpdateManyWithoutUserNestedInput>;
  adBoards?: InputMaybe<AdBoardUpdateManyWithoutCreatedByNestedInput>;
  adminWorkspaces?: InputMaybe<WorkspaceUpdateManyWithoutAdminNestedInput>;
  audits?: InputMaybe<AuditUpdateManyWithoutUserNestedInput>;
  bookings?: InputMaybe<BookingUpdateManyWithoutUserNestedInput>;
  campaigns?: InputMaybe<CampaignUpdateManyWithoutUserNestedInput>;
  changelogs?: InputMaybe<ChangelogUpdateManyWithoutUserNestedInput>;
  createdFiles?: InputMaybe<FileUpdateManyWithoutCreatedByNestedInput>;
  displayName?: InputMaybe<Scalars['String']>;
  email?: InputMaybe<Scalars['String']>;
  image?: InputMaybe<Scalars['String']>;
  memberships?: InputMaybe<MembershipUpdateManyWithoutUserNestedInput>;
  orders?: InputMaybe<OrderUpdateManyWithoutCreatedByNestedInput>;
  otherDetails?: InputMaybe<Scalars['JSON']>;
  permissions?: InputMaybe<Array<Permission>>;
  phoneNumber?: InputMaybe<Scalars['String']>;
  refunds?: InputMaybe<Array<BookingRefundCreateInput>>;
  roles?: InputMaybe<RoleUpdateManyWithoutUsersNestedInput>;
  sharedBookings?: InputMaybe<BookingUpdateManyWithoutSharedUsersNestedInput>;
  stripe?: InputMaybe<UserStripeCreateInput>;
  uid?: InputMaybe<Scalars['String']>;
  updatedFiles?: InputMaybe<FileUpdateManyWithoutUpdatedByNestedInput>;
};

export type UserUpsertWithWhereUniqueWithoutAccessLabelsInput = {
  create: UserCreateWithoutAccessLabelsInput;
  update: UserUpdateWithoutAccessLabelsInput;
  where: UserWhereUniqueInput;
};

export type UserUpsertWithWhereUniqueWithoutRolesInput = {
  create: UserCreateWithoutRolesInput;
  update: UserUpdateWithoutRolesInput;
  where: UserWhereUniqueInput;
};

export type UserUpsertWithWhereUniqueWithoutSharedBookingsInput = {
  create: UserCreateWithoutSharedBookingsInput;
  update: UserUpdateWithoutSharedBookingsInput;
  where: UserWhereUniqueInput;
};

export type UserUpsertWithWhereUniqueWithoutWorkspacesInput = {
  create: UserCreateWithoutWorkspacesInput;
  update: UserUpdateWithoutWorkspacesInput;
  where: UserWhereUniqueInput;
};

export type UserUpsertWithoutAdBoardsInput = {
  create: UserCreateWithoutAdBoardsInput;
  update: UserUpdateWithoutAdBoardsInput;
  where?: InputMaybe<UserWhereInput>;
};

export type UserUpsertWithoutAdminWorkspacesInput = {
  create: UserCreateWithoutAdminWorkspacesInput;
  update: UserUpdateWithoutAdminWorkspacesInput;
  where?: InputMaybe<UserWhereInput>;
};

export type UserUpsertWithoutAuditsInput = {
  create: UserCreateWithoutAuditsInput;
  update: UserUpdateWithoutAuditsInput;
  where?: InputMaybe<UserWhereInput>;
};

export type UserUpsertWithoutBookingsInput = {
  create: UserCreateWithoutBookingsInput;
  update: UserUpdateWithoutBookingsInput;
  where?: InputMaybe<UserWhereInput>;
};

export type UserUpsertWithoutCampaignsInput = {
  create: UserCreateWithoutCampaignsInput;
  update: UserUpdateWithoutCampaignsInput;
  where?: InputMaybe<UserWhereInput>;
};

export type UserUpsertWithoutChangelogsInput = {
  create: UserCreateWithoutChangelogsInput;
  update: UserUpdateWithoutChangelogsInput;
  where?: InputMaybe<UserWhereInput>;
};

export type UserUpsertWithoutCreatedFilesInput = {
  create: UserCreateWithoutCreatedFilesInput;
  update: UserUpdateWithoutCreatedFilesInput;
  where?: InputMaybe<UserWhereInput>;
};

export type UserUpsertWithoutMembershipsInput = {
  create: UserCreateWithoutMembershipsInput;
  update: UserUpdateWithoutMembershipsInput;
  where?: InputMaybe<UserWhereInput>;
};

export type UserUpsertWithoutOrdersInput = {
  create: UserCreateWithoutOrdersInput;
  update: UserUpdateWithoutOrdersInput;
  where?: InputMaybe<UserWhereInput>;
};

export type UserUpsertWithoutUpdatedFilesInput = {
  create: UserCreateWithoutUpdatedFilesInput;
  update: UserUpdateWithoutUpdatedFilesInput;
  where?: InputMaybe<UserWhereInput>;
};

export type UserWhereInput = {
  AND?: InputMaybe<Array<UserWhereInput>>;
  NOT?: InputMaybe<Array<UserWhereInput>>;
  OR?: InputMaybe<Array<UserWhereInput>>;
  accessLabels?: InputMaybe<AccessLabelListRelationFilter>;
  accessLabelsIDs?: InputMaybe<StringNullableListFilter>;
  adBoards?: InputMaybe<AdBoardListRelationFilter>;
  adminWorkspaces?: InputMaybe<WorkspaceListRelationFilter>;
  audits?: InputMaybe<AuditListRelationFilter>;
  bookings?: InputMaybe<BookingListRelationFilter>;
  campaigns?: InputMaybe<CampaignListRelationFilter>;
  changelogs?: InputMaybe<ChangelogListRelationFilter>;
  createdFiles?: InputMaybe<FileListRelationFilter>;
  displayName?: InputMaybe<StringNullableFilter>;
  email?: InputMaybe<StringFilter>;
  id?: InputMaybe<StringFilter>;
  image?: InputMaybe<StringNullableFilter>;
  memberships?: InputMaybe<MembershipListRelationFilter>;
  orders?: InputMaybe<OrderListRelationFilter>;
  otherDetails?: InputMaybe<JsonNullableFilter>;
  permissions?: InputMaybe<EnumPermissionNullableListFilter>;
  phoneNumber?: InputMaybe<StringNullableFilter>;
  refunds?: InputMaybe<Array<BookingRefundObjectEqualityInput>>;
  roleIDs?: InputMaybe<StringNullableListFilter>;
  roles?: InputMaybe<RoleListRelationFilter>;
  sharedBookingIds?: InputMaybe<StringNullableListFilter>;
  sharedBookings?: InputMaybe<BookingListRelationFilter>;
  stripe?: InputMaybe<UserStripeNullableCompositeFilter>;
  uid?: InputMaybe<StringFilter>;
  updatedFiles?: InputMaybe<FileListRelationFilter>;
  workspaces?: InputMaybe<WorkspaceListRelationFilter>;
  workspacesIDs?: InputMaybe<StringNullableListFilter>;
};

export type UserWhereUniqueInput = {
  AND?: InputMaybe<Array<UserWhereInput>>;
  NOT?: InputMaybe<Array<UserWhereInput>>;
  OR?: InputMaybe<Array<UserWhereInput>>;
  accessLabels?: InputMaybe<AccessLabelListRelationFilter>;
  accessLabelsIDs?: InputMaybe<StringNullableListFilter>;
  adBoards?: InputMaybe<AdBoardListRelationFilter>;
  adminWorkspaces?: InputMaybe<WorkspaceListRelationFilter>;
  audits?: InputMaybe<AuditListRelationFilter>;
  bookings?: InputMaybe<BookingListRelationFilter>;
  campaigns?: InputMaybe<CampaignListRelationFilter>;
  changelogs?: InputMaybe<ChangelogListRelationFilter>;
  createdFiles?: InputMaybe<FileListRelationFilter>;
  displayName?: InputMaybe<StringNullableFilter>;
  email?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  image?: InputMaybe<StringNullableFilter>;
  memberships?: InputMaybe<MembershipListRelationFilter>;
  orders?: InputMaybe<OrderListRelationFilter>;
  otherDetails?: InputMaybe<JsonNullableFilter>;
  permissions?: InputMaybe<EnumPermissionNullableListFilter>;
  phoneNumber?: InputMaybe<StringNullableFilter>;
  refunds?: InputMaybe<Array<BookingRefundObjectEqualityInput>>;
  roleIDs?: InputMaybe<StringNullableListFilter>;
  roles?: InputMaybe<RoleListRelationFilter>;
  sharedBookingIds?: InputMaybe<StringNullableListFilter>;
  sharedBookings?: InputMaybe<BookingListRelationFilter>;
  stripe?: InputMaybe<UserStripeNullableCompositeFilter>;
  uid?: InputMaybe<Scalars['String']>;
  updatedFiles?: InputMaybe<FileListRelationFilter>;
  workspaces?: InputMaybe<WorkspaceListRelationFilter>;
  workspacesIDs?: InputMaybe<StringNullableListFilter>;
};

export type Workspace = {
  __typename?: 'Workspace';
  PiSignagePlayers: Array<PiSignagePlayer>;
  _count?: Maybe<WorkspaceCount>;
  accessLabels: Array<AccessLabel>;
  adBoardGroups: Array<AdBoardGroup>;
  adBoards: Array<AdBoard>;
  admin: User;
  adminUserId: Scalars['String'];
  audits: Array<Audit>;
  bookings: Array<Booking>;
  createdAt: Scalars['DateTime'];
  files: Array<File>;
  id: Scalars['String'];
  memberships: Array<Membership>;
  name: Scalars['String'];
  playlists: Array<Playlist>;
  transactions: Array<Transaction>;
  updatedAt: Scalars['DateTime'];
  userIds: Array<Scalars['String']>;
  users: Array<User>;
};


export type WorkspacePiSignagePlayersArgs = {
  cursor?: InputMaybe<PiSignagePlayerWhereUniqueInput>;
  distinct?: InputMaybe<Array<PiSignagePlayerScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<PiSignagePlayerOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<PiSignagePlayerWhereInput>;
};


export type WorkspaceAccessLabelsArgs = {
  cursor?: InputMaybe<AccessLabelWhereUniqueInput>;
  distinct?: InputMaybe<Array<AccessLabelScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<AccessLabelOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<AccessLabelWhereInput>;
};


export type WorkspaceAdBoardGroupsArgs = {
  cursor?: InputMaybe<AdBoardGroupWhereUniqueInput>;
  distinct?: InputMaybe<Array<AdBoardGroupScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<AdBoardGroupOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<AdBoardGroupWhereInput>;
};


export type WorkspaceAdBoardsArgs = {
  cursor?: InputMaybe<AdBoardWhereUniqueInput>;
  distinct?: InputMaybe<Array<AdBoardScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<AdBoardOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<AdBoardWhereInput>;
};


export type WorkspaceAuditsArgs = {
  cursor?: InputMaybe<AuditWhereUniqueInput>;
  distinct?: InputMaybe<Array<AuditScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<AuditOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<AuditWhereInput>;
};


export type WorkspaceBookingsArgs = {
  cursor?: InputMaybe<BookingWhereUniqueInput>;
  distinct?: InputMaybe<Array<BookingScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<BookingOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<BookingWhereInput>;
};


export type WorkspaceFilesArgs = {
  cursor?: InputMaybe<FileWhereUniqueInput>;
  distinct?: InputMaybe<Array<FileScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<FileOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<FileWhereInput>;
};


export type WorkspaceMembershipsArgs = {
  cursor?: InputMaybe<MembershipWhereUniqueInput>;
  distinct?: InputMaybe<Array<MembershipScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<MembershipOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<MembershipWhereInput>;
};


export type WorkspacePlaylistsArgs = {
  cursor?: InputMaybe<PlaylistWhereUniqueInput>;
  distinct?: InputMaybe<Array<PlaylistScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<PlaylistOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<PlaylistWhereInput>;
};


export type WorkspaceTransactionsArgs = {
  cursor?: InputMaybe<TransactionWhereUniqueInput>;
  distinct?: InputMaybe<Array<TransactionScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<TransactionOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<TransactionWhereInput>;
};


export type WorkspaceUsersArgs = {
  cursor?: InputMaybe<UserWhereUniqueInput>;
  distinct?: InputMaybe<Array<UserScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<UserOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<UserWhereInput>;
};

export type WorkspaceCount = {
  __typename?: 'WorkspaceCount';
  PiSignagePlayers: Scalars['Int'];
  accessLabels: Scalars['Int'];
  adBoardGroups: Scalars['Int'];
  adBoards: Scalars['Int'];
  audits: Scalars['Int'];
  bookings: Scalars['Int'];
  files: Scalars['Int'];
  memberships: Scalars['Int'];
  playlists: Scalars['Int'];
  transactions: Scalars['Int'];
  users: Scalars['Int'];
};


export type WorkspaceCountPiSignagePlayersArgs = {
  where?: InputMaybe<PiSignagePlayerWhereInput>;
};


export type WorkspaceCountAccessLabelsArgs = {
  where?: InputMaybe<AccessLabelWhereInput>;
};


export type WorkspaceCountAdBoardGroupsArgs = {
  where?: InputMaybe<AdBoardGroupWhereInput>;
};


export type WorkspaceCountAdBoardsArgs = {
  where?: InputMaybe<AdBoardWhereInput>;
};


export type WorkspaceCountAuditsArgs = {
  where?: InputMaybe<AuditWhereInput>;
};


export type WorkspaceCountBookingsArgs = {
  where?: InputMaybe<BookingWhereInput>;
};


export type WorkspaceCountFilesArgs = {
  where?: InputMaybe<FileWhereInput>;
};


export type WorkspaceCountMembershipsArgs = {
  where?: InputMaybe<MembershipWhereInput>;
};


export type WorkspaceCountPlaylistsArgs = {
  where?: InputMaybe<PlaylistWhereInput>;
};


export type WorkspaceCountTransactionsArgs = {
  where?: InputMaybe<TransactionWhereInput>;
};


export type WorkspaceCountUsersArgs = {
  where?: InputMaybe<UserWhereInput>;
};

export type WorkspaceCountAggregate = {
  __typename?: 'WorkspaceCountAggregate';
  _all: Scalars['Int'];
  adminUserId: Scalars['Int'];
  createdAt: Scalars['Int'];
  id: Scalars['Int'];
  name: Scalars['Int'];
  updatedAt: Scalars['Int'];
  userIds: Scalars['Int'];
};

export type WorkspaceCountOrderByAggregateInput = {
  adminUserId?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  name?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
  userIds?: InputMaybe<SortOrder>;
};

export type WorkspaceCreateInput = {
  PiSignagePlayers?: InputMaybe<PiSignagePlayerCreateNestedManyWithoutWorkspaceInput>;
  accessLabels?: InputMaybe<AccessLabelCreateNestedManyWithoutWorkspaceInput>;
  adBoardGroups?: InputMaybe<AdBoardGroupCreateNestedManyWithoutWorkspaceInput>;
  adBoards?: InputMaybe<AdBoardCreateNestedManyWithoutWorkspaceInput>;
  admin: UserCreateNestedOneWithoutAdminWorkspacesInput;
  audits?: InputMaybe<AuditCreateNestedManyWithoutWorkspaceInput>;
  bookings?: InputMaybe<BookingCreateNestedManyWithoutWorkspaceInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  files?: InputMaybe<FileCreateNestedManyWithoutWorkspaceInput>;
  id?: InputMaybe<Scalars['String']>;
  memberships?: InputMaybe<MembershipCreateNestedManyWithoutWorkspaceInput>;
  name: Scalars['String'];
  playlists?: InputMaybe<PlaylistCreateNestedManyWithoutWorkspaceInput>;
  transactions?: InputMaybe<TransactionCreateNestedManyWithoutWorkspaceInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  users?: InputMaybe<UserCreateNestedManyWithoutWorkspacesInput>;
};

export type WorkspaceCreateManyAdminInput = {
  createdAt?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  userIds?: InputMaybe<Array<Scalars['String']>>;
};

export type WorkspaceCreateManyAdminInputEnvelope = {
  data: Array<WorkspaceCreateManyAdminInput>;
};

export type WorkspaceCreateManyInput = {
  adminUserId: Scalars['String'];
  createdAt?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  userIds?: InputMaybe<Array<Scalars['String']>>;
};

export type WorkspaceCreateNestedManyWithoutAdminInput = {
  connect?: InputMaybe<Array<WorkspaceWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<WorkspaceCreateOrConnectWithoutAdminInput>>;
  create?: InputMaybe<Array<WorkspaceCreateWithoutAdminInput>>;
  createMany?: InputMaybe<WorkspaceCreateManyAdminInputEnvelope>;
};

export type WorkspaceCreateNestedManyWithoutUsersInput = {
  connect?: InputMaybe<Array<WorkspaceWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<WorkspaceCreateOrConnectWithoutUsersInput>>;
  create?: InputMaybe<Array<WorkspaceCreateWithoutUsersInput>>;
};

export type WorkspaceCreateNestedOneWithoutAccessLabelsInput = {
  connect?: InputMaybe<WorkspaceWhereUniqueInput>;
  connectOrCreate?: InputMaybe<WorkspaceCreateOrConnectWithoutAccessLabelsInput>;
  create?: InputMaybe<WorkspaceCreateWithoutAccessLabelsInput>;
};

export type WorkspaceCreateNestedOneWithoutAdBoardGroupsInput = {
  connect?: InputMaybe<WorkspaceWhereUniqueInput>;
  connectOrCreate?: InputMaybe<WorkspaceCreateOrConnectWithoutAdBoardGroupsInput>;
  create?: InputMaybe<WorkspaceCreateWithoutAdBoardGroupsInput>;
};

export type WorkspaceCreateNestedOneWithoutAdBoardsInput = {
  connect?: InputMaybe<WorkspaceWhereUniqueInput>;
  connectOrCreate?: InputMaybe<WorkspaceCreateOrConnectWithoutAdBoardsInput>;
  create?: InputMaybe<WorkspaceCreateWithoutAdBoardsInput>;
};

export type WorkspaceCreateNestedOneWithoutAuditsInput = {
  connect?: InputMaybe<WorkspaceWhereUniqueInput>;
  connectOrCreate?: InputMaybe<WorkspaceCreateOrConnectWithoutAuditsInput>;
  create?: InputMaybe<WorkspaceCreateWithoutAuditsInput>;
};

export type WorkspaceCreateNestedOneWithoutBookingsInput = {
  connect?: InputMaybe<WorkspaceWhereUniqueInput>;
  connectOrCreate?: InputMaybe<WorkspaceCreateOrConnectWithoutBookingsInput>;
  create?: InputMaybe<WorkspaceCreateWithoutBookingsInput>;
};

export type WorkspaceCreateNestedOneWithoutFilesInput = {
  connect?: InputMaybe<WorkspaceWhereUniqueInput>;
  connectOrCreate?: InputMaybe<WorkspaceCreateOrConnectWithoutFilesInput>;
  create?: InputMaybe<WorkspaceCreateWithoutFilesInput>;
};

export type WorkspaceCreateNestedOneWithoutMembershipsInput = {
  connect?: InputMaybe<WorkspaceWhereUniqueInput>;
  connectOrCreate?: InputMaybe<WorkspaceCreateOrConnectWithoutMembershipsInput>;
  create?: InputMaybe<WorkspaceCreateWithoutMembershipsInput>;
};

export type WorkspaceCreateNestedOneWithoutPiSignagePlayersInput = {
  connect?: InputMaybe<WorkspaceWhereUniqueInput>;
  connectOrCreate?: InputMaybe<WorkspaceCreateOrConnectWithoutPiSignagePlayersInput>;
  create?: InputMaybe<WorkspaceCreateWithoutPiSignagePlayersInput>;
};

export type WorkspaceCreateNestedOneWithoutPlaylistsInput = {
  connect?: InputMaybe<WorkspaceWhereUniqueInput>;
  connectOrCreate?: InputMaybe<WorkspaceCreateOrConnectWithoutPlaylistsInput>;
  create?: InputMaybe<WorkspaceCreateWithoutPlaylistsInput>;
};

export type WorkspaceCreateNestedOneWithoutTransactionsInput = {
  connect?: InputMaybe<WorkspaceWhereUniqueInput>;
  connectOrCreate?: InputMaybe<WorkspaceCreateOrConnectWithoutTransactionsInput>;
  create?: InputMaybe<WorkspaceCreateWithoutTransactionsInput>;
};

export type WorkspaceCreateOrConnectWithoutAccessLabelsInput = {
  create: WorkspaceCreateWithoutAccessLabelsInput;
  where: WorkspaceWhereUniqueInput;
};

export type WorkspaceCreateOrConnectWithoutAdBoardGroupsInput = {
  create: WorkspaceCreateWithoutAdBoardGroupsInput;
  where: WorkspaceWhereUniqueInput;
};

export type WorkspaceCreateOrConnectWithoutAdBoardsInput = {
  create: WorkspaceCreateWithoutAdBoardsInput;
  where: WorkspaceWhereUniqueInput;
};

export type WorkspaceCreateOrConnectWithoutAdminInput = {
  create: WorkspaceCreateWithoutAdminInput;
  where: WorkspaceWhereUniqueInput;
};

export type WorkspaceCreateOrConnectWithoutAuditsInput = {
  create: WorkspaceCreateWithoutAuditsInput;
  where: WorkspaceWhereUniqueInput;
};

export type WorkspaceCreateOrConnectWithoutBookingsInput = {
  create: WorkspaceCreateWithoutBookingsInput;
  where: WorkspaceWhereUniqueInput;
};

export type WorkspaceCreateOrConnectWithoutFilesInput = {
  create: WorkspaceCreateWithoutFilesInput;
  where: WorkspaceWhereUniqueInput;
};

export type WorkspaceCreateOrConnectWithoutMembershipsInput = {
  create: WorkspaceCreateWithoutMembershipsInput;
  where: WorkspaceWhereUniqueInput;
};

export type WorkspaceCreateOrConnectWithoutPiSignagePlayersInput = {
  create: WorkspaceCreateWithoutPiSignagePlayersInput;
  where: WorkspaceWhereUniqueInput;
};

export type WorkspaceCreateOrConnectWithoutPlaylistsInput = {
  create: WorkspaceCreateWithoutPlaylistsInput;
  where: WorkspaceWhereUniqueInput;
};

export type WorkspaceCreateOrConnectWithoutTransactionsInput = {
  create: WorkspaceCreateWithoutTransactionsInput;
  where: WorkspaceWhereUniqueInput;
};

export type WorkspaceCreateOrConnectWithoutUsersInput = {
  create: WorkspaceCreateWithoutUsersInput;
  where: WorkspaceWhereUniqueInput;
};

export type WorkspaceCreateWithoutAccessLabelsInput = {
  PiSignagePlayers?: InputMaybe<PiSignagePlayerCreateNestedManyWithoutWorkspaceInput>;
  adBoardGroups?: InputMaybe<AdBoardGroupCreateNestedManyWithoutWorkspaceInput>;
  adBoards?: InputMaybe<AdBoardCreateNestedManyWithoutWorkspaceInput>;
  admin: UserCreateNestedOneWithoutAdminWorkspacesInput;
  audits?: InputMaybe<AuditCreateNestedManyWithoutWorkspaceInput>;
  bookings?: InputMaybe<BookingCreateNestedManyWithoutWorkspaceInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  files?: InputMaybe<FileCreateNestedManyWithoutWorkspaceInput>;
  id?: InputMaybe<Scalars['String']>;
  memberships?: InputMaybe<MembershipCreateNestedManyWithoutWorkspaceInput>;
  name: Scalars['String'];
  playlists?: InputMaybe<PlaylistCreateNestedManyWithoutWorkspaceInput>;
  transactions?: InputMaybe<TransactionCreateNestedManyWithoutWorkspaceInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  users?: InputMaybe<UserCreateNestedManyWithoutWorkspacesInput>;
};

export type WorkspaceCreateWithoutAdBoardGroupsInput = {
  PiSignagePlayers?: InputMaybe<PiSignagePlayerCreateNestedManyWithoutWorkspaceInput>;
  accessLabels?: InputMaybe<AccessLabelCreateNestedManyWithoutWorkspaceInput>;
  adBoards?: InputMaybe<AdBoardCreateNestedManyWithoutWorkspaceInput>;
  admin: UserCreateNestedOneWithoutAdminWorkspacesInput;
  audits?: InputMaybe<AuditCreateNestedManyWithoutWorkspaceInput>;
  bookings?: InputMaybe<BookingCreateNestedManyWithoutWorkspaceInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  files?: InputMaybe<FileCreateNestedManyWithoutWorkspaceInput>;
  id?: InputMaybe<Scalars['String']>;
  memberships?: InputMaybe<MembershipCreateNestedManyWithoutWorkspaceInput>;
  name: Scalars['String'];
  playlists?: InputMaybe<PlaylistCreateNestedManyWithoutWorkspaceInput>;
  transactions?: InputMaybe<TransactionCreateNestedManyWithoutWorkspaceInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  users?: InputMaybe<UserCreateNestedManyWithoutWorkspacesInput>;
};

export type WorkspaceCreateWithoutAdBoardsInput = {
  PiSignagePlayers?: InputMaybe<PiSignagePlayerCreateNestedManyWithoutWorkspaceInput>;
  accessLabels?: InputMaybe<AccessLabelCreateNestedManyWithoutWorkspaceInput>;
  adBoardGroups?: InputMaybe<AdBoardGroupCreateNestedManyWithoutWorkspaceInput>;
  admin: UserCreateNestedOneWithoutAdminWorkspacesInput;
  audits?: InputMaybe<AuditCreateNestedManyWithoutWorkspaceInput>;
  bookings?: InputMaybe<BookingCreateNestedManyWithoutWorkspaceInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  files?: InputMaybe<FileCreateNestedManyWithoutWorkspaceInput>;
  id?: InputMaybe<Scalars['String']>;
  memberships?: InputMaybe<MembershipCreateNestedManyWithoutWorkspaceInput>;
  name: Scalars['String'];
  playlists?: InputMaybe<PlaylistCreateNestedManyWithoutWorkspaceInput>;
  transactions?: InputMaybe<TransactionCreateNestedManyWithoutWorkspaceInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  users?: InputMaybe<UserCreateNestedManyWithoutWorkspacesInput>;
};

export type WorkspaceCreateWithoutAdminInput = {
  PiSignagePlayers?: InputMaybe<PiSignagePlayerCreateNestedManyWithoutWorkspaceInput>;
  accessLabels?: InputMaybe<AccessLabelCreateNestedManyWithoutWorkspaceInput>;
  adBoardGroups?: InputMaybe<AdBoardGroupCreateNestedManyWithoutWorkspaceInput>;
  adBoards?: InputMaybe<AdBoardCreateNestedManyWithoutWorkspaceInput>;
  audits?: InputMaybe<AuditCreateNestedManyWithoutWorkspaceInput>;
  bookings?: InputMaybe<BookingCreateNestedManyWithoutWorkspaceInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  files?: InputMaybe<FileCreateNestedManyWithoutWorkspaceInput>;
  id?: InputMaybe<Scalars['String']>;
  memberships?: InputMaybe<MembershipCreateNestedManyWithoutWorkspaceInput>;
  name: Scalars['String'];
  playlists?: InputMaybe<PlaylistCreateNestedManyWithoutWorkspaceInput>;
  transactions?: InputMaybe<TransactionCreateNestedManyWithoutWorkspaceInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  users?: InputMaybe<UserCreateNestedManyWithoutWorkspacesInput>;
};

export type WorkspaceCreateWithoutAuditsInput = {
  PiSignagePlayers?: InputMaybe<PiSignagePlayerCreateNestedManyWithoutWorkspaceInput>;
  accessLabels?: InputMaybe<AccessLabelCreateNestedManyWithoutWorkspaceInput>;
  adBoardGroups?: InputMaybe<AdBoardGroupCreateNestedManyWithoutWorkspaceInput>;
  adBoards?: InputMaybe<AdBoardCreateNestedManyWithoutWorkspaceInput>;
  admin: UserCreateNestedOneWithoutAdminWorkspacesInput;
  bookings?: InputMaybe<BookingCreateNestedManyWithoutWorkspaceInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  files?: InputMaybe<FileCreateNestedManyWithoutWorkspaceInput>;
  id?: InputMaybe<Scalars['String']>;
  memberships?: InputMaybe<MembershipCreateNestedManyWithoutWorkspaceInput>;
  name: Scalars['String'];
  playlists?: InputMaybe<PlaylistCreateNestedManyWithoutWorkspaceInput>;
  transactions?: InputMaybe<TransactionCreateNestedManyWithoutWorkspaceInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  users?: InputMaybe<UserCreateNestedManyWithoutWorkspacesInput>;
};

export type WorkspaceCreateWithoutBookingsInput = {
  PiSignagePlayers?: InputMaybe<PiSignagePlayerCreateNestedManyWithoutWorkspaceInput>;
  accessLabels?: InputMaybe<AccessLabelCreateNestedManyWithoutWorkspaceInput>;
  adBoardGroups?: InputMaybe<AdBoardGroupCreateNestedManyWithoutWorkspaceInput>;
  adBoards?: InputMaybe<AdBoardCreateNestedManyWithoutWorkspaceInput>;
  admin: UserCreateNestedOneWithoutAdminWorkspacesInput;
  audits?: InputMaybe<AuditCreateNestedManyWithoutWorkspaceInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  files?: InputMaybe<FileCreateNestedManyWithoutWorkspaceInput>;
  id?: InputMaybe<Scalars['String']>;
  memberships?: InputMaybe<MembershipCreateNestedManyWithoutWorkspaceInput>;
  name: Scalars['String'];
  playlists?: InputMaybe<PlaylistCreateNestedManyWithoutWorkspaceInput>;
  transactions?: InputMaybe<TransactionCreateNestedManyWithoutWorkspaceInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  users?: InputMaybe<UserCreateNestedManyWithoutWorkspacesInput>;
};

export type WorkspaceCreateWithoutFilesInput = {
  PiSignagePlayers?: InputMaybe<PiSignagePlayerCreateNestedManyWithoutWorkspaceInput>;
  accessLabels?: InputMaybe<AccessLabelCreateNestedManyWithoutWorkspaceInput>;
  adBoardGroups?: InputMaybe<AdBoardGroupCreateNestedManyWithoutWorkspaceInput>;
  adBoards?: InputMaybe<AdBoardCreateNestedManyWithoutWorkspaceInput>;
  admin: UserCreateNestedOneWithoutAdminWorkspacesInput;
  audits?: InputMaybe<AuditCreateNestedManyWithoutWorkspaceInput>;
  bookings?: InputMaybe<BookingCreateNestedManyWithoutWorkspaceInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['String']>;
  memberships?: InputMaybe<MembershipCreateNestedManyWithoutWorkspaceInput>;
  name: Scalars['String'];
  playlists?: InputMaybe<PlaylistCreateNestedManyWithoutWorkspaceInput>;
  transactions?: InputMaybe<TransactionCreateNestedManyWithoutWorkspaceInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  users?: InputMaybe<UserCreateNestedManyWithoutWorkspacesInput>;
};

export type WorkspaceCreateWithoutMembershipsInput = {
  PiSignagePlayers?: InputMaybe<PiSignagePlayerCreateNestedManyWithoutWorkspaceInput>;
  accessLabels?: InputMaybe<AccessLabelCreateNestedManyWithoutWorkspaceInput>;
  adBoardGroups?: InputMaybe<AdBoardGroupCreateNestedManyWithoutWorkspaceInput>;
  adBoards?: InputMaybe<AdBoardCreateNestedManyWithoutWorkspaceInput>;
  admin: UserCreateNestedOneWithoutAdminWorkspacesInput;
  audits?: InputMaybe<AuditCreateNestedManyWithoutWorkspaceInput>;
  bookings?: InputMaybe<BookingCreateNestedManyWithoutWorkspaceInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  files?: InputMaybe<FileCreateNestedManyWithoutWorkspaceInput>;
  id?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
  playlists?: InputMaybe<PlaylistCreateNestedManyWithoutWorkspaceInput>;
  transactions?: InputMaybe<TransactionCreateNestedManyWithoutWorkspaceInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  users?: InputMaybe<UserCreateNestedManyWithoutWorkspacesInput>;
};

export type WorkspaceCreateWithoutPiSignagePlayersInput = {
  accessLabels?: InputMaybe<AccessLabelCreateNestedManyWithoutWorkspaceInput>;
  adBoardGroups?: InputMaybe<AdBoardGroupCreateNestedManyWithoutWorkspaceInput>;
  adBoards?: InputMaybe<AdBoardCreateNestedManyWithoutWorkspaceInput>;
  admin: UserCreateNestedOneWithoutAdminWorkspacesInput;
  audits?: InputMaybe<AuditCreateNestedManyWithoutWorkspaceInput>;
  bookings?: InputMaybe<BookingCreateNestedManyWithoutWorkspaceInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  files?: InputMaybe<FileCreateNestedManyWithoutWorkspaceInput>;
  id?: InputMaybe<Scalars['String']>;
  memberships?: InputMaybe<MembershipCreateNestedManyWithoutWorkspaceInput>;
  name: Scalars['String'];
  playlists?: InputMaybe<PlaylistCreateNestedManyWithoutWorkspaceInput>;
  transactions?: InputMaybe<TransactionCreateNestedManyWithoutWorkspaceInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  users?: InputMaybe<UserCreateNestedManyWithoutWorkspacesInput>;
};

export type WorkspaceCreateWithoutPlaylistsInput = {
  PiSignagePlayers?: InputMaybe<PiSignagePlayerCreateNestedManyWithoutWorkspaceInput>;
  accessLabels?: InputMaybe<AccessLabelCreateNestedManyWithoutWorkspaceInput>;
  adBoardGroups?: InputMaybe<AdBoardGroupCreateNestedManyWithoutWorkspaceInput>;
  adBoards?: InputMaybe<AdBoardCreateNestedManyWithoutWorkspaceInput>;
  admin: UserCreateNestedOneWithoutAdminWorkspacesInput;
  audits?: InputMaybe<AuditCreateNestedManyWithoutWorkspaceInput>;
  bookings?: InputMaybe<BookingCreateNestedManyWithoutWorkspaceInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  files?: InputMaybe<FileCreateNestedManyWithoutWorkspaceInput>;
  id?: InputMaybe<Scalars['String']>;
  memberships?: InputMaybe<MembershipCreateNestedManyWithoutWorkspaceInput>;
  name: Scalars['String'];
  transactions?: InputMaybe<TransactionCreateNestedManyWithoutWorkspaceInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  users?: InputMaybe<UserCreateNestedManyWithoutWorkspacesInput>;
};

export type WorkspaceCreateWithoutTransactionsInput = {
  PiSignagePlayers?: InputMaybe<PiSignagePlayerCreateNestedManyWithoutWorkspaceInput>;
  accessLabels?: InputMaybe<AccessLabelCreateNestedManyWithoutWorkspaceInput>;
  adBoardGroups?: InputMaybe<AdBoardGroupCreateNestedManyWithoutWorkspaceInput>;
  adBoards?: InputMaybe<AdBoardCreateNestedManyWithoutWorkspaceInput>;
  admin: UserCreateNestedOneWithoutAdminWorkspacesInput;
  audits?: InputMaybe<AuditCreateNestedManyWithoutWorkspaceInput>;
  bookings?: InputMaybe<BookingCreateNestedManyWithoutWorkspaceInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  files?: InputMaybe<FileCreateNestedManyWithoutWorkspaceInput>;
  id?: InputMaybe<Scalars['String']>;
  memberships?: InputMaybe<MembershipCreateNestedManyWithoutWorkspaceInput>;
  name: Scalars['String'];
  playlists?: InputMaybe<PlaylistCreateNestedManyWithoutWorkspaceInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  users?: InputMaybe<UserCreateNestedManyWithoutWorkspacesInput>;
};

export type WorkspaceCreateWithoutUsersInput = {
  PiSignagePlayers?: InputMaybe<PiSignagePlayerCreateNestedManyWithoutWorkspaceInput>;
  accessLabels?: InputMaybe<AccessLabelCreateNestedManyWithoutWorkspaceInput>;
  adBoardGroups?: InputMaybe<AdBoardGroupCreateNestedManyWithoutWorkspaceInput>;
  adBoards?: InputMaybe<AdBoardCreateNestedManyWithoutWorkspaceInput>;
  admin: UserCreateNestedOneWithoutAdminWorkspacesInput;
  audits?: InputMaybe<AuditCreateNestedManyWithoutWorkspaceInput>;
  bookings?: InputMaybe<BookingCreateNestedManyWithoutWorkspaceInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  files?: InputMaybe<FileCreateNestedManyWithoutWorkspaceInput>;
  id?: InputMaybe<Scalars['String']>;
  memberships?: InputMaybe<MembershipCreateNestedManyWithoutWorkspaceInput>;
  name: Scalars['String'];
  playlists?: InputMaybe<PlaylistCreateNestedManyWithoutWorkspaceInput>;
  transactions?: InputMaybe<TransactionCreateNestedManyWithoutWorkspaceInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type WorkspaceGroupBy = {
  __typename?: 'WorkspaceGroupBy';
  _count?: Maybe<WorkspaceCountAggregate>;
  _max?: Maybe<WorkspaceMaxAggregate>;
  _min?: Maybe<WorkspaceMinAggregate>;
  adminUserId: Scalars['String'];
  createdAt: Scalars['DateTime'];
  id: Scalars['String'];
  name: Scalars['String'];
  updatedAt: Scalars['DateTime'];
  userIds?: Maybe<Array<Scalars['String']>>;
};

export type WorkspaceListRelationFilter = {
  every?: InputMaybe<WorkspaceWhereInput>;
  none?: InputMaybe<WorkspaceWhereInput>;
  some?: InputMaybe<WorkspaceWhereInput>;
};

export type WorkspaceMaxAggregate = {
  __typename?: 'WorkspaceMaxAggregate';
  adminUserId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type WorkspaceMaxOrderByAggregateInput = {
  adminUserId?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  name?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
};

export type WorkspaceMinAggregate = {
  __typename?: 'WorkspaceMinAggregate';
  adminUserId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type WorkspaceMinOrderByAggregateInput = {
  adminUserId?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  name?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
};

export type WorkspaceNullableRelationFilter = {
  is?: InputMaybe<WorkspaceWhereInput>;
  isNot?: InputMaybe<WorkspaceWhereInput>;
};

export type WorkspaceOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type WorkspaceOrderByWithAggregationInput = {
  _count?: InputMaybe<WorkspaceCountOrderByAggregateInput>;
  _max?: InputMaybe<WorkspaceMaxOrderByAggregateInput>;
  _min?: InputMaybe<WorkspaceMinOrderByAggregateInput>;
  adminUserId?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  name?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
  userIds?: InputMaybe<SortOrder>;
};

export type WorkspaceOrderByWithRelationInput = {
  PiSignagePlayers?: InputMaybe<PiSignagePlayerOrderByRelationAggregateInput>;
  accessLabels?: InputMaybe<AccessLabelOrderByRelationAggregateInput>;
  adBoardGroups?: InputMaybe<AdBoardGroupOrderByRelationAggregateInput>;
  adBoards?: InputMaybe<AdBoardOrderByRelationAggregateInput>;
  admin?: InputMaybe<UserOrderByWithRelationInput>;
  adminUserId?: InputMaybe<SortOrder>;
  audits?: InputMaybe<AuditOrderByRelationAggregateInput>;
  bookings?: InputMaybe<BookingOrderByRelationAggregateInput>;
  createdAt?: InputMaybe<SortOrder>;
  files?: InputMaybe<FileOrderByRelationAggregateInput>;
  id?: InputMaybe<SortOrder>;
  memberships?: InputMaybe<MembershipOrderByRelationAggregateInput>;
  name?: InputMaybe<SortOrder>;
  playlists?: InputMaybe<PlaylistOrderByRelationAggregateInput>;
  transactions?: InputMaybe<TransactionOrderByRelationAggregateInput>;
  updatedAt?: InputMaybe<SortOrder>;
  userIds?: InputMaybe<SortOrder>;
  users?: InputMaybe<UserOrderByRelationAggregateInput>;
};

export type WorkspaceRelationFilter = {
  is?: InputMaybe<WorkspaceWhereInput>;
  isNot?: InputMaybe<WorkspaceWhereInput>;
};

export enum WorkspaceScalarFieldEnum {
  AdminUserId = 'adminUserId',
  CreatedAt = 'createdAt',
  Id = 'id',
  Name = 'name',
  UpdatedAt = 'updatedAt',
  UserIds = 'userIds'
}

export type WorkspaceScalarWhereInput = {
  AND?: InputMaybe<Array<WorkspaceScalarWhereInput>>;
  NOT?: InputMaybe<Array<WorkspaceScalarWhereInput>>;
  OR?: InputMaybe<Array<WorkspaceScalarWhereInput>>;
  adminUserId?: InputMaybe<StringFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  id?: InputMaybe<StringFilter>;
  name?: InputMaybe<StringFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
  userIds?: InputMaybe<StringNullableListFilter>;
};

export type WorkspaceScalarWhereWithAggregatesInput = {
  AND?: InputMaybe<Array<WorkspaceScalarWhereWithAggregatesInput>>;
  NOT?: InputMaybe<Array<WorkspaceScalarWhereWithAggregatesInput>>;
  OR?: InputMaybe<Array<WorkspaceScalarWhereWithAggregatesInput>>;
  adminUserId?: InputMaybe<StringWithAggregatesFilter>;
  createdAt?: InputMaybe<DateTimeWithAggregatesFilter>;
  id?: InputMaybe<StringWithAggregatesFilter>;
  name?: InputMaybe<StringWithAggregatesFilter>;
  updatedAt?: InputMaybe<DateTimeWithAggregatesFilter>;
  userIds?: InputMaybe<StringNullableListFilter>;
};

export type WorkspaceUpdateInput = {
  PiSignagePlayers?: InputMaybe<PiSignagePlayerUpdateManyWithoutWorkspaceNestedInput>;
  accessLabels?: InputMaybe<AccessLabelUpdateManyWithoutWorkspaceNestedInput>;
  adBoardGroups?: InputMaybe<AdBoardGroupUpdateManyWithoutWorkspaceNestedInput>;
  adBoards?: InputMaybe<AdBoardUpdateManyWithoutWorkspaceNestedInput>;
  admin?: InputMaybe<UserUpdateOneRequiredWithoutAdminWorkspacesNestedInput>;
  audits?: InputMaybe<AuditUpdateManyWithoutWorkspaceNestedInput>;
  bookings?: InputMaybe<BookingUpdateManyWithoutWorkspaceNestedInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  files?: InputMaybe<FileUpdateManyWithoutWorkspaceNestedInput>;
  memberships?: InputMaybe<MembershipUpdateManyWithoutWorkspaceNestedInput>;
  name?: InputMaybe<Scalars['String']>;
  playlists?: InputMaybe<PlaylistUpdateManyWithoutWorkspaceNestedInput>;
  transactions?: InputMaybe<TransactionUpdateManyWithoutWorkspaceNestedInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  users?: InputMaybe<UserUpdateManyWithoutWorkspacesNestedInput>;
};

export type WorkspaceUpdateManyMutationInput = {
  createdAt?: InputMaybe<Scalars['DateTime']>;
  name?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type WorkspaceUpdateManyWithWhereWithoutAdminInput = {
  data: WorkspaceUpdateManyMutationInput;
  where: WorkspaceScalarWhereInput;
};

export type WorkspaceUpdateManyWithWhereWithoutUsersInput = {
  data: WorkspaceUpdateManyMutationInput;
  where: WorkspaceScalarWhereInput;
};

export type WorkspaceUpdateManyWithoutAdminNestedInput = {
  connect?: InputMaybe<Array<WorkspaceWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<WorkspaceCreateOrConnectWithoutAdminInput>>;
  create?: InputMaybe<Array<WorkspaceCreateWithoutAdminInput>>;
  createMany?: InputMaybe<WorkspaceCreateManyAdminInputEnvelope>;
  delete?: InputMaybe<Array<WorkspaceWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<WorkspaceScalarWhereInput>>;
  disconnect?: InputMaybe<Array<WorkspaceWhereUniqueInput>>;
  set?: InputMaybe<Array<WorkspaceWhereUniqueInput>>;
  update?: InputMaybe<Array<WorkspaceUpdateWithWhereUniqueWithoutAdminInput>>;
  updateMany?: InputMaybe<Array<WorkspaceUpdateManyWithWhereWithoutAdminInput>>;
  upsert?: InputMaybe<Array<WorkspaceUpsertWithWhereUniqueWithoutAdminInput>>;
};

export type WorkspaceUpdateManyWithoutUsersNestedInput = {
  connect?: InputMaybe<Array<WorkspaceWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<WorkspaceCreateOrConnectWithoutUsersInput>>;
  create?: InputMaybe<Array<WorkspaceCreateWithoutUsersInput>>;
  delete?: InputMaybe<Array<WorkspaceWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<WorkspaceScalarWhereInput>>;
  disconnect?: InputMaybe<Array<WorkspaceWhereUniqueInput>>;
  set?: InputMaybe<Array<WorkspaceWhereUniqueInput>>;
  update?: InputMaybe<Array<WorkspaceUpdateWithWhereUniqueWithoutUsersInput>>;
  updateMany?: InputMaybe<Array<WorkspaceUpdateManyWithWhereWithoutUsersInput>>;
  upsert?: InputMaybe<Array<WorkspaceUpsertWithWhereUniqueWithoutUsersInput>>;
};

export type WorkspaceUpdateOneRequiredWithoutAdBoardGroupsNestedInput = {
  connect?: InputMaybe<WorkspaceWhereUniqueInput>;
  connectOrCreate?: InputMaybe<WorkspaceCreateOrConnectWithoutAdBoardGroupsInput>;
  create?: InputMaybe<WorkspaceCreateWithoutAdBoardGroupsInput>;
  update?: InputMaybe<WorkspaceUpdateToOneWithWhereWithoutAdBoardGroupsInput>;
  upsert?: InputMaybe<WorkspaceUpsertWithoutAdBoardGroupsInput>;
};

export type WorkspaceUpdateOneRequiredWithoutAdBoardsNestedInput = {
  connect?: InputMaybe<WorkspaceWhereUniqueInput>;
  connectOrCreate?: InputMaybe<WorkspaceCreateOrConnectWithoutAdBoardsInput>;
  create?: InputMaybe<WorkspaceCreateWithoutAdBoardsInput>;
  update?: InputMaybe<WorkspaceUpdateToOneWithWhereWithoutAdBoardsInput>;
  upsert?: InputMaybe<WorkspaceUpsertWithoutAdBoardsInput>;
};

export type WorkspaceUpdateOneRequiredWithoutMembershipsNestedInput = {
  connect?: InputMaybe<WorkspaceWhereUniqueInput>;
  connectOrCreate?: InputMaybe<WorkspaceCreateOrConnectWithoutMembershipsInput>;
  create?: InputMaybe<WorkspaceCreateWithoutMembershipsInput>;
  update?: InputMaybe<WorkspaceUpdateToOneWithWhereWithoutMembershipsInput>;
  upsert?: InputMaybe<WorkspaceUpsertWithoutMembershipsInput>;
};

export type WorkspaceUpdateOneRequiredWithoutPlaylistsNestedInput = {
  connect?: InputMaybe<WorkspaceWhereUniqueInput>;
  connectOrCreate?: InputMaybe<WorkspaceCreateOrConnectWithoutPlaylistsInput>;
  create?: InputMaybe<WorkspaceCreateWithoutPlaylistsInput>;
  update?: InputMaybe<WorkspaceUpdateToOneWithWhereWithoutPlaylistsInput>;
  upsert?: InputMaybe<WorkspaceUpsertWithoutPlaylistsInput>;
};

export type WorkspaceUpdateOneWithoutAccessLabelsNestedInput = {
  connect?: InputMaybe<WorkspaceWhereUniqueInput>;
  connectOrCreate?: InputMaybe<WorkspaceCreateOrConnectWithoutAccessLabelsInput>;
  create?: InputMaybe<WorkspaceCreateWithoutAccessLabelsInput>;
  delete?: InputMaybe<WorkspaceWhereInput>;
  disconnect?: InputMaybe<Scalars['Boolean']>;
  update?: InputMaybe<WorkspaceUpdateToOneWithWhereWithoutAccessLabelsInput>;
  upsert?: InputMaybe<WorkspaceUpsertWithoutAccessLabelsInput>;
};

export type WorkspaceUpdateOneWithoutAuditsNestedInput = {
  connect?: InputMaybe<WorkspaceWhereUniqueInput>;
  connectOrCreate?: InputMaybe<WorkspaceCreateOrConnectWithoutAuditsInput>;
  create?: InputMaybe<WorkspaceCreateWithoutAuditsInput>;
  delete?: InputMaybe<WorkspaceWhereInput>;
  disconnect?: InputMaybe<Scalars['Boolean']>;
  update?: InputMaybe<WorkspaceUpdateToOneWithWhereWithoutAuditsInput>;
  upsert?: InputMaybe<WorkspaceUpsertWithoutAuditsInput>;
};

export type WorkspaceUpdateOneWithoutBookingsNestedInput = {
  connect?: InputMaybe<WorkspaceWhereUniqueInput>;
  connectOrCreate?: InputMaybe<WorkspaceCreateOrConnectWithoutBookingsInput>;
  create?: InputMaybe<WorkspaceCreateWithoutBookingsInput>;
  delete?: InputMaybe<WorkspaceWhereInput>;
  disconnect?: InputMaybe<Scalars['Boolean']>;
  update?: InputMaybe<WorkspaceUpdateToOneWithWhereWithoutBookingsInput>;
  upsert?: InputMaybe<WorkspaceUpsertWithoutBookingsInput>;
};

export type WorkspaceUpdateOneWithoutFilesNestedInput = {
  connect?: InputMaybe<WorkspaceWhereUniqueInput>;
  connectOrCreate?: InputMaybe<WorkspaceCreateOrConnectWithoutFilesInput>;
  create?: InputMaybe<WorkspaceCreateWithoutFilesInput>;
  delete?: InputMaybe<WorkspaceWhereInput>;
  disconnect?: InputMaybe<Scalars['Boolean']>;
  update?: InputMaybe<WorkspaceUpdateToOneWithWhereWithoutFilesInput>;
  upsert?: InputMaybe<WorkspaceUpsertWithoutFilesInput>;
};

export type WorkspaceUpdateOneWithoutPiSignagePlayersNestedInput = {
  connect?: InputMaybe<WorkspaceWhereUniqueInput>;
  connectOrCreate?: InputMaybe<WorkspaceCreateOrConnectWithoutPiSignagePlayersInput>;
  create?: InputMaybe<WorkspaceCreateWithoutPiSignagePlayersInput>;
  delete?: InputMaybe<WorkspaceWhereInput>;
  disconnect?: InputMaybe<Scalars['Boolean']>;
  update?: InputMaybe<WorkspaceUpdateToOneWithWhereWithoutPiSignagePlayersInput>;
  upsert?: InputMaybe<WorkspaceUpsertWithoutPiSignagePlayersInput>;
};

export type WorkspaceUpdateOneWithoutTransactionsNestedInput = {
  connect?: InputMaybe<WorkspaceWhereUniqueInput>;
  connectOrCreate?: InputMaybe<WorkspaceCreateOrConnectWithoutTransactionsInput>;
  create?: InputMaybe<WorkspaceCreateWithoutTransactionsInput>;
  delete?: InputMaybe<WorkspaceWhereInput>;
  disconnect?: InputMaybe<Scalars['Boolean']>;
  update?: InputMaybe<WorkspaceUpdateToOneWithWhereWithoutTransactionsInput>;
  upsert?: InputMaybe<WorkspaceUpsertWithoutTransactionsInput>;
};

export type WorkspaceUpdateToOneWithWhereWithoutAccessLabelsInput = {
  data: WorkspaceUpdateWithoutAccessLabelsInput;
  where?: InputMaybe<WorkspaceWhereInput>;
};

export type WorkspaceUpdateToOneWithWhereWithoutAdBoardGroupsInput = {
  data: WorkspaceUpdateWithoutAdBoardGroupsInput;
  where?: InputMaybe<WorkspaceWhereInput>;
};

export type WorkspaceUpdateToOneWithWhereWithoutAdBoardsInput = {
  data: WorkspaceUpdateWithoutAdBoardsInput;
  where?: InputMaybe<WorkspaceWhereInput>;
};

export type WorkspaceUpdateToOneWithWhereWithoutAuditsInput = {
  data: WorkspaceUpdateWithoutAuditsInput;
  where?: InputMaybe<WorkspaceWhereInput>;
};

export type WorkspaceUpdateToOneWithWhereWithoutBookingsInput = {
  data: WorkspaceUpdateWithoutBookingsInput;
  where?: InputMaybe<WorkspaceWhereInput>;
};

export type WorkspaceUpdateToOneWithWhereWithoutFilesInput = {
  data: WorkspaceUpdateWithoutFilesInput;
  where?: InputMaybe<WorkspaceWhereInput>;
};

export type WorkspaceUpdateToOneWithWhereWithoutMembershipsInput = {
  data: WorkspaceUpdateWithoutMembershipsInput;
  where?: InputMaybe<WorkspaceWhereInput>;
};

export type WorkspaceUpdateToOneWithWhereWithoutPiSignagePlayersInput = {
  data: WorkspaceUpdateWithoutPiSignagePlayersInput;
  where?: InputMaybe<WorkspaceWhereInput>;
};

export type WorkspaceUpdateToOneWithWhereWithoutPlaylistsInput = {
  data: WorkspaceUpdateWithoutPlaylistsInput;
  where?: InputMaybe<WorkspaceWhereInput>;
};

export type WorkspaceUpdateToOneWithWhereWithoutTransactionsInput = {
  data: WorkspaceUpdateWithoutTransactionsInput;
  where?: InputMaybe<WorkspaceWhereInput>;
};

export type WorkspaceUpdateWithWhereUniqueWithoutAdminInput = {
  data: WorkspaceUpdateWithoutAdminInput;
  where: WorkspaceWhereUniqueInput;
};

export type WorkspaceUpdateWithWhereUniqueWithoutUsersInput = {
  data: WorkspaceUpdateWithoutUsersInput;
  where: WorkspaceWhereUniqueInput;
};

export type WorkspaceUpdateWithoutAccessLabelsInput = {
  PiSignagePlayers?: InputMaybe<PiSignagePlayerUpdateManyWithoutWorkspaceNestedInput>;
  adBoardGroups?: InputMaybe<AdBoardGroupUpdateManyWithoutWorkspaceNestedInput>;
  adBoards?: InputMaybe<AdBoardUpdateManyWithoutWorkspaceNestedInput>;
  admin?: InputMaybe<UserUpdateOneRequiredWithoutAdminWorkspacesNestedInput>;
  audits?: InputMaybe<AuditUpdateManyWithoutWorkspaceNestedInput>;
  bookings?: InputMaybe<BookingUpdateManyWithoutWorkspaceNestedInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  files?: InputMaybe<FileUpdateManyWithoutWorkspaceNestedInput>;
  memberships?: InputMaybe<MembershipUpdateManyWithoutWorkspaceNestedInput>;
  name?: InputMaybe<Scalars['String']>;
  playlists?: InputMaybe<PlaylistUpdateManyWithoutWorkspaceNestedInput>;
  transactions?: InputMaybe<TransactionUpdateManyWithoutWorkspaceNestedInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  users?: InputMaybe<UserUpdateManyWithoutWorkspacesNestedInput>;
};

export type WorkspaceUpdateWithoutAdBoardGroupsInput = {
  PiSignagePlayers?: InputMaybe<PiSignagePlayerUpdateManyWithoutWorkspaceNestedInput>;
  accessLabels?: InputMaybe<AccessLabelUpdateManyWithoutWorkspaceNestedInput>;
  adBoards?: InputMaybe<AdBoardUpdateManyWithoutWorkspaceNestedInput>;
  admin?: InputMaybe<UserUpdateOneRequiredWithoutAdminWorkspacesNestedInput>;
  audits?: InputMaybe<AuditUpdateManyWithoutWorkspaceNestedInput>;
  bookings?: InputMaybe<BookingUpdateManyWithoutWorkspaceNestedInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  files?: InputMaybe<FileUpdateManyWithoutWorkspaceNestedInput>;
  memberships?: InputMaybe<MembershipUpdateManyWithoutWorkspaceNestedInput>;
  name?: InputMaybe<Scalars['String']>;
  playlists?: InputMaybe<PlaylistUpdateManyWithoutWorkspaceNestedInput>;
  transactions?: InputMaybe<TransactionUpdateManyWithoutWorkspaceNestedInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  users?: InputMaybe<UserUpdateManyWithoutWorkspacesNestedInput>;
};

export type WorkspaceUpdateWithoutAdBoardsInput = {
  PiSignagePlayers?: InputMaybe<PiSignagePlayerUpdateManyWithoutWorkspaceNestedInput>;
  accessLabels?: InputMaybe<AccessLabelUpdateManyWithoutWorkspaceNestedInput>;
  adBoardGroups?: InputMaybe<AdBoardGroupUpdateManyWithoutWorkspaceNestedInput>;
  admin?: InputMaybe<UserUpdateOneRequiredWithoutAdminWorkspacesNestedInput>;
  audits?: InputMaybe<AuditUpdateManyWithoutWorkspaceNestedInput>;
  bookings?: InputMaybe<BookingUpdateManyWithoutWorkspaceNestedInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  files?: InputMaybe<FileUpdateManyWithoutWorkspaceNestedInput>;
  memberships?: InputMaybe<MembershipUpdateManyWithoutWorkspaceNestedInput>;
  name?: InputMaybe<Scalars['String']>;
  playlists?: InputMaybe<PlaylistUpdateManyWithoutWorkspaceNestedInput>;
  transactions?: InputMaybe<TransactionUpdateManyWithoutWorkspaceNestedInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  users?: InputMaybe<UserUpdateManyWithoutWorkspacesNestedInput>;
};

export type WorkspaceUpdateWithoutAdminInput = {
  PiSignagePlayers?: InputMaybe<PiSignagePlayerUpdateManyWithoutWorkspaceNestedInput>;
  accessLabels?: InputMaybe<AccessLabelUpdateManyWithoutWorkspaceNestedInput>;
  adBoardGroups?: InputMaybe<AdBoardGroupUpdateManyWithoutWorkspaceNestedInput>;
  adBoards?: InputMaybe<AdBoardUpdateManyWithoutWorkspaceNestedInput>;
  audits?: InputMaybe<AuditUpdateManyWithoutWorkspaceNestedInput>;
  bookings?: InputMaybe<BookingUpdateManyWithoutWorkspaceNestedInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  files?: InputMaybe<FileUpdateManyWithoutWorkspaceNestedInput>;
  memberships?: InputMaybe<MembershipUpdateManyWithoutWorkspaceNestedInput>;
  name?: InputMaybe<Scalars['String']>;
  playlists?: InputMaybe<PlaylistUpdateManyWithoutWorkspaceNestedInput>;
  transactions?: InputMaybe<TransactionUpdateManyWithoutWorkspaceNestedInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  users?: InputMaybe<UserUpdateManyWithoutWorkspacesNestedInput>;
};

export type WorkspaceUpdateWithoutAuditsInput = {
  PiSignagePlayers?: InputMaybe<PiSignagePlayerUpdateManyWithoutWorkspaceNestedInput>;
  accessLabels?: InputMaybe<AccessLabelUpdateManyWithoutWorkspaceNestedInput>;
  adBoardGroups?: InputMaybe<AdBoardGroupUpdateManyWithoutWorkspaceNestedInput>;
  adBoards?: InputMaybe<AdBoardUpdateManyWithoutWorkspaceNestedInput>;
  admin?: InputMaybe<UserUpdateOneRequiredWithoutAdminWorkspacesNestedInput>;
  bookings?: InputMaybe<BookingUpdateManyWithoutWorkspaceNestedInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  files?: InputMaybe<FileUpdateManyWithoutWorkspaceNestedInput>;
  memberships?: InputMaybe<MembershipUpdateManyWithoutWorkspaceNestedInput>;
  name?: InputMaybe<Scalars['String']>;
  playlists?: InputMaybe<PlaylistUpdateManyWithoutWorkspaceNestedInput>;
  transactions?: InputMaybe<TransactionUpdateManyWithoutWorkspaceNestedInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  users?: InputMaybe<UserUpdateManyWithoutWorkspacesNestedInput>;
};

export type WorkspaceUpdateWithoutBookingsInput = {
  PiSignagePlayers?: InputMaybe<PiSignagePlayerUpdateManyWithoutWorkspaceNestedInput>;
  accessLabels?: InputMaybe<AccessLabelUpdateManyWithoutWorkspaceNestedInput>;
  adBoardGroups?: InputMaybe<AdBoardGroupUpdateManyWithoutWorkspaceNestedInput>;
  adBoards?: InputMaybe<AdBoardUpdateManyWithoutWorkspaceNestedInput>;
  admin?: InputMaybe<UserUpdateOneRequiredWithoutAdminWorkspacesNestedInput>;
  audits?: InputMaybe<AuditUpdateManyWithoutWorkspaceNestedInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  files?: InputMaybe<FileUpdateManyWithoutWorkspaceNestedInput>;
  memberships?: InputMaybe<MembershipUpdateManyWithoutWorkspaceNestedInput>;
  name?: InputMaybe<Scalars['String']>;
  playlists?: InputMaybe<PlaylistUpdateManyWithoutWorkspaceNestedInput>;
  transactions?: InputMaybe<TransactionUpdateManyWithoutWorkspaceNestedInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  users?: InputMaybe<UserUpdateManyWithoutWorkspacesNestedInput>;
};

export type WorkspaceUpdateWithoutFilesInput = {
  PiSignagePlayers?: InputMaybe<PiSignagePlayerUpdateManyWithoutWorkspaceNestedInput>;
  accessLabels?: InputMaybe<AccessLabelUpdateManyWithoutWorkspaceNestedInput>;
  adBoardGroups?: InputMaybe<AdBoardGroupUpdateManyWithoutWorkspaceNestedInput>;
  adBoards?: InputMaybe<AdBoardUpdateManyWithoutWorkspaceNestedInput>;
  admin?: InputMaybe<UserUpdateOneRequiredWithoutAdminWorkspacesNestedInput>;
  audits?: InputMaybe<AuditUpdateManyWithoutWorkspaceNestedInput>;
  bookings?: InputMaybe<BookingUpdateManyWithoutWorkspaceNestedInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  memberships?: InputMaybe<MembershipUpdateManyWithoutWorkspaceNestedInput>;
  name?: InputMaybe<Scalars['String']>;
  playlists?: InputMaybe<PlaylistUpdateManyWithoutWorkspaceNestedInput>;
  transactions?: InputMaybe<TransactionUpdateManyWithoutWorkspaceNestedInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  users?: InputMaybe<UserUpdateManyWithoutWorkspacesNestedInput>;
};

export type WorkspaceUpdateWithoutMembershipsInput = {
  PiSignagePlayers?: InputMaybe<PiSignagePlayerUpdateManyWithoutWorkspaceNestedInput>;
  accessLabels?: InputMaybe<AccessLabelUpdateManyWithoutWorkspaceNestedInput>;
  adBoardGroups?: InputMaybe<AdBoardGroupUpdateManyWithoutWorkspaceNestedInput>;
  adBoards?: InputMaybe<AdBoardUpdateManyWithoutWorkspaceNestedInput>;
  admin?: InputMaybe<UserUpdateOneRequiredWithoutAdminWorkspacesNestedInput>;
  audits?: InputMaybe<AuditUpdateManyWithoutWorkspaceNestedInput>;
  bookings?: InputMaybe<BookingUpdateManyWithoutWorkspaceNestedInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  files?: InputMaybe<FileUpdateManyWithoutWorkspaceNestedInput>;
  name?: InputMaybe<Scalars['String']>;
  playlists?: InputMaybe<PlaylistUpdateManyWithoutWorkspaceNestedInput>;
  transactions?: InputMaybe<TransactionUpdateManyWithoutWorkspaceNestedInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  users?: InputMaybe<UserUpdateManyWithoutWorkspacesNestedInput>;
};

export type WorkspaceUpdateWithoutPiSignagePlayersInput = {
  accessLabels?: InputMaybe<AccessLabelUpdateManyWithoutWorkspaceNestedInput>;
  adBoardGroups?: InputMaybe<AdBoardGroupUpdateManyWithoutWorkspaceNestedInput>;
  adBoards?: InputMaybe<AdBoardUpdateManyWithoutWorkspaceNestedInput>;
  admin?: InputMaybe<UserUpdateOneRequiredWithoutAdminWorkspacesNestedInput>;
  audits?: InputMaybe<AuditUpdateManyWithoutWorkspaceNestedInput>;
  bookings?: InputMaybe<BookingUpdateManyWithoutWorkspaceNestedInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  files?: InputMaybe<FileUpdateManyWithoutWorkspaceNestedInput>;
  memberships?: InputMaybe<MembershipUpdateManyWithoutWorkspaceNestedInput>;
  name?: InputMaybe<Scalars['String']>;
  playlists?: InputMaybe<PlaylistUpdateManyWithoutWorkspaceNestedInput>;
  transactions?: InputMaybe<TransactionUpdateManyWithoutWorkspaceNestedInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  users?: InputMaybe<UserUpdateManyWithoutWorkspacesNestedInput>;
};

export type WorkspaceUpdateWithoutPlaylistsInput = {
  PiSignagePlayers?: InputMaybe<PiSignagePlayerUpdateManyWithoutWorkspaceNestedInput>;
  accessLabels?: InputMaybe<AccessLabelUpdateManyWithoutWorkspaceNestedInput>;
  adBoardGroups?: InputMaybe<AdBoardGroupUpdateManyWithoutWorkspaceNestedInput>;
  adBoards?: InputMaybe<AdBoardUpdateManyWithoutWorkspaceNestedInput>;
  admin?: InputMaybe<UserUpdateOneRequiredWithoutAdminWorkspacesNestedInput>;
  audits?: InputMaybe<AuditUpdateManyWithoutWorkspaceNestedInput>;
  bookings?: InputMaybe<BookingUpdateManyWithoutWorkspaceNestedInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  files?: InputMaybe<FileUpdateManyWithoutWorkspaceNestedInput>;
  memberships?: InputMaybe<MembershipUpdateManyWithoutWorkspaceNestedInput>;
  name?: InputMaybe<Scalars['String']>;
  transactions?: InputMaybe<TransactionUpdateManyWithoutWorkspaceNestedInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  users?: InputMaybe<UserUpdateManyWithoutWorkspacesNestedInput>;
};

export type WorkspaceUpdateWithoutTransactionsInput = {
  PiSignagePlayers?: InputMaybe<PiSignagePlayerUpdateManyWithoutWorkspaceNestedInput>;
  accessLabels?: InputMaybe<AccessLabelUpdateManyWithoutWorkspaceNestedInput>;
  adBoardGroups?: InputMaybe<AdBoardGroupUpdateManyWithoutWorkspaceNestedInput>;
  adBoards?: InputMaybe<AdBoardUpdateManyWithoutWorkspaceNestedInput>;
  admin?: InputMaybe<UserUpdateOneRequiredWithoutAdminWorkspacesNestedInput>;
  audits?: InputMaybe<AuditUpdateManyWithoutWorkspaceNestedInput>;
  bookings?: InputMaybe<BookingUpdateManyWithoutWorkspaceNestedInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  files?: InputMaybe<FileUpdateManyWithoutWorkspaceNestedInput>;
  memberships?: InputMaybe<MembershipUpdateManyWithoutWorkspaceNestedInput>;
  name?: InputMaybe<Scalars['String']>;
  playlists?: InputMaybe<PlaylistUpdateManyWithoutWorkspaceNestedInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  users?: InputMaybe<UserUpdateManyWithoutWorkspacesNestedInput>;
};

export type WorkspaceUpdateWithoutUsersInput = {
  PiSignagePlayers?: InputMaybe<PiSignagePlayerUpdateManyWithoutWorkspaceNestedInput>;
  accessLabels?: InputMaybe<AccessLabelUpdateManyWithoutWorkspaceNestedInput>;
  adBoardGroups?: InputMaybe<AdBoardGroupUpdateManyWithoutWorkspaceNestedInput>;
  adBoards?: InputMaybe<AdBoardUpdateManyWithoutWorkspaceNestedInput>;
  admin?: InputMaybe<UserUpdateOneRequiredWithoutAdminWorkspacesNestedInput>;
  audits?: InputMaybe<AuditUpdateManyWithoutWorkspaceNestedInput>;
  bookings?: InputMaybe<BookingUpdateManyWithoutWorkspaceNestedInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  files?: InputMaybe<FileUpdateManyWithoutWorkspaceNestedInput>;
  memberships?: InputMaybe<MembershipUpdateManyWithoutWorkspaceNestedInput>;
  name?: InputMaybe<Scalars['String']>;
  playlists?: InputMaybe<PlaylistUpdateManyWithoutWorkspaceNestedInput>;
  transactions?: InputMaybe<TransactionUpdateManyWithoutWorkspaceNestedInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type WorkspaceUpsertWithWhereUniqueWithoutAdminInput = {
  create: WorkspaceCreateWithoutAdminInput;
  update: WorkspaceUpdateWithoutAdminInput;
  where: WorkspaceWhereUniqueInput;
};

export type WorkspaceUpsertWithWhereUniqueWithoutUsersInput = {
  create: WorkspaceCreateWithoutUsersInput;
  update: WorkspaceUpdateWithoutUsersInput;
  where: WorkspaceWhereUniqueInput;
};

export type WorkspaceUpsertWithoutAccessLabelsInput = {
  create: WorkspaceCreateWithoutAccessLabelsInput;
  update: WorkspaceUpdateWithoutAccessLabelsInput;
  where?: InputMaybe<WorkspaceWhereInput>;
};

export type WorkspaceUpsertWithoutAdBoardGroupsInput = {
  create: WorkspaceCreateWithoutAdBoardGroupsInput;
  update: WorkspaceUpdateWithoutAdBoardGroupsInput;
  where?: InputMaybe<WorkspaceWhereInput>;
};

export type WorkspaceUpsertWithoutAdBoardsInput = {
  create: WorkspaceCreateWithoutAdBoardsInput;
  update: WorkspaceUpdateWithoutAdBoardsInput;
  where?: InputMaybe<WorkspaceWhereInput>;
};

export type WorkspaceUpsertWithoutAuditsInput = {
  create: WorkspaceCreateWithoutAuditsInput;
  update: WorkspaceUpdateWithoutAuditsInput;
  where?: InputMaybe<WorkspaceWhereInput>;
};

export type WorkspaceUpsertWithoutBookingsInput = {
  create: WorkspaceCreateWithoutBookingsInput;
  update: WorkspaceUpdateWithoutBookingsInput;
  where?: InputMaybe<WorkspaceWhereInput>;
};

export type WorkspaceUpsertWithoutFilesInput = {
  create: WorkspaceCreateWithoutFilesInput;
  update: WorkspaceUpdateWithoutFilesInput;
  where?: InputMaybe<WorkspaceWhereInput>;
};

export type WorkspaceUpsertWithoutMembershipsInput = {
  create: WorkspaceCreateWithoutMembershipsInput;
  update: WorkspaceUpdateWithoutMembershipsInput;
  where?: InputMaybe<WorkspaceWhereInput>;
};

export type WorkspaceUpsertWithoutPiSignagePlayersInput = {
  create: WorkspaceCreateWithoutPiSignagePlayersInput;
  update: WorkspaceUpdateWithoutPiSignagePlayersInput;
  where?: InputMaybe<WorkspaceWhereInput>;
};

export type WorkspaceUpsertWithoutPlaylistsInput = {
  create: WorkspaceCreateWithoutPlaylistsInput;
  update: WorkspaceUpdateWithoutPlaylistsInput;
  where?: InputMaybe<WorkspaceWhereInput>;
};

export type WorkspaceUpsertWithoutTransactionsInput = {
  create: WorkspaceCreateWithoutTransactionsInput;
  update: WorkspaceUpdateWithoutTransactionsInput;
  where?: InputMaybe<WorkspaceWhereInput>;
};

export type WorkspaceWhereInput = {
  AND?: InputMaybe<Array<WorkspaceWhereInput>>;
  NOT?: InputMaybe<Array<WorkspaceWhereInput>>;
  OR?: InputMaybe<Array<WorkspaceWhereInput>>;
  PiSignagePlayers?: InputMaybe<PiSignagePlayerListRelationFilter>;
  accessLabels?: InputMaybe<AccessLabelListRelationFilter>;
  adBoardGroups?: InputMaybe<AdBoardGroupListRelationFilter>;
  adBoards?: InputMaybe<AdBoardListRelationFilter>;
  admin?: InputMaybe<UserRelationFilter>;
  adminUserId?: InputMaybe<StringFilter>;
  audits?: InputMaybe<AuditListRelationFilter>;
  bookings?: InputMaybe<BookingListRelationFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  files?: InputMaybe<FileListRelationFilter>;
  id?: InputMaybe<StringFilter>;
  memberships?: InputMaybe<MembershipListRelationFilter>;
  name?: InputMaybe<StringFilter>;
  playlists?: InputMaybe<PlaylistListRelationFilter>;
  transactions?: InputMaybe<TransactionListRelationFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
  userIds?: InputMaybe<StringNullableListFilter>;
  users?: InputMaybe<UserListRelationFilter>;
};

export type WorkspaceWhereUniqueInput = {
  AND?: InputMaybe<Array<WorkspaceWhereInput>>;
  NOT?: InputMaybe<Array<WorkspaceWhereInput>>;
  OR?: InputMaybe<Array<WorkspaceWhereInput>>;
  PiSignagePlayers?: InputMaybe<PiSignagePlayerListRelationFilter>;
  accessLabels?: InputMaybe<AccessLabelListRelationFilter>;
  adBoardGroups?: InputMaybe<AdBoardGroupListRelationFilter>;
  adBoards?: InputMaybe<AdBoardListRelationFilter>;
  admin?: InputMaybe<UserRelationFilter>;
  adminUserId?: InputMaybe<StringFilter>;
  audits?: InputMaybe<AuditListRelationFilter>;
  bookings?: InputMaybe<BookingListRelationFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  files?: InputMaybe<FileListRelationFilter>;
  id?: InputMaybe<Scalars['String']>;
  memberships?: InputMaybe<MembershipListRelationFilter>;
  name?: InputMaybe<StringFilter>;
  playlists?: InputMaybe<PlaylistListRelationFilter>;
  transactions?: InputMaybe<TransactionListRelationFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
  userIds?: InputMaybe<StringNullableListFilter>;
  users?: InputMaybe<UserListRelationFilter>;
};

export type UpdateUserMutationVariables = Exact<{
  accountDetails: AccountDetails;
}>;


export type UpdateUserMutation = { __typename?: 'Mutation', updateUser?: { __typename?: 'User', id: string } | null };

export type BookingPart2Fragment = { __typename?: 'Booking', id: string, bookingDate: any, bookingStatus: BookingStatus, assets: Array<{ __typename?: 'File', url: string, type: string, name: string }>, user: { __typename?: 'User', email: string }, adBoard: { __typename?: 'AdBoard', title: string, pricePerDay: number, address: string, galleryImgs: Array<string> }, selectedDates: { __typename?: 'OrderSelectedDate', startDate: any, endDate: any } };

export type GetBookingsQueryVariables = Exact<{
  where?: InputMaybe<BookingWhereInput>;
}>;


export type GetBookingsQuery = { __typename?: 'Query', bookings: Array<{ __typename?: 'Booking', id: string, bookingDate: any, bookingStatus: BookingStatus, assets: Array<{ __typename?: 'File', url: string, type: string, name: string }>, user: { __typename?: 'User', email: string }, adBoard: { __typename?: 'AdBoard', title: string, pricePerDay: number, address: string, galleryImgs: Array<string> }, selectedDates: { __typename?: 'OrderSelectedDate', startDate: any, endDate: any } }> };

export type GetBookingsAccessQueryVariables = Exact<{
  where: AccessLabelWhereInput;
}>;


export type GetBookingsAccessQuery = { __typename?: 'Query', accessLabels: Array<{ __typename?: 'AccessLabel', bookingIDs: Array<string> }> };

export type GetBookingDetailsQueryVariables = Exact<{
  getBookingWhere2: BookingWhereUniqueInput;
}>;


export type GetBookingDetailsQuery = { __typename?: 'Query', getBooking?: { __typename?: 'Booking', id: string, bookingDate: any, bookingStatus: BookingStatus, bookingCode: string, assets: Array<{ __typename?: 'File', name: string, type: string, url: string }>, proofs: Array<{ __typename?: 'File', url: string, mtime: string }>, adBoard: { __typename?: 'AdBoard', slots?: string | null, id: string, galleryImgs: Array<string>, address: string, title: string, screenSize?: { __typename?: 'ScreenSize', height: number, width: number, unit: MeasurementUnit } | null, resolution?: { __typename?: 'Resolution', height: number, width: number } | null }, payment?: { __typename?: 'BookingPayment', totalDetails?: { __typename?: 'PaymentTotalDetails', total: number, subtotal: number, tax: number, discount: number } | null } | null } | null };

export type GetChangelogsQueryVariables = Exact<{
  where?: InputMaybe<ChangelogWhereInput>;
}>;


export type GetChangelogsQuery = { __typename?: 'Query', changelogs: Array<{ __typename?: 'Changelog', userId: string, createdAt: any, action: string, updates?: any | null, user: { __typename?: 'User', displayName?: string | null } }> };

export type GetOrderQueryVariables = Exact<{
  where: OrderWhereUniqueInput;
}>;


export type GetOrderQuery = { __typename?: 'Query', order?: { __typename?: 'Order', paymentId?: string | null, selectedSlots: Array<number>, origin: string, id: string, selectedDate: { __typename?: 'OrderSelectedDate', startDate: any, endDate: any }, adBoard: { __typename?: 'AdBoard', id: string, address: string, title: string, galleryImgs: Array<string>, pricePerDay: number }, priceSummary: { __typename?: 'OrderPriceSummary', rentPerDay: number, discount?: number | null, totalRent: number, serviceCharge: number, payableRent: number, days: number } } | null };

export type PrepareBookingMutationVariables = Exact<{
  bookingRequest: BookingRequest;
}>;


export type PrepareBookingMutation = { __typename?: 'Mutation', prepareBooking: { __typename?: 'Booking', id: string } };

export type GetAdBoardQueryVariables = Exact<{
  where: AdBoardWhereUniqueInput;
}>;


export type GetAdBoardQuery = { __typename?: 'Query', adBoard?: { __typename?: 'AdBoard', title: string, address: string, id: string, slots?: string | null, description?: string | null, status: AdBoardStatus, pricePerDay: number, galleryImgs: Array<string>, resolution?: { __typename?: 'Resolution', width: number, height: number } | null, screenSize?: { __typename?: 'ScreenSize', width: number, height: number, unit: MeasurementUnit } | null, specifications: Array<{ __typename?: 'Specification', name: string }>, aboutSpecifications: Array<{ __typename?: 'Specification', name: string, value?: string | null }>, map: { __typename?: 'Map', lat: number, lng: number } } | null };

export type GetSlotsQueryVariables = Exact<{
  where?: InputMaybe<SlotWhereInput>;
}>;


export type GetSlotsQuery = { __typename?: 'Query', blockedSlots: Array<{ __typename?: 'Slot', date: any, bookingId?: string | null, time: number }> };

export type GetBookedSlotsQueryVariables = Exact<{
  where2?: InputMaybe<SlotWhereInput>;
}>;


export type GetBookedSlotsQuery = { __typename?: 'Query', getBookedSlots: Array<{ __typename?: 'Slot', date: any, bookingId?: string | null, time: number }> };

export type DeleteOneFileMutationVariables = Exact<{
  where: FileWhereUniqueInput;
}>;


export type DeleteOneFileMutation = { __typename?: 'Mutation', deleteOneFile?: { __typename?: 'File', url: string } | null };

export type UploadedFilesFragmentFragment = { __typename?: 'File', id: string, name: string, url: string, mtime: string, status?: FileStatus | null, type: string, size: number, isDirectory: boolean, meta: { __typename?: 'FileMeta', width: number, height: number, duration: number } };

export type UploadedFilesQueryVariables = Exact<{
  filesWhere2?: InputMaybe<FileWhereInput>;
  sort?: InputMaybe<Array<FileOrderByWithRelationInput> | FileOrderByWithRelationInput>;
}>;


export type UploadedFilesQuery = { __typename?: 'Query', files: Array<{ __typename?: 'File', id: string, name: string, url: string, mtime: string, status?: FileStatus | null, type: string, size: number, isDirectory: boolean, meta: { __typename?: 'FileMeta', width: number, height: number, duration: number } }> };

export type GetUserQueryVariables = Exact<{
  userWhere2: UserWhereUniqueInput;
}>;


export type GetUserQuery = { __typename?: 'Query', user?: { __typename?: 'User', id: string } | null };

export type GetBookingQueryVariables = Exact<{
  getBookingWhere2: BookingWhereUniqueInput;
}>;


export type GetBookingQuery = { __typename?: 'Query', getBooking?: { __typename?: 'Booking', id: string, bookingCode: string, bookingDetails: { __typename?: 'BookingDetails', email: string, phone?: string | null }, assets: Array<{ __typename?: 'File', name: string, url: string, type: string }>, payment?: { __typename?: 'BookingPayment', totalDetails?: { __typename?: 'PaymentTotalDetails', total: number, subtotal: number, tax: number, discount: number } | null } | null, adBoard: { __typename?: 'AdBoard', id: string, galleryImgs: Array<string>, address: string, title: string, pricePerDay: number }, selectedDates: { __typename?: 'OrderSelectedDate', startDate: any, endDate: any } } | null };

export type AdBoardFragmentFragment = { __typename?: 'AdBoard', pricePerDay: number, status: AdBoardStatus, id: string, slots?: string | null, href?: string | null, title: string, featuredImage?: string | null, address: string, galleryImgs: Array<string>, resolution?: { __typename?: 'Resolution', width: number, height: number } | null, screenSize?: { __typename?: 'ScreenSize', width: number, height: number, unit: MeasurementUnit } | null, map: { __typename?: 'Map', lat: number, lng: number } };

export type UploadFileMutationVariables = Exact<{
  data: FileCreateInput;
}>;


export type UploadFileMutation = { __typename?: 'Mutation', createOneFile: { __typename?: 'File', id: string } };

export type GetAdBoardsQueryVariables = Exact<{
  adBoardsWhere?: InputMaybe<AdBoardWhereInput>;
}>;


export type GetAdBoardsQuery = { __typename?: 'Query', adBoards: Array<{ __typename?: 'AdBoard', pricePerDay: number, status: AdBoardStatus, id: string, slots?: string | null, href?: string | null, title: string, featuredImage?: string | null, address: string, galleryImgs: Array<string>, resolution?: { __typename?: 'Resolution', width: number, height: number } | null, screenSize?: { __typename?: 'ScreenSize', width: number, height: number, unit: MeasurementUnit } | null, map: { __typename?: 'Map', lat: number, lng: number } }> };

export type CreateOneOrderMutationVariables = Exact<{
  data: OrderCreateInput;
}>;


export type CreateOneOrderMutation = { __typename?: 'Mutation', createOneOrder: { __typename?: 'Order', id: string } };

export const BookingPart2FragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"BookingPart2"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Booking"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"bookingDate"}},{"kind":"Field","name":{"kind":"Name","value":"assets"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"email"}}]}},{"kind":"Field","name":{"kind":"Name","value":"bookingStatus"}},{"kind":"Field","name":{"kind":"Name","value":"adBoard"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"pricePerDay"}},{"kind":"Field","name":{"kind":"Name","value":"address"}},{"kind":"Field","name":{"kind":"Name","value":"galleryImgs"}}]}},{"kind":"Field","name":{"kind":"Name","value":"selectedDates"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"startDate"}},{"kind":"Field","name":{"kind":"Name","value":"endDate"}}]}}]}}]} as unknown as DocumentNode<BookingPart2Fragment, unknown>;
export const UploadedFilesFragmentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UploadedFilesFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"File"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"mtime"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"size"}},{"kind":"Field","name":{"kind":"Name","value":"isDirectory"}},{"kind":"Field","name":{"kind":"Name","value":"meta"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}},{"kind":"Field","name":{"kind":"Name","value":"duration"}}]}}]}}]} as unknown as DocumentNode<UploadedFilesFragmentFragment, unknown>;
export const AdBoardFragmentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"AdBoardFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"AdBoard"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"pricePerDay"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"slots"}},{"kind":"Field","name":{"kind":"Name","value":"href"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"featuredImage"}},{"kind":"Field","name":{"kind":"Name","value":"address"}},{"kind":"Field","name":{"kind":"Name","value":"galleryImgs"}},{"kind":"Field","name":{"kind":"Name","value":"resolution"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}}]}},{"kind":"Field","name":{"kind":"Name","value":"screenSize"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}},{"kind":"Field","name":{"kind":"Name","value":"unit"}}]}},{"kind":"Field","name":{"kind":"Name","value":"map"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"lat"}},{"kind":"Field","name":{"kind":"Name","value":"lng"}}]}}]}}]} as unknown as DocumentNode<AdBoardFragmentFragment, unknown>;
export const UpdateUserDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateUser"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"accountDetails"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"AccountDetails"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateUser"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"accountDetails"},"value":{"kind":"Variable","name":{"kind":"Name","value":"accountDetails"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<UpdateUserMutation, UpdateUserMutationVariables>;
export const GetBookingsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetBookings"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"BookingWhereInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"bookings"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"BookingPart2"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"BookingPart2"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Booking"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"bookingDate"}},{"kind":"Field","name":{"kind":"Name","value":"assets"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"email"}}]}},{"kind":"Field","name":{"kind":"Name","value":"bookingStatus"}},{"kind":"Field","name":{"kind":"Name","value":"adBoard"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"pricePerDay"}},{"kind":"Field","name":{"kind":"Name","value":"address"}},{"kind":"Field","name":{"kind":"Name","value":"galleryImgs"}}]}},{"kind":"Field","name":{"kind":"Name","value":"selectedDates"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"startDate"}},{"kind":"Field","name":{"kind":"Name","value":"endDate"}}]}}]}}]} as unknown as DocumentNode<GetBookingsQuery, GetBookingsQueryVariables>;
export const GetBookingsAccessDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetBookingsAccess"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"AccessLabelWhereInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"accessLabels"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"bookingIDs"}}]}}]}}]} as unknown as DocumentNode<GetBookingsAccessQuery, GetBookingsAccessQueryVariables>;
export const GetBookingDetailsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetBookingDetails"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"getBookingWhere2"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"BookingWhereUniqueInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getBooking"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"getBookingWhere2"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"assets"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"proofs"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"mtime"}}]}},{"kind":"Field","name":{"kind":"Name","value":"adBoard"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slots"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"galleryImgs"}},{"kind":"Field","name":{"kind":"Name","value":"screenSize"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"height"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"unit"}}]}},{"kind":"Field","name":{"kind":"Name","value":"resolution"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"height"}},{"kind":"Field","name":{"kind":"Name","value":"width"}}]}},{"kind":"Field","name":{"kind":"Name","value":"address"}},{"kind":"Field","name":{"kind":"Name","value":"title"}}]}},{"kind":"Field","name":{"kind":"Name","value":"bookingDate"}},{"kind":"Field","name":{"kind":"Name","value":"bookingStatus"}},{"kind":"Field","name":{"kind":"Name","value":"bookingCode"}},{"kind":"Field","name":{"kind":"Name","value":"payment"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalDetails"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"total"}},{"kind":"Field","name":{"kind":"Name","value":"subtotal"}},{"kind":"Field","name":{"kind":"Name","value":"tax"}},{"kind":"Field","name":{"kind":"Name","value":"discount"}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetBookingDetailsQuery, GetBookingDetailsQueryVariables>;
export const GetChangelogsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetChangelogs"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ChangelogWhereInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"changelogs"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"userId"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"displayName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"action"}},{"kind":"Field","name":{"kind":"Name","value":"updates"}}]}}]}}]} as unknown as DocumentNode<GetChangelogsQuery, GetChangelogsQueryVariables>;
export const GetOrderDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetOrder"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"OrderWhereUniqueInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"order"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"paymentId"}},{"kind":"Field","name":{"kind":"Name","value":"selectedSlots"}},{"kind":"Field","name":{"kind":"Name","value":"origin"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"selectedDate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"startDate"}},{"kind":"Field","name":{"kind":"Name","value":"endDate"}}]}},{"kind":"Field","name":{"kind":"Name","value":"adBoard"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"address"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"galleryImgs"}},{"kind":"Field","name":{"kind":"Name","value":"pricePerDay"}}]}},{"kind":"Field","name":{"kind":"Name","value":"priceSummary"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"rentPerDay"}},{"kind":"Field","name":{"kind":"Name","value":"discount"}},{"kind":"Field","name":{"kind":"Name","value":"totalRent"}},{"kind":"Field","name":{"kind":"Name","value":"serviceCharge"}},{"kind":"Field","name":{"kind":"Name","value":"payableRent"}},{"kind":"Field","name":{"kind":"Name","value":"days"}}]}}]}}]}}]} as unknown as DocumentNode<GetOrderQuery, GetOrderQueryVariables>;
export const PrepareBookingDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"PrepareBooking"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"bookingRequest"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"BookingRequest"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"prepareBooking"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"bookingRequest"},"value":{"kind":"Variable","name":{"kind":"Name","value":"bookingRequest"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<PrepareBookingMutation, PrepareBookingMutationVariables>;
export const GetAdBoardDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetAdBoard"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"AdBoardWhereUniqueInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"adBoard"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"address"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"slots"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"resolution"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}}]}},{"kind":"Field","name":{"kind":"Name","value":"screenSize"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}},{"kind":"Field","name":{"kind":"Name","value":"unit"}}]}},{"kind":"Field","name":{"kind":"Name","value":"specifications"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"aboutSpecifications"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}},{"kind":"Field","name":{"kind":"Name","value":"pricePerDay"}},{"kind":"Field","name":{"kind":"Name","value":"galleryImgs"}},{"kind":"Field","name":{"kind":"Name","value":"map"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"lat"}},{"kind":"Field","name":{"kind":"Name","value":"lng"}}]}}]}}]}}]} as unknown as DocumentNode<GetAdBoardQuery, GetAdBoardQueryVariables>;
export const GetSlotsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetSlots"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"SlotWhereInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"blockedSlots"},"name":{"kind":"Name","value":"slots"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"date"}},{"kind":"Field","name":{"kind":"Name","value":"bookingId"}},{"kind":"Field","name":{"kind":"Name","value":"time"}}]}}]}}]} as unknown as DocumentNode<GetSlotsQuery, GetSlotsQueryVariables>;
export const GetBookedSlotsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetBookedSlots"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where2"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"SlotWhereInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"getBookedSlots"},"name":{"kind":"Name","value":"slots"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where2"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"date"}},{"kind":"Field","name":{"kind":"Name","value":"bookingId"}},{"kind":"Field","name":{"kind":"Name","value":"time"}}]}}]}}]} as unknown as DocumentNode<GetBookedSlotsQuery, GetBookedSlotsQueryVariables>;
export const DeleteOneFileDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"DeleteOneFile"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"FileWhereUniqueInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"deleteOneFile"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}}]} as unknown as DocumentNode<DeleteOneFileMutation, DeleteOneFileMutationVariables>;
export const UploadedFilesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"UploadedFiles"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filesWhere2"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"FileWhereInput"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"sort"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"FileOrderByWithRelationInput"}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"files"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filesWhere2"}}},{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"Variable","name":{"kind":"Name","value":"sort"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"UploadedFilesFragment"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UploadedFilesFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"File"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"mtime"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"size"}},{"kind":"Field","name":{"kind":"Name","value":"isDirectory"}},{"kind":"Field","name":{"kind":"Name","value":"meta"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}},{"kind":"Field","name":{"kind":"Name","value":"duration"}}]}}]}}]} as unknown as DocumentNode<UploadedFilesQuery, UploadedFilesQueryVariables>;
export const GetUserDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetUser"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userWhere2"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UserWhereUniqueInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"user"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userWhere2"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<GetUserQuery, GetUserQueryVariables>;
export const GetBookingDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetBooking"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"getBookingWhere2"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"BookingWhereUniqueInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getBooking"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"getBookingWhere2"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"bookingCode"}},{"kind":"Field","name":{"kind":"Name","value":"bookingDetails"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"phone"}}]}},{"kind":"Field","name":{"kind":"Name","value":"assets"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"type"}}]}},{"kind":"Field","name":{"kind":"Name","value":"payment"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalDetails"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"total"}},{"kind":"Field","name":{"kind":"Name","value":"subtotal"}},{"kind":"Field","name":{"kind":"Name","value":"tax"}},{"kind":"Field","name":{"kind":"Name","value":"discount"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"adBoard"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"galleryImgs"}},{"kind":"Field","name":{"kind":"Name","value":"address"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"pricePerDay"}}]}},{"kind":"Field","name":{"kind":"Name","value":"selectedDates"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"startDate"}},{"kind":"Field","name":{"kind":"Name","value":"endDate"}}]}}]}}]}}]} as unknown as DocumentNode<GetBookingQuery, GetBookingQueryVariables>;
export const UploadFileDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UploadFile"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"data"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"FileCreateInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createOneFile"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"Variable","name":{"kind":"Name","value":"data"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<UploadFileMutation, UploadFileMutationVariables>;
export const GetAdBoardsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetAdBoards"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"adBoardsWhere"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"AdBoardWhereInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"adBoards"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"adBoardsWhere"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"AdBoardFragment"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"AdBoardFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"AdBoard"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"pricePerDay"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"slots"}},{"kind":"Field","name":{"kind":"Name","value":"href"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"featuredImage"}},{"kind":"Field","name":{"kind":"Name","value":"address"}},{"kind":"Field","name":{"kind":"Name","value":"galleryImgs"}},{"kind":"Field","name":{"kind":"Name","value":"resolution"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}}]}},{"kind":"Field","name":{"kind":"Name","value":"screenSize"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}},{"kind":"Field","name":{"kind":"Name","value":"unit"}}]}},{"kind":"Field","name":{"kind":"Name","value":"map"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"lat"}},{"kind":"Field","name":{"kind":"Name","value":"lng"}}]}}]}}]} as unknown as DocumentNode<GetAdBoardsQuery, GetAdBoardsQueryVariables>;
export const CreateOneOrderDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreateOneOrder"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"data"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"OrderCreateInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createOneOrder"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"Variable","name":{"kind":"Name","value":"data"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<CreateOneOrderMutation, CreateOneOrderMutationVariables>;